(function() {

  'use strict';

  appConfig.$inject = ['$compileProvider', '$httpProvider', 'iScrollServiceProvider'];
  angular.module('ptCrm', [
    'config',
    'ui.router',
    'translations',
    'templates-dist',
    'ngTouch',
    'ngSanitize',
    'swipe',
    'angular-iscroll',
    'toastr',
    'rzModule',
    'permission',
    'permission.ui',
    'ui.select',
    'ui.mask',
    'color.picker',
    'ui.bootstrap',
    'ngFileUpload',
    'angularTrix',
    'angular-carousel',
    'ngPromiseExtras',
    'ngMessages',
    window.angularDragula(angular) // angularDragula initialization requirements
  ])
    .constant('STRINGS', {
      APPLICATION_NAME: 'Personal Trainer Admin'
    })
    .config(appConfig);


  function appConfig($compileProvider, $httpProvider, iScrollServiceProvider) {
    var env = window.config && window.config.env;
    $compileProvider.debugInfoEnabled(env !== 'prod');

    $httpProvider.interceptors.push('authInterceptorService');

    // set app timezone
    moment.tz.setDefault('GMT');

    // iScroll always overwrites mouseWheel option with default value
    // we can remove this fix when https://github.com/mtr/angular-iscroll/pull/17 wil be merged
    var iScrollDefaults = iScrollServiceProvider.getDefaults();
    delete iScrollDefaults.iScroll.mouseWheel;
  }

  // Gets overridden during by templates.js during build
  angular.module('templates-dist', []);

}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .run(['PermissionStrategies', '$rootScope', 'profileService', '$urlRouter', 'langService', function(PermissionStrategies, $rootScope, profileService, $urlRouter, langService) {
      $rootScope.PermissionStrategies = PermissionStrategies;
      $rootScope.PermissionStrategies.disableUiSelect = function(scope) {
        return function() {
          scope.$select.disabled = true;
        };
      };

      $rootScope.PermissionStrategies.enableUiSelect = function(scope) {
        return function() {
          scope.$select.disabled = false;
        };
      };

      $rootScope.PermissionStrategies.disableTab = function($el) {
        $el.remove();
        $rootScope.$emit('tabs:disabled', $el.attr('name'));
      };

      profileService.authorize()
        .then(langService.setAppLanguage)
        .finally(function() {
          $urlRouter.sync();
          $urlRouter.listen();
        });
    }]);


}());

(function() {
  'use strict';

  angular.module('config', [])
    .provider('config', function() {
      // Default config
      var config = {
        basePath: '/', // Should match <base href=""/> in index.html
        assetBaseUrl: '',
        translationsUrl: '/translations/',
        defaultLanguage: 'en',

          // Language key expected format: two letter ISO_639-1 code + region
          // http://www.w3.org/International/articles/language-tags/
        languages: {
          en: {
            name: 'English'
          },
          de: {
            name: 'Deutsch'
          },
          'zh-CN': {
            name: '简体中国',
            aliases: ['zh']
          },
          'zh-TW': {
            name: '中國傳統'
          }
        },
        availableLanguages: [], // Generated from languages
        languageAliases: {},    // Generated from languages,
        apiPath: '/',
        get apiBase() {
          return this.apiPath + 'api/v1';
        },
        env: 'dev'
      };

      // Build | dist config based off of global config object
      if (!_.isUndefined(window.config)) {
        _.extend(config, window.config);
      }

      config.availableLanguages = _.map(config.languages, function(obj, key) {
        return key;
      });

      // TODO: Examine the necessity of all this aliasing and consider
      // replacing it with a language/region resolver that's used
      // directly by angular translate
      //
      // https://github.com/angular-translate/angular-translate/blob/a2ac7000f94bcee6dd8e206cab5d7cec3527dd25/src/service/translate.js#L694

      // Maps language_region to language-region.  zh_TW to zh-TW for example.
      function createUnderscoreAlias(name) {
        if (name.indexOf('-') > -1) {
          config.languageAliases[name.replace('-', '_')] = name;
        }
      }

      // Create map of aliases
      _.each(config.languages, function(obj, key) {
        _.each(obj.aliases, function(alias) {
          config.languageAliases[alias] = key;
          createUnderscoreAlias(alias);
        });

        if (key.length === 2) {
          config.languageAliases[key + '*'] = key;
        }

        createUnderscoreAlias(key);
      });

      this.$get = function() {
        return config;
      };
    });

}());

(function() {
  'use strict';

  appRoutes.$inject = ['configProvider', '$locationProvider', '$stateProvider', '$urlRouterProvider', 'USER_HOME_PAGE'];
  angular.module('ptCrm')
    .constant('USER_HOME_PAGE', {
      URL: 'login'
    })
    .constant('PAGES_PRIORITIES', [
      {
        permission:  'DASHBOARD_VIEW_READ',
        URL: 'app.dashboard'
      },{
        permission:  'SCHEDULE_VIEW_READ',
        URL: 'app.calendar'
      },{
        permission:  'TRAINING_LIBRARY_VIEW_READ',
        URL: 'app.library.list'
      },{
        permission: 'ROSTER_CLIENT_VIEW_READ',
        URL: 'app.users.list'
      },{
        permission: 'ROSTER_NON_CLIENT_VIEW_READ',
        URL: 'app.users.list'
      },{
        permission: 'SETTINGS_VIEW_READ',
        URL: 'app.settings'
      },{
        permission: 'CLIENT_PERSONAL_DETAILS_SELF_READ',
        URL: 'app.users.details',
        PARAMS: {
          userId: 'me'
        }
      }
    ])
    .config(appRoutes);

  function appRoutes(configProvider, $locationProvider, $stateProvider, $urlRouterProvider, USER_HOME_PAGE) {
    var config = configProvider.$get();

    $stateProvider
      .state('nolang', {
        url: '^/',
        controller: 'AppController'
      })

      .state('app', {
        url: '^/:lang?token',
        abstract: true,
        controller: 'AppController as app',
        templateUrl: '/app/layout/layout.html'
      })

// ------------------------------ LOGIN ------------------------------
      .state('login', {
        url: '^/:lang/login?next',
        templateUrl: '/app/auth/login.html',
        controller: 'LoginController as loginCtrl',
        data: {
          loginNotRequired: true
        }
      })

// ------------------------------ DASHBOARD ------------------------------
      .state('app.dashboard', {
        url: '/',
        controller: 'DashboardController as dashboard',
        templateUrl: '/app/dashboard/dashboard.html',
        data: {
          permissions: {
            only: 'DASHBOARD_VIEW_READ',
            redirectTo: redirectToHome
          }
        }
      })

// ------------------------------ SCHEDULE ------------------------------
      .state('app.calendar', {
        url: '/calendar/:userId',
        params: {
          date: null,
          userId: null
        },
        controller: 'CalendarController as calendar',
        templateUrl: '/app/calendar/calendar.html',
        data: {
          permissions: {
            only: 'SCHEDULE_VIEW_READ',
            redirectTo: redirectToHome
          }
        }
      })

      // ------------------------------ LIBRARY ------------------------------
      .state('app.library', {
        abstract: true,
        url: '/library',
        template: '<div ui-view class="library-view fade-onload"></div>'
      })

      .state('app.library.list', {
        url: '/?tab',
        controller: 'LibraryController as library',
        templateUrl: '/app/library/library.html',
        params: {
          tab: null
        },
        data: {
          permissions: {
            only: 'TRAINING_LIBRARY_VIEW_READ',
            redirectTo: redirectToHome
          }
        }
      })

      // ------------------------------ USERS ------------------------------
      .state('app.users', {
        abstract: true,
        url: '/users',
        template: '<div ui-view class="roster-view fade-onload"></div>'
      })

      .state('app.users.list', {
        url: '/',
        controller: 'RosterController as roster',
        templateUrl: '/app/roster/roster.html',
        data: {
          permissions: {
            only: ['ROSTER_CLIENT_VIEW_READ', 'ROSTER_NON_CLIENT_VIEW_READ'],
            redirectTo: redirectToHome
          }
        }
      })

      // ------------------------------ SETTINGS ------------------------------
      .state('app.settings', {
        url: '/settings?tab',
        controller: 'SettingsController as settingsCtrl',
        templateUrl: '/app/settings/settings.html',
        data: {
          permissions: {
            only: 'SETTINGS_VIEW_READ',
            redirectTo: redirectToHome
          }
        }
      })

      // ------------------------------ EXERCISES ------------------------------
      .state('app.library.exercise', {
        url: '/exercise/:id',
        controller: 'ExerciseController as exerciseCtrl',
        templateUrl: '/app/library/exercise/exercise.html',
        data: {
          permissions: {
            only: getPermission,
            redirectTo: redirectToHome
          }
        }
      })

      // ------------------------------ SETS ------------------------------
      .state('app.library.set', {
        url: '/set/:id',
        controller: 'CreateTrainingSetController as createSetCtrl',
        templateUrl: '/app/library/training-set/training-set.html',
        data: {
          permissions: {
            only: getPermission,
            redirectTo: redirectToHome
          }
        }
      })

      // ------------------------------ ASSIGNMENTS ------------------------------
      .state('app.assignment', {
        url: '/assignment/:id?userId',
        params: {
          prevState: null,
          prevParams: null,
          userId: null,
          isMe: null,
          startDate: null,
          endDate: null
        },
        controller: 'CreateAssignmentController as createCtrl',
        templateUrl: '/app/library/create-assignment/create-assignment.html',
        data: {
          permissions: {
            only: ['WORKOUT_ASSIGNMENTS_OTHER_CREATE', 'WORKOUT_ASSIGNMENTS_SELF_CREATE'],
            redirectTo: redirectToHome
          }
        }
      })

      // ------------------------------ TASK   ------------------------------
      .state('app.task', {
        url: '/task/:id?userId,startDate,endDate,isMe',
        params: {
          prevState: null,
          prevParams: null,
          userId: null,
          isMe: null,
          startDate: null,
          endDate: null
        },
        controller: 'TaskController as taskCtrl',
        templateUrl: '/app/library/task/task.html',
        data: {
          permissions: {
            only: getPermission,
            redirectTo: redirectToHome
          }
        }
      })

      // ------------------------------ USER DETAILS ------------------------------
      .state('app.users.details', {
        url: '/:userId?tab',
        params: {
          tab: null,
          prevState: null,
          prevParams: null
        },
        controller: 'UserController as userCtrl',
        templateUrl: '/app/user/user.html'
      });

    // Redirect unknown routes to root
    $urlRouterProvider

      // removed when because of http://goo.gl/FD1uJb
      .otherwise('/')
      .deferIntercept();

    // =============== HELPERS =============
    function getPermission(router) {
      var subject = '';
      switch (router.toState.name) {
      case 'app.library.set':
        subject = 'TRAINING_SETS';
        break;
      case 'app.library.exercise':
        subject = 'EXERCISES';
        break;
      case 'app.task':
        var owner = router.toParams.isMe || router.toParams.userId === 'me' ? '_SELF' : '_OTHER';
        subject = 'TASKS' + owner;
        break;
      default:
        return [];
      }
      var action = router.toParams.id ? '_UPDATE' : '_CREATE';
      return [subject + action];
    }

    function redirectToHome(unresolvedPermission, router) {
      var additionalParams = {};
      if (USER_HOME_PAGE.URL === 'login') {
        additionalParams = { next: encodeURIComponent(window.location.href) };
      }

      return {
        state: USER_HOME_PAGE.URL,
        params: _.extend(router.toParams, USER_HOME_PAGE.PARAMS, additionalParams)
      };
    }

    // You will probably want to use html5 mode as it gives clean urls,
    // but currently, this breaks if your <base href=""/> is anything
    // besides "/".
    //
    // https://github.com/angular/angular.js/issues/11091
    //
    // Disabled html5 mode to be consistent with how routes were during development
    $locationProvider.html5Mode(false);
  }

}());

(function() {
  'use strict';

  AppController.$inject = ['langService', '$rootScope', 'authService', 'profileService'];
  angular.module('ptCrm')
    .controller('AppController', AppController);

  function AppController(langService, $rootScope, authService, profileService) {

    var vm = this;

    vm.profile = profileService;

    langService.addLanguageKeyToUrl();

    $rootScope.$on('auth:loginRequired', function() {
      authService.logout(window.location.href);
    });
  }

}());

(function() {
  'use strict';

  angular.module('translations', [
    'pascalprecht.translate',
    'config'
  ])
    .config(['$translateProvider', 'configProvider', function($translateProvider, configProvider) {
      var config = configProvider.$get();

      $translateProvider.useStaticFilesLoader({
        prefix: config.translationsUrl,
        suffix: '.json'
      })
        .registerAvailableLanguageKeys(config.availableLanguages, config.languageAliases)
        .fallbackLanguage(config.defaultLanguage)
        .useSanitizeValueStrategy('escaped');
    }]);

}());

(function() {
  'use strict';

  angular.module('ptCrm')
    .service('storageService', storageService);

  function storageService() {
    var TOKEN_KEY = 'jht-token';

    return {
      getToken: getToken,
      setToken: setToken,
      removeToken: removeToken
    };

    function getToken() {
      return localStorage.getItem(TOKEN_KEY) || null;
    }

    function setToken(token) {
      localStorage.setItem(TOKEN_KEY, token);
    }

    function removeToken() {
      localStorage.removeItem(TOKEN_KEY);
    }

  }
}());

(function() {
  'use strict';

  authService.$inject = ['$http', '$state', 'config', 'storageService'];
  angular.module('ptCrm')
    .service('authService', authService);

  function authService($http, $state, config, storageService) {
    return {
      login: login,
      logout: logout,

      refreshPage: refreshPage
    };

    function login(user) {
      return $http.post(config.apiBase + '/auth_token', user).then(function(response) {
        return response.data;
      });
    }

    function logout(next) {
      storageService.removeToken();

      if (next) {
        $state.params.next = encodeURIComponent(next);
      }

      $state.go('login', $state.params, { reload: false, notify: false })
        .finally(refreshPage);
    }

    function refreshPage() {
      setTimeout(function() {
        window.location.reload();
      });
    }

  }
}());

(function() {
  'use strict';

  authInterceptorService.$inject = ['$rootScope', '$q', 'storageService', 'config'];
  angular.module('ptCrm')
    .service('authInterceptorService', authInterceptorService);

  function authInterceptorService($rootScope, $q, storageService, config) {


    angular.extend(this, {
      request: request,
      responseError: responseError
    });


    function request(reqConfig) {
      var token = storageService.getToken();

      if (reqConfig.url.indexOf(config.apiBase) === 0 && token) {
        reqConfig.headers.authorization = 'Bearer ' + token;

        if (reqConfig.method === 'GET') {
          // TODO: Evaluate if this is necessary
          // disable IE ajax request caching
          reqConfig.headers['If-Modified-Since'] = 'Thu, 01 Jan 1970 00:00:00 GMT';
        }
      }

      return reqConfig;
    }

    function responseError(response) {
      switch (response.status) {
        // TODO handle 403 state too
      case 401:
        $rootScope.$broadcast('auth:loginRequired', response);
        return $q.reject(response);


      default:
        return $q.reject(response);
      }
    }

  }
}());

(function() {
  'use strict';

  PaginateList.$inject = ['$http', '$q', '$timeout', '$rootScope'];
  angular.module('ptCrm')
    .service('PaginateList', PaginateList);

  function PaginateList($http, $q, $timeout, $rootScope) {


    /**
     * A service that helps you handle fetching paginate lists from backend page by page
     *
     * @constructor
     * @param {Object} config The object has following properties:
     *
     * - **url** – `{string}` – $http url to fetch data
     * - **params** – `{string}` – object that each $http request will be extended with
     * - **responseExtract** – `{Function}` – function for transform response list
     *
     */
    function List(config) {
      config = config || {};

      this.items = [];
      this.nextPage = 1;
      this.url = config.url;
      this.defaultParams = config.params;
      this.responseExtract = config.responseExtract;

      this.isLoading = false;
      this.deferredAbortList = null;
      return this;
    }

    List.prototype._extendItems = _extendItems;
    List.prototype.extendDefaultParams = extendDefaultParams;
    List.prototype.load = load;
    List.prototype.reset = reset;

    function reset() {
      this.items.length = 0;
      this.nextPage = 1;
    }

    function _extendItems(data) {
      var vm = this;

      // keep reference to the model
      _.each(data, function(item) {
        vm.items.push(item);
      });

      return this;
    }

    /**
     * @name extendDefaultParams
     * @description
     * Use this function to set default $http params
     *
     * @param {Object} params object that each $http request will be extended with
     *
     * @returns {Object} current List object
     */
    function extendDefaultParams(params) {
      var extendedParams = _.extend({}, this.defaultParams, params);
      this.defaultParams = _validateParams(extendedParams);
      return this;
    }

    function _validateParams(params) {
      // remove empty or undefined params
      return _.pickBy(params, _.identity);
    }

    /**
     * @name load
     * @description
     * Use this function to start loading next chunk of data
     *
     * @param {Object} config The object has following properties:
     *
     * - **params** – `{Object}` – params object that $http requests will be extended with
     * - **responseExtract** – `{Function}` – function for transform response list
     *
     * @returns {promise} $http.get promise
     */
    function load(config) {
      config = _.extend({
        responseExtract: this.responseExtract
      }, config);

      var vm = this,
        params = config.params || {};

      if (config.update || !vm.items.length) {
        vm.nextPage = 1;
      }

      if (!vm.nextPage) {
        return $q.reject();
      }

      vm.isLoading = true;

      if (vm.deferredAbortList) {
        vm.deferredAbortList.resolve();
      }
      vm.deferredAbortList = $q.defer();

      return $http.get(vm.url, {
        params: _.extend({}, vm.defaultParams, params, {
          page: vm.nextPage
        }),

        // abort request if another request started
        timeout: vm.deferredAbortList.promise
      })
      .finally(function() {
        vm.isLoading = false;
      })
      .then(function(res) {
        var resultData = res.data.data;

        if (res.data.meta.page === 1) {
          vm.items.length = 0;
        }

        if (_.isFunction(config.responseExtract)) {
          resultData = config.responseExtract(resultData);
        }

        return $q.when(resultData).then(function(transformedData) {
          vm._extendItems(transformedData);
          vm.nextPage = _getNextPage(res.data.meta);

          $timeout(function() {
            $rootScope.$emit('infiniteScroll:complete');
          });

          return res.data;
        });
      });
    }

    function _getNextPage(meta) {
      return meta.page * meta.limit < meta.totalCount ? meta.page + 1 : null;
    }

    return List;
  }
}());

(function() {
  'use strict';

  userService.$inject = ['$http', 'config', 'urlService', '$q'];
  angular.module('ptCrm')
    .service('userService', userService);

  function userService($http, config, urlService, $q) {
    return {
      getUsers: getUsers,
      getUser: getUser,
      getCurrentUser: getCurrentUser,
      createUser: createUser,
      updateUser: updateUser,
      updateWorkInfo: updateWorkInfo,
      updateTrainerClients: updateTrainerClients,
      deleteUser: deleteUser,
      deleteAccount: deleteAccount,
      resetPassword: resetPassword,
      changePassword: changePassword,
      getNetpulseProfile: getNetpulseProfile,
      createClientByXid: createClientByXid,
      assignUserToFacility: assignUserToFacility,
      updateCurrentUser: updateCurrentUser,
      getFullUserName: getFullUserName

    };

    function getUsers(params) {
      return $http.get(config.apiBase + '/users', { params: params })
        .then(function(response) {
          return response.data.data;
        });
    }

    function getUser(uuid) {
      return $http.get(urlService.interpolate(config.apiBase + '/users/{{uuid}}', { uuid: uuid }))
        .then(function(response) {
          return response.data;
        });
    }

    function getCurrentUser() {
      return $http.get(config.apiBase + '/users/me')
        .then(function(response) {
          return response.data;
        });
    }

    function updateCurrentUser(data) {
      return $http.put(config.apiBase + '/users/me', data)
        .then(function(response) {
          return response.data;
        });
    }

    function createUser(user) {
      return $http.post(config.apiBase + '/users', user)
        .then(function(response) {
          return response.data;
        });
    }

    function updateUser(user, id) {
      return $http.put(urlService.interpolate(config.apiBase + '/users/{{uuid}}', { uuid: id }), user)
        .then(function(response) {
          return response.data;
        });
    }

    function updateWorkInfo(workInfo, id) {
      return $http.put(urlService.interpolate(config.apiBase + '/users/{{uuid}}/work_info', { uuid: id }), workInfo)
      .then(function(response) {
        return response.data;
      });
    }

    function updateTrainerClients(clientsIds, id) {
      return $http.put(urlService.interpolate(config.apiBase + '/users/{{uuid}}/clients', { uuid: id }), clientsIds)
      .then(function(response) {
        return response.data;
      });
    }

    function deleteUser(uuid) {
      return $http.delete(urlService.interpolate(config.apiBase + '/users/{{uuid}}', { uuid: uuid }))
        .then(function(response) {
          return response.data;
        });
    }

    function getNetpulseProfile(xID) {
      return $http.get(urlService.interpolate(config.apiBase + '/netpulse_profiles/{{xID}}', { xID: xID }))
        .then(function(response) {
          return response.data;
        });
    }

    function createClientByXid(xID, password) {
      return $http.post(urlService.interpolate(config.apiBase + '/users/xid/{{xID}}', { xID: xID }), { password: password })
        .then(function(response) {
          return response.data;
        });
    }

    function assignUserToFacility(id) {
      return $http.post(urlService.interpolate(config.apiBase + '/users/{{id}}/permission', { id: id }))
        .then(function(response) {
          return response.data;
        });
    }

    // ========= SETTINGS INFO BLOCK ===========
    // ================= MOCKUPS ==========
    // TODO @ilukianov remove this after integration with API

    function deleteAccount(id) {
      return $q.when({ id: id, success: true });
    }

    function resetPassword(id) {
      return $http.put(urlService.interpolate(config.apiBase + '/users/{{uuid}}', { uuid: id }), {
        resetPassword: true
      });
    }

    function changePassword(id, currentPassword, newPassword) {
      return $http.put(urlService.interpolate(config.apiBase + '/users/{{uuid}}', { uuid: id }), {
        currentPassword: currentPassword,
        newPassword: newPassword
      });
    }

    function getFullUserName(user) {
      return _.get(user, 'firstName', '') + ' ' + _.get(user, 'lastName', '');
    }
  }
}());

(function() {
  'use strict';

  angular.module('ptCrm')
    .service('workInfoService', workInfoService);

  function workInfoService() {
    // we need prefix because BE returns us only hours and minutes
    // but for using uib-timepicker component we need Date object
    // so we just add this prefix to responce from BE and create new Date
    // since date is started from Jan 01 1970 00:00:00 we'll use
    // 1970-01-01 as prefix
    var datePrefix = '1970-01-01 ';

    return {
      toDate: toDate,
      toString: toString
    };

    function toDate(schedule) {
      _.each(schedule, _convertStringToDate);
      return schedule;
    }

    function toString(schedule) {
      _.each(schedule, function(times) {
        _convertDateToString(times);
      });
      return schedule;
    }

    function _convertStringToDate(times) {
      _.each(times, function(time) {
        time.max = moment(datePrefix + time.max).utc();
        time.min = moment(datePrefix + time.min).utc();
      });
    }

    function _convertDateToString(times) {
      _.each(times, function(time) {
        time.max = moment(time.max).format('HH:mm');
        time.min = moment(time.min).format('HH:mm');
      });
    }

  }
}());

(function() {
  'use strict';

  langService.$inject = ['$location', '$translate', '$stateParams', 'config', 'STRINGS', 'langRegex', 'profileService'];
  angular.module('ptCrm')
    .constant('langRegex', /^[a-z]{2}([-_][A-Z]{2})?$/)
    .service('langService', langService);

  function langService($location, $translate, $stateParams, config, STRINGS, langRegex, profileService) {

    return {
      setAppLanguage: setAppLanguage,
      addLanguageKeyToUrl: addLanguageKeyToUrl
    };

    function setAppLanguage() {
      var profileLanguage = profileService.user.settings && profileService.user.settings.language;

      if (profileLanguage) {
        profileLanguage = profileLanguage.toLowerCase();
        $translate.preferredLanguage(profileLanguage);
      } else {
        // try to use browser's settings
        var browserLang = $translate.resolveClientLocale();
        $translate.preferredLanguage($translate.negotiateLocale(browserLang) || browserLang);
      }

      if (!_.includes(config.availableLanguages, $translate.preferredLanguage())) {
        $translate.preferredLanguage(config.defaultLanguage);
      }

      return $translate.use($translate.preferredLanguage())
        .catch(function() {
          // assumed, that default language will be always available
          return $translate.use($translate.fallbackLanguage());
        });
    }


    function addLanguageKeyToUrl() {
      var path,
        newpath;

      // to prevent possible infinite looop
      if (!$translate.preferredLanguage()) {
        return;
      }

      // add language to url
      if (!langRegex.test($stateParams.lang)) {
        $location.path('/' + $translate.preferredLanguage() + $location.path());
      } else if ($translate.preferredLanguage() !== $stateParams.lang) {
        path = $location.path();
        newpath = '/' + path.split('/').splice(2).join('/');
        newpath += (newpath.length > 1 && path[path.length - 1] === '/' ? '/' : '');

        $location.path('/' + $translate.preferredLanguage() + newpath);
      }
    }
  }
}());

(function() {
  'use strict';

  permissionsService.$inject = ['$http', 'config'];
  angular.module('ptCrm')
  .service('permissionsService', permissionsService);

  function permissionsService($http, config) {
    return {
      getUserPermissions: getUserPermissions,
      saveUserPermissions: saveUserPermissions,
      getPermissionSubjects: getPermissionSubjects,
      getMyCompiledPermission: getMyCompiledPermission,
      getMyPermissions: getMyPermissions
    };

    function getPermissionSubjects() {
      return $http.get(config.apiBase + '/permission_subjects', { cache: true }).then(function(response) {
        return response.data;
      });
    }

    function getUserPermissions(userId) {
      return $http.get(config.apiBase + '/users/' + userId + '/permission')
      .then(function(response) {
        return response.data;
      });
    }

    function saveUserPermissions(userId, data) {
      var groupsIds = _.map(data.groups, '_id');
      data.groups = _.compact(groupsIds);
      delete data.roles;
      return $http.put(config.apiBase + '/users/' + userId + '/permission', data)
      .then(function(response) {
        return response.data;
      });
    }

    function getMyCompiledPermission() {
      return $http.get(config.apiBase + '/users/me/compiled_permission')
      .then(function(response) {
        return response.data;
      });
    }

    function getMyPermissions() {
      return $http.get(config.apiBase + '/users/me/permission')
        .then(function(response) {
          return response.data;
        });
    }

  }
}());

(function() {
  'use strict';

  CertificationsList.$inject = ['$http', 'config', '$q', '$translate', 'PaginateList', 'popup', 'Upload'];
  angular.module('ptCrm')
    .service('CertificationsList', CertificationsList);

  function CertificationsList($http, config, $q, $translate, PaginateList, popup, Upload) {


    function List(userId) {
      this.forms = {};
      this.items = [];

      this._isLoading = false;

      this._apiPrefix = config.apiBase + '/users/' + userId + '/certificates';
      return this;
    }

    List.prototype.load = load;
    List.prototype.add = addEmpty;
    List.prototype.addCertification = addCertification;
    List.prototype.deleteCertification = deleteCertification;
    List.prototype.copy = copy;
    List.prototype.update = update;
    List.prototype.remove = remove;
    List.prototype.saveAll = saveAll;
    List.prototype.revertAll = revertAll;

    return List;

    function addCertification(item) {
      return Upload.upload({
        url: this._apiPrefix,
        data: item.data
      }).then(function(response) {
        item.data = response.data;
      });
    }

    function deleteCertification(id) {
      var vm = this;

      return $http.delete(vm._apiPrefix + '/' + id).then(function() {
        vm.items = _.reject(vm.items, function(item) {
          return item.data._id === id;
        });
      });
    }

    function load() {
      var vm = this;

      return $http.get(vm._apiPrefix)
        .then(function(response) {
          vm.items = _.map(response.data, function(certification) {
            return { data: certification };
          });

          return vm.items;
        });
    }

    function addEmpty() {
      return this.items.push({
        _virtualId: _.uniqueId('virtual_'),
        data: {}
      });
    }

    function copy(item) {
      var index = _.findIndex(this.items, item);

      return this.items.splice(index + 1, 0, {
        _virtualId: _.uniqueId('virtual_'),
        data: _.omit(_.clone(item.data), '_id')
      });
    }

    function update(item) {

      Upload.upload({
        method: 'PUT',
        url: this._apiPrefix + '/' + item._id,
        data: item
      });
    }

    function remove(item) {
      var vm = this;

      return popup.confirm({
        okText: $translate.instant('DELETE_CERTIFICATION'),
        description: $translate.instant('CONFIRM_DELETE_CERTIFICATION')
      })
        .then(function() {
          if (item.data._id) {
            item._isDeleted = true;
          } else if (item._virtualId) {
            vm.items = _.reject(vm.items, { _virtualId: item._virtualId });
          }
        });
    }

    function saveAll() {
      var vm = this;

      _.forEach(vm.forms, function(form) {
        if (form) {
          form.$setSubmitted(true);
        }
      });

      vm._isLoading = true;
      var aggregationRequests = _.chain(vm.items)
        .filter(function(item) {
          var itemForm = vm.forms[item.data._id || item._virtualId];

          if (item.data._id) {
            return item._isDeleted || (itemForm.$dirty && itemForm.$valid);
          } else {
            return itemForm.$valid;
          }
        })
        .map(function(item) {
          if (item._isDeleted) {
            return vm.deleteCertification(item.data._id);
          } else if (item.data._id) {
            return vm.update(item.data);
          } else if (item._virtualId) {
            return vm.addCertification(item);
          }
        })
        .value();

      $q.all(aggregationRequests).finally(function() {
        vm._isLoading = false;
      });
    }

    function revertAll() {
      return this.load();
    }
  }
}());

(function() {
  'use strict';

  profileService.$inject = ['$rootScope', '$q', 'PermissionStore', 'RoleStore', 'permissionsService', 'userService', 'storageService', 'USER_HOME_PAGE', 'PAGES_PRIORITIES'];
  angular.module('ptCrm')
    .service('profileService', profileService);

  function profileService($rootScope, $q, PermissionStore, RoleStore, permissionsService, userService,
    storageService, USER_HOME_PAGE, PAGES_PRIORITIES) {

    var profile = {
      user: {},
      permissionNames: [],

      update: updateProfile,
      authorize: authorize
    };

    return profile;

    function updateProfile() {
      if (!storageService.getToken()) {
        return $q.when(profile);
      }

      return $q.all({
        compiledPermissions: permissionsService.getMyCompiledPermission(),
        details: userService.getCurrentUser()
      }).then(function(data) {
        profile.user = data.details;
        profile.permissionNames = transformPermissionsToList(data.compiledPermissions);

        return profile;
      });
    }

    function authorize() {
      return updateProfile().then(function(profile) {
        $rootScope.user = profile.user;

        PermissionStore.defineManyPermissions(profile.permissionNames, function(name) {
          return _.includes(profile.permissionNames, name);
        });

        var homePage = defineUserHomePage(PAGES_PRIORITIES, profile.permissionNames);
        USER_HOME_PAGE.URL = homePage.URL;
        USER_HOME_PAGE.PARAMS = homePage.PARAMS;

        defineAdditionalsRoles();
        return profile;
      });
    }

    // ================ HELPERS ==============
    function defineUserHomePage(pages, permissions) {
      var page = _.find(pages, function(page) {
        return _.includes(permissions, page.permission);
      });
      return page || USER_HOME_PAGE;
    }

    function defineAdditionalsRoles() {
      RoleStore.defineRole('EXERCISES_READ+TRAINING_SETS_READ',
        ['EXERCISES_READ', 'TRAINING_SETS_READ']);

      RoleStore.defineRole('CHAIN_WIDE_UPDATE+RESTRICTED_FLAG_UPDATE',
        ['CHAIN_WIDE_UPDATE', 'RESTRICTED_FLAG_UPDATE']);
      RoleStore.defineRole('CHAIN_WIDE_CREATE+RESTRICTED_FLAG_UPDATE',
        ['CHAIN_WIDE_CREATE', 'RESTRICTED_FLAG_UPDATE']);

      RoleStore.defineRole('EXERCISES_CREATE+RESTRICTED_FLAG_UPDATE',
        ['EXERCISES_CREATE', 'RESTRICTED_FLAG_UPDATE']);
      RoleStore.defineRole('EXERCISES_UPDATE+RESTRICTED_FLAG_UPDATE',
        ['EXERCISES_UPDATE', 'RESTRICTED_FLAG_UPDATE']);
      RoleStore.defineRole('EXERCISES_DELETE+RESTRICTED_FLAG_DELETE',
        ['EXERCISES_DELETE', 'RESTRICTED_FLAG_DELETE']);

      RoleStore.defineRole('TRAINING_SETS_CREATE+RESTRICTED_FLAG_UPDATE',
        ['TRAINING_SETS_CREATE', 'RESTRICTED_FLAG_UPDATE']);
      RoleStore.defineRole('TRAINING_SETS_UPDATE+RESTRICTED_FLAG_UPDATE',
        ['TRAINING_SETS_UPDATE', 'RESTRICTED_FLAG_UPDATE']);

      RoleStore.defineRole('TRAINING_SETS_DELETE+RESTRICTED_FLAG_DELETE+CHAIN_WIDE_DELETE',
        ['TRAINING_SETS_DELETE', 'RESTRICTED_FLAG_DELETE', 'CHAIN_WIDE_DELETE']);
      RoleStore.defineRole('TRAINING_SETS_DELETE+RESTRICTED_FLAG_DELETE',
        ['TRAINING_SETS_DELETE', 'RESTRICTED_FLAG_DELETE']);
      RoleStore.defineRole('TRAINING_SETS_DELETE+CHAIN_WIDE_DELETE',
        ['TRAINING_SETS_DELETE', 'CHAIN_WIDE_DELETE']);

      RoleStore.defineRole('TRAINING_SETS_UPDATE+CHAIN_WIDE_UPDATE',
        ['TRAINING_SETS_UPDATE', 'CHAIN_WIDE_UPDATE']);
      RoleStore.defineRole('TRAINING_SETS_UPDATE+RESTRICTED_FLAG_UPDATE+CHAIN_WIDE_UPDATE',
        ['TRAINING_SETS_UPDATE', 'RESTRICTED_FLAG_UPDATE', 'CHAIN_WIDE_UPDATE']);

      RoleStore.defineRole('EXERCISES_UPDATE+CHAIN_WIDE_UPDATE',
        ['EXERCISES_UPDATE', 'CHAIN_WIDE_UPDATE']);
      RoleStore.defineRole('EXERCISES_UPDATE+RESTRICTED_FLAG_UPDATE+CHAIN_WIDE_UPDATE',
        ['EXERCISES_UPDATE', 'RESTRICTED_FLAG_UPDATE', 'CHAIN_WIDE_UPDATE']);
    }

    function transformPermissionsToList(permissions) {
      return _.chain(permissions)
        .map(function(permission) {
          return _.chain(permission.options)
            .pickBy(_.identity)
            .map(function(value, optionName) {
              return permission.name + '_' + optionName;
            }).value();
        })
        .flatten()
        .value();
    }
  }
}());

(function() {
  'use strict';
  formatUserService.$inject = ['workInfoService', 'profileService'];
  angular.module('ptCrm')
    .service('formatUserService', formatUserService);

  function formatUserService(workInfoService, profileService) {
    return {
      restructureUser: restructureUser,
      destructureUser: destructureUser,
      _unixToDate: _unixToDate,
      _dateToUnix: _dateToUnix
    };

    function destructureUser(user) {
      user.clientProfile = user.clientProfile || {};
      var destructuredUser = {
        _id: user._id,
        npXid: user.npXid,
        firstName: user.firstName,
        lastName: user.lastName,
        pictureUrl: user.pictureUrl,
        roles: _.invert(_.mapValues(user.roles)),
        interested: user.clientProfile.interested,
        active: user.clientProfile.active,
        stats: {
          birthday: _unixToDate(user.clientProfile.birthday),
          gender: user.clientProfile.gender,
          body: user.clientProfile.body
        },

        personalInfo: {
          address1: user.address1,
          address2: user.address2,
          phoneNumber1: user.phoneNumber1,
          phoneNumber2: user.phoneNumber2,
          email: user.email,
          club: user.club,
          planDetails: {
            lastWorkoutDate: _unixToDate(user.clientProfile.lastWorkoutDate),
            lastConsoleSignInDate: _unixToDate(user.clientProfile.lastConsoleSignInDate),
            nextAssignmentDate: _unixToDate(user.clientProfile.nextAssignmentDate),
            sessionRemains: user.clientProfile.sessionRemains || 0
          }
        },
        trainers: user.clientProfile.trainers || [],
        settings: user.settings || {}
      };
      if (user.workInfo) {
        _.each(user.workInfo.schedules, function(schedule) {
          schedule.days = workInfoService.toDate(schedule.days);
        });
        destructuredUser.workInfo = {
          permittedFacilities: user.workInfo.facilities || [],
          permittedSchedules: user.workInfo.schedules || [],
          clients: user.workInfo.clients || []
        };
        destructuredUser.clients = user.workInfo.clients || [];
      }

      if (!user.roles.client && user.facilities) {
        var activeFacility = _.find(user.facilities, { _id: user.activeFacility });
        destructuredUser.personalInfo.club.name = activeFacility && activeFacility.name;
      }

      return destructuredUser;
    }

    function restructureUser(subj, data, role) {
      switch (subj) {
      default:
        break;
      case 'stats':
        return {
          clientProfile: {
            birthday: data.birthday && moment(data.birthday).unix(),
            gender: data.gender,
            body: data.body
          }
        };
      case 'personalInfo':
        var user = {
          address1: data.address1,
          address2: data.address2,
          phoneNumber1: data.phoneNumber1,
          phoneNumber2: data.phoneNumber2,
          email: data.email,
          club: data.club

            // this fields not editable for now
            // lastWorkoutDate: moment(data.planDetails.lastWorkoutDate).valueOf(),
            // lastConsoleSignInDate: moment(data.planDetails.lastConsoleSignInDate).valueOf(),
            // nextAssignmentDate: moment(data.planDetails.nextAssignmentDate).valueOf(),
        };
        if (role !== 'Facility' && _.includes(profileService.permissionNames, 'SESSION_FLAG_UPDATE')) {
          _.extend(user, {
            clientProfile: {
              sessionRemains: parseInt(data.planDetails.sessionRemains, 10)
            }
          });
        }
        return user;
      case 'trainers':
        return {
          clientProfile: {
            trainers: _.map(data, '_id')
          }
        };
      case 'workInfo':
        var restructuredSchedules = [];
        _.each(data.permittedSchedules, function(schedule, i) {
          restructuredSchedules.push(angular.copy(schedule));
          // Strip out the hoursEditable property which isn't included in the yaml
          delete restructuredSchedules[i].facility.hoursEditable;
          restructuredSchedules[i].days = workInfoService.toString(angular.copy(schedule.days));
        });
        return {
          // schedules is the only property on workInfo that can change
          // so we won't include facilities or clients here
          workInfo: {
            schedules: restructuredSchedules
          }
        };
      case 'settings':
        return {
          settings: data
        };
      }
    }

    function _unixToDate(unixTimeStamp) {
      return _.isNumber(unixTimeStamp) ?
        moment.unix(unixTimeStamp).toDate() :
        unixTimeStamp;
    }

    function _dateToUnix(dateObject) {
      return dateObject && moment(dateObject).unix();
    }


  }
}());

(function() {
  'use strict';

  trainingSetService.$inject = ['$http', '$q', 'config', 'PaginateList', 'Upload'];
  angular.module('ptCrm')
    .service('trainingSetService', trainingSetService);

  function trainingSetService($http, $q, config, PaginateList, Upload) {

    return {
      getTrainingSetsPaginateList: getTrainingSetsPaginateList,
      getTrainingSet: getTrainingSet,
      createTrainingSet: createTrainingSet,
      deleteTrainingSet: deleteTrainingSet,
      editTrainingSet: editTrainingSet
    };


    function getTrainingSetsPaginateList(params) {
      return new PaginateList({
        url: config.apiBase + '/training_sets',
        params: _.extend({ limit: 10 }, params)
      });
    }

    function createTrainingSet(data) {
      // strip out the $$hashKey values
      var strippedData = JSON.parse(angular.toJson(data));

      // add the picture back
      strippedData.picture = data.picture;

      return Upload.upload({
        url: config.apiBase + '/training_sets',
        method: 'POST',
        data: strippedData
      });
    }

    function editTrainingSet(data) {
      // strip out the $$hashKey values
      var strippedData = JSON.parse(angular.toJson(data));

      // add the picture back
      strippedData.picture = data.picture;

      return Upload.upload({
        url: config.apiBase + '/training_sets/' + data._id,
        method: 'PUT',
        data: strippedData
      });
    }

    function deleteTrainingSet(id) {
      return $http.delete(config.apiBase + '/training_sets/' + id)
      .then(function(response) {
        return response.data;
      });
    }

    function getTrainingSet(id) {
      return $http.get(config.apiBase + '/training_sets/' + id)
      .then(function(response) {
        return response.data;
      });
    }

  }
}());

(function() {
  'use strict';

  riskService.$inject = ['$http', 'config'];
  angular.module('ptCrm')
    .service('riskService', riskService);

  function riskService($http, config) {
    return {
      getRisks: getRisks,
      updateRisks: updateRisks
    };

    function getRisks() {
      return $http.get(config.apiBase + '/risks').then(function(response) {
        return response.data;
      });
    }

    function updateRisks(risks) {
      return $http.put(config.apiBase + '/risks', risks).then(function(response) {
        return response.data;
      });
    }

  }
}());

(function() {
  'use strict';

  urlService.$inject = ['$interpolate'];
  angular.module('ptCrm')
    .service('urlService', urlService);

  function urlService($interpolate) {

    return {
      interpolate: interpolate
    };

    function interpolate(url, params) {
      if (!params) {
        return;
      }

      return $interpolate(url, false, null, true)(params);
    }
  }
}());

(function() {
  'use strict';

  angular.module('ptCrm')
    .service('userPermissionsService', userPermissionsService);

  function userPermissionsService() {
    return {
      getUserStaticPermissions: getUserStaticPermissions,
      getUserDynamicPermissions: getUserDynamicPermissions
    };
    function getUserStaticPermissions(isMe) {

      return {
        task: {
          create: isMe ? 'TASKS_SELF_CREATE' : 'TASKS_OTHER_CREATE'
        },
        workout: {
          create: isMe ? 'WORKOUT_ASSIGNMENTS_SELF_CREATE' : 'WORKOUT_ASSIGNMENTS_OTHER_CREATE'
        },
        stats: {
          read: isMe ? 'CLIENT_FITNESS_DETAILS_SELF_READ' : 'CLIENT_FITNESS_DETAILS_OTHER_READ',
          update: isMe ? 'CLIENT_FITNESS_DETAILS_SELF_UPDATE' : 'CLIENT_FITNESS_DETAILS_OTHER_UPDATE'
        },
        trainers: {
          create: isMe ? 'CLIENT_TRAINER_SELF_CREATE' : 'CLIENT_TRAINER_OTHER_CREATE',
          read: isMe ? 'CLIENT_TRAINER_SELF_READ' : 'CLIENT_TRAINER_OTHER_READ',
          update: isMe ? 'CLIENT_TRAINER_SELF_UPDATE' : 'CLIENT_TRAINER_OTHER_UPDATE',
          delete: isMe ? 'CLIENT_TRAINER_SELF_DELETE' : 'CLIENT_TRAINER_OTHER_DELETE'
        },
        certifications: {
          create: isMe ? 'TRAINER_CERTIFICATIONS_SELF_CREATE' : 'TRAINER_CERTIFICATIONS_OTHER_CREATE',
          read: isMe ? 'TRAINER_CERTIFICATIONS_SELF_READ' : 'TRAINER_CERTIFICATIONS_OTHER_READ',
          update: isMe ? 'TRAINER_CERTIFICATIONS_SELF_UPDATE' : 'TRAINER_CERTIFICATIONS_OTHER_UPDATE',
          delete: isMe ? 'TRAINER_CERTIFICATIONS_SELF_DELETE' : 'TRAINER_CERTIFICATIONS_OTHER_DELETE'
        },
        clients: {
          create: isMe ? 'TRAINER_CLIENTS_SELF_CREATE' : 'TRAINER_CLIENTS_OTHER_CREATE',
          read: isMe ? 'TRAINER_CLIENTS_SELF_READ' : 'TRAINER_CLIENTS_OTHER_READ',
          update: isMe ? 'TRAINER_CLIENTS_SELF_UPDATE' : 'TRAINER_CLIENTS_OTHER_UPDATE',
          delete: isMe ? 'TRAINER_CLIENTS_SELF_DELETE' : 'TRAINER_CLIENTS_OTHER_DELETE'
        },
        settings: {
          read: isMe ? 'USER_SETTINGS_SELF_READ' : 'USER_SETTINGS_OTHER_READ',
          update: isMe ? 'USER_SETTINGS_SELF_UPDATE' : 'USER_SETTINGS_OTHER_UPDATE'
        },
        workoutHistory: {
          read: isMe ? 'WORKOUT_HISTORY_SELF_READ' : 'WORKOUT_HISTORY_OTHER_READ',
          update: isMe ? 'WORKOUT_HISTORY_SELF_UPDATE' : 'WORKOUT_HISTORY_OTHER_UPDATE'
        },
        nutrition: {
          read: isMe ? 'NUTRITION_SELF_READ' : 'NUTRITION_OTHER_READ',
          update: isMe ? 'NUTRITION_SELF_UPDATE' : 'NUTRITION_OTHER_UPDATE'
        }
      };
    }

    function getUserDynamicPermissions(isMe, isClient) {

      /* eslint-disable no-nested-ternary */
      return {
        personalDetails: {
          read: isMe ? (isClient ? 'CLIENT_PERSONAL_DETAILS_SELF_READ' : 'STAFF_PERSONAL_DETAILS_SELF_READ') :
            (isClient ? 'CLIENT_PERSONAL_DETAILS_OTHER_READ' : 'STAFF_PERSONAL_DETAILS_OTHER_READ'),
          update: isMe ? (isClient ? 'CLIENT_PERSONAL_DETAILS_SELF_UPDATE' : 'STAFF_PERSONAL_DETAILS_SELF_UPDATE') :
            (isClient ? 'CLIENT_PERSONAL_DETAILS_OTHER_UPDATE' : 'STAFF_PERSONAL_DETAILS_OTHER_UPDATE')
        },
        resetPassword: {
          update: isMe ? 'CLIENT_PERSONAL_DETAILS_SELF_UPDATE' :
            (isClient ? 'CLIENT_PASSWORD_OTHER_UPDATE' : 'STAFF_PASSWORD_OTHER_UPDATE')
        }
      };

      /* eslint-enable */
    }


  }
}());

(function() {
  'use strict';

  exercisersService.$inject = ['$http', '$filter', 'config', 'PaginateList'];
  angular.module('ptCrm')
    .service('exercisersService', exercisersService);

  function exercisersService($http, $filter, config, PaginateList) {
    return {
      getExerciser: getExerciser,
      getExercisers: getExercisers,
      getNotClients: getNotClients,
      getPaginateList: getPaginateList,
      parseExercise: parseExercise
    };

    // Round the metric to display properly
    function roundMetric(metric, key) {
      var precision = 2;

      if (key === 'duration' ||
          key === 'startingIncline') {
        precision = 0;
      } else if (key === 'startingSpeed') {
        precision = 1;
      }

      return metric.toFixed(precision);
    }

    function parseExercise(exercise) {
      var presetMetrics = {},
        result = {
          metrics: {},
          assignedData: {},
          completedData: {}
        };

      if (exercise.preset) {
        exercise.preset.metrics.forEach(function(metric) {
          presetMetrics[metric.name] = {
            unit: metric.unit,
            math: metric.math
          };
        });
      }

      if (exercise.assignedProfile && exercise.assignedProfile.global) {
        Object.keys(exercise.assignedProfile.global).forEach(function(key) {
          result.metrics[key] = parseInt(exercise.assignedProfile.global[key], 10).toFixed(2) +
          (presetMetrics[key] ? (' ' + presetMetrics[key].unit) : '');
          result.assignedData[key] = {
            value: parseInt(exercise.assignedProfile.global[key], 10),
            unit: presetMetrics[key].unit || ''
          };
        });
      }
      if (exercise.assignedProfile.segments) {

        Object.keys(exercise.assignedProfile.segments[0] || {}).forEach(function(key) {
          if (key === '$$hashKey' || key === '_progressHeight' || key === '_isActive') {
            return;
          }

          if (!result.metrics[key]) {
            var calculatedValue;

            if (presetMetrics[key]) {

              switch (presetMetrics[key].math) {
              case 'sum':
                calculatedValue = exercise.assignedProfile.segments.reduce(function(prev, next) {
                  return prev + next[key];
                }, 0);
                break;
              case 'average':
                calculatedValue = (exercise.assignedProfile.segments.reduce(function(prev, next) {
                  return prev + next[key];
                }, 0) / exercise.assignedProfile.segments.length);
                break;
              default:
                calculatedValue = exercise.assignedProfile.segments[0][key];
              }

              calculatedValue = roundMetric(calculatedValue, key);
            } else {
              calculatedValue = exercise.assignedProfile.segments[0][key].toFixed(2);
            }

            result.assignedData[key] = {
              value: calculatedValue,
              unit: (presetMetrics[key] && presetMetrics[key].unit) || ''
            };

            result.metrics[key] = calculatedValue;
            if (presetMetrics[key] && presetMetrics[key].unit) {
              result.metrics[key] += ' ' + presetMetrics[key].unit;
            }
          }
        });
      }

      if (exercise.completedProfile) {
        result.completedData = getProfileCompleted(exercise);
        _buildAssignedVsCompletedComparison(result);
      }
      return result;
    }

    function getProfileCompleted(exercise) {
      var params = {},
        profile = exercise.completedProfile;

      if (angular.isDefined(profile.duration)) {
        params.duration = _getExerciseCompletedDuration(exercise);
      }

      if (angular.isDefined(profile.calories)) {
        params.calories = _getExerciseCompletedCalories(exercise);
      }

      if (angular.isDefined(profile.distance)) {
        params.distance = _getExerciseCompletedDistance(exercise);
      }

      if (profile.speedHistory && profile.speedHistory.length) {
        params.averageSpeed = _getExerciseCompletedSpeedFromHistory(exercise);
      } else if (angular.isDefined(profile.duration) && angular.isDefined(profile.distance)) {
        params.averageSpeed = _getExerciseCompletedSpeedCalculated(exercise);
      }

      if (angular.isDefined(profile.averageIncline)) {
        params.averageIncline = _getExerciseCompletedIncline(exercise);
      }

      if (angular.isDefined(profile.averageHeartRate)) {
        params.averageHeartRate = _getExerciseCompletedHeartRate(exercise);
      }

      return params;
    }

    function _buildAssignedVsCompletedComparison(exercise) {
      var assigned = exercise.assignedData;
      var completed = exercise.completedData;

      if (completed.duration) {
        completed.duration.comparision = _compareValues(completed.duration, assigned.duration);
      }

      if (completed.calories) {
        completed.calories.comparision = _compareValues(completed.calories, assigned.calories);
      }

      if (completed.distance) {
        completed.distance.comparision = _compareValues(completed.distance, assigned.distance);
      }

      if (completed.averageSpeed) {
        completed.averageSpeed.comparision = _compareValues(completed.averageSpeed, assigned.startingSpeed);
      }

      if (completed.averageIncline) {
        completed.averageIncline.comparision = _compareValues(completed.averageIncline, assigned.startingIncline);
      }

      if (completed.averageHeartRate) {
        completed.averageHeartRate.comparision = _compareValues(completed.averageHeartRate, assigned.heartRate);
      }

      if (completed.level) {
        completed.level.comparision = _compareValues(completed.level, assigned.level);
      }
    }

    function _compareValues(a, b) {
      if (_.isUndefined(a) || _.isUndefined(b) || _.isUndefined(a.value) || _.isUndefined(b.value)) {
        return;
      }

      if (a.value === b.value) {
        return 'equal';
      }

      if (a.value > b.value) {
        return 'greater';
      }

      if (a.value < b.value) {
        return 'less';
      }
    }

    function _getExerciseCompletedDuration(exercise) {
      // TODO: investigate if we can get rid of hardcode

      var timeUnits = exercise.completedProfile.workoutSource !== 'MANUAL' ? 'seconds' : 'minutes';

      return {
        value: _getFormattedDuration(exercise.completedProfile.duration, timeUnits),
        unit: 'min'
      };
    }

    function _getExerciseCompletedCalories(exercise) {
      return {
        value: exercise.completedProfile.calories,
        unit: 'cal'
      };
    }

    function _getExerciseCompletedDistance(exercise) {
      return {
        name: 'distance',
        value: _getFormattedDistance(exercise.completedProfile.distance),
        unit: exercise.completedProfile.distanceUnit
      };
    }

    function _getExerciseCompletedSpeedFromHistory(exercise) {
      return {
        name: 'averageSpeed',
        value: _getFormattedSpeedHistory(exercise.completedProfile.speedHistory),
        unit: exercise.completedProfile.speedUnit
      };
    }

    function _getExerciseCompletedSpeedCalculated(exercise) {
      var speedMetrics = exercise.preset && _.find(exercise.preset.metrics, { name: 'startingSpeed' });
      if (speedMetrics) {
        // Note: duration is always stored in minutes
        var MINUTES_IN_HOUR = 60;

        var unit = speedMetrics ? speedMetrics.unit : '';
        var value = MINUTES_IN_HOUR * exercise.completedProfile.distance / exercise.completedProfile.duration;
        value = parseFloat(value.toFixed(2));

        return {
          name: 'averageSpeed',
          value: value,
          unit: unit
        };
      }
      return null;
    }

    function _getExerciseCompletedIncline(exercise) {
      return {
        name: 'averageIncline',
        value: exercise.completedProfile.averageIncline,
        unit: '%'
      };
    }

    function _getExerciseCompletedHeartRate(exercise) {
      return {
        name: 'averageHeartRate',
        value: exercise.completedProfile.averageHeartRate,
        unit: ''
      };
    }

    function _getFormattedDistance(distance) {
      return $filter('number')(distance, '2');
    }

    function _getFormattedSpeedHistory(speedHistory) {
      return $filter('number')(_averageFilter(speedHistory), '1');
    }

    function _getFormattedDuration(duration, timeUnits) {
      timeUnits = timeUnits || 'minutes';
      return Math.ceil(+moment.duration(duration, timeUnits).asMinutes().toFixed(2));
    }

    function _averageFilter(collection) {
      collection = angular.isString(collection) ? collection.split(',') : collection;

      if (!angular.isArray(collection) || collection.length === 0) {
        return;
      }

      return _.reduce(collection, function(memo, num) {
        return memo + parseFloat(num);
      }, 0) / collection.length;
    }

    function getExerciser(id) {
      return $http.get(config.apiBase + '/users/' + id).then(function(response) {
        return response.data;
      });
    }

    function getExercisers(params) {
      return $http.get(config.apiBase + '/users', {
        params: _.extend(params || {}, { limit: 200 })
      }).then(function(response) {
        return response.data;
      });
    }

    function getNotClients(params) {
      return getExercisers(params).then(function(users) {
        return _.filter(users.data, function(user) {
          return _.intersection(user.roles, ['trainer', 'facility_staff']).length;
        });
      });
    }

    function getPaginateList(options, responseExtract) {
      return new PaginateList({
        url: config.apiBase + '/users',
        responseExtract: responseExtract,
        params: _.extend({ limit: 10 }, options)
      });
    }
  }
}());

(function() {
  'use strict';

  exercisesService.$inject = ['$http', '$q', 'config', 'PaginateList', '$translate', 'profileService'];
  angular.module('ptCrm')
    .service('exercisesService', exercisesService);

  function exercisesService($http, $q, config, PaginateList, $translate, profileService) {
    var videoUrl = '';

    var pictureLookup = {
      weightlifting: '//images.jhtassets.com/76037ca8035c93efb502dff134c6c459ce23eb89/',
      'weightlifting-active': '//images.jhtassets.com/13403a59b6d2dab0c5b7b774c9d0bb5509e4bb3f/',
      treadmill: '//images.jhtassets.com/01ed464107b44bbf658284e7c3d6521c99dc1114/',
      'treadmill-active': '//images.jhtassets.com/8e3dfad173766d0ce8cc319f380253451fea91ea/',
      stretching: '//images.jhtassets.com/bfa9008baf7ad17ea6b371631a69ed1fdd03a246/',
      'stretching-active': '//images.jhtassets.com/077d24ff365c88f5bf4347889380fa0dab0cdded/',
      strength: '//images.jhtassets.com/76037ca8035c93efb502dff134c6c459ce23eb89/',
      'strength-active': '//images.jhtassets.com/13403a59b6d2dab0c5b7b774c9d0bb5509e4bb3f/',
      stepper: '//images.jhtassets.com/b2b24179bc42af2640083e32e434a6c53dc2ea1f/',
      'stepper-active': '//images.jhtassets.com/77ea13f0c57cc6f040099d63543615d87e388084/',
      rower: '//images.jhtassets.com/5bc6fbb81f30292f0497bbc150d4ac61594382a4/',
      'rower-active': '//images.jhtassets.com/e66ffde952192d1c66c995f3c55489b8aa4a2d55/',
      hybrid_bike: '//images.jhtassets.com/932f36e4ef511eb6687697d40ff2db132d0572a9/',
      'hybrid_bike-active': '//images.jhtassets.com/3f5c1f3b4198214212df6a17eabb7d9d7bd4f186/',
      elliptical: '//images.jhtassets.com/999b4c88c85d81b7596ae3362bb64469c42c15c9/',
      'elliptical-active': '//images.jhtassets.com/dc2d55c187e0cf19045cff114f74886ce0cd309c/',
      default_exercise: '//images.jhtassets.com/bfa9008baf7ad17ea6b371631a69ed1fdd03a246/',
      'default_exercise-active': '//images.jhtassets.com/077d24ff365c88f5bf4347889380fa0dab0cdded/',
      climbmill: '//images.jhtassets.com/b337878ce1d2d74b76db88f424f66a444370439d/',
      'climbmill-active': '//images.jhtassets.com/4ac51639626adfb82d28481f4861fe777711c7f2/',
      class: '//images.jhtassets.com/bfa9008baf7ad17ea6b371631a69ed1fdd03a246/',
      'class-active': '//images.jhtassets.com/077d24ff365c88f5bf4347889380fa0dab0cdded/',
      bike: '//images.jhtassets.com/932f36e4ef511eb6687697d40ff2db132d0572a9/',
      'bike-active': '//images.jhtassets.com/3f5c1f3b4198214212df6a17eabb7d9d7bd4f186/',
      arc_trainer: '//images.jhtassets.com/c594197de85b02fdc4a61657daafcfe847a3fd00/',
      'arc_trainer-active': '//images.jhtassets.com/3e9d6e0db1512c035c768b1a3f598c269396ead7/',
      '3rd_party': '//images.jhtassets.com/a63d76b26d40418b110f4a016b2e391f2726a385/',
      '3rd_party-active': '//images.jhtassets.com/384127ff4e5e8caf29978ed55f56f2184cd4fa8c/'
    };

    return {
      getExercisesTemplates: getExercisesTemplates,
      getExerciseCategories: getExerciseCategories,
      getTemplatesPaginateList: getTemplatesPaginateList,
      getEquipmentPresets: getEquipmentPresets,
      createExercise: createExercise,
      deleteExercise: deleteExercise,
      updateExercise: updateExercise,
      getExercise: getExercise,
      getSingleExercise: getSingleExercise,
      getExercises: getExercises,
      setVideoUrl: setVideoUrl,
      extendExercises: extendExercises,
      hasPermission: hasPermission
    };

    function getExercisesTemplates(search) {
      search = search || null;

      return $http.get(config.apiBase + '/exercise_templates', {
        params: {
          search: search,
          limit: 200
        }
      })
        .then(function(response) {
          return response.data;
        });
    }

    function createExercise(data) {
      if (videoUrl.length) {
        data.video = videoUrl;
      }
      return $http.post(config.apiBase + '/exercise_templates', data)
        .then(function(response) {
          return response.data;
        });
    }

    function deleteExercise(exerciseId) {
      return $http.delete(config.apiBase + '/exercise_templates/' + exerciseId)
        .then(function(response) {
          return response.data;
        });
    }

    function updateExercise(exerciseId, data) {
      return $http.put(config.apiBase + '/exercise_templates/' + exerciseId, data)
        .then(function(response) {
          return response.data;
        });
    }

    function getExercise(exerciseId) {
      return $http.get(config.apiBase + '/exercise_templates/' + exerciseId)
        .then(function(response) {
          return response.data;
        });
    }

    function getSingleExercise(exerciseId) {
      return $http.get(config.apiBase + '/exercises/' + exerciseId)
        .then(function(response) {
          return response.data;
        });
    }

    function getExercises(exerciseIds) {
      return $q.all(_.map(exerciseIds, getExercise));
    }

    function getTemplatesPaginateList(options, responseExtract) {
      return new PaginateList({
        url: config.apiBase + '/exercise_templates',
        responseExtract: responseExtract,
        params: _.extend({ limit: 20 }, options)
      });
    }

    function getEquipmentPresets() {
      return $http.get(config.apiBase + '/equipment_presets', { cache: true })
        .then(function(response) {
          return extendExercises(response.data.data);
        });
    }

    function getExerciseCategories() {
      return $http.get(config.apiBase + '/exercise_categories')
        .then(function(response) {
          return response.data;
        });
    }

    function setVideoUrl(url) {
      videoUrl = url || '';
    }

    function hasPermission(permission) {
      return _.includes(profileService.permissionNames, permission);
    }

    function extendExercises(items) {
      // extend with custom pictures
      return _.map(items, function(equipment) {
        var pictureName = equipment.equipmentType ? equipment.equipmentType.toLowerCase() : 'default_exercise';
        return _.assign(equipment, { pictureUrl: pictureLookup[pictureName] });
      });
    }
  }
}());

(function() {
  'use strict';

  exerciseImagesService.$inject = ['$http', 'config', '$q', 'Upload', 'toastr', '$translate'];
  angular.module('ptCrm')
    .service('exerciseImagesService', exerciseImagesService);

  function exerciseImagesService($http, config, $q, Upload, toastr, $translate) {


    function Images(images) {
      this.url = '/exercise_templates/';
      this.items = images || [];
      this.removedItems = [];
      this.newPrimaryItem = null;
    }

    Images.prototype.add = add;
    Images.prototype.remove = remove;
    Images.prototype.save = save;
    Images.prototype.setAsPrimary = setAsPrimary;
    Images.prototype._autoSetPrimary = _autoSetPrimary;

    return {
      getInstance: getInstance
    };

    function getInstance(images) {
      return new Images(images);
    }

    function save(exerciseId) {
      var postRequests, deleteRequests, updateRequest, allRequests = [];
      var vm = this;

      postRequests = _.chain(this.items)
        .reject('_id')
        .map(function(item) {
          return _post(item, exerciseId, vm.url);
        }).value();

      deleteRequests = _.map(this.removedItems, function(item) {
        return _delete(item, exerciseId, vm.url);
      });

      if (this.newPrimaryItem) {
        updateRequest = _update(this.newPrimaryItem, exerciseId, vm.url);
      }

      allRequests = allRequests.concat(postRequests, deleteRequests, updateRequest);

      return $q.all(allRequests).catch(function() {
        toastr.error($translate.instant('EXERCISE_IMAGES_SAVE_ERROR'));
      });
    }

    function _post(item, exerciseId, url) {
      delete item.$$hashKey;
      return Upload.upload({
        url: config.apiBase + url + exerciseId + '/images',
        data: item
      });
    }

    function _delete(item, exerciseId, url) {
      return $http.delete(config.apiBase + url + exerciseId + '/images/' + item._id);
    }

    function _update(item, exerciseId, url) {
      return $http.put(config.apiBase + url + exerciseId + '/images/' + item._id, {
        isPrimary: item.isPrimary
      });
    }

    function add(files, limit) {
      if (!files || !files.length || this.items.length >= limit) {
        return;
      }
      var image = {
        picture: files[0]
      };
      this.items.unshift(image);
      this._autoSetPrimary();
    }

    function remove(image) {
      var index = this.items.indexOf(image),
        previousIndex = index === 0 ? 0 : index - 1;
      this.items.splice(index, 1);

      // if image is already exist on server we need to send delete request
      if (image._id) {
        this.removedItems.push(image);
      }
      this._autoSetPrimary(previousIndex);
    }

    function _autoSetPrimary(index) {
      var primary = _.find(this.items, { isPrimary: true });
      if (primary) {
        return;
      } else {
        this.setAsPrimary(this.items[index || 0]);
      }
    }

    function setAsPrimary(image) {
      if (!image) {
        return;
      }

      _.each(this.items, function(item) {
        delete item.isPrimary;
      });

      image.isPrimary = true;

      // set new primary image from the list of already existed images on server
      if (image._id) {
        this.newPrimaryItem = image;
      }
    }
  }
}());

(function() {
  'use strict';

  assignmentsService.$inject = ['$http', 'config', '$q', '$translate', 'PaginateList', 'urlService', 'userService'];
  angular.module('ptCrm')
    .service('assignmentsService', assignmentsService);

  function assignmentsService($http, config, $q, $translate, PaginateList, urlService, userService) {

    return {
      createAssignment: createAssignment,
      updateMassAssignment: updateMassAssignment,
      deleteMassAssignment: deleteMassAssignment,
      getAssignments: getAssignments,
      getAppointedAssignments: getAppointedAssignments,
      getAppointedAssignment: getAppointedAssignment,
      prepareSelectedClients: prepareSelectedClients,
      getSingleAssignments: getSingleAssignments,
      getClientAssignmentsPaginateList: getClientAssignmentsPaginateList,
      getAssignmentsById: getAssignmentsById
    };

    function getAssignments(params) {
      return $http.get(config.apiBase + '/mass_assignments', { params: params })
        .then(function(response) {
          return response.data;
        });
    }

    function getAssignmentsById(id) {
      return $http.get(urlService.interpolate(config.apiBase + '/mass_assignments/{{id}}', { id: id }))
        .then(function(response) {
          return response.data;
        });
    }

    function getSingleAssignments(params) {
      return $http.get(config.apiBase + '/assignments', { params: params })
        .then(function(response) {
          return response.data;
        });
    }

    function getClientAssignmentsPaginateList(userId) {
      return new PaginateList({
        url: config.apiBase + '/assignments',
        params: { limit: 10, exerciserId: userId }
      });
    }

    function createAssignment(assignment, clients) {
      var error = _validateBody(assignment);
      if (error) {
        return $q.reject(error);
      }

      return $http.post(config.apiBase + '/mass_assignments', assignment)
        .catch(getCreateAssignmentErrorHandler(clients));
    }

    function updateMassAssignment(assignment, clients, id) {
      var error = _validateBody(assignment);
      if (error) {
        return $q.reject(error);
      }

      return $http.put(config.apiBase + '/mass_assignments/' + id, assignment)
        .catch(getCreateAssignmentErrorHandler(clients));
    }

    function deleteMassAssignment(id) {
      return $http.delete(urlService.interpolate(config.apiBase + '/mass_assignments/{{id}}', { id: id }))
        .then(function(response) {
          return response.data;
        });
    }

    function _validateBody(body) {
      if (!body.startDate || !body.endDate) {
        return $translate.instant('PLEASE_PICK_DATES');
      }

      if (body.startDate >= body.endDate) {
        return $translate.instant('END_DATE_MUST_BE_GREATER_THEN_START_DATE');
      }

      if (body.appointment && (body.appointment.startTime >= body.appointment.endTime)) {
        return $translate.instant('END_TIME_MUST_BE_GREATER_THEN_START_TIME');
      }

      if (!body.exercises.length) {
        return $translate.instant('PLEASE_PICK_EXERCISES');
      }
    }


    function getCreateAssignmentErrorHandler(clients) {
      return function handleCreateAssignmentError(response) {
        var errorData = response.data,
          intersectionError = _getIntersectionError(errorData.errors, clients);

        if (intersectionError) {
          return $q.reject(intersectionError);
        } else if (errorData.message) {
          return $q.reject(errorData.message);
        } else {
          return $q.reject(response.statusText);
        }
      };
    }

    function _getIntersectionError(errors, clients) {
      return _.chain(errors)
        .filter({ key: 'exercisers' })
        .groupBy('message')
        .mapValues(function(errorGroup) {
          return _.chain(errorGroup)
            .map(function(err) {
              var client = _.find(clients, { _id: err.value });
              return userService.getFullUserName(client);
            })
            .filter()
            .uniq()
            .join(', ')
            .value();
        })
        .reduce(function(result, names, errorName) {
          var message = names ?
            $translate.instant(_.toUpper(_.snakeCase(errorName)) + '_CLIENTS_ERROR') + ' ' + names + '; ' :
            '';
          return result + message;
        }, '')
        .value();
    }

    function getAppointedAssignments(assignments, user) {
      return _.chain(assignments)
        .filter('exercises')
        .map(function(assn) {
          // No image placeholder
          var img = '//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png',
            from = getTimeOf('start', assn),
            to = getTimeOf('end', assn);

          if (from.isSame(to, 'day')) {
            from = momentToInteger(from);
            to = momentToInteger(to);
          } else {
            from = 0;
            to = 24;
          }

          var appointedAssignment = {
            _id: assn._id,
            timeFrom: from,
            timeTo: to,
            dateFrom: moment.unix(assn.startDate),
            dateTo: moment.unix(assn.endDate),
            type: 'assignment'
          };

          switch (assn.exercisers && assn.exercisers.length) {

            // single assignemnt
          case undefined:
            appointedAssignment = _.extend(appointedAssignment, {
              exerciserId: assn.exerciserId,
              caption: getCaption(user, 1),
              img: user.pictureUrl || img,
              club: _.get(user, 'club.name', '')
            });
            break;

            // mass_assignment with one client
          case 1:
            appointedAssignment = _.extend(appointedAssignment, {
              caption: getCaption(assn.exercisers[0], 1),
              img: assn.exercisers[0].pictureUrl || img,
              club: _.get(assn.exercisers[0], 'club.name', '')
            });
            break;

            // mass_assignment with many clients
          default:
            appointedAssignment = _.extend(appointedAssignment, {
              caption: getCaption(false, assn.exercisers.length),
              img: img,
              club: _.get(assn.exercisers[0], 'club.name', '')
            });
          }
          return appointedAssignment;

        })
        .value();
    }

    function getCaption(user, amount) {
      if (user) {
        return userService.getFullUserName(user);
      } else {
        return $translate.instant('AMOUNT_EXERCISERS', { amount: amount });
      }
    }

    function getAppointedAssignment(user, assignment) {
      return _.first(getAppointedAssignments([assignment], user));
    }

    function getTimeOf(point, assignment) {
      var period = assignment.appointment ? 'Time' : 'Date';
      var correction = point === 'end' ? 1 : 0;
      var basis = assignment.appointment || assignment;
      return moment.unix(basis[point + period] + correction);
    }

    function momentToInteger(momentTime) {
      return momentTime.get('hours') + (momentTime.get('minutes') ? 0.5 : 0);
    }

    function prepareSelectedClients(selectedClients) {
      var caption, img;

      if (!selectedClients.length) {
        return {};
      } else {
        caption = selectedClients.length > 1 ? selectedClients.length + ' ' + $translate.instant('EXERCISERS') :
          userService.getFullUserName(selectedClients[0]);
          //                               No image placeholder
        img = selectedClients.length > 1 ? '//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png' :
          //                                No image placeholder
          (selectedClients[0].pictureUrl || '//images.jhtassets.com/264082bb3a1af70d5499c7d22b0902cb454b6d12/');

        return {
          img: img,
          club: _.get(selectedClients[0], 'club.name', ''),
          caption: caption
        };
      }
    }

  }
}());

(function() {
  'use strict';

  workoutsService.$inject = ['$http', 'config', 'profileService'];
  angular.module('ptCrm')
    .service('workoutsService', workoutsService);

  function workoutsService($http, config, profileService) {
    return {
      getWorkouts: getWorkouts
    };

    function getWorkouts(params) {

      // TODO: remove after fix BE to accept 'me' in workouts
      if (params.exerciserId === 'me') {
        params.exerciserId = profileService.user._id;
      }

      params = angular.extend({}, { limit: 200 }, params);
      return $http.get(config.apiBase + '/np_workouts', { params: params })
        .then(function(response) {
          return response.data;
        });
    }
  }
}());

(function() {
  'use strict';

  notesService.$inject = ['$http', 'config', 'urlService'];
  angular.module('ptCrm')
    .service('notesService', notesService);

  function notesService($http, config, urlService) {

    return {
      getNotes: getNotes,
      updateNote: updateNote,
      deleteNote: deleteNote,
      createNote: createNote
    };

    function getNotes(userId) {
      return $http.get(urlService.interpolate(config.apiBase + '/users/{{id}}/notes', { id: userId }))
        .then(function(response) {
          return response.data;
        }
      );
    }

    function updateNote(userId, note) {
      var url = urlService.interpolate(config.apiBase + '/users/{{id}}/notes/{{noteId}}',
        { id: userId, noteId: note._id }
      );
      var data = { title: note.title, content: note.content };
      return $http.put(url, data)
        .then(function(response) {
          return response.data;
        }
      );
    }

    function deleteNote(userId, noteId) {
      var url = urlService.interpolate(config.apiBase + '/users/{{id}}/notes/{{noteId}}', { id: userId, noteId: noteId });
      return $http.delete(url)
        .then(function(response) {
          return response.data;
        }
      );
    }

    function createNote(userId, note) {
      var url = urlService.interpolate(config.apiBase + '/users/{{id}}/notes', { id: userId });
      var data = { title: note.title, content: note.content };
      return $http.post(url, data)
        .then(function(response) {
          return response.data;
        }
      );
    }
  }
}());

(function() {
  'use strict';

  taskService.$inject = ['$q', 'config', '$http', '$translate'];
  angular.module('ptCrm')
    .service('taskService', taskService);

  function taskService($q, config, $http, $translate) {

    return {
      createTask: createTask,
      getTask: getTask,
      getTasks: getTasks,
      deleteTask: deleteTask,
      editTask: editTask,
      prepareTask: prepareTask,
      isTask: isTask
    };

    function getTask(id) {
      return $http.get(config.apiBase + '/tasks/' + id).then(function(response) {
        return response.data;
      });
    }

    function getTasks(params) {
      return $http.get(config.apiBase + '/tasks', { params: params })
        .then(function(response) {
          return response.data;
        });
    }

    function createTask(task) {
      return $http.post(config.apiBase + '/tasks', task)
        .then(function(response) {
          return response.data;
        });
    }

    function deleteTask(id) {
      return $http.delete(config.apiBase + '/tasks/' + id)
        .then(function(response) {
          return response.data;
        });
    }

    function editTask(task) {
      return $http.put(config.apiBase + '/tasks/' + task._id, _.omit(task, '_id'))
        .then(function(response) {
          return response.data;
        });
    }

    // helper
    function prepareTask(user, task) {

      var from = moment.unix(task.startTime),
        to = moment.unix(task.endTime),
        caption = task.users.length + ' ' + $translate.instant('USERS'),
        // No image placeholder
        img = '//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png',
        userId = null,
        _id = task._id;

      // if start and end times is not in the same day -
      // then this day is fully occupied
      if (from.isSame(to, 'day')) {
        from = from.get('hours') + (from.get('minutes') ? 0.5 : 0);
        to = to.get('hours') + (to.get('minutes') ? 0.5 : 0);
      } else {
        from = 0;
        to = 24;
      }

      // as far as we have only one user
      // we use user info from model not from response
      if (task.users.length === 1) {
        caption = (user.firstName || '') + ' ' + (user.lastName || '');
        //                       No image placeholder
        img = user.pictureUrl || '//images.jhtassets.com/264082bb3a1af70d5499c7d22b0902cb454b6d12/';
        userId = user._id;
      }

      return {
        _id: _id,
        exerciserId: userId,
        timeFrom: from,
        timeTo: to,
        caption: caption,
        title: task.title,
        description: task.description,
        img: img,
        type: 'task'
      };

    }

    function isTask(item) {
      return item.type === 'task';
    }

  }
}());

(function() {
  'use strict';

  printService.$inject = ['$http', 'config', 'urlService', '$window', '$translate'];
  angular.module('ptCrm')
    .service('printService', printService);

  function printService($http, config, urlService, $window, $translate) {
    return {
      printExerciseTemplate: printExerciseTemplate,
      printTrainingSet: printTrainingSet,
      printExercise: printExercise,
      printAssignment: printAssignment
    };

    function printExerciseTemplate(item) {
      var printPopup = $window.open('', '_blank');
      getExerciseTemplatePDF(item).then(function(response) {
        openPdfInNewTab(printPopup, response);
      });
    }

    function printTrainingSet(item) {
      var printPopup = $window.open('', '_blank');
      getTrainingSetPDF(item).then(function(response) {
        openPdfInNewTab(printPopup, response);
      });
    }

    function printExercise(item) {
      var printPopup = $window.open('', '_blank');
      getExercisePDF(item).then(function(response) {
        openPdfInNewTab(printPopup, response);
      });
    }

    function printAssignment(item) {
      var printPopup = $window.open('', '_blank');
      getAssignmentPDF(item).then(function(response) {
        openPdfInNewTab(printPopup, response);
      });
    }

    function getExerciseTemplatePDF(item) {
      return $http.post(
        urlService.interpolate(
          config.apiBase + '/exercise_templates/{{id}}/pdf', { id: item._id }
        )
      );
    }

    function getTrainingSetPDF(item) {
      return $http.post(
        urlService.interpolate(
          config.apiBase + '/training_sets/{{id}}/pdf', { id: item._id }
        )
      );
    }

    function getExercisePDF(item) {
      return $http.post(
        urlService.interpolate(
          config.apiBase + '/exercises/{{id}}/pdf', { id: item._id }
        )
      );
    }

    function getAssignmentPDF(item) {
      return $http.post(
        urlService.interpolate(
          config.apiBase + '/assignments/{{id}}/pdf', { id: item._id }
        )
      );
    }

    function openPdfInNewTab(popup, response) {
      popup.location.href = config.apiBase + '/pdfs/' + response.data.link +
        '?locale=' + $translate.preferredLanguage();
    }
  }
}());

(function() {
  'use strict';

  nutritionService.$inject = ['$http', 'config'];
  angular.module('ptCrm')
    .service('nutritionService', nutritionService);

  function nutritionService($http, config) {
    return {
      getNutritionData: getNutritionData
    };

    function getNutritionData(userId, date) {
      return $http.get(config.apiBase + '/users/' + userId + '/nutrition', { params: { date: date } })
      .then(function(response) {
        return response.data;
      });
    }

  }
}());

(function() {
  'use strict';

  authConfig.$inject = ['$httpProvider'];
  angular.module('ptCrm')
    .config(authConfig);

  function authConfig($httpProvider) {
    $httpProvider.interceptors.push('authInterceptorService');
  }

}());




(function() {
  'use strict';

  loginController.$inject = ['authService', '$state', 'storageService', 'toastr', '$translate', 'profileService', 'USER_HOME_PAGE'];
  angular.module('ptCrm')
    .controller('LoginController', loginController);

  function loginController(authService, $state, storageService, toastr, $translate, profileService, USER_HOME_PAGE) {

    var vm = this;

    vm.user = {};
    vm.login = login;


    function login() {
      authService.login(vm.user).then(function(data) {
        storageService.setToken(data.authToken);
        profileService.authorize().then(function() {
          if ($state.params.next) {
            window.location.href = decodeURIComponent($state.params.next);
          } else {
            return $state.go(USER_HOME_PAGE.URL, _.extend($state.params, USER_HOME_PAGE.PARAMS),
              { reload: false, notify: false })
              .finally(authService.refreshPage);
          }
        });
      }, function(e) {
        console.error('Cannot login:', e); // eslint-disable-line no-console
        if (e.status === 401) {
          toastr.error($translate.instant('ERROR_LOGIN_INCORRECT'));
        } else {
          toastr.error($translate.instant('ERROR_COMMON'));
        }
      });
    }

  }
}());

(function() {

  'use strict';

  dashboardController.$inject = ['$q', '$state', 'exercisersService', 'assignmentsService'];
  angular.module('ptCrm')
    .controller('DashboardController', dashboardController);

  function dashboardController($q, $state, exercisersService, assignmentsService) {

    var vm = this;

    vm.timelineClients = [];
    vm.today = new Date();
    vm.navigateToUserDetails = navigateToUserDetails;
    vm.clients = {};
    vm.onEditAssigment = onEditAssigment;

    getClientGroups();
    getTodayAppointments();

    function getClientGroups() {
      var groups = [
        'interested',
        'in_gym',
        'at_risk'
      ];

      _.each(groups, function(group) {
        _getExercisersDataByFilter(group).then(function(data) {
          vm.clients[group] = filterExtraClients(data, group);
        });
      });

    }

    function navigateToUserDetails(user) {
      if (user && user.exerciserId) {
        $state.go('app.users.details', { userId: user.exerciserId });
      }
    }

    function getTodayAppointments() {
      var now = moment();

      assignmentsService.getAssignments({
        startDate: now.startOf('day').unix(),
        endDate: now.endOf('day').unix(),
        filter: 'appointed'
      }).then(function(response) {
        vm.timelineClients = assignmentsService.getAppointedAssignments(response.data);
      });
    }

    function _getExercisersDataByFilter(filter) {
      return exercisersService.getExercisers({ filter: filter }).then(function(res) {
        return res.data;
      });
    }

    function onEditAssigment(assignment) {
      if (assignment._id) {
        $state.go('app.assignment', { id: assignment._id });
      }
    }

    function filterExtraClients(clients, type) {
      switch (type) {
      case 'interested':

          // please see https://goo.gl/Q8qXC2
        return _.filter(clients, function(client) {
          return !client.clientProfile.active || _.isEmpty(client.clientProfile.trainers);
        });

      case 'in_gym':

        return _.filter(clients, function(client) {
          return client.clientProfile.interested;
        });

      default :
        return clients;
      }

    }

  }

}());

(function() {
  'use strict';

  CalendarController.$inject = ['$scope', '$state', 'assignmentsService', 'exercisersService', 'taskService', 'profileService', 'userService'];
  angular.module('ptCrm').controller('CalendarController', CalendarController);

  function CalendarController($scope, $state,
    assignmentsService, exercisersService, taskService, profileService, userService) {

    var vm = this;

    vm.monthOffset = 6;
    vm.isLoading = true;

    vm.selectedDate = $state.params.date ? moment.unix($state.params.date) : moment();
    vm.selectedUser = { _id: $state.params.userId || profileService.user._id };

    vm.users = [];

    vm.showTimeline = false;
    $scope.$on('calendar-body:day:init', chooseDateIfUserIsReady);
    vm.timelineDisplayDate = null;

    // public methods
    vm.selectMonth = selectMonth;
    vm.chooseDate = chooseDate;
    vm.addEvent = addEvent;
    vm.toggleTimelineVeiw = toggleTimelineVeiw;
    vm.selectSiblingDay = selectSiblingDay;
    vm.navigateToUserDetails = navigateToUserDetails;
    vm.onEditAssigment = onEditAssigment;
    vm.onEditTask = onEditTask;
    vm.changeUser = changeUser;
    vm.getFullUserName = userService.getFullUserName;

    _calculateRange();
    var userReadyPromise = exercisersService.getExercisers().then(function(response) {
      vm.users = _.chain([profileService.user])
        .unionBy(response.data, '_id')
        .map(function(user) {
          return _.assign(user, { fullName: userService.getFullUserName(user) });
        })
        .value();

      vm.selectedUser = _.find(vm.users, { _id: vm.selectedUser._id });
      vm.searchStr = vm.selectedUser.fullName;
    });

    function selectSiblingDay(dayDiff) {
      if (vm.selectedDate && _.isNumber(dayDiff)) {
        var newDay = moment(vm.selectedDate).add(dayDiff, 'day'),
          isSameMonth = newDay.isSame(vm.selectedDate, 'month');

        _updateSelectedDate(newDay);

        if (!isSameMonth) {
          _calculateRange();
        }

        $scope.$broadcast('calendar:day:changed', newDay);
      }
    }

    function selectMonth(monthNumber, year) {
      var newDate = moment(vm.selectedDate).set('month', monthNumber).set('year', year);
      _updateSelectedDate(newDate);
      toggleTimelineVeiw(false);
      _updateTimelineClients([]);
      _calculateRange();

      $scope.$broadcast('calendar:month:changed', monthNumber, year);
    }

    function toggleTimelineVeiw(force) {
      vm.showTimeline = _.isUndefined(force) ? !vm.showTimeline : !!force;
    }

    function _updateSelectedDate(date) {
      vm.selectedDate = date;
      vm.timelineDisplayDate = date.toDate();
    }

    function chooseDateIfUserIsReady() {

      // here all requests inside calendar are finished
      var args = arguments;
      return userReadyPromise.then(function() {
        chooseDate.apply(null, args);
      }).finally(function() {
        vm.isLoading = false;
      });
    }

    function chooseDate(clickEvent, day) {
      var assignments = _.chain(day.events)
        .filter({ type: 'assignment' })
        .map('assignment')
        .map(assignmentsService.getAppointedAssignment.bind(null, vm.selectedUser))
        .value();

      var tasks = _.chain(day.events)
        .filter({ type: 'task' })
        .map('assignment')
        .map(taskService.prepareTask.bind(null, vm.selectedUser))
        .value();

      var events = assignments.concat(tasks);
      _updateSelectedDate(day.moment);
      _updateTimelineClients(events);

      // show timeline only after click on calendar day
      if (clickEvent) {
        toggleTimelineVeiw(true);
      }
    }

    function addEvent(day) {
      var destination = _.includes(vm.selectedUser.roles, 'client') ? 'app.assignment' : 'app.task';
      return $state.go(destination, {
        startDate: day.moment.startOf('day').unix(),
        endDate: day.moment.clone().endOf('day').unix(),
        userId: vm.selectedUser._id,
        isMe: vm.selectedUser._id === 'me' || vm.selectedUser._id === profileService.user._id
      });
    }

    function _updateTimelineClients(list) {
      list = _.isArray(list) ? list : [];
      vm.timelineClients = list;
    }

    function _calculateRange() {
      var range,
        selectedDate = moment(vm.selectedDate)
          .set('date', 1)
          .subtract(vm.monthOffset, 'months');

      range = [{
        number: selectedDate.month(),
        displayText: selectedDate.format('MM'),
        year: selectedDate.format('YYYY')
      }];

      vm.fromYear = selectedDate.year();
      for (var month = 0; month < 11; month++) {
        selectedDate.add(1, 'months');
        range.push({
          number: selectedDate.month(),
          displayText: selectedDate.format('MM'),
          year: selectedDate.format('YYYY')
        });
      }
      vm.toYear = selectedDate.year();

      vm.monthRange = range;
    }

    function navigateToUserDetails(user) {
      if (user && user.exerciserId) {
        $state.go('app.users.details', { userId: user.exerciserId });
      }
    }

    function onEditAssigment(assignment) {
      if (assignment._id) {
        $state.go('app.assignment', {
          id: assignment._id,
          userId: assignment.exerciserId
        });
      }
    }

    function onEditTask(task) {
      if (task._id) {
        $state.go('app.task', {
          id: task._id,
          userId: task.exerciserId,
          isMe: task.exerciserId === 'me' || task.exerciserId === profileService.user._id
        });
      }
    }

    function changeUser(user) {
      $state.go('app.calendar', { userId: user._id, date: moment(vm.timelineDisplayDate).unix() });
    }

  }


}());

(function() {
  'use strict';

  userController.$inject = ['$uibModal', '$translate', '$state', 'Upload', 'popup', 'CertificationsList', 'config', 'assignmentsService', 'exercisersService', 'workoutsService', 'userPermissionsService', 'formatUserService', 'profileService', 'userService', 'printService', 'authService'];
  angular.module('ptCrm')
    .controller('UserController', userController);

  function userController($uibModal, $translate, $state, Upload, popup, CertificationsList, config,
    assignmentsService, exercisersService, workoutsService, userPermissionsService, formatUserService, profileService,
    userService, printService, authService) {
    var vm = this,
      isMe = $state.params.userId === 'me' || $state.params.userId === profileService.user._id;

    vm.userId = $state.params.userId;
    vm.user = {};
    vm.assignments = assignmentsService.getClientAssignmentsPaginateList(vm.userId);
    vm.certifications = new CertificationsList(vm.userId);
    vm.forms = {};
    vm.permissions = userPermissionsService.getUserStaticPermissions(isMe);
    vm.initialDataIsLoaded = false;
    vm.languages = config.availableLanguages.map(function(langCode) { return langCode.toUpperCase(); });

    _.extend(vm, {
      loadAssignments: loadAssignments,
      hasDescription: hasDescription,
      uploadImg: uploadImg,
      save: saveData,
      savePersonalInfo: savePersonalInfo,
      saveWorkInfo: saveWorkInfo,
      updateTrainerClients: updateTrainerClients,
      updateClientFlags: updateClientFlags,
      reset: resetClientData,
      removeTrainer: removeTrainer,
      removeClient: removeClient,
      showTrainerPopup: showTrainerPopup,
      showClientPopup: showClientPopup,
      showDeleteAcc: showDeleteAcc,
      resetPassword: resetPassword,
      changePassword: changePassword,
      showCompletionState: showCompletionState,
      onEditAssigment: onEditAssigment,
      printExercise: printExercise,
      printAssignment: printAssignment,
      updateAvatar: updateAvatar
    });


    init();

    function init() {
      exercisersService.getExerciser($state.params.userId)
        .then(_assignResponseClient)
        .then(saveBackup.bind(this, 'all'))
        .finally(function() {
          vm.initialDataIsLoaded = true;
        });
    }

    function loadAssignments() {
      vm.assignments.load({ responseExtract: extendAssignmentsWithWorkouts });
    }

    function _assignResponseClient(user) {
      vm.user = formatUserService.destructureUser(user);
      vm.permissions = _.extend(vm.permissions,
        userPermissionsService.getUserDynamicPermissions(isMe, !!vm.user.roles.client));
      return vm.user;
    }

    function extendAssignmentsWithWorkouts(assignments) {
      if (_.isEmpty(assignments)) {
        return assignments;
      }

      var params = {
        startDate: _.get(_.minBy(assignments, 'startDate'), 'startDate'),
        endDate: _.get(_.maxBy(assignments, 'endDate'), 'endDate'),
        exerciserId: $state.params.userId
      };

      return workoutsService.getWorkouts(params)
        .then(function(workouts) {
          return _.map(assignments, function(assignment) {
            var matchedWorkouts = _filterWorkoutsInAssignmentRange(workouts.data, assignment);
            return _.extend({}, assignment, _prepareAssignments(assignment, matchedWorkouts));
          });
        });
    }

    function _filterWorkoutsInAssignmentRange(workouts, assignment) {
      return _.filter(workouts, function(workout) {
        return workout.completedDate >= assignment.startDate && workout.completedDate <= assignment.endDate;
      });
    }

    function _prepareAssignments(assignment, workouts) {
      // TODO: reafactor
      var result = {
          showDetails: false,
          workouts: parseWorkouts(workouts)
        },
        ds = moment.unix(assignment.startDate).utc(),
        de = moment.unix(assignment.endDate).utc();

      result.date = ds.isSame(de, 'day') ? ds.format('MMMM D, YYYY') : ds.format('MMMM D, YYYY') + ' - ' +
      de.format('MMMM D, YYYY');
      result.count = assignment.exercises.length;
      result.calories = workouts.reduce(function(sum, next) {
        return sum + (next.completedProfile.calories || 0);
      }, 0) + assignment.exercises.reduce(function(rez, ex) {
        rez += ex.completedProfile ? ex.completedProfile.calories : 0;
        return rez;
      }, 0) || '';
      result.duration = workouts.reduce(function(sum, next) {
        return sum + (next.completedProfile.duration || 0);
      }, 0) + assignment.exercises.reduce(function(rez, ex) {
        rez += ex.completedProfile ? ex.completedProfile.duration : 0;
        return rez;
      }, 0);

      result.duration = (result.duration || 0) + ' min';

      result.exercises = assignment.exercises.map(function(ex) {
        return angular.extend(ex, exercisersService.parseExercise(ex));
      });

      result.isPassed = moment.unix(assignment.startDate).isBefore(moment(), 'day');

      return result;
    }

    function parseWorkouts(workouts) {
      return workouts.map(function(workout) {
        var cp = workout.completedProfile;

        workout.metrics = {};
        Object.keys(cp).forEach(function(e) {
          if (e === 'duration') {
            workout.metrics[e] = (cp[e] / 60).toFixed(0) + ' min';
          } else if (e === 'distance' && (+cp[e]).toFixed(2) > 0) {
            workout.metrics[e] = (+cp[e]).toFixed(2) + ' ' + cp.distanceUnit;
          } else if (typeof cp[e] === 'number') {
            workout.metrics[e] = cp[e];
          }
        });
        return workout;
      });
    }

    function hasDescription(ex) {
      return ex.description && (ex.description.length > 0);
    }


    //  =============== USER DETAILS SECTION ==============

    function removeTrainer(trainer) {
      vm.user.trainers = _.without(vm.user.trainers, trainer);
      vm.forms.trainers.$setDirty();
    }

    function removeClient(client) {
      vm.user.clients = _.without(vm.user.clients, client);
      vm.forms.clients.$setDirty();
    }

    function saveBackup(subj, data) {
      if (subj === 'all') {
        vm.backup = angular.copy(data);
      } else {
        vm.backup[subj] = angular.copy(data);
      }
    }

    // =========== SAVE USER DATA BLOCK ================

    function saveData(subj, data, role) {
      role = role || '';
      var updatedUser = formatUserService.restructureUser(subj, data, role);

      userService.updateUser(updatedUser, vm.userId).then(function() {
        if (subj === 'settings') {
          _updateSettings(updatedUser);
        }
      })
        .then(saveBackup.bind(this, subj, data));
      vm.forms[subj + role].$setPristine();
    }

    function savePersonalInfo(subj, data, role) {
      if (!isValidPersonalInfo()) {
        popup.alert({
          title: $translate.instant('FORM_VALIDATION_ALERT_MSG')
        });
      } else {
        saveData(subj, data, role);
      }
    }

    function isValidPersonalInfo() {
      return !(vm.forms.personalInfoClient.$error.pattern || vm.forms.personalInfoClient.$error.required);
    }

    //  here is separated methods because we have serparated endpoints
    function saveWorkInfo(workInfo) {
      var formattedWorkInfo = formatUserService.restructureUser('workInfo', workInfo).workInfo;
      userService.updateWorkInfo(formattedWorkInfo, vm.userId)
      .then(saveBackup.bind(this, 'workInfo', workInfo));
      vm.forms.workInfo.$setPristine();
    }

    function updateTrainerClients(clients) {
      var clientsIds = _.map(clients, '_id');
      userService.updateTrainerClients(clientsIds, vm.userId)
      .then(saveBackup.bind(this, 'clients', clients));
      vm.forms.clients.$setPristine();
    }

    function updateClientFlags(value, field) {
      switch (field) {
      default:
        break;
      case 'interested':
        userService.updateUser({
          clientProfile: {
            interested: value
          }
        }, vm.userId);
        break;
      case 'active':
        userService.updateUser({
          clientProfile: {
            active: value
          }
        }, vm.userId);
        break;
      }
    }

    function resetClientData(subj, role) {
      role = role || '';
      vm.user[subj] = angular.copy(vm.backup[subj]);
      vm.forms[subj + role].$setPristine();
    }

    // ====================== POPUPS SECTION =================

    // ============= TRAINER POPUP  ==========
    function showTrainerPopup() {
      var handler = function(trainers) {
        // selected from popup
        vm.user.trainers = vm.user.trainers.concat(trainers);
        vm.forms.trainers.$setDirty();
      };
      var errorHandler = function(reason) {
        if (reason === 'ALL_USERS_SELECTED') {
          popup.alert({
            title: $translate.instant(reason)
          });
        }
      };

      return showAddUserPopup(vm.user.trainers, 'trainer').result.then(handler, errorHandler);
    }

    // ============= CLIENT POPUP  ==========
    function showClientPopup() {
      var handler = function(clients) {
        vm.user.clients = vm.user.clients.concat(clients);
        vm.forms.clients.$setDirty();
      };
      var errorHandler = function(reason) {
        if (reason === 'ALL_USERS_SELECTED') {
          popup.alert({
            title: $translate.instant(reason)
          });
        }
      };

      return showAddUserPopup(vm.user.clients, 'client').result.then(handler, errorHandler);
    }

    function showAddUserPopup(chosenUsers, userType) {
      return $uibModal.open({
        windowClass: 'modal--trainer user-details__trainer-popup',
        controller: 'userModalController',
        controllerAs: 'usersCtrl',
        templateUrl: '/app/user/tabs/userDetails/userModal/userModal.html',
        bindToController: true,
        resolve: {
          chosenUsers: function() {
            return chosenUsers;
          },
          userType: function() {
            return userType;
          }
        }
      });
    }

    // ============ DELETE ACCOUNT POPUP ===========
    function showDeleteAcc(user) {
      return popup.confirm({
        title: $translate.instant('DELETE_THIS_ACCOUNT?'),
        description: $translate.instant('DELETE_ACCOUNT_MESSAGE'),
        templateUrl: '/app/user/tabs/userDetails/deleteAccount/deleteAccount.html',
        scope: {
          user: user
        }
      }).then(function() {
        userService.deleteAccount(user._id)
          .then(function() {
            popup.alert({
              title: $translate.instant('ACCOUNT_DELETED')
            });
          });
      });
    }

    function resetPassword() {
      userService.resetPassword(vm.userId).then(function() {
        return popup.alert({
          title: $translate.instant('PASSWORD_SUCCESSFULLY_CHANGED_AND_EMAIL_WAS_SENT')
        });
      });
    }

    function changePassword() {
      return $uibModal.open({
        // windowClass: 'modal--workout-accomplishment-status',
        templateUrl: '/app/user/tabs/userDetails/changePassword/change-password-modal.html',
        resolve: {
          userId: function() {
            return vm.userId;
          }
        },
        controller: 'changePasswordModalController',
        controllerAs: 'changePasswordController',
        bindToController: true
      });
    }

    function uploadImg() {
    }

    function onEditAssigment(assignment) {
      if (assignment.parentAssignmentId) {
        $state.go('app.assignment', { id: assignment.parentAssignmentId });
      }
    }

    // ============ SHOW COMPLETION STATE POPUP ===========
    function showCompletionState(assignment, exercise) {
      return $uibModal.open({
        windowClass: 'modal--workout-accomplishment-status',
        templateUrl: '/app/user/tabs/workouts/workout-status-modal.html',
        resolve: {
          selectedExercise: function() {
            return exercise;
          },
          selectedAssignment: function() {
            return assignment;
          },
          assignments: function() {
            return _.filter(vm.assignments.items, 'isPassed');
          }
        },
        controller: 'workoutStatusModalController',
        controllerAs: 'workoutStatusController',
        bindToController: true
      });
    }

    // ============ PRINT ===========
    function printExercise(exercise, event) {
      event.stopPropagation();
      printService.printExercise(exercise);
    }

    function printAssignment(exercise, event) {
      event.stopPropagation();
      printService.printAssignment(exercise);
    }

    // ============ UPDATE AVATAR ===========
    function updateAvatar(file) {
      if (file) {
        var apiPrefix = config.apiBase + '/users/' + vm.user._id + '/avatars';
        return Upload.upload({
          url: apiPrefix,
          data: {
            picture: file
          }
        }).then(function(response) {
          vm.user.pictureUrl = response.data;

          if (isMe) {
            profileService.user.pictureUrl = response.data;
          }
        });
      }
    }


    function _updateSettings(updatedUser) {
      var newLang = _.get(updatedUser, 'settings.language');
      var oldLang = _.get(vm.backup, 'settings.language');

      var newUnits = _.get(updatedUser, 'settings.measurementUnit');
      var oldUnits = _.get(vm.backup, 'settings.measurementUnit');

      // Have to reload page due to one-time bindings
      if (isMe && ((newLang && newLang !== oldLang) || (newUnits && newUnits !== oldUnits))) {
        authService.refreshPage();
      }
    }
  }

}());

(function() {

  'use strict';

  NutritionController.$inject = ['$state', '$translate', 'nutritionService'];
  angular.module('ptCrm')
    .controller('NutritionController', NutritionController);

  function NutritionController($state, $translate, nutritionService) {

    var vm = this,
      _breakdownItems = _getBreakdownItems();

    vm.userId = $state.params.userId;
    vm.data = null;
    vm.isLoading = false;
    vm.date = _getInitialDate();
    vm.goRight = goRight;
    vm.goLeft = goLeft;

    updateData();

    function updateData() {
      vm.isLoading = true;
      return nutritionService.getNutritionData(vm.userId, vm.date).then(function(res) {
        vm.data = _extendNutritionData(res);
      }, function(err) {
        if (err) {
          vm.data = null;
        }
      }).finally(function() {
        vm.isLoading = false;
      });
    }

    function goRight() {
      vm.date = moment.unix(vm.date).add(1, 'day').unix();
      updateData();
    }

    function goLeft() {
      vm.date = moment.unix(vm.date).subtract(1, 'day').unix();
      updateData();
    }

    function _extendNutritionData(data) {
      if (_.isObject(data)) {

        data.breakdown = _.map(_breakdownItems, function(breakdownItem) {
          return _.extend({ value: +data.nutrition[breakdownItem.name] }, breakdownItem);
        });

        data.remaining = data.goal - data.food + data.exercise;
      }

      return data;
    }


    function _getInitialDate() {
      return moment().unix();
    }

    function _getBreakdownItems() {
      return [{
        name: 'carbs',
        title: $translate.instant('CARBS'),
        color: '#83d700'
      }, {
        name: 'fats',
        title: $translate.instant('FAT'),
        color: '#ff8300'
      }, {
        name: 'proteins',
        title: $translate.instant('PROTEIN'),
        color: '#ffd200'
      }];
    }
  }

}());

(function() {

  'use strict';

  UserPermissionsController.$inject = ['$state', '$translate', '$q', 'popup', 'permissionsService', 'permissionGroupsService', 'authService', 'profileService'];
  angular.module('ptCrm')
    .controller('UserPermissionsController', UserPermissionsController);

  function UserPermissionsController($state, $translate, $q,
    popup, permissionsService, permissionGroupsService, authService, profileService) {

    var vm = this,
      backupUserPermissions, backupDisabledOptions;
    vm.userId = $state.params.userId;

    vm.disabledOptions = {};
    vm.selectedPermissionGroup = {};
    vm.permissionsGroups = [];
    vm.userPermissions = {};
    vm.forms = {};

    vm.showGroupsPopup = showGroupsPopup;
    vm.savePermissions = savePermissions;
    vm.resetPermissions = resetPermissions;
    vm.onGroupClick = onGroupClick;
    vm.hasUserTheGroup = hasUserTheGroup;

    loadPermissions();


    function loadPermissions() {
      $q.all([permissionGroupsService.getGroups(), permissionsService.getUserPermissions(vm.userId)])
      .then(setInitState);
    }

    function savePermissions() {
      permissionsService.saveUserPermissions(vm.userId, vm.userPermissions).then(function() {
        var isMe = vm.userId === 'me' || vm.userId === profileService.user._id;
        if (isMe) {
          authService.refreshPage();
        } else {
          $state.reload();
        }
      });
    }

    function resetPermissions() {
      vm.userPermissions = angular.copy(backupUserPermissions);
      vm.selectedPermissionGroup = {};
      vm.disabledOptions = angular.copy(backupDisabledOptions);
      vm.forms.permissions.$setPristine();
    }

    function setInitState(resps) {
      vm.permissionsGroups = resps[0].data;
      vm.userPermissions = resps[1];

      vm.userPermissions.groups = _.map(vm.userPermissions.groups, function(id) {
        return _.find(vm.permissionsGroups, { _id: id });
      });
      _.each(vm.userPermissions.groups, function(group) {
        _syncGroupWithUserPermissions(group);
      });
      backupUserPermissions = angular.copy(vm.userPermissions);
      backupDisabledOptions = angular.copy(vm.disabledOptions);
    }

    function onGroupClick(selectedGroup) {

      if (hasUserTheGroup(selectedGroup)) {
        _revokeSelectedGroupOptions(selectedGroup);
        vm.userPermissions.groups = _.filter(vm.userPermissions.groups, function(group) {
          return group._id !== selectedGroup._id;
        });
      } else {
        vm.userPermissions.groups.push(selectedGroup);
      }

      _.each(vm.userPermissions.groups, function(group) {
        _syncGroupWithUserPermissions(group);
      });

      vm.forms.permissions.$setDirty();
    }

    function hasUserTheGroup(group) {
      return !!_.find(vm.userPermissions.groups, { _id: group._id });
    }

    function _syncGroupWithUserPermissions(group) {
      _.each(vm.userPermissions.subjects, function(userSubject) {
        var selectedSubject = _.find(group.subjects, { name: userSubject.name });

        if (!selectedSubject) {
          return;
        }
        _applySelectedGroupOptions(userSubject, selectedSubject, group);
      });
    }

    function showGroupsPopup() {
      return popup.show({
        title: $translate.instant('PERMISSIONS_GROUPS'),
        templateUrl: '/app/user/tabs/permissions/groups-modal.html',
        cssClass: 'permissions-groups-pop-up modal--select-from-list',
        showCancel: false,
        showOk: false,
        scope: {
          permissionsGroups: vm.permissionsGroups,
          hasUserTheGroup: hasUserTheGroup,
          onGroupClick: onGroupClick
        }
      });
    }

    function _applySelectedGroupOptions(userSubject, groupSubject) {
      _.each(groupSubject.options, function(val, key) {
        if (val) {
          userSubject.options[key] = val;
          _toggleDisableOptionsAccordinglyToGroup(groupSubject, true);
        }
      });
    }

    function _revokeSelectedGroupOptions(group) {
      var groupSubjsWithTrueOption = _.filter(group.subjects, function(subj) {
        return _.some(subj.options);
      });

      _.each(groupSubjsWithTrueOption, function(groupSubj) {
        var userSubject = _.find(vm.userPermissions.subjects, { name: groupSubj.name });
        _.each(groupSubj.options, function(val, key) {
          if (val) {
            userSubject.options[key] = false;
            _toggleDisableOptionsAccordinglyToGroup(groupSubj, false);
          }
        });
      });
    }

    function _toggleDisableOptionsAccordinglyToGroup(subject, mode) {
      _.each(subject.options, function(val, key) {
        if (val) {
          vm.disabledOptions[subject.name] =
            vm.disabledOptions[subject.name] || {};
          vm.disabledOptions[subject.name][key] = mode;
        }
      });
    }
  }

}());

(function() {

  'use strict';

  NotesController.$inject = ['$state', 'notesService'];
  angular.module('ptCrm')
    .controller('NotesController', NotesController);

  function NotesController($state, notesService) {

    var vm = this;

    vm.userId = $state.params.userId;
    vm.forms = {};
    vm.notes = [];

    vm.save = save;
    vm.edit = edit;
    vm.add = add;
    vm.remove = remove;
    vm.reset = reset;
    vm.applyNoteEdit = applyNoteEdit;
    vm.cancelNoteEdit = cancelNoteEdit;
    vm.onTitleChange = onTitleChange;

    loadNotes();

    function loadNotes() {
      notesService.getNotes(vm.userId).then(_init);
    }

    function remove(note) {
      note.isDeleted = true;
      vm.forms.notes.$setDirty();
    }

    function save() {
      _.each(vm.notes, function(note) {

        if (note.isDeleted) {
          if (!note._isNew) {
            notesService.deleteNote(vm.userId, note._id);
          }
        } else if (note._isNew) {
          notesService.createNote(vm.userId, note).then(function(data) {
            _updateNoteId(note, data);
          });
          delete note._isNew;
        } else if ((vm.forms[note._id || note._virtualId].$dirty)) {
          notesService.updateNote(vm.userId, note);
        }

        vm.forms[note._id || note._virtualId].$setPristine();

      });
      vm.forms.notes.$setPristine();
      vm.backup = angular.copy(vm.notes);
    }

    function add() {
      var note = angular.copy(vm.blank);
      note._isNew = true;
      note.isEdited = true;
      note.isExpanded = true;
      note._virtualId = _getVirtualId();
      note.date = moment().unix();
      note.formattedDate = moment.unix(note.date).format('DD/MM/YYYY');
      vm.notes.push(note);
      vm.forms.notes.$setDirty();
    }

    function reset() {
      vm.notes = angular.copy(vm.backup);
      vm.forms.notes.$setPristine();
    }

    function edit(note) {
      note.isEdited = true;
    }

    function applyNoteEdit(note) {
      note.isEdited = false;
      note.backup = note.content;
      vm.forms.notes.$setDirty();
    }

    function cancelNoteEdit(note) {
      note.isEdited = false;
      note.content = note.backup;
    }

    function onTitleChange() {
      vm.forms.notes.$setDirty();
    }

    function _init(data) {
      vm.notes = data;
      _.each(vm.notes, function(note) {
        note.isEdited = false;
        note.backup = note.content;
        note.formattedDate = moment.unix(note.date).format('DD/MM/YYYY');
      });
      vm.backup = angular.copy(vm.notes);
      vm.blank = _createBlank();
    }

    function _createBlank() {
      return {
        userId: vm.userId,
        title: 'New note',
        content: ''
      };
    }

    function _getVirtualId() {
      return _.uniqueId('virtual_');
    }

    function _updateNoteId(note, data) {
      note._id = data._id;

      delete note._virtualId;
      vm.backup = angular.copy(vm.notes);
    }
  }
}());

(function() {

  'use strict';

  userModalController.$inject = ['exercisersService', '$uibModalInstance'];
  angular.module('ptCrm')
    .controller('userModalController', userModalController);

  function userModalController(exercisersService, $uibModalInstance) {

    var vm = this;
    vm.modal = {};
    vm.user.modalType = vm.$resolve.userType;

    vm.usersList = exercisersService.getPaginateList(
      {
        role: vm.$resolve.userType
      },
      function(users) {
        return filterSelectedUsers(users, vm.$resolve.chosenUsers);
      }
    );

    vm.loadUsers = loadUsers;
    vm.searcUsersByStr = filterByName;
    vm.searchStr = '';
    vm.isAllSelected = false;
    vm.selectAll = selectAll;
    vm.addUsers = addUsers;
    vm.resetTrainers = resetTrainers;
    vm.closeModal = closeModal.bind(this, 'cancelled');

    loadUsers();

    function loadUsers() {
      return vm.usersList.load().then(function() {
        if (_.isEmpty(vm.usersList.items)) {
          closeModal('ALL_USERS_SELECTED');
        }
      });
    }

    function filterSelectedUsers(users, selectedUsers) {
      return _.differenceBy(users, selectedUsers, '_id');
    }

    function filterByName() {
      vm.usersList
        .extendDefaultParams({ search: vm.searchStr })
        .load({ update: true });
    }

    function selectAll(selected, usersList) {
      usersList = _.map(usersList, function(el) {
        return _.assign(el, { selected: selected });
      });
    }

    function addUsers(users) {
      $uibModalInstance.close(_.filter(users, {
        selected: true
      }));
    }

    function resetTrainers() {
      vm.usersList.items = _.map(vm.usersList.items, function(el) {
        return _.assign(el, { selected: false });
      });
      vm.searchStr = '';
      vm.isAllSelected = false;
      vm.trainerModalForm.$setPristine();
    }

    function closeModal(reason) {
      $uibModalInstance.dismiss(reason);
    }

  }

}());

(function() {

  'use strict';

  changePasswordModalController.$inject = ['$uibModalInstance', 'userId', 'userService'];
  angular.module('ptCrm')
    .controller('changePasswordModalController', changePasswordModalController);

  function changePasswordModalController($uibModalInstance, userId, userService) {

    var vm = this;

    _init();

    function _init() {
      vm.cancel = cancel;
      vm.ok = ok;
    }

    function ok() {
      vm.loading = true;
      vm.error = null;

      userService.changePassword(userId, vm.currentPassword, vm.newPassword)
      .then(function() {
        cancel();
      })
      .catch(function(error) {
        vm.error = error;
      })
      .finally(function() {
        vm.loading = true;
      });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
}());

var compareTo = function() {
  return {
    require: 'ngModel',
    scope: {
      otherModelValue: '=compareTo'
    },
    link: function(scope, element, attributes, ngModel) {

      ngModel.$validators.compareTo = function(modelValue) {
        return modelValue === scope.otherModelValue;
      };

      scope.$watch('otherModelValue', function() {
        ngModel.$validate();
      });
    }
  };
};

angular.module('ptCrm').directive('compareTo', compareTo);

(function() {

  'use strict';

  workoutStatusModalController.$inject = ['$uibModalInstance'];
  angular.module('ptCrm')
    .controller('workoutStatusModalController', workoutStatusModalController);

  function workoutStatusModalController($uibModalInstance) {

    var vm = this;
    vm.modal = {};
    vm.selectAssignment = selectAssignment;
    vm.selectExercise = selectExercise;

    _init();

    function _init() {
      vm.assignments = vm.$resolve.assignments;
      vm.closeModal = closeModal;
      vm.selectedAssignment = vm.$resolve.selectedAssignment;
      vm.selectedAssignmentIndex = _.findIndex(vm.assignments, { _id: vm.selectedAssignment._id });
      vm.selectedExercise = vm.$resolve.selectedExercise;
      vm.selectedExerciseIndex = _.findIndex(vm.selectedAssignment.exercises, { _id: vm.selectedExercise._id });
    }

    function selectAssignment(direction) {
      direction = direction || 0;
      vm.selectedAssignmentIndex += direction;
      if (vm.selectedAssignmentIndex >= vm.assignments.length) {
        vm.selectedAssignmentIndex = 0;
      }
      if (vm.selectedAssignmentIndex < 0) {
        vm.selectedAssignmentIndex = vm.assignments.length - 1;
      }
      vm.selectedAssignment = vm.assignments[vm.selectedAssignmentIndex];
      vm.selectedExerciseIndex = 0;
      vm.selectedExercise = vm.selectedAssignment.exercises[vm.selectedExerciseIndex];
    }

    function selectExercise(direction) {
      direction = direction || 0;
      vm.selectedExerciseIndex += direction;
      if (vm.selectedExerciseIndex >= vm.selectedAssignment.exercises.length) {
        vm.selectedExerciseIndex = 0;
      }
      if (vm.selectedExerciseIndex < 0) {
        vm.selectedExerciseIndex = vm.selectedAssignment.exercises.length - 1;
      }
      vm.selectedExercise = vm.selectedAssignment.exercises[vm.selectedExerciseIndex];
    }

    function closeModal() {
      $uibModalInstance.dismiss();
    }
  }
}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('calendarBody', ['assignmentsService', 'taskService', '$q', function(assignmentsService, taskService, $q) {
      return {
        restrict: 'E',
        templateUrl: '/app/components/calendar/calendar-body.html',
        scope: {
          monthOffset: '=?',
          options: '=?',
          user: '=?',
          onDaySelected: '&',
          addEvent: '&'
        },
        link: calendarBodyLink
      };


      function calendarBodyLink($scope) {
        var body = $scope.body = {};

        $scope.options = $scope.options || {};

        // date for updating calendar view
        body.selectedDate = null;

        // day which will be highlighted as selected
        body.selectedMoment = null;

        _initDefaults();

        _calculateInitialDate();

        // public
        body.onDaySelected = onDaySelected;
        body.addEvent = addEvent;
        body.getSelectedMonthName = getSelectedMonthName;
        body.getSelectedMonthNumber = getSelectedMonthNumber;

        // remove becuse it because options.initialDate is not working
        // $scope.$watch('options.initialDate', _calculateInitialDate);
        $scope.$on('calendar:month:changed', _onMonthChanged);
        $scope.$on('calendar:day:changed', _onDayChanged);


        // //////////////////////////////////////////////////////////
        function onDaySelected(day, event) {
          if (!day) {
            console.warn('[Calendar] No  data'); // eslint-disable-line no-console
            return;
          }

          body.selectedDate = day.moment;
          _selectCalendarDay(day);

          if (angular.isFunction($scope.onDaySelected)) {
            $scope.onDaySelected({
              day: day,
              event: event
            });
          }
        }

        function addEvent(day) {
          if (!day) {
            return;
          }

          if (angular.isFunction($scope.addEvent)) {
            $scope.addEvent({
              day: day
            });
          }
        }


        function _selectCalendarDay(day) {
          var alreadySelectedDay = _findCalendarDay({ selected: true });
          if (alreadySelectedDay) {
            alreadySelectedDay.selected = false;
          }

          day.selected = true;
          _updateSelectedMoment(day.moment);
        }

        function _onDayChanged(e, day) {
          if ($scope.monthOffset) {
            return false;
          }

          var updateMonth = $q.when(),
            isSameMonth = day.isSame(body.selectedDate, 'month');

          if (!isSameMonth) {
            body.selectedDate = day;
            updateMonth = _calculateWeeks();
          }

          updateMonth.then(function() {
            var calendarDay = _findCalendarDay(function(weekDay) {
              return day.isSame(weekDay.moment, 'day');
            });

            onDaySelected(calendarDay);
          });
        }

        function _updateSelectedMoment(dayMoment) {
          body.selectedMoment = moment(dayMoment);
        }

        function _findCalendarDay(predicateFn) {
          return _.chain(body.weeks)
            .flatten()
            .filter()
            .find(predicateFn)
            .value();
        }

        function _findSelectedCalendarMoment() {
          return _findCalendarDay(function(weekDay) {
            return moment(body.selectedMoment).isSame(weekDay.moment, 'day');
          });
        }

        function getSelectedMonthName() {
          return body.selectedDate.format('MMMM');
        }

        function getSelectedMonthNumber() {
          return body.selectedDate.format('MM');
        }

        function _initDefaults() {
          body.weekdays = moment.weekdaysShort();
        }

        function _calculateWeeks(isInit) {
          var day, dayNumber, dateMoment, daysInCurrentMonth, week,
            now = moment(),
            selectedYear = body.selectedDate.year(),
            selectedMonth = body.selectedDate.month();

          body.weeks = [];

          daysInCurrentMonth = body.selectedDate.daysInMonth();

          for (day = 1; day <= daysInCurrentMonth; day++) {
            dateMoment = moment().set({ year: selectedYear, month: selectedMonth, date: day });
            dayNumber = dateMoment.day();

            if (!week) {
              // 7days of week
              week = [null, null, null, null, null, null, null];
            }
            week[dayNumber] = {
              day: day,
              moment: dateMoment,
              current: now.isSame(dateMoment, 'day'),
              isFuture: dateMoment.isAfter(now, 'day'),
              selected: body.selectedDate.isSame(dateMoment, 'day')
            };


            if (dayNumber === 6 || day === daysInCurrentMonth) {
              body.weeks.push(week);
              week = null;
            }
          }

          return _applyEventsToWeekDays(isInit);
        }

        function _calculateInitialDate() {
          if ($scope.options.initialDate) {
            body.selectedDate = moment($scope.options.initialDate);
          } else {
            body.selectedDate = moment();
          }

          _applyOffset();
          return _calculateWeeks(true);
        }

        function _onMonthChanged(e, month, year) {
          body.selectedDate.set('month', month).set('year', year);
          _applyOffset();

          return _calculateWeeks().then(function() {
            var selectedCalendarDay = _findSelectedCalendarMoment();
            onDaySelected(selectedCalendarDay);
          });
        }

        function _applyOffset() {
          if ($scope.monthOffset) {
            body.selectedDate.add($scope.monthOffset, 'month');
          }
        }


        function _applyEventsToWeekDays(isInit) {
          var startOfMonth = moment(body.selectedDate).startOf('month'),
            endOfMonth = moment(body.selectedDate).endOf('month');
          return $q.allSettled({
            assignments: fetchAssignments(startOfMonth, endOfMonth),
            massAssignments: fetchMassAssignments(startOfMonth, endOfMonth),
            tasks: fetchTasks(startOfMonth, endOfMonth)
          }).then(function(response) {
            var eventsGroups = [];
            var massAssignments = _.get(response, 'massAssignments.value.data', []);
            var assignments = _.get(response, 'assignments.value.data', []);
            var tasks = _.get(response, 'tasks.value.data', []);

            var allAssignments = _.concat(massAssignments, assignments);
            angular.forEach(allAssignments, function(assignment) {
              if (!_.isEmpty(assignment.exercises)) {
                eventsGroups.push({
                  assignmentId: assignment._id,
                  startDate: moment.unix(assignment.startDate),
                  endDate: moment.unix(assignment.endDate),
                  count: assignment.exercises.length,
                  assignment: assignment,
                  type: 'assignment'
                });
              }
            });

            angular.forEach(tasks, function(task) {
              if (!_.isEmpty(task.users)) {
                eventsGroups.push({
                  assignmentId: task._id,
                  startDate: moment.unix(task.startTime),
                  endDate: moment.unix(task.endTime),
                  count: 1,
                  assignment: task,
                  type: 'task'
                });
              }
            });

            angular.forEach(body.weeks, function(week) {
              angular.forEach(week, function(date) {
                if (!date) {
                  return;
                }
                var startOfDay = moment(date.moment).startOf('day');
                var endOfDay = moment(date.moment).add(1, 'day').startOf('day');


                var events = _.reject(eventsGroups, function(event) {

                  //     event finished before this day           or  event will be started after this day
                  return startOfDay.isSameOrAfter(event.endDate) || endOfDay.isSameOrBefore(event.startDate);
                });

                // during initialiazing of calendar throw current day up
                if (isInit && date.selected) {
                  $scope.$emit('calendar-body:day:init', date);
                }

                if (!events.length) {
                  return;
                }

                date.events = events;


              });
            });

          });
        }

        function fetchAssignments(startOfMonth, endOfMonth) {
          return assignmentsService.getSingleAssignments({
            startDate: moment(startOfMonth).startOf('day').unix(),
            endDate: moment(endOfMonth).endOf('day').unix(),
            exerciserId: $scope.user && $scope.user._id
          });
        }

        function fetchMassAssignments(startOfMonth, endOfMonth) {
          return assignmentsService.getAssignments({
            startDate: moment(startOfMonth).startOf('day').unix(),
            endDate: moment(endOfMonth).endOf('day').unix(),
            trainerId: $scope.user && $scope.user._id
          });
        }

        function fetchTasks(startOfMonth, endOfMonth) {
          return taskService.getTasks({
            startTime: moment(startOfMonth).startOf('day').unix(),
            endTime: moment(endOfMonth).add(1, 'day').startOf('day').unix(),
            userId: $scope.user && $scope.user._id
          });
        }

      }
    }]);

}());

(function() {
  'use strict';

  addClientService.$inject = ['$http', '$translate', 'popup', 'userService', '$state', 'toastr'];
  angular.module('ptCrm')
    .service('addClientService', addClientService);

  function addClientService($http, $translate, popup, userService, $state, toastr) {


    return {
      addUser: addUserModal
    };

    function addUserModal(scope) {
      if (scope) {
        // closes the previous popup
        scope.cancel();
      }

      return popup.confirm({
        title: $translate.instant('ADD_USER'),
        cssClass: 'modal--select-from-list',
        templateUrl: '/app/components/add-client/add-user.modal.html',
        scope: {
          addClient: addClientModal,
          findFacility: findFacilityModal
        },
        showOk: false,
        showCancel: false
      });
    }

    function getConfirmUserModalConfig(user, identifier, password) {
      return {
        templateUrl: '/app/components/add-client/confirm-client.modal.html',
        okText: $translate.instant('CONFIRM'),
        cssClass: 'modal--confirm-client',
        scope: {
          user: user,
          identifier: identifier,
          password: password
        }
      };
    }

    // ============ Client =============
    function addClientModal(scope) {
      if (scope) {
        // closes the previous popup
        scope.cancel();
      }
      return popup.confirm({
        title: $translate.instant('ADD_CLIENT'),
        templateUrl: '/app/components/add-client/add-client.modal.html',
        okText: $translate.instant('CONNECT'),
        cssClass: 'modal--add-client',
        okAction: findClient,
        showBack: true,
        backAction: addUserModal,
        scope: {
          xID: null,
          password: '',
          addClientForm: {}
        }
      });

    }

    function findClient(scope, modalInstance) {
      if (scope.addClientForm.$valid) {
        scope.showLoading(true);
        userService.getNetpulseProfile(scope.xID).then(function(user) {
          modalInstance.close();
          confirmClientModal(user, scope.xID, scope.password);
        }).catch(function() {
          modalInstance.close();
          popup.alert({
            title: $translate.instant('NOT_FOUND'),
            okAction: addClientModal
          });
        });
      }
    }

    function confirmClientModal(user, xID, password) {
      var template = _.extend(getConfirmUserModalConfig(user, xID, password), {
        title: $translate.instant('CONFIRM_CLIENT'),
        okAction: confirmClient
      });

      return popup.confirm(template);
    }

    function confirmClient(scope, modalInstance) {
      scope.showLoading(true);
      userService.createClientByXid(scope.identifier, scope.password).then(function(user) {
        modalInstance.close();
        $state.go('app.users.details', { userId: user._id });
      })
      .catch(function() {
        modalInstance.close();
        popup.alert({
          title: $translate.instant('ERROR_COMMON'),
          okAction: addClientModal
        });
      });
    }

    // ============ Facility =============
    function addFacility(scope, modalInstance) {
      if (scope.addFacilityForm.$valid) {
        scope.showLoading(true);
        userService.createUser({
          email: scope.email,
          firstName: scope.firstName,
          lastName: scope.lastName,
          password: scope.password
        }).then(function(user) {
          modalInstance.close();
          $state.go('app.users.details', { userId: user._id });
        }).catch(function(error) {
          scope.showLoading(false);
          toastr.warning(error.data.message);
        });
      }
    }

    function confirmFacilityModal(user) {
      var template = _.extend(getConfirmUserModalConfig(user), {
        title: $translate.instant('CONFIRM_EXISTING_USER'),
        okAction: confirmFacility
      });

      return popup.confirm(template);
    }

    function confirmFacility(scope, modalInstance) {
      scope.showLoading(true);
      userService.assignUserToFacility(scope.user._id).then(function() {
        modalInstance.close();
        $state.go('app.users.details', { userId: scope.user._id });
      });
    }

    function findFacilityModal(scope) {
      if (scope) {
        // closes the previous popup
        scope.cancel();
      }
      return popup.confirm({
        title: $translate.instant('ADD_STAFF'),
        templateUrl: '/app/components/add-client/find-staff.modal.html',
        okText: $translate.instant('FIND'),
        cssClass: 'modal--add-client',
        okAction: findFacility,
        showBack: true,
        backAction: addUserModal,
        scope: {
          email: null,
          findFacilityForm: {}
        }
      });
    }

    function findFacility(scope, modalInstance) {
      if (scope.findFacilityForm.$valid) {
        scope.showLoading(true);
        userService.getUsers({
          email: scope.email,
          allUsers: true
        }).then(function(users) {
          modalInstance.close();
          if (_.isEmpty(users)) {
            addFacilityModal(users, scope.email);
          } else {
            confirmFacilityModal(_.first(users));
          }
        });
      }
    }

    function addFacilityModal(scope, email) {
      if (scope && scope.cancel) {
        // closes the previous popup
        scope.cancel();
      }
      return popup.confirm({
        title: $translate.instant('ADD_STAFF'),
        templateUrl: '/app/components/add-client/add-staff.modal.html',
        okText: $translate.instant('CONNECT'),
        cssClass: 'modal--add-client',
        okAction: addFacility,
        showBack: true,
        backAction: findFacilityModal,
        scope: {
          firstName: null,
          lastName: null,
          email: email || null,
          password: null,
          addFacilityForm: {}
        }
      });
    }

  }
}());

(function() {

  'use strict';

  headerController.$inject = ['authService', 'popup', 'profileService', 'userService'];
  angular.module('ptCrm')
    .controller('HeaderController', headerController);

  function headerController(authService, popup, profileService, userService) {

    var vm = this;
    vm.selectNewFacility = selectNewFacility;
    vm.logout = logout;
    vm.showAllFacilities = showAllFacilities;

    vm.facilities = _.sortBy(profileService.user.facilities, function(facility) {
      return facility._id !== profileService.user.activeFacility;
    });

    function logout() {
      authService.logout();
    }

    function showAllFacilities() {
      popup.show({
        title: 'Your Facilities',
        showCancel: false,
        showOk: false,
        templateUrl: '/app/components/header/facility.modal.html',
        cssClass: 'modal--select-from-list',
        scope: {
          facilities: vm.facilities,
          selectNewFacility: selectNewFacility
        }
      });
    }

    function selectNewFacility(facility) {
      if (profileService.user.activeFacility !== facility._id &&
        _.includes(profileService.permissionNames, 'CURRENT_FACILITY_UPDATE')) {
        userService.updateCurrentUser({
          activeFacility: facility._id
        }).then(authService.refreshPage);
      }
    }

  }


}());

(function(angular) {

  'use strict';

  angular.module('ptCrm')
    .directive('ptCrmHeader', function() {
      return {
        restrict: 'E',
        templateUrl: '/app/components/header/header.html',
        controller: 'HeaderController',
        controllerAs: 'header'
      };
    });

}(angular));

(function(angular) {

  'use strict';

  leftMenuController.$inject = ['$rootScope', 'addClientService'];
  angular.module('ptCrm')
    .directive('ptCrmLeftMenu', function() {
      return {
        restrict: 'E',
        templateUrl: '/app/components/left_menu/left_menu.html',
        controller: leftMenuController,
        controllerAs: 'menu'
      };
    });

  angular.module('ptCrm')
    .directive('ptCrmLeftMenuToggle', function() {
      return {
        require: '^ptCrmLeftMenu',
        link: function($scope, $element, $attrs, menuCtrl) {
          $element.bind('click', function() {
            $scope.$apply(menuCtrl.toggle);
          });
        }
      };
    });

  function leftMenuController($rootScope, addClientService) {

    var vm = this;

    vm.toggle = toggleMenu;
    vm.addUser = addClientService.addUser;

    $rootScope.$on('$stateChangeStart', closeMenu);

    closeMenu();

    function closeMenu() {
      vm.isOpened = false;
    }

    function toggleMenu() {
      vm.isOpened = !vm.isOpened;
    }
  }

}(angular));

(function() {

  'use strict';

  ItemsBagCtrl.$inject = ['$scope', '$rootScope', 'toastr', 'camelToSnakeCaseFilter'];
  angular.module('ptCrm')
    .controller('ItemsBagCtrl', ItemsBagCtrl);

  function ItemsBagCtrl($scope, $rootScope, toastr, camelToSnakeCaseFilter) {
    var vm = this;
    vm.scope = $scope;
    vm.activeItemIndex = vm.activeItemIndex || 0;

    vm.deselectItem = deselectItem;
    vm.activateItem = activateItem;
    $scope.$watch('bagCtrl.id', function() {
      var action = vm.id ? '_UPDATE' : '_CREATE';
      var subject = vm.isChainWide ? 'CHAIN_WIDE' : camelToSnakeCaseFilter(vm.bagType);
      vm.editBagPermission = subject + action;
    });

    $scope.$watch(function() {
      return vm.selectedItems;
    }, function(newArr, oldArr) {
      if (newArr.length > oldArr.length) {
        vm.selectedItems = oldArr.concat(_.differenceBy(newArr, oldArr, '_id'));
      }
    }, true);

    $scope.$on('itemsList.items.drop-model', _refreshScroll);

    // =============== METHODS =====================

    function deselectItem(index) {
      var item = vm.selectedItems[index];
      if (item) {
        vm.selectedItems.splice(index, 1);
        vm.itemsList.items.push(item);
        vm.activeItemIndex = 0;
      } else {
        toastr.error('Cannot find selected item');
      }
    }

    function activateItem(index) {
      vm.activeItemIndex = index;
    }

    function _refreshScroll() {
      $rootScope.$emit('iscroll:refresh');
    }
  }

}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptItemsBag', ptItemsBag);

  function ptItemsBag() {
    return {
      templateUrl: '/app/components/items-bag/items-bag.html',
      bindToController: {
        selectedItems: '=?', // array of already selected into bag items
        activeItemIndex: '=?',    // selected from bag item index to show details (1,2)
        isChainWide: '<?',    // if it is set and it is chainwide
        id: '=?',            // id of main element, if exists
        itemsList: '=',      // paginationList of possible items
        editItem: '=?',      // function to edit part items
        bagType: '@',            // type of main result item in terms of app (exercises, sets ...)
        itemType: '@',            // type of items(parts) in terms of app (exercises, sets ...)
        hidePrintIcon: '='            // define showing print icon on library card
      },
      controller: 'ItemsBagCtrl as bagCtrl'
    };
  }

}());

(function() {

  'use strict';

  UsersBagCtrl.$inject = ['$scope', 'toastr'];
  angular.module('ptCrm')
    .controller('UsersBagCtrl', UsersBagCtrl);

  function UsersBagCtrl($scope, toastr) {
    var vm = this;

    // need this for dragula
    vm.scope = $scope;
    vm.searchStr = '';

    vm.deselectUser = deselectUser;
    vm.loadUsers = loadUsers;
    vm.filterDuplicates = filterDuplicates;

    $scope.$watch(function() {
      return vm.selectedUsers;
    }, function(newArr, oldArr) {
      if (newArr.length > oldArr.length) {
        vm.selectedUsers = oldArr.concat(_.differenceBy(newArr, oldArr, '_id'));
      }
    }, true);

    loadUsers();

    // =============== METHODS =====================
    function deselectUser(index) {
      var user = vm.selectedUsers[index];
      if (user) {
        vm.selectedUsers.splice(index, 1);
        vm.usersList.items.push(user);
      } else {
        toastr.error('Cannot find selected user');
      }
    }

    function loadUsers(searchStr) {
      return vm.usersList
        .extendDefaultParams({ search: searchStr })
        .load({
          update: angular.isDefined(searchStr)
        })
        .then(vm.filterDuplicates);
    }


    //  ============ HELPERS ===============
    function filterDuplicates() {
      vm.usersList.items = _.reject(vm.usersList.items, function(user) {
        return _.find(vm.selectedUsers, { _id: user._id });
      });

      return vm.usersList.items;
    }
  }

}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptUsersBag', ptUsersBag);

  function ptUsersBag() {
    return {
      templateUrl: '/app/components/users-bag/users-bag.html',
      bindToController: {
        selectedUsers: '=?',      // array of already selected into bag users
        usersList: '=',           // paginationList of possible users
        bagType: '@',             // type of main result user in terms of app (exercises, sets ...)
        userType: '@',            // type of users(parts) in terms of app (exercises, sets ...)
        editBagPermission: '=?',  // permission to edit bag (as training_sets_update)
        bagLimit: '@?'            // max number of items in a bag
      },
      controller: 'UsersBagCtrl as bagCtrl'
    };
  }

}());

(function() {

  'use strict';

  TimeSlotController.$inject = ['profileService', 'popup', 'taskService'];
  angular.module('ptCrm')
    .controller('TimeSlotController', TimeSlotController);

  function TimeSlotController(profileService, popup, taskService) {


    var vm = this;
    vm.showTaskInfo = showTaskInfo;
    vm.editTimeSlot = editTimeSlot; // proxy to stop propogation
    vm.isTask = taskService.isTask;

    var isMy = vm.item.exerciserId === profileService.user._id;
    var owner = isMy ? '_SELF' : '_OTHER';
    var subject = taskService.isTask(vm.item) ? 'TASKS' : 'WORKOUT_ASSIGNMENTS';
    vm.editPermission = subject + owner + '_UPDATE';
    vm.readPermission = subject + owner + '_READ';

    vm.isPassedAssignment = vm.item.type === 'assignment' &&
      vm.item.dateFrom.isSameOrBefore(moment(), 'day');

    // =============== METHODS ===============
    function showTaskInfo($event) {
      $event.stopPropagation();
      popup.alert({
        title: vm.item.title,
        description: vm.item.description
      });
    }

    function editTimeSlot($event, client) {
      $event.stopPropagation();
      vm.editSlot(client);
    }

  }

}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptTimeSlot', ptTimeSlot);

  function ptTimeSlot() {
    return {
      templateUrl: '/app/components/time-slot/time-slot.html',
      bindToController: {
        item: '=',            // item (timeTo, timeFrom, img, caption, club, type, exerciserId)
        editSlot: '=?',       // function to call for editing timeslot
        isEditable: '='
      },
      controller: 'TimeSlotController as timeCtrl'
    };
  }

}());

(function() {
  'use strict';

  ExerciseProfileController.$inject = ['$scope', '$rootScope', '$timeout'];
  angular.module('ptCrm')
    .controller('ExerciseProfileController', ExerciseProfileController);

  function ExerciseProfileController($scope, $rootScope, $timeout) {
    var vm = this;
    var handleEvents = _handleSegmentScrollEvents();
    vm.totalDuration = 0;
    vm.global = {};

    // define public methods in the followong way to avoid "too many statements" error
    angular.extend(vm, {
      addSegment: addSegment,
      moreSegmentsAvailable: moreSegmentsAvailable,
      activateSegment: activateSegment,
      canDeleteSegments: canDeleteSegments,
      deleteActiveSegment: deleteActiveSegment,
      resetActiveSegment: resetActiveSegment,
      sliderValueChanged: sliderValueChanged,
      getMetrics: getMetrics
    });


    $scope.$watch('exerciseCtrl.exercise', function(exercise) {
      if (exercise) {
        vm.exercise = exercise;
        vm.segments = _.get(exercise, 'assignedProfile.segments');
        recalculateTotalDuration();
      }
    });

    $scope.$watch('exerciseCtrl.segments', _setSegmentsProgress, true);

    // ============== PUBLIC METHODS ==================
    function addSegment() {
      if (!moreSegmentsAvailable()) {
        return false;
      }

      vm.segments.push(getEquipmentDefaultValues());

      recalculateTotalDuration();
      _refreshScroll();

      if (vm.scrollInstance) {
        $timeout(function() {
          // scroll to the last segment
          if (vm.scrollInstance.pages.length) {
            vm.scrollInstance.goToPage(vm.scrollInstance.pages.length, 0);
          }

          handleEvents();
        });
      }
    }

    function moreSegmentsAvailable() {
      return vm.exercise && vm.exercise.preset.maxSegments > vm.segments.length;
    }

    function activateSegment(segment) {
      // toggle state
      if (_.isObject(segment) && segment._isActive) {
        segment = null;
      }

      vm.activeSegment = segment;
      var activeSegment = _.find(vm.segments, { _isActive: true }) || {};
      activeSegment._isActive = false;

      if (_.isObject(segment)) {
        segment._isActive = true;
      }
    }

    function canDeleteSegments() {
      // the number of segments should be at least 1
      return vm.segments.length > 1;
    }

    function deleteActiveSegment() {
      var activeSegmentIndex = _.indexOf(vm.segments, vm.activeSegment),
        newActiveSegmentIndex = 0;

      if (activeSegmentIndex > -1) {
        vm.segments.splice(activeSegmentIndex, 1);

        // select previous segment or first segment
        newActiveSegmentIndex = _.max([activeSegmentIndex - 1, 0]);
        activateSegment(vm.segments[newActiveSegmentIndex]);

        recalculateTotalDuration();
        _refreshScroll();
      }
    }

    function resetActiveSegment() {
      if (vm.activeSegment) {
        _.extend(vm.activeSegment, getEquipmentDefaultValues());
      }
    }

    function sliderValueChanged(metricName) {
      if (metricName === 'duration') {
        recalculateTotalDuration();
      }
    }

    // ============ HELPERS ======================
    function getEquipmentDefaultValues() {
      return _.reduce(vm.exercise.preset.metrics, function(mem, metric) {
        if (metric.forSegment) {
          mem[metric.name] = metric.validation.default;
        }
        return mem;
      }, {});
    }

    function getMetrics(name) {
      return vm.exercise && vm.exercise.preset && _.find(vm.exercise.preset.metrics, { name: name });
    }

    function _handleSegmentScrollEvents() {
      return _.once(function() {
        vm.scrollInstance.on('refresh', _updateIscrollLimits);
        vm.scrollInstance.on('scrollEnd', _updateIscrollLimits);
      });
    }

    function _updateIscrollLimits() {
      $timeout(function() {
        vm.scrollInstance._enableLeft = false;
        vm.scrollInstance._enableRight = false;

        if (vm.scrollInstance.hasHorizontalScroll) {
          vm.scrollInstance._enableLeft = vm.scrollInstance.x !== 0;
          vm.scrollInstance._enableRight = vm.scrollInstance.x !== vm.scrollInstance.maxScrollX;
        }
      });
    }

    function recalculateTotalDuration() {
      $timeout(function() {
        if (!_.isEmpty(vm.segments)) {
          var total = _.reduce(vm.segments, function(time, segment) {
            return time + (segment.duration || 0);
          }, 0);
          vm.exercise.totalDuration = +total.toFixed(1);
        }
      });
    }

    function _refreshScroll() {
      $rootScope.$emit('iscroll:refresh');
    }

    function _setSegmentsProgress(newVal) {
      if (!newVal) {
        return;
      }
      var params = ['startingResistance', 'startingIncline'];

      vm.segments.forEach(function(segment) {
        var resultsCount = 0,
          sum,
          percentage;

        sum = params.map(function(param) {
          var metric = _.find(vm.exercise.preset.metrics, { name: param, forSegment: true });

          if (angular.isDefined(segment[param]) && metric) {
            resultsCount++;
            return (segment[param] - metric.validation.minValue) /
              (metric.validation.maxValue - metric.validation.minValue) * 100;
          }

          return 0;
        }).reduce(function(a, b) {
          return a + b;
        }, 0);


        percentage = sum / resultsCount;


        // handle NaN, negative values
        if (!percentage || percentage < 0) {
          percentage = 0;
        }

        segment._progressHeight = percentage + '%';
      });

      $scope.$applyAsync();
    }

  }

}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptExerciseProfile', function() {

      return {
        templateUrl: '/app/components/exercise-profile/exercise-profile.html',
        bindToController: {
          exercise: '=',
          editPermission: '=?'
        },
        controller: 'ExerciseProfileController as exerciseCtrl'
      };
    });

}());

(function() {
  'use strict';

  ExerciseItemDetailsController.$inject = ['$scope', 'camelToSnakeCaseFilter'];
  angular.module('ptCrm')
    .controller('ExerciseItemDetailsController', ExerciseItemDetailsController);

  function ExerciseItemDetailsController($scope, camelToSnakeCaseFilter) {

    var vm = this;
    if (!vm.editPermission) {
      $scope.$watch('itemCtrl.item', function() {
        var action = (vm.item && vm.item._id) ? '_UPDATE' : '_CREATE';
        var subject = (vm.item && vm.item.chainWide) ? 'CHAIN_WIDE' : camelToSnakeCaseFilter(vm.type);
        vm.editPermission = subject + action;
      });
    }

  }

}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptExerciseItemDetails', function() {

      return {
        templateUrl: '/app/components/exercise-item-details/exercise-item-details.html',
        bindToController: {
          item: '=',
          editPermission: '=?',
          type: '@'
        },
        controller: 'ExerciseItemDetailsController as itemCtrl'
      };
    });

}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptEmbedVideo', ['$sce', function($sce) {

      var youTubeRegExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      var vimeoRegExp = /^(http\:\/\/|https\:\/\/)?(www\.)?(vimeo\.com\/)([0-9]+)$/;
      var youtubeBaseSrc = 'https://www.youtube.com/embed/';
      var vimeoBaseSrc = 'https://player.vimeo.com/video/';

      return {
        templateUrl: '/app/components/embed-video/embed-video.html',
        scope: {
          url: '<',
          onInvalid: '&'
        },
        link: ptEmbedVideoLink
      };

      function ptEmbedVideoLink(scope) {
        var youtubeSrc, vimeoSrc;
        scope.trustedYoutubeSrc = '';
        scope.trustedVimeoSrc = '';

        scope.$watch('url', function(newVal) {

          if (_isValidYoutubeUrl(newVal)) {
            youtubeSrc = youtubeBaseSrc + _getYoutubeVideoId(newVal);
            scope.trustedYoutubeSrc = getTrustedSrc(youtubeSrc);
            scope.trustedVimeoSrc = '';
            return;
          }

          if (_isValidVimeoUrl(newVal)) {
            vimeoSrc = vimeoBaseSrc + _getVimeoVideoId(newVal);
            scope.trustedVimeoSrc = getTrustedSrc(vimeoSrc);
            scope.trustedYoutubeSrc = '';
            return;
          }

          scope.onInvalid();
        });


      }

      function _isValidYoutubeUrl(url) {
        return youTubeRegExp.test(url);
      }

      function _isValidVimeoUrl(url) {
        return vimeoRegExp.test(url);
      }

      function _getYoutubeVideoId(url) {
        var match = url.match(youTubeRegExp);
        return match[1];
      }

      function _getVimeoVideoId(url) {
        var match = url.match(vimeoRegExp);
        return match[4];
      }

      function getTrustedSrc(src) {
        return $sce.trustAsResourceUrl(src);
      }

    }]);

}());

(function() {

  'use strict';

  ExerciseMultimediaCtrl.$inject = ['$scope'];
  angular.module('ptCrm')
    .controller('ExerciseMultimediaCtrl', ExerciseMultimediaCtrl);

  function ExerciseMultimediaCtrl($scope) {

    var vm = this;

    vm.videoUrl = '';
    vm.isVideoUrlInvalid = false;
    vm.showEmbedVideo = false;

    vm.onVideoUrlChange = onVideoUrlChange;
    vm.onVideoPreview = onVideoPreview;
    vm.onVideoUrlInvalid = onVideoUrlInvalid;

    $scope.$watch(function() {
      return vm.video;
    }, function(newVal) {
      if (newVal) {
        vm.videoUrl = newVal;
        onVideoPreview();
      }
    });

    function onVideoUrlChange() {
      if (!vm.videoUrl) {
        vm.isVideoUrlInvalid = false;
      }
    }

    function onVideoPreview() {
      if (vm.videoUrl) {
        vm.videoUrlForEmbedVideo = vm.videoUrl;
        vm.onVideoUpdate({ url: vm.videoUrl });
        vm.isVideoUrlInvalid = false;
        vm.showEmbedVideo = true;
      }
    }

    function onVideoUrlInvalid() {
      vm.showEmbedVideo = false;
      vm.isVideoUrlInvalid = true;
      vm.onVideoUpdate('');
    }

  }

}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptExerciseMultimedia', ptExerciseMultimedia);

  function ptExerciseMultimedia() {
    return {
      templateUrl: '/app/components/exercise-multimedia/exercise-multimedia.html',
      bindToController: {
        video: '<',
        type: '@',
        imagesList: '=',
        imagesLimit: '<?',
        onVideoUpdate: '&'
      },
      controller: 'ExerciseMultimediaCtrl as exMultCtrl'
    };
  }

}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .controller('ImageCarouselCtrl', ImageCarouselCtrl);

  function ImageCarouselCtrl() {
    var vm = this;

    // add defult value for comparison
    vm.imagesLimit = vm.imagesLimit || Infinity;
  }

}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptImageCarousel', ptImageCarousel);

  function ptImageCarousel() {
    return {
      templateUrl: '/app/components/image-carousel/image-carousel.html',
      bindToController: {
        imagesList: '=',
        imagesLimit: '<?'
      },
      controller: 'ImageCarouselCtrl as imageCarouselCtrl'
    };
  }

}());

(function() {

  'use strict';

  TabsController.$inject = ['$state', '$timeout', '$rootScope'];
  angular.module('ptCrm')
    .controller('TabsController', TabsController);

  function TabsController($state, $timeout, $rootScope) {

    var vm = this;

    vm.tabs = [];
    vm.select = select;
    vm.addTab = addTab;
    vm.removeTab = removeTab;

    $rootScope.$on('tabs:disabled', function(e, tabName) {
      removeTab(tabName);
    });

    var selectActiveTab = _.debounce(function() {
      $timeout(function() {
        var selectTab = getFirstActiveTab() || getActiveStateTab() || getFirstValidTab();
        select(selectTab);
      });
    });

    function getFirstActiveTab() {
      return _.find(vm.tabs, { active: true });
    }

    function getActiveStateTab() {
      return _.find(vm.tabs, { name: $state.params.tab });
    }

    function getFirstValidTab() {
      return _.find(vm.tabs, function(tab) {
        return !(tab.button || tab.disabled);
      });
    }

    function deactivateNotSelectedTabs(selectedTab) {
      _.forEach(vm.tabs, function(tab) {
        if (tab.active && tab !== selectedTab) {
          tab.onDeselect();
        }

        selectedTab.alreadySelected = false;
        tab.active = false;
      });
    }

    function activateTab(selectedTab) {
      selectedTab.active = true;

      if (!selectedTab.alreadySelected) {
        selectedTab.onSelect();
        selectedTab.alreadySelected = true;
      }

      if (selectedTab.name && selectedTab.name !== $state.params.tab) {
        $state.go($state.current.name, { tab: selectedTab.name }, {
          notify: false, reload: false, location: 'replace'
        });
      }
    }

    function select(selectedTab) {
      if (!selectedTab || selectedTab.button || selectedTab.disabled) {
        return false;
      }

      deactivateNotSelectedTabs(selectedTab);
      activateTab(selectedTab);
    }

    function addTab(tab) {
      vm.tabs.push(tab);
      selectActiveTab();
    }

    function removeTab(tab) {
      if (_.isString(tab)) {
        tab = _.find(vm.tabs, { name: tab });
      }

      if (_.isObject(tab)) {
        tab.hidden = true;
        vm.tabs = _.reject(vm.tabs, tab);
        selectActiveTab();
      }
    }
  }

}());

(function() {

  'use strict';

  angular.module('ptCrm')

    /**
     * Container for tabs
     * @see tab directive for example
     */
    .directive('tabs', function() {
      return {
        transclude: true,
        replace: true,
        scope: true,
        controller: 'TabsController as tabsCtrl',
        templateUrl: '/app/components/tabs/tabs.html'
      };
    });


}());

(function() {

  'use strict';

  angular.module('ptCrm')

    /**
     * Creates a tab. Must be placed under tabs directive
     *
     * @example
     <example>
       <tabs>
         <tab>
          <tab-head><button>{{'CREATE_WORKOUT'|translate}}</button></tab-head>
           <tab-content>
             <div class="create-assignment__selected-clients">
               <client-card></client-card>
             </div>
             <div class="create-assignment__scrollbar"></div>

             <library-search></library-search>

             <div class="create-assignment__clients">
              <client-card></client-card>
             </div>
           </tab-content>
         </tab>
        <tab button="true">
        </tab>
       </tabs>
     </example>
     */
    .directive('tab', function() {
      return {
        require: '^tabs',
        replace: true,
        templateUrl: '/app/components/tabs/tab.html',
        transclude: true,
        scope: {
          name: '@',
          active: '=?',
          disabled: '=?isDisabled',
          hidden: '<?isHidden',
          button: '=?isButton',
          onSelect: '&select',
          onDeselect: '&deselect'
        },
        link: function($scope, $element, $attrs, tabsCtrl, $transclude) {
          if ($scope.hidden) {
            $element.remove();
            return false;
          }

          tabsCtrl.addTab($scope);

          $element[0].addEventListener('click', _handleClicks, true);
          $element[0].addEventListener('touchstart', _handleClicks, true);


          // public
          $scope.select = select;
          $scope.transcludeContent = transcludeContent;

          // events
          $scope.$watch('active', onActiveTabChanged);
          $scope.$on('$destroy', onDestroy);


          // ///////////////////////////////////////////
          function select() {
            if (!$scope.disabled) {
              $scope.active = true;
            }
          }

          function onDestroy() {
            tabsCtrl.removeTab($scope);
          }

          function onActiveTabChanged(active) {
            if (active) {
              tabsCtrl.select($scope);
            }
          }

          // we have to transclude content during content linking phase to apply correct scope
          function transcludeContent($contentElement) {
            $transclude($scope.$parent, function(clone) {
              angular.forEach(clone, function(node) {
                switch (node.tagName) {
                default:
                  break;
                case 'TAB-HEAD':
                  $element.append(node);
                  break;

                case 'TAB-CONTENT':
                  $contentElement.append(node);
                  break;
                }
              });
            });
          }


          function _handleClicks(e) {
            if ($scope.disabled) {
              e.stopPropagation();
            }
          }

        }
      };
    });

}());

(function() {

  'use strict';

  angular.module('ptCrm')

    /**
     * Place for tab content
     */
    .directive('tabContent', ['$timeout', function($timeout) {
      return {
        restrict: 'A',
        require: '^tabs',
        replace: true,
        transclude: true,
        scope: {
          tab: '=?tabInstance'
        },
        link: function($scope, $element) {
          $timeout(function() {
            if (!$scope.tab.hidden) {
              $scope.tab.transcludeContent($element);
            }
          });
        }
      };
    }]);

}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('datepicker', function() {
      return {
        restrict: 'E',
        scope: {
          validator: '&',
          selected: '=',
          firstAvailiable: '=?',
          from: '=',
          to: '='
        },
        templateUrl: '/app/components/datepicker/datepicker.html',
        link: datepickerLink
      };

      function datepickerLink(scope) {
        var currentMoment = moment();

        scope.selected = scope.selected || moment();
        scope.isValid = true;
        scope.weeks = [];
        scope.togglePicker = togglePicker;
        scope.getSelected = getSelected;
        scope.getTitle = getTitle;
        scope.isSelected = isSelected;
        scope.selectDay = selectDay;
        scope.prev = prev;
        scope.next = next;
        scope.now = now;
        scope.isAvailiable = isAvailiable;

        scope.$watch(function() {
          return scope.selected;
        }, function(newVal, oldVal) {
          if (angular.isFunction(scope.validator) && newVal !== oldVal) {
            scope.isValid = scope.validator({ selectedDay: newVal });
          }
        });

        scope.$watch(function() {
          return scope.from;
        }, function(val) {
          if (!val || !val.isValid()) {
            _init();
          } else if (!moment(scope.from).isSame(currentMoment, 'month')) {
            currentMoment = moment(val);
            _init();
          }
        });

        _init();

        function getTitle() {
          return scope.selected ? scope.selected.format('DD MMMM') : currentMoment.format('MMMM');
        }

        function togglePicker() {
          scope.collapsed = !scope.collapsed;
          if (!scope.collapsed) {
            scope.isValid = true;
          }
        }

        function getSelected(format) {
          return scope.selected ? scope.selected.format(format) : '';
        }

        function isSelected(day) {
          var _day = moment(currentMoment).set('date', day);

          if (scope.selected) {
            if (scope.from) {
              return scope.from <= _day && _day <= scope.selected;
            } else {
              return angular.isFunction(_day.isSame) && _day.isSame(scope.selected, 'day');
            }
          } else {
            return false;
          }
        }

        function selectDay(day) {
          if ((day !== null) && isAvailiable(day)) {
            scope.selected = moment(currentMoment).date(day);
          }
        }

        function prev() {
          var startOfMonth = moment(currentMoment).startOf('month').startOf('day');

          if (!scope.from || startOfMonth.diff(moment(scope.from).startOf('day')) > 0) {
            currentMoment.subtract(1, 'M');
            _getMonth();
          }
        }

        function next() {
          var endOfMonth = moment(currentMoment).endOf('month').startOf('day');

          if (!scope.to || endOfMonth.diff(moment(scope.to).endOf('day')) < 0) {
            currentMoment.add(1, 'M');
            _getMonth();
          }
        }

        function now() {
          var time = moment();

          return time.year() === currentMoment.year() && time.month() === currentMoment.month() ? time.date() : null;
        }

        function isAvailiable(day) {
          var date = moment(currentMoment);

          date.date(day);
          var isAfterFirstAvailiable = scope.firstAvailiable ? scope.firstAvailiable.isSameOrBefore(date) : true;
          return ((!scope.from || date.diff(moment(scope.from).startOf('day')) >= 0) &&
          (!scope.to || date.diff(moment(scope.to).endOf('day')) <= 0)) && isAfterFirstAvailiable;
        }

        function _init() {
          if (angular.isFunction(scope.validator)) {
            scope.isValid = scope.validator({ selectedDay: scope.selected });
          }
          _getMonth();
        }

        function _getMonth() {
          var i, len, idx, newWeeks = [],
            _currentMoment = moment(currentMoment);

          idx = (_currentMoment.startOf('month').day() + 6) % 7;
          newWeeks.length = Math.ceil((idx + _currentMoment.endOf('month').date()) / 7);
          for (i = 0, len = newWeeks.length; i < len; i++) {
            newWeeks[i] = [null, null, null, null, null, null, null];
          }
          for (i = 0, len = _currentMoment.endOf('month').date(); i < len; i++) {
            newWeeks[Math.floor((idx + i) / 7)][(idx + i) % 7] = i + 1;
          }
          scope.weeks = newWeeks;
        }
      }
    });
}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('timepicker', ['$document', function($document) {
      return {
        restrict: 'E',
        templateUrl: '/app/components/timepicker/timepicker.html',
        scope: {
          clients: '=',
          selectedClients: '=',
          onEditClient: '&',
          onEditTask: '&',
          editAssign: '=',
          startTime: '=',
          endTime: '=',
          readOnly: '@',
          onClientSelect: '&',
          onTitleClick: '&',
          isEditable: '='
        },
        link: timepickerLink
      };

      function timepickerLink(scope, element) {
        var from, to,
          lowerLimit, upperLimit,
          events = {},
          startX = 0,
          startY = 0,
          startEl,
          x = 0,
          y = 0,
          _move = _defineMove(50),
          move = false,
          clientsContainer = angular.element(element[0].querySelector('.timepicker-container-right')),
          clients = angular.element(element[0].querySelector('.timepicker-container-right-client'));

        // define drag events
        if ('ontouchstart' in window || 'onmsgesturechange' in window) {
          events.moveStart = 'touchstart';
          events.move = 'touchmove';
          events.moveEnd = 'touchend';
        } else {
          events.moveStart = 'mousedown';
          events.move = 'mousemove';
          events.moveEnd = 'mouseup';
        }

        scope.timeRanges = ['12:00 am', '12:30 am', '1:00 am', '1:30 am', '2:00 am', '2:30 am', '3:00 am', '3:30 am',
          '4:00 am', '4:30 am', '5:00 am', '5:30 am', '6:00 am', '6:30 am', '7:00 am', '7:30 am', '8:00 am', '8:30 am',
          '9:00 am', '9:30 am', '10:00 am', '10:30 am', '11:00 am', '11:30 am', '12:00 pm', '12:30 pm', '1:00 pm',
          '1:30 pm', '2:00 pm', '2:30 pm', '3:00 pm', '3:30 pm', '4:00 pm', '4:30 pm', '5:00 pm', '5:30 pm', '6:00 pm',
          '6:30 pm', '7:00 pm', '7:30 pm', '8:00 pm', '8:30 pm', '9:00 pm', '9:30 pm', '10:00 pm', '10:30 pm',
          '11:00 pm', '11:30 pm'];
        scope.titles = ['12:00 am', '1:00 am', '2:00 am', '3:00 am', '4:00 am', '5:00 am', '6:00 am', '7:00 am',
          '8:00 am', '9:00 am', '10:00 am', '11:00 am', '12:00 pm', '1:00 pm', '2:00 pm', '3:00 pm', '4:00 pm',
          '5:00 pm', '6:00 pm', '7:00 pm', '8:00 pm', '9:00 pm', '10:00 pm', '11:00 pm'];

        scope.generateStyle = generateStyle;
        scope.checkOverlap = checkOverlap;
        scope.clientSelect = clientSelect;

        scope.$on('timepicker:resetTime', titleClicked);
        scope.titleClicked = titleClicked;
        scope.editClient = editClient;
        scope.editTask = editTask;

        if (_.isUndefined(scope.readOnly)) {
          clientsContainer.on('mousedown', _onRangeSelect);
          clients.on('mousedown', function(event) {
            event.stopPropagation();
          });
        } else {
          clientsContainer.off('mousedown', _onRangeSelect);
        }

        scope.$watch('editAssign', function() {
          if (scope.editAssign) {
            scope.selectedClients = scope.editAssign;
            _onTimeChange();
            scope.$applyAsync(function() {
              addStretchButtonListener();
            });
          }
        });

        function _onTimeChange() {
          scope.startTime = moment().startOf('day').minute(scope.selectedClients.timeFrom * 60).toDate();
          scope.endTime = moment().startOf('day').minute(scope.selectedClients.timeTo * 60).toDate();
        }

        function onMoveStart(e) {
          e.preventDefault();
          e.stopPropagation();

          if (!_.isUndefined(scope.selectedClients.timeFrom)) {
            from = scope.selectedClients.timeFrom * 2;
            to = scope.selectedClients.timeTo * 2;
          }
          startX = e.pageX || e.touches[0].pageX;
          startY = e.pageY || e.touches[0].pageY;

          $document.on(events.move, _move);
          $document.on(events.moveEnd, _moveEnd);
        }

        function _removeListeners() {
          $document.off(events.move, _move);
          $document.off(events.moveEnd, _moveEnd);
        }

        function clientSelect(client) {
          if (scope.onClientSelect) {
            scope.onClientSelect({ $item: client });
          }
        }

        function generateStyle(client) {
          return {
            top: client.timeFrom * 100 + 10 + 'px',
            height: (client.timeTo - client.timeFrom) * 100 + 'px'
          };
        }

        function checkOverlap() {
          var selectedClient = scope.selectedClients,
            timeFrom,
            timeTo,
            clients;

          if (!selectedClient) {
            return false;
          }

          timeFrom = selectedClient.timeFrom;
          timeTo = selectedClient.timeTo;

          clients = _.filter(scope.clients, function(client) {
            return client._id !== selectedClient._id;
          });

          if (clients.length === 0) {
            return false;
          }

          return _.some(clients, function(client) {
            return !(
              (timeFrom < client.timeFrom && timeTo <= client.timeFrom) ||
              (timeFrom >= client.timeTo && timeTo > client.timeTo)
            );
          });
        }

        function titleClicked() {

          // unselect all selected rows
          if (scope.selectedClients) {
            scope.selectedClients.timeFrom = null;
            scope.selectedClients.timeTo = null;
          }

          scope.onTitleClick();
        }

        function _onRangeSelect(event) {
          if (event.target.className.indexOf('timepicker-container-right-item') === -1) {
            return false;
          }
          move = false;
          event.preventDefault();
          startEl = angular.element(event.target);
          while (!startEl.hasClass('timepicker-container-right-item')) {
            startEl = startEl.parent();
          }


          from = Array.prototype.indexOf.call(clientsContainer.children(), startEl[0]);
          lowerLimit = scope.clients.filter(function(e) {
            return e.timeTo * 2 <= from;
          }).reduce(function(rez, next) {
            return Math.max(next.timeTo, rez);
          }, 0);
          upperLimit = scope.clients.filter(function(e) {
            return e.timeFrom * 2 >= from + 1;
          }).reduce(function(rez, next) {
            return Math.min(next.timeFrom, rez);
          }, 99);

          to = from + 1 === upperLimit * 2 ? from + 1 : from + 2;

          scope.selectedClients.timeTo = to / 2;
          scope.selectedClients.timeFrom = from / 2;
          _onTimeChange();

          scope.$apply();
          addStretchButtonListener();
        }

        function _checkLimits() {
          if (scope.selectedClients.timeFrom < lowerLimit) {
            scope.selectedClients.timeFrom = lowerLimit;
            if (scope.selectedClients.timeFrom === scope.selectedClients.timeTo) {
              scope.selectedClients.timeTo += 0.5;
            }
            _removeListeners();
            _onTimeChange();
          }
          if (scope.selectedClients.timeTo > upperLimit) {
            scope.selectedClients.timeTo = upperLimit;
            if (scope.selectedClients.timeFrom === scope.selectedClients.timeTo) {
              scope.selectedClients.timeFrom -= 0.5;
            }
            _removeListeners();
            _onTimeChange();
          }
        }

        function _defineMove(interval) {
          var now, directionCahnged, prev = 0;

          return function(event) {
            now = Date.now();
            if (now - prev > interval) {
              event.stopPropagation();
              y = (event.pageY || event.touches[0].pageY) - startY;
              x = (event.pageX || event.touches[0].pageX) - startX;

              if (y > (to - from) * (-50)) {
                scope.selectedClients.timeTo = (to + y / 50) / 2;
                if (directionCahnged) {
                  scope.selectedClients.timeFrom = Math.floor(to + y / 50) / 2;
                  directionCahnged = false;
                }
              } else {
                scope.selectedClients.timeFrom = (to + y / 50) / 2;
                scope.selectedClients.timeTo = from / 2;
                directionCahnged = true;
              }
              _checkLimits();
              scope.$apply();

              prev = now;
            }
          };
        }

        function _moveEnd(event) {
          y = (event.pageY || event.changedTouches[0].pageY) - startY;
          x = (event.pageX || event.changedTouches[0].pageX) - startX;
          if (y > (to - from) * (-50)) {
            scope.selectedClients.timeTo = Math.ceil(to + y / 50) / 2;
          } else {
            scope.selectedClients.timeFrom = Math.floor(to + y / 50) / 2;
            scope.selectedClients.timeTo = from / 2;
          }
          _removeListeners();
          _onTimeChange();
          scope.$apply();
        }

        function addStretchButtonListener() {
          var dragger = angular.element(element[0].querySelector('.timepicker-container-right-client-dragger'));
          dragger.on(events.moveStart, onMoveStart);
        }

        function editClient(client) {
          if (scope.onEditClient) {
            scope.onEditClient({ $item: client });
          }
        }

        function editTask(task) {
          if (scope.onEditTask) {
            scope.onEditTask({ $item: task });
          }
        }

      }
    }]);
}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptDaySchedule', function() {

      return {
        templateUrl: '/app/components/day-schedule/day-schedule.html',
        require: ['?^form'],
        scope: {
          times: '=',
          day: '<',
          editable: '='
        },
        link: function(scope, element, attrs, ctrl) {
          var formCtrl = ctrl[0];
          scope.addHours = addHours;
          scope.removeHours = removeHours;

          function addHours() {
            scope.times.push({
              min: new Date(1970, 0, 1, 10, 0, 0),
              max: new Date(1970, 0, 1, 10, 0, 0)
            });
            if (formCtrl) {
              formCtrl.$setDirty();
            }
          }

          function removeHours(time) {
            scope.times.splice(scope.times.indexOf(time), 1);
            if (formCtrl) {
              formCtrl.$setDirty();
            }
          }

        }
      };
    });

}());

(function() {
  'use strict';

  rzSliderOptions.$inject = ['RzSlider', 'rzSliderTicksCount'];
  angular.module('ptCrm')
    .value('rzSliderTicksCount', 12)
    .run(rzSliderOptions);


  function rzSliderOptions(RzSlider, rzSliderTicksCount) {

    /**
     * patched method Slider.updateTicksScale from bower_components/angularjs-slider/src/rzslider.js:736
     * always shows the given number of dashes
     *
     */
    RzSlider.prototype.updateTicksScale = function() {


      if (!this.options.showTicks) {
        return;
      }

      // freeze number of ticks in sliders
      var ticksCount = rzSliderTicksCount;

      this.scope.ticks = [];
      for (var i = 0; i < ticksCount; i++) {
        var value = this.roundStep(this.minValue + i * this.step);
        var tick = {
          selected: this.isTickSelected(value)
        };
        if (tick.selected && this.options.getSelectionBarColor) {
          tick.style = {
            'background-color': this.getSelectionBarColor()
          };
        }
        if (this.options.ticksTooltip) {
          tick.tooltip = this.options.ticksTooltip(value);
          tick.tooltipPlacement = this.options.vertical ? 'right' : 'top';
        }
        if (this.options.showTicksValues) {
          tick.value = this.getDisplayValue(value);
          if (this.options.ticksValuesTooltip) {
            tick.valueTooltip = this.options.ticksValuesTooltip(value);
            tick.valueTooltipPlacement = this.options.vertical ? 'right' : 'top';
          }
        }
        this.scope.ticks.push(tick);
      }
    };
  }


}());

(function() {
  'use strict';

  angular.module('ptCrm')
    .directive('segmentSlider', function() {
      sliderCtrl.$inject = ['$scope'];
      return {
        bindToController: {
          value: '=',
          options: '=',
          onEnd: '&'
        },
        controllerAs: 'slider',
        controller: sliderCtrl,
        template:
          '<div class="segment-slider">' +
            '<div class="segment-slider__control segment-slider__control--increase" ' +
              'ng-click="slider.increase()"></div>' +
            '<rzslider ng-if="slider.optReady" ' +
              'rz-slider-model="slider.val" ' +
              'rz-slider-options="slider.options">' +
            '</rzslider>' +
            '<div class="segment-slider__control segment-slider__control--decrease" ' +
              'ng-click="slider.decrease()"></div>' +
          '</div>'
      };

      function sliderCtrl($scope) {

        var vm = this;

        vm.val = 0;

        vm.increase = increase;
        vm.decrease = decrease;

        $scope.$watch(getValue, updateValue);

        updateOptions();

        function updateOptions() {
          if (_.isObject(vm.options)) {
            if (_.isArray(vm.options.enum)) {
              vm.options = _.extend({}, vm.options, generateEnumOptions(vm.options.enum));
            }

            vm.options = _.extend({}, vm.options, generateOptions(vm.options), getDefaultSliderOptions());
            vm.options.onChange = valueChanged;
            vm.options.onEnd = vm.onEnd;

            vm.val = vm.options.default || vm.options.floor;
          }

          vm.optReady = true;
        }

        function getValue() {
          return vm.value;
        }

        function updateValue(value) {
          if (value !== vm.val) {
            vm.val = value || vm.options.default || vm.options.floor;
            valueChanged();
          }
        }

        function valueChanged() {
          vm.val = +(+vm.val).toFixed(vm.options.precision) || vm.options.floor;

          if (vm.options.enum) {
            vm.value = getClosestVal(vm.val, vm.options.enum);
          } else {
            vm.value = vm.val;
          }

          if (vm.onChange) {
            vm.onChange();
          }
        }

        function increase() {
          var newVal = vm.val + vm.options.step;

          if (vm.options.enum) {
            newVal = _getSiblingEnum(newVal, vm.options.enum, +1);
          }

          vm.val = _.min([newVal, vm.options.ceil]);

          _triggerSliderChange();
        }

        function decrease() {
          var newVal = vm.val - vm.options.step;

          if (vm.options.enum) {
            newVal = _getSiblingEnum(newVal, vm.options.enum, -1);
          }

          vm.val = _.max([newVal, vm.options.floor]);

          _triggerSliderChange();
        }

        function _triggerSliderChange() {
          vm.options.onChange();
          vm.options.onEnd();
        }
      }


      function getDefaultSliderOptions() {
        return {
          vertical: true,
          hideLimitLabels: true,
          showTicks: true
        };
      }

      function generateOptions(options) {
        return {
          floor: options.minValue,
          ceil: options.maxValue,
          step: options.increment,
          precision: options.increment < 1 ? 1 : 0
        };
      }

      function generateEnumOptions(list) {
        return {
          minValue: _.min(list),
          maxValue: _.max(list),

          // TODO: improve
          increment: 1,
          default: list[0],
          translate: function(val) {
            return getClosestVal(val, list);
          }
        };
      }

      function getClosestVal(val, list) {
        return _.minBy(list, function(item) {
          return Math.abs(item - val);
        });
      }

      function _getSiblingEnum(val, list, indexDiff) {
        indexDiff = indexDiff || 0;

        var closestVal = getClosestVal(val, list),
          index = _.indexOf(list, closestVal),
          newIndex = _.max([index + indexDiff, 0]);

        return list[newIndex] || _.last(list);
      }


    });



}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('userCard', function() {
      return {
        templateUrl: '/app/components/user-card/user-card.html',
        bindToController: {
          user: '=',
          isRemovable: '=',
          remove: '&',
          role: '@?'
        },
        controllerAs: 'card',
        controller: function() {
        }
      };
    });

}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('libraryCard', function() {
      var SPRINT8_REGEX = /sprint\s8/i;

      // ========= HELPERS ===========

      var imageLookup = {
        bike: '//images.jhtassets.com/924391af84a225d36fdb5c726cb2a531b589e539/',
        stepper: '//images.jhtassets.com/47b3756904136919d50b49c9f95ffb2bda3477e8/',
        treadmill: '//images.jhtassets.com/1b517b7ed1aef6db68a9b1bd736b96c5a9598244/',
        climbmill: '//images.jhtassets.com/e513570080625da8af5c215a25356a710ae1cb4c/',
        'elliptical-arc': '//images.jhtassets.com/f1fa94df4b0c34e49a6e59874cf366f65cde0b4c/',
        common: '//images.jhtassets.com/fbea4f75aee396e61378ee78a9d9ee37cc001e74/',
        sprint8: '//images.jhtassets.com/d17d412e18d6b030bb2c119ad18d7ff79236f026/'
      };

      function _getImageName(exercise) {

        var imageName;

        if (SPRINT8_REGEX.test(exercise.title)) {
          imageName = 'sprint8';
        } else {
          switch (exercise.equipmentType) {
          case 'Bike':
          case 'Stepper':
          case 'Treadmill':
          case 'Climbmill':
            imageName = exercise.equipmentType.toLowerCase();
            break;
          case 'Elliptical':
          case 'Arc_Trainer':
            imageName = 'elliptical-arc';
            break;
          case 'Hybrid_Bike':
            imageName = 'bike';
            break;
          default:
            imageName = 'common';
          }
        }
        return imageLookup[imageName];
      }

      return {
        templateUrl: '/app/components/library-card/library-card.html',
        replace: true,
        bindToController: {
          onEditCard: '&',
          onPrintCard: '&',
          data: '=',
          type: '@?',
          editPermission: '=',
          hidePrintIcon: '='
        },
        controllerAs: 'card',
        controller: ['exercisersService', 'exercisesService', function(exercisersService, exercisesService) {

          var vm = this;

          vm.metrics = vm.type === 'exercises' ? exercisersService.parseExercise(vm.data).metrics : '';
          vm.getImagePath = getImagePath;

          // ========= INIT =============
          if (vm.type === 'trainingSets') {
            vm.data.exercises = exercisesService.extendExercises(vm.data.exercises);
          }

          // ========= PUBLIC METHODS ===========
          function getImagePath() {
            if (vm.type === 'trainingSets') {
              return vm.data.picture || _getImageName(vm.data);
            }

            var primaryImage;
            if (!_.isEmpty(vm.data.images)) {
              primaryImage = _.find(vm.data.images, { isPrimary: true });
            }

            return primaryImage ? primaryImage.picturePath : _getImageName(vm.data);
          }


        }],
        link: function(scope, element) {
          element.on('click', function() {
            element.toggleClass('active');
          });
        }
      };
    });

}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('selectedExerciseCard', function() {
      return {
        templateUrl: '/app/components/selected-exercise-card/selected-exercise-card.html',
        scope: true,
        bindToController: {
          data: '=',
          index: '=',
          isRemovable: '=',
          removePermission: '=?',
          remove: '&'
        },
        controllerAs: 'card',
        controller: function() {
        }
      };
    });

}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('backButton', ['$state', 'USER_HOME_PAGE', 'popup', '$window', '$translate', function($state, USER_HOME_PAGE, popup, $window, $translate) {
      return {
        restrict: 'C',
        link: backButtonLink,
        scope: {
          needConfirmation: '<'
        }
      };

      function backButtonLink($scope, $element) {

        $element.on('click', onBackButtonClick);

        function onBackButtonClick() {
          if ($scope.needConfirmation) {
            popup.confirm({
              title: $translate.instant('ARE_YOU_SURE?'),
              description: $translate.instant('CHANGES_WILL_BE_DISCARDED'),
              okText: $translate.instant('Yes')
            }).then(_goToPrevState);
          } else {
            _goToPrevState();
          }
        }

        function _goToPrevState() {
          $window.history.back();
        }
      }
    }]);
}());

(function() {
  'use strict';


  popupService.$inject = ['$uibModal', '$translate', '$templateRequest', '$q'];
  angular.module('ptCrm')
    .service('popup', popupService);

  function popupService($uibModal, $translate, $templateRequest, $q) {
    return {
      show: show,
      confirm: confirm,
      alert: alert
    };

    /**
     * A service that helps you to create custom popups
     *
     * @constructor
     * @param {Object} options The object has following properties:
     *
     * - **cssClass** – `{string}` class that would be applied to popup content
     * - **title** – `{string}` popup title
     * - **description** – `{string}` popup description
     * - **content** – `{string}` popup description
     * - **templateUrl** – `{string}` url to the template, which will be included into content
     * - **okAction** – `{function}` function called after 'ok' click
     * - **okText** – `{string}` text of 'ok' button
     * - **cancelAction** – `{function}` function called after 'cancel' click
     * - **cancelText** – `{string}` text of 'ok' button
     * - **showCancel** – `{boolean}` condition to show/hide 'cancel' button
     * - **showOk** – `{boolean}` condition to show/hide 'ok' button
     * - **showLoading** – `{function}` function changed isLoading param
     *
     */

    function show(options) {
      options = options || {};

      var modalInstance = $uibModal.open({
        windowClass: options.windowClass,
        templateUrl: '/app/components/popup/_popup.html',
        controller: ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
          angular.extend($scope, options.scope || {});

          $scope.isLoading = false;
          $scope.cssClass = options.cssClass || '';
          $scope.title = options.title;
          $scope.description = options.description;
          $scope.content = options.content;

          var contentPromise = options.templateUrl ?
            $templateRequest(options.templateUrl) :
            $q.when(options.template || options.content || '');

          contentPromise.then(function(content) {
            $scope.content = content;
          });

          $scope.ok = function() {
            var closeFn = options.okAction || $uibModalInstance.close;
            closeFn($scope, $uibModalInstance);
          };

          $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');
          };

          $scope.back = function() {
            var closeFn = options.backAction || $uibModalInstance.close;
            closeFn($scope, $uibModalInstance);
          };

          $scope.showLoading = function(flag) {
            $scope.isLoading = flag;
          };

          $scope.showCancel = !_.isUndefined(options.showCancel) ? options.showCancel : true;
          $scope.showOk = !_.isUndefined(options.showOk) ? options.showOk : true;
          $scope.cancelText = options.cancelText || $translate.instant('CANCEL');
          $scope.okText = options.okText || $translate.instant('OK');
          $scope.showBack = _.isUndefined(options.showBack) ? false : options.showBack;
        }]
      });

      return modalInstance.result;
    }

    function confirm(options) {
      options = _.extend({
        title: $translate.instant('ARE_YOU_SURE?')
      }, options || {});

      return show(options);
    }


    function alert(options) {
      options = _.extend({
        showCancel: false
      }, options, {});

      return show(options);
    }

  }
}());

(function() {

  'use strict';

  libraryController.$inject = ['$scope', 'trainingSetService', 'exercisesService', '$state', 'printService'];
  angular.module('ptCrm')
    .controller('LibraryController', libraryController);

  function libraryController($scope, trainingSetService, exercisesService, $state, printService) {

    var vm = this;
    vm.filterByName = filterByName;

    vm.exercises = exercisesService.getTemplatesPaginateList();
    vm.editExercise = editExercise;
    vm.printExerciseTemplate = printExerciseTemplate;

    vm.trainingSets = trainingSetService.getTrainingSetsPaginateList();
    vm.editTrainingSet = editTrainingSet;
    vm.printTrainingSet = printTrainingSet;

    vm.scope = $scope;

    vm.showTab = showTab;
    vm.getCardPermission = getCardPermission;
    vm.activeTab = '';

    function filterByName() {
      vm.exercises
        .extendDefaultParams({ search: vm.search })
        .load({ update: true });
      vm.trainingSets
        .extendDefaultParams({ search: vm.search })
        .load({ update: true });
    }

    vm.filters = {
      isOpen: false,
      toggle: toggleFiltersBlock,
      select: selectFilter,
      list: _getFiltersList()
    };

    function selectFilter(filter) {
      filter._isSelected = !filter._isSelected;

      // TODO: implement
    }

    function editExercise(exercise) {
      $state.go('app.library.exercise', { id: exercise._id });
    }

    function printExerciseTemplate(item) {
      printService.printExerciseTemplate(item);
    }

    function editTrainingSet(set) {
      $state.go('app.library.set', { id: set._id });
    }

    function printTrainingSet(item) {
      printService.printTrainingSet(item);
    }

    function toggleFiltersBlock() {
      vm.filters.isOpen = !vm.filters.isOpen;
    }

    function showTab(subject) {
      vm.activeTab = subject;
    }

    function getCardPermission(card) {
      var subject = card.exercises ? 'TRAINING_SETS_UPDATE' : 'EXERCISES_UPDATE';
      var restricted = card.restricted ? '+RESTRICTED_FLAG_UPDATE' : '';
      var chainWide = card.chainWide ? '+CHAIN_WIDE_UPDATE' : '';
      return subject + restricted + chainWide;
    }

    // TODO: integrate
    function _getFiltersList() {
      return [{
        title: 'FACILITY',
        items: [
          { title: 'ALL' },
          { title: 'Treadmill' },
          { title: 'Studio' },
          { title: 'Rolling Hills' },
          { title: 'Virtual active' },
          { title: 'Lorem Ipsum' }
        ]
      }, {
        title: 'Equipment',
        items: [
          { title: 'ALL' },
          { title: 'Treadmill', _isSelected: true },
          { title: 'Studio' },
          { title: 'Rolling Hills' },
          { title: 'Virtual active' },
          { title: 'Lorem Ipsum' }
        ]
      }, {
        title: 'EXERCISE/PROGRAM_TYPE',
        items: [
          { title: 'ALL' },
          { title: 'Treadmill' },
          { title: 'Studio' }
        ]
      }, {
        title: 'EXERCISE/PROGRAM_TYPE',
        items: [
          { title: 'ALL' },
          { title: 'Treadmill' },
          { title: 'Studio' },
          { title: 'Rolling Hills' },
          { title: 'Virtual active' },
          { title: 'Lorem Ipsum' }
        ]
      }];
    }
  }

}());

(function() {

  'use strict';
  CreateAssignmentController.$inject = ['exercisersService', 'exercisesService', 'trainingSetService', 'assignmentsService', 'profileService', '$scope', '$rootScope', '$state', 'USER_HOME_PAGE', 'popup', '$translate', '$q'];
  angular.module('ptCrm')
    .controller('CreateAssignmentController', CreateAssignmentController);

  function CreateAssignmentController(exercisersService, exercisesService, trainingSetService, assignmentsService,
    profileService, $scope, $rootScope, $state, USER_HOME_PAGE, popup, $translate, $q) {

    var vm = this;

    var assignmentId = $state.params.id;
    var userId = $state.params.userId;

    // if userId is defined it means we got singleAssignment
    // otherwise it's massAssignment
    vm.isEdit = !!assignmentId;

    // we need scope for dragula directives
    vm.scope = $scope;
    vm.today = moment();
    vm.isLoading = false;

    vm.clients = exercisersService.getPaginateList({ role: 'client' });
    vm.trainers = exercisersService.getPaginateList({ role: 'trainer' });
    vm.exercises = exercisesService.getTemplatesPaginateList({});
    vm.trainingSets = trainingSetService.getTrainingSetsPaginateList({ withExercises: true });

    vm.initialDataIsLoaded = false;

    vm.selectedClients = [];
    vm.selectedTrainers = [];
    vm.selectedExercises = [];

    _.extend(vm, {
      loadExercises: loadExercises,
      loadTrainingSets: loadTrainingSets,

      loadClients: loadClients,
      removeClient: removeClient,
      loadTrainers: loadTrainers,
      removeTrainer: removeTrainer,
      isClientDisabled: isClientDisabled,
      isClientSelected: isClientSelected,
      isRequiredDataFilled: isRequiredDataFilled,
      activateDateTab: activateDateTab,
      checkTimeAvailability: checkTimeAvailability,
      removeExercise: removeExercise,
      filterExercises: filterExercises,
      navigateToUserDetails: navigateToUserDetails,
      resetAppointmentTime: resetAppointmentTime,
      activateTrainerTab: activateTrainerTab,
      activateExerciseTab: activateExerciseTab,
      save: save,
      remove: remove,
      parseDate: parseDate
    });

    // events
    $scope.$on('clients.drop-model', _refreshScroll);
    $scope.$on('trainers.drop-model', _refreshScroll);
    $scope.$on('exercises.items.drop-model', extractSet);
    $scope.$on('exercises.items.drop-model', _refreshScroll);

    $scope.$watch(function() {
      return { start: vm.startDate, end: vm.endDate };
    }, datesChanged, true);

    $scope.$watch(function() {
      return vm.selectedClients;
    }, selectedClientsChanged, true);

    $scope.$watch(function() {
      return vm.selectedTrainers;
    }, _replaceTrainer, true);

    $scope.$watch(function() {
      return vm.selectedExercises;
    }, function(newArr, oldArr) {
      if (newArr.length > oldArr.length) {
        vm.selectedExercises = oldArr.concat(_.differenceBy(newArr, oldArr, '_id'));
      }
    }, true);

    _init();

    // //////////////////////////////////////////////////////////////////////

    function _init() {
      _resetPageState();
      _checkStateParamsDate();

      $q.allSettled([
        getInitialUserDetails(),
        getInitialAssignmentDetails()
      ]).finally(function() {
        vm.initialDataIsLoaded = true;

        loadClients();
      });
    }

    function getInitialAssignmentDetails() {
      return !assignmentId ?
        $q.resolve() :
        assignmentsService.getAssignmentsById(assignmentId).then(fetchAssignmentDetails);
    }

    function getInitialUserDetails() {
      return !userId ?
        $q.resolve() :
        exercisersService.getExerciser(userId).then(function(client) {
          vm.selectedClients.push(client);
        });
    }

    function datesChanged() {
      checkTimeAvailability();

      if (vm.canPickTime) {
        assignmentsService.getAssignments({
          startDate: moment(vm.startDate).startOf('day').unix(),
          endDate: moment(vm.startDate).endOf('day').unix(),
          filter: 'appointed'
        }).then(function(response) {
          vm.timelineClients = assignmentsService.getAppointedAssignments(response.data);
        });
      } else {
        vm.timelineClients = [];
      }
    }

    function selectedClientsChanged(newValue, oldValue) {
      vm.timelineSelectedClients = assignmentsService.prepareSelectedClients(newValue);

      if (newValue.length > oldValue.length) {
        vm.selectedClients = oldValue.concat(_.differenceBy(newValue, oldValue, '_id'));
      }

      // clear exercises, and reload for single user (could be talored)
      if ((newValue && newValue.length === 1) || (oldValue && oldValue.length === 1)) {
        vm.exercises.reset();
      }
    }

    function parseDate() {
      return moment(vm.startDate).format('MM/DD/YYYY') + ((vm.endDate.isSame(vm.startDate, 'day')) ? '' : ' - ' +
        moment(vm.endDate).format('MM/DD/YYYY'));
    }

    function removeClient(index) {
      var client = vm.selectedClients[index];
      if (client) {
        vm.selectedClients.splice(index, 1);
        vm.clients.items.unshift(client);
        _refreshScroll();
      } else {
        popup.alert({
          title: $translate.instant('CAN_NOT_FIND_SELECTED_CLIENT')
        });
      }

      if (!vm.selectedClients.length) {
        _resetPageState();
      }
    }

    function removeTrainer(index) {
      var trainer = vm.selectedTrainers[index];
      vm.selectedTrainers = [];
      vm.trainers.items.unshift(trainer);
    }

    function removeExercise(index) {
      var exercise = vm.selectedExercises[index];
      if (exercise) {
        vm.selectedExercises.splice(index, 1);
        vm.exercises.items.push(exercise);
        _refreshScroll();
      } else {
        popup.alert({
          title: $translate.instant('CAN_NOT_FIND_SELECTED_EXERCISE')
        });
      }
    }

    function loadClients(isUpdate) {
      return vm.clients
        .extendDefaultParams({ search: vm.clientSearch })
        .load({
          update: isUpdate,
          responseExtract: function(clients) {
            return filterSelectedUsers(clients, vm.selectedClients);
          }
        });
    }

    function loadTrainers(isUpdate) {
      return vm.trainers
        .extendDefaultParams({ search: vm.trainerSearch })
        .load({
          update: isUpdate,
          responseExtract: function(trainers) {
            return filterSelectedUsers(trainers, vm.selectedTrainers);
          }
        });
    }

    function filterExercises() {
      return $q.all([
        loadExercises(true),
        loadTrainingSets(true)
      ]);
    }

    function loadExercises(isUpdate) {
      return vm.exercises
        .extendDefaultParams(getExercisesParams())
        .load({
          update: isUpdate,
          responseExtract: filterSelectedExercises
        });
    }

    function loadTrainingSets(isUpdate) {
      return vm.trainingSets
        .extendDefaultParams({ search: vm.exerciseSearch })
        .load({ update: isUpdate });
    }

    function getExercisesParams() {
      var isSingleUser = vm.selectedClients.length === 1;

      return {
        search: vm.exerciseSearch,
        clientId: isSingleUser ? vm.selectedClients[0]._id : ''
      };
    }

    function activateTrainerTab() {
      var currentUser = _.assign({}, profileService.user);

      if (_.isEmpty(vm.selectedTrainers) && _.includes(currentUser.roles, 'trainer')) {
        vm.selectedTrainers.push(currentUser);
      }

      $rootScope.$emit('infiniteScroll:complete');
      _refreshScroll();
    }

    function activateExerciseTab() {
      vm.isExerciseTabWasSelected = true;

      $rootScope.$emit('infiniteScroll:complete');
      _refreshScroll();
    }

    function activateDateTab(startDate, endDate) {
      if (!vm.isDateTabWasSelected) {
        vm.startDate = moment(startDate);
        vm.endDate = moment(endDate);
      }

      checkTimeAvailability();

      vm.isDateTabWasSelected = true;
    }

    function _checkStateParamsDate() {
      if ($state.params.startDate && $state.params.endDate) {
        activateDateTab(moment.unix($state.params.startDate), moment.unix($state.params.endDate));
      }
    }

    function checkTimeAvailability() {
      vm.canPickTime = moment(vm.startDate).isSame(vm.endDate, 'day');
    }

    function isClientSelected() {
      return vm.selectedClients.length;
    }

    function isRequiredDataFilled() {
      return !!(vm.selectedClients.length && vm.selectedTrainers.length);
    }

    function resetAppointmentTime() {
      vm.startTime = null;
      vm.endTime = null;
    }

    function navigateToUserDetails(user) {
      if (user && user.exerciserId) {
        $state.go('app.users.details', { userId: user.exerciserId });
      }
    }

    function save() {
      vm.isLoading = true;
      saveAssignment()
        .finally(function() {
          vm.isLoading = false;
        })
        .then(function() {
          if (vm.selectedClients.length === 1) {
            return $state.go('app.users.details', { userId: vm.selectedClients[0]._id });
          } else {
            return $state.go(USER_HOME_PAGE.URL);
          }
        }, function(error) {
          var errorTitle = vm.isEdit ?
            $translate.instant('ERROR_CANNOT_UPDATE_ASSIGNMENT') :
            $translate.instant('ERROR_CANNOT_SAVE_ASSIGNMENT');

          return popup.alert({
            title: errorTitle,
            description: error
          });
        });
    }

    function saveAssignment() {
      var clients = vm.selectedClients;
      return vm.isEdit ?
        assignmentsService.updateMassAssignment(_createRequestBody(), clients, assignmentId) :
        assignmentsService.createAssignment(_createRequestBody(), clients);
    }

    function _resetPageState() {
      vm.selectedExercises.length = 0;
      vm.selectedClients.length = 0;
      vm.selectedTrainers.length = 0;

      vm.isDateTabWasSelected = false;
      vm.isExerciseTabWasSelected = false;

      vm.startDate = null;
      vm.endDate = null;

      resetAppointmentTime();
    }

    function _refreshScroll() {
      $rootScope.$emit('iscroll:refresh');
    }

    function _replaceTrainer(newSelectedTrainers, oldSelectedTrainers) {
      if (newSelectedTrainers.length > 1 && oldSelectedTrainers.length) {
        var newTrainer = _.reject(newSelectedTrainers, { _id: oldSelectedTrainers[0]._id });
        var oldTrainer = oldSelectedTrainers[0];
        vm.trainers.items.unshift(oldTrainer);
        vm.selectedTrainers = newTrainer;
      }
    }

    function extractSet() {
      // only trainingSet will have exercises field
      var trainingSet = _.find(vm.selectedExercises, 'exercises');

      if (trainingSet) {
        vm.selectedExercises = _.chain(vm.selectedExercises)
          .without(trainingSet)
          .concat(trainingSet.exercises)
          .uniqBy('_id')
          .value();

        vm.exercises.items = filterSelectedExercises(vm.exercises.items);
      }
    }

    function _createRequestBody() {
      var body = {
        startDate: vm.startDate ? moment(vm.startDate).startOf('day').unix() : null,
        endDate: vm.endDate ? moment(vm.endDate).endOf('day').unix() : null,
        exercises: _.map(vm.selectedExercises, prepareExercise),
        exercisers: _.map(vm.selectedClients, '_id'),
        trainerId: _.get(vm.selectedTrainers[0], '_id')
      };

      if (vm.canPickTime && vm.startTime && vm.endTime) {
        var currentDate = moment(vm.startDate),
          currentYear = currentDate.year(),
          currentMonth = currentDate.month(),
          currentDay = currentDate.date(),
          startTime = moment(vm.startTime).set({
            year: currentYear,
            month: currentMonth,
            date: currentDay
          });

        angular.extend(body, {
          appointment: {

            /* apply selected time to selected date */
            startTime: startTime.unix(),

            /* have to reduce end time by 1 second to avoid time ranges intersections */
            endTime: moment(startTime).add(vm.endTime - vm.startTime, 'ms').unix() - 1
          }
        });
      }

      return body;
    }

    function prepareExercise(exercise) {
      return _.omit(exercise, [
        'restricted',
        'facility',
        'totalDuration',
        'exerciseTemplateId',
        'completedManually',
        'pictureUrl',
        'id'
      ]);
    }

    function fetchAssignmentDetails(assignment) {
      vm.selectedExercises = mergeExercises(vm.selectedExercises, assignment.exercises);
      vm.selectedExercises = exercisesService.extendExercises(vm.selectedExercises);
      activateExerciseTab();
      activateDateTab();
      vm.startDate = moment.unix(assignment.startDate);
      vm.endDate = moment.unix(assignment.endDate);

      vm.editAssignment = assignment;

      var clientIds = _.map(assignment.exercisers, '_id');
      var trainerId = assignment.trainerId;

      if (trainerId) {
        getClientsByIds([trainerId]).then(function(trainers) {
          vm.selectedTrainers = trainers;
        });
      }

      if (clientIds.length) {
        return getClientsByIds(clientIds).then(function(clients) {
          vm.selectedClients = clients;
          vm.activeAssignment = assignmentsService.getAppointedAssignment(clients[0], vm.editAssignment);
        });
      }
    }

    function remove() {
      return popup.confirm({
        title: $translate.instant('DELETE_THIS_ASSIGNMENT?'),
        description: $translate.instant('PLEASE_CONFIRM_DELETE_ASSIGNMENT'),
        okText: $translate.instant('DELETE_ASSIGNMENT')
      }).then(function() {
        return assignmentsService.deleteMassAssignment(vm.editAssignment._id)
          .then(function() {
            $state.go(USER_HOME_PAGE.URL);
          }, function() {
            return popup.alert({
              title: $translate.instant('ERROR_CANNOT_DELETE_ASSIGNMENT')
            });
          });
      });
    }

    function isClientDisabled(user) {
      return !user.clientProfile || !user.clientProfile.sessionRemains || user.clientProfile.sessionRemains <= 0;
    }

    function mergeExercises(selectedExercises, exercises) {
      return _.chain(selectedExercises)
        .concat(exercises)
        .uniqBy('_id')
        .value();
    }

    function getClientsByIds(ids) {
      var clientPromises = _.map(ids, exercisersService.getExerciser);

      return $q.allSettled(clientPromises).then(function(results) {
        return _.chain(results)
          .filter('value')
          .map('value')
          .value();
      });
    }

    function filterSelectedExercises(exercises) {
      return _.differenceBy(exercisesService.extendExercises(exercises), vm.selectedExercises, function(exercise) {
        return exercise.exerciseTemplateId || exercise._id;
      });
    }

    function filterSelectedUsers(users, selectedUsers) {
      return _.differenceBy(users, selectedUsers, '_id');
    }
  }
}());

(function() {

  'use strict';

  TaskController.$inject = ['exercisersService', 'taskService', 'assignmentsService', '$state', '$scope', 'profileService', 'popup', '$translate', '$q'];
  angular.module('ptCrm')
    .controller('TaskController', TaskController);

  function TaskController(exercisersService, taskService, assignmentsService,
    $state, $scope, profileService, popup, $translate, $q) {

    var vm = this;
    vm.form = {};
    vm.task = getFormattedTask();
    vm.today = moment();
    vm.isEdit = !!$state.params.id;

    vm.remove = remove;
    vm.save = save;
    vm.activateDateTab = activateDateTab;
    vm.parseDate = parseDate;
    vm.resetAppointmentTime = resetAppointmentTime;
    vm.navigateToUserDetails = navigateToUserDetails;
    vm.onEditAssigment = onEditAssigment;
    vm.onEditTask = onEditTask;

    // ========= FOR date-time PICKER ==========
    $scope.$watch(function() {
      return {
        start: vm.task.startDate,
        end: vm.task.endDate
      };
    }, prepareTimeline, true);

    $scope.$watch(function() {
      return vm.task.users.length;
    }, prepareNamePlate);

    $scope.$watch(function() {
      return vm.task.users.length;
    }, prepareTimeline);

    init();
    function init() {
      updatePermissions();
      vm.users = exercisersService.getPaginateList(null, filterOutClients);

      if (vm.isEdit) {
        taskService.getTask($state.params.id).then(function(task) {

          // if there is no task -> create
          if (!task) {
            console.warn('No task with id', $state.params.id); // eslint-disable-line no-console
            $state.params.id = '';
            vm.isEdit = false;
            return;
          }
          _.extend(vm.task, getFormattedTask(task));

          // now dateTab is ready for rendering
          vm.isDateTabWasSelected = true;
          fetchUserDetails(task.users[0]);
        });
      } else {

        if ($state.params.startDate || $state.params.endDate) {
          vm.isDateTabWasSelected = true;
        }

        // user was selected on previous page
        // now only one user for one task
        if ($state.params.userId) {
          fetchUserDetails($state.params.userId);
        }
      }
    }

    // =================================================================
    // ========================== PUBLIC METHODS =======================
    // =================================================================
    function remove(id) {
      popup.confirm().then(function() {
        taskService.deleteTask(id).then(function() {
          $state.go('app.library.list');
        });
      });
    }

    function save(task) {
      var formattedTask = formatTask(task);
      var isValid = isTaskValid(formattedTask);
      if (!isValid) {
        return popup.alert({
          title: $translate.instant('ERROR_CANNOT_SAVE_TASK')
        });
      } else {
        var promise = vm.isEdit ?
          taskService.editTask(formattedTask) :
          taskService.createTask(formattedTask);

        promise.then(function(task) {
          $state.go('app.calendar', {
            date: task.startTime,
            userId: task.users[0]
          });
        }, function() {
          var errorMessage = vm.isEdit ?
            $translate.instant('ERROR_CANNOT_UPDATE_TASK') :
            $translate.instant('ERROR_CANNOT_SAVE_TASK');

          return popup.alert({ title: errorMessage });
        });
      }
    }

    // ============= for date-time picker ================
    function activateDateTab(startDate, endDate) {
      if (!vm.isDateTabWasSelected) {
        vm.task.startDate = moment(startDate).startOf('day');
        vm.task.endDate = moment(endDate).endOf('day');
      }

      checkTimeAvailability();

      vm.isDateTabWasSelected = true;
    }

    function parseDate() {
      return moment(vm.task.startDate).format('MM/DD/YYYY') +
        (isInsideOneDay() ? '' :
        ' - ' + moment(vm.task.endDate).format('MM/DD/YYYY'));
    }

    function resetAppointmentTime() {
      vm.task.appointment.startTime = null;
      vm.task.appointment.endTime = null;
    }

    // =================================================================
    // ========================== HELPERS ==============================
    // =================================================================


    function isTaskValid(task) {
      return task.title && task.endTime && task.startTime && !_.isEmpty(task.users);
    }

    function formatTask(task) {
      var formattedTask = {
        _id: task._id,
        users: _.map(task.users, '_id'),
        title: task.title,
        description: task.description
      };

      if (isInsideOneDay() && task.appointment.startTime && task.appointment.endTime) {
        formattedTask.startTime = moment(task.appointment.startTime).set({
          year: task.startDate.year(),
          month: task.startDate.month(),
          date: task.startDate.date()
        }).unix();
        formattedTask.endTime = moment(task.appointment.endTime).set({
          year: task.endDate.year(),
          month: task.endDate.month(),
          date: task.endDate.date()
        }).unix();
      } else {
        formattedTask.startTime = moment(task.startDate).startOf('day').unix();
        formattedTask.endTime = moment(task.endDate).add(1, 'day').startOf('day').unix();
      }

      return formattedTask;
    }

    function getFormattedTask(task) {
      task = task || {};
      return {
        _id: task._id || $state.params._id,
        users: [], // users will be placed here after fetchUserDetails()
        appointment: {
          endTime: task.endTime && moment.unix(task.endTime),
          startTime: task.startTime && moment.unix(task.startTime)
        },
        startDate: getMoment(task.startTime || $state.params.startDate, 'start'),
        endDate: getMoment(task.endTime || $state.params.endDate, 'end'),
        title: task.title,
        description: task.description
      };
    }

    function getMoment(date, dayTime) {
      return date && moment.unix(date)[dayTime + 'Of']('day');
    }

    function fetchUserDetails(userId) {
      return exercisersService.getExerciser(userId).then(function(user) {
        vm.task.users.push(user);
        prepareNamePlate(vm.task.users);
      });
    }

    function filterOutClients(users) {
      return _.filter(users, function(user) {
        return _.intersection(user.roles, ['trainer', 'facility_staff']).length;
      });
    }

    // ============= for date-time picker ================
    function isInsideOneDay() {
      return moment(vm.task.startDate).isSame(vm.task.endDate, 'day');
    }

    function checkTimeAvailability() {
      vm.canPickTime = isInsideOneDay();
    }

    function prepareNamePlate(newValue, oldValue) {
      if (newValue !== oldValue) {

        vm.namePlate = assignmentsService.prepareSelectedClients(vm.task.users);
        vm.namePlate.type = 'task';
      }
    }

    function updatePermissions() {
      var isMy = vm.task.users[0] &&
        (vm.task.users[0]._id === 'me' || vm.task.users[0]._id === profileService.user._id);
      vm.createPermission = isMy ? 'TASKS_SELF_CREATE' : 'TASKS_OTHER_CREATE';
      vm.editPermission = isMy ? 'TASKS_SELF_UPDATE' : 'TASKS_OTHER_UPDATE';
      vm.deletePermission = isMy ? 'TASKS_SELF_DELETE' : 'TASKS_OTHER_DELETE';
    }

    function prepareTimeline(newValue, oldValue) {

      if (newValue !== oldValue && vm.task.users[0] && vm.isDateTabWasSelected) {
        updatePermissions();
        checkTimeAvailability();
        if (vm.canPickTime) {
          $q.all({
            assignments: fetchAssignments(),
            tasks: fetchTasks()
          }).then(function(responses) {
            var tasks = _.map(responses.tasks.data, taskService.prepareTask.bind(null, vm.task.users[0]));
            var assignments = assignmentsService.getAppointedAssignments(responses.assignments.data);
            if (vm.isEdit) {
              vm.taskOnEdit = _.find(tasks, { _id: vm.task._id });
            }

            vm.timeSlots = assignments.concat(tasks);
          });
        }
      }
    }

    function fetchAssignments() {
      return assignmentsService.getAssignments({
        startDate: moment(vm.task.startDate).startOf('day').unix(),
        endDate: moment(vm.task.startDate).endOf('day').unix(),
        filter: 'appointed'
      }).catch(function(error) {
        console.warn('getAssignments unsuccessful', error); // eslint-disable-line no-console
        return {};
      });
    }

    function fetchTasks() {
      return taskService.getTasks({
        userId: vm.task.users[0]._id,
        startTime: moment(vm.task.startDate).startOf('day').unix(),
        endTime: moment(vm.task.startDate).add(1, 'day').startOf('day').unix()
      }).catch(function(error) {
        console.warn('getTasks unsuccessful', error); // eslint-disable-line no-console
        return {};
      });
    }

    //  ============= navigators =================
    function navigateToUserDetails(item) {
      return $state.go('app.users.details', { userId: item.exerciserId });
    }
    function onEditAssigment(item) {
      $state.go('app.assignment', { id: item._id, userId: item.exerciserId });
    }
    function onEditTask(item) {
      return $state.go('app.task', { id: item._id, userId: item.exerciserId });
    }

  }
}());

(function() {

  'use strict';

  CreateTrainingSetController.$inject = ['$state', 'popup', '$translate', 'exercisesService', 'exerciseImagesService', 'trainingSetService', 'USER_HOME_PAGE'];
  angular.module('ptCrm')
    .controller('CreateTrainingSetController', CreateTrainingSetController);

  function CreateTrainingSetController(
    $state, popup, $translate, exercisesService, exerciseImagesService, trainingSetService, USER_HOME_PAGE) {

    var vm = this;

    vm.activeExerciseIndex = 0;
    vm.editExercise = editExercise;
    vm.setVideo = setVideo;
    vm.save = save;
    vm.cancel = cancel;
    vm.remove = remove;
    vm.isLoading = false;
    vm.deletePermission = false;

    // should be availiable before carusel init
    vm.set = {
      imagesList: exerciseImagesService.getInstance()
    };


    if ($state.params.id) {
      vm.isEdit = true;
      fetchTraingSetAndInit($state.params.id);
    } else {
      vm.isEdit = false;
      init({});
      vm.exercises = exercisesService.getTemplatesPaginateList(null, _filterExerciseTiles);
      vm.exercises.load();
    }


    function init(set) {
      vm.set = {
        _id: set._id,
        title: set.title,
        description: set.description,
        video: set.video,
        imagesList: set.imagesList || exerciseImagesService.getInstance(),
        exercises: set.exercises || [],
        restricted: set.restricted,
        chainWide: set.chainWide
      };
    }

    function fetchTraingSetAndInit(id) {
      return trainingSetService.getTrainingSet(id)
        .then(function(set) {
          if (set.restricted && !exercisesService.hasPermission('RESTRICTED_FLAG_UPDATE')) {
            return $state.go(USER_HOME_PAGE.URL, _.extend($state.params, USER_HOME_PAGE.PARAMS));
          }
          vm.deletePermission = updateDeletePermission(set);
          set.exercises = exercisesService.extendExercises(set.exercises);
          set.imagesList = exerciseImagesService.getInstance(set.picture && [{
            picturePath: set.picture
          }]);

          init(set);

          // load exercises for tiles
          vm.exercises = exercisesService.getTemplatesPaginateList(null, _filterExerciseTiles);
          vm.exercises.load();
        });
    }

    // =============== METHODS ============
    function editExercise(exercise) {
      $state.go('app.library.exercise', { id: exercise._id });
    }


    function setVideo(videoUrl) {
      vm.set.video = videoUrl;
    }

    function save(set) {
      var formattedSet = _formatSet(set);
      var isValid = _isSetValid(formattedSet);
      if (!isValid) {
        return popup.alert({
          title: $translate.instant('ERROR_CANNOT_SAVE_TRAINING_SET')
        });
      } else {
        vm.isLoading = true;
        var promise = vm.isEdit ?
          trainingSetService.editTrainingSet(formattedSet) :
          trainingSetService.createTrainingSet(formattedSet);

        promise.then(function() {
          vm.isLoading = false;
          $state.go('app.library.list', { tab: 'TRAINING_SETS_READ' });
        });
      }
    }

    function cancel() {
      return popup.confirm({
        title: $translate.instant('ARE_YOU_SURE?'),
        okText: $translate.instant('CANCEL_TRAINING_SET')
      }).then(function() {
        return $state.go('app.library.list', { tab: 'TRAINING_SETS_READ' });
      });
    }


    function remove(id) {
      return popup.confirm({
        title: $translate.instant('DELETE_THIS_TRAINING_SET?'),
        description: $translate.instant('PLEASE_CONFIRM_DELETE_TRAINING_SET'),
        okText: $translate.instant('DELETE_TRAINING_SET')
      })
        .then(function() {
          return trainingSetService.deleteTrainingSet(id)
            .then(function() {
              $state.go('app.library.list', { tab: 'TRAINING_SETS_READ' });
            }, function() {
              return popup.alert({
                title: $translate.instant('ERROR_CANNOT_DELETE_TRAINING_SET')
              });
            });
        });
    }


    //  ================= HELPERS ==============
    function _formatSet(set) {
      return {
        _id: set._id,
        title: set.title,
        description: set.description,
        video: set.video || undefined,
        picture: set.imagesList.items[0] && set.imagesList.items[0].picture,
        pictureIsDeleted: _.isEmpty(set.imagesList.items),
        exercises: set.exercises,
        restricted: set.restricted,
        chainWide: set.chainWide
      };
    }


    function _isSetValid(formattedSet) {
      return formattedSet.title && !_.isEmpty(formattedSet.exercises);
    }

    function updateDeletePermission(set) {
      return 'TRAINING_SETS_DELETE' +
        (set.restricted ? '+RESTRICTED_FLAG_DELETE' : '') +
        (set.chainWide ? '+CHAIN_WIDE_DELETE' : '');
    }

    // the paginate-list used by the exercisesService exposes a callback that is used to map
    // the data for the exercises that it fetches. However, in this instance, we only want to
    // return unselected exercises, and we want to do this filtering out of the selected exercises
    // on every call of the infinite scroll function, so we must filter them out in the callback.
    function _filterExerciseTiles(items) {
      var selectedIds = vm.set && vm.set.exercises ? _.map(vm.set.exercises, '_id') : [];
      return exercisesService.extendExercises(_.reject(items, function(exercise) {
        return _.includes(selectedIds, exercise._id);
      }));
    }
  }

}());

(function() {

  'use strict';

  rosterController.$inject = ['exercisersService'];
  angular.module('ptCrm')
    .controller('RosterController', rosterController);

  function rosterController(exercisersService) {

    var vm = this;

    vm.clientsList = exercisersService.getPaginateList();
    vm.loadClients = loadClients;
    vm.filterByName = filterByName;
    vm.getUrlByGroup = getUrlByGroup;
    vm.getUserViewPermission = getUserViewPermission;

    loadClients();

    function loadClients() {
      return vm.clientsList.load();
    }

    function filterByName() {
      vm.clientsList
        .extendDefaultParams({ search: vm.search })
        .load({ update: true });
    }

    function getUrlByGroup(person) {

      // TODO: @afilenko remove when data will be received from server
      return person.group === 'facility-staff' ? 'facility-staff' : 'client';
    }

    function getUserViewPermission(client) {
      return _.includes(client.roles, 'client') ? 'ROSTER_CLIENT_VIEW_READ' : 'ROSTER_NON_CLIENT_VIEW_READ';
    }
  }

}());

(function() {

  'use strict';

  ExerciseController.$inject = ['exercisesService', '$rootScope', '$timeout', '$state', '$q', 'toastr', '$translate', '$scope', 'popup', 'exerciseImagesService', 'USER_HOME_PAGE'];
  angular.module('ptCrm')
    .controller('ExerciseController', ExerciseController);

  function ExerciseController(exercisesService, $rootScope, $timeout, $state, $q,
    toastr, $translate, $scope, popup, exerciseImagesService, USER_HOME_PAGE) {

    var vm = this;
    var handleEvents = _handleSegmentScrollEvents();
    var exerciseId = $state.params.id;

    init();

    function init() {
      vm.exercise = {};
      vm.isEdit = !!exerciseId;
      vm.exercise.images = exerciseImagesService.getInstance();
      vm.details = {};
      vm.equipmentPresets = [];
      vm.selectedEquipment = null;
      vm.isConnected = false;
      vm.categories = [];
      vm.totalDuration = 0;
      vm.segments = [];
      vm.global = {};
      vm.isLoading = false;
    }

    // define public methods in the followong way to avoid "too many statements" error
    angular.extend(vm, {
      isActiveEquipment: isActiveEquipment,
      selectEquipment: selectEquipment,
      addSegment: addSegment,
      setVideo: setVideo,
      moreSegmentsAvailable: moreSegmentsAvailable,
      activateSegment: activateSegment,
      canDeleteSegments: canDeleteSegments,
      deleteActiveSegment: deleteActiveSegment,
      resetActiveSegment: resetActiveSegment,
      sliderValueChanged: sliderValueChanged,
      createExercise: createExercise,
      deleteExercise: deleteExercise,
      cancelExercise: cancelExercise
    });


    $scope.$watch(function() {
      return vm.segments;
    }, _setSegmentsProgress, true);

    _resetSegments();
    _init();

    function _init() {
      vm.isLoading = true;

      $q.allSettled([
        fetchEquipmentPresets(),
        fetchCategories(),
        fetchCurrentExercise()
      ]).finally(function() {
        vm.isLoading = false;
      });
    }

    function fetchEquipmentPresets() {
      return exercisesService.getEquipmentPresets().then(function(data) {
        vm.equipmentPresets = data;
      });
    }

    function fetchCategories() {
      return exercisesService.getExerciseCategories().then(function(response) {
        vm.categories = response.data;
      });
    }

    function fetchCurrentExercise() {
      if (!exerciseId) {
        return $q.resolve();
      }

      return exercisesService.getExercise(exerciseId).then(function(response) {
        if (response.restricted && !exercisesService.hasPermission('RESTRICTED_FLAG_UPDATE')) {
          $state.go(USER_HOME_PAGE.URL, _.extend($state.params, USER_HOME_PAGE.PARAMS));
        } else {
          vm.exercise = response;
          setEditParams();
        }
      });
    }

    function setEditParams() {
      vm.details = _.pick(vm.exercise, ['_id', 'description', 'title', 'restricted', 'chainWide']);

      vm.exerciseVideo = vm.exercise.video;
      vm.exercise.images = exerciseImagesService.getInstance(vm.exercise.images);

      var equipmentPresets = _.find(vm.equipmentPresets, function(element) {
        if (element.equipmentType) {
          return element.equipmentType === vm.exercise.equipmentType;
        } else {
          return true;
        }
      });
      selectEquipment(equipmentPresets);

      vm.segments = _.map(vm.exercise.assignedProfile.segments, function(value) {
        return { data: value };
      });

      vm.global = vm.exercise.assignedProfile.global;
      vm.selectedEquipment.category = vm.exercise.category;
    }

    function setVideo(val) {
      vm.exerciseVideo = val;
    }

    function _resetSegments() {
      vm.segments.length = 0;
      activateSegment(null);
      addSegment();
      _refreshScroll();
    }

    function _resetGlobal() {
      vm.global = {};
    }

    function addSegment() {
      if (!moreSegmentsAvailable()) {
        return false;
      }

      vm.segments.push({ data: getEquipmentDefaultValues() });

      recalculateTotalDuration();
      _refreshScroll();

      if (vm.scrollInstance) {
        $timeout(function() {
          // scroll to the last segment
          if (vm.scrollInstance.pages.length) {
            vm.scrollInstance.goToPage(vm.scrollInstance.pages.length, 0);
          }

          handleEvents();
        });
      }
    }

    function sliderValueChanged(metricName) {
      if (metricName === 'duration') {
        recalculateTotalDuration();
      }
    }

    function recalculateTotalDuration() {
      if (vm.segments.length) {
        $timeout(function() {
          var total = _.reduce(vm.segments, function(time, segment) {
            return time + (segment.data.duration || 0);
          }, 0);

          vm.totalDuration = +total.toFixed(1);
        });
      }
    }

    function getEquipmentDefaultValues() {
      return _.chain(vm.selectedEquipment.metrics)
        .filter('forSegment')
        .keyBy('name')
        .mapValues('validation.default')
        .value();
    }

    function moreSegmentsAvailable() {
      return vm.selectedEquipment && vm.selectedEquipment.maxSegments > vm.segments.length;
    }

    function _handleSegmentScrollEvents() {
      return _.once(function() {
        vm.scrollInstance.on('refresh', _updateIscrollLimits);
        vm.scrollInstance.on('scrollEnd', _updateIscrollLimits);
      });
    }

    function _updateIscrollLimits() {
      $timeout(function() {
        vm.scrollInstance._enableLeft = false;
        vm.scrollInstance._enableRight = false;

        if (vm.scrollInstance.hasHorizontalScroll) {
          vm.scrollInstance._enableLeft = vm.scrollInstance.x !== 0;
          vm.scrollInstance._enableRight = vm.scrollInstance.x !== vm.scrollInstance.maxScrollX;
        }
      });
    }

    function activateSegment(segment) {

      // toggle state
      if (_.isObject(segment) && segment._isActive) {
        segment = null;
      }

      vm.activeSegment = segment;
      var activeSegment = _.find(vm.segments, { _isActive: true }) || {};
      activeSegment._isActive = false;

      if (_.isObject(segment)) {
        segment._isActive = true;
      }
    }

    function canDeleteSegments() {
      // the number of segments should be at least 1
      return vm.segments.length > 1;
    }

    function deleteActiveSegment() {
      var activeSegmentIndex = _.indexOf(vm.segments, vm.activeSegment),
        newActiveSegmentIndex = 0;

      if (activeSegmentIndex > -1) {
        vm.segments.splice(activeSegmentIndex, 1);

        // select previous segment or first segment
        newActiveSegmentIndex = _.max([activeSegmentIndex - 1, 0]);
        activateSegment(vm.segments[newActiveSegmentIndex]);

        recalculateTotalDuration();
        _refreshScroll();
      }
    }

    function resetActiveSegment() {
      if (vm.activeSegment) {
        vm.activeSegment.data = getEquipmentDefaultValues();
      }
    }

    function _setSegmentsProgress() {
      var params = ['startingResistance', 'startingIncline'];

      vm.segments.forEach(function(segment) {
        var resultsCount = 0,
          sum,
          percentage;

        sum = params.map(function(param) {
          var metric = _.find(vm.selectedEquipment.metrics, { name: param, forSegment: true });

          if (angular.isDefined(segment.data[param]) && metric) {
            resultsCount++;
            return (segment.data[param] - metric.validation.minValue) /
              (metric.validation.maxValue - metric.validation.minValue) * 100;
          }

          return 0;
        }).reduce(function(a, b) {
          return a + b;
        }, 0);


        percentage = sum / resultsCount;


        // handle NaN, negative values
        if (!percentage || percentage < 0) {
          percentage = 0;
        }

        segment._progressHeight = percentage + '%';
      });

      $scope.$applyAsync();
    }

    function editExercise() {
      if (!validateExercise()) {
        return false;
      }
      vm.isLoading = true;
      exercisesService.updateExercise(exerciseId, getExerciseFormatData())
        .then(function() {
          vm.exercise.images.save(exerciseId).finally(function() {
            vm.isLoading = false;
            $state.go('app.library.list', { tab: 'EXERCISES_READ' });
          });
        }, function() {
          toastr.error($translate.instant('ERROR_CANNOT_UPDATE_EXERCISE'));
        });
    }

    function deleteExercise() {
      return popup.confirm({
        title: $translate.instant('DELETE_THIS_EXERCISE?'),
        description: $translate.instant('PLEASE_CONFIRM_DELETE_EXERCISE'),
        okText: $translate.instant('DELETE_EXERCISE')
      })
        .then(function() {
          return exercisesService.deleteExercise(exerciseId)
            .then(function() {
              $state.go('app.library.list', { tab: 'EXERCISES_READ' });
            }, function() {
              toastr.error($translate.instant('ERROR_CANNOT_DELETE_EXERCISE'));
            });
        });
    }

    function createExercise() {

      if (vm.isLoading) {
        return;
      }

      if (vm.isEdit) {
        editExercise();
        return;
      }
      if (!validateExercise()) {
        return false;
      }

      vm.isLoading = true;

      exercisesService.createExercise(getExerciseFormatData())
        .then(function(resp) {
          vm.exercise.images.save(resp._id).finally(function() {
            vm.isLoading = false;
            $state.go('app.library.list', { tab: 'EXERCISES_READ' });
          });
        }, function() {
          toastr.error($translate.instant('ERROR_CANNOT_CREATE_EXERCISE'));
        });
    }

    function getExerciseFormatData() {
      return {
        title: vm.details.title,
        description: vm.details.description,

        chainWide: vm.details.chainWide,
        restricted: vm.details.restricted,
        equipmentType: vm.selectedEquipment.equipmentType,
        category: vm.selectedEquipment.category || 'Other',
        video: vm.exerciseVideo,
        assignedProfile: {
          global: vm.global,
          segments: _.map(vm.segments, 'data')
        },
        preset: _.pick(vm.selectedEquipment, 'maxSegments', 'metrics')
      };
    }

    function validateExercise() {
      if (!vm.selectedEquipment) {
        toastr.warning($translate.instant('WARN_CHOOSE_EQUIPMENT_TYPE'));
        return false;
      }

      if (!vm.details.title) {
        toastr.warning($translate.instant('WARN_SET_EXERCISE_TITLE'));
        return false;
      }

      return true;
    }

    function selectEquipment(eq) {
      vm.selectedEquipment = _.assign({}, eq);

      vm.isConnected = !!vm.selectedEquipment.equipmentType;
      _resetSegments();
      _resetGlobal();
    }

    function isActiveEquipment(eq) {
      return vm.selectedEquipment &&
        vm.selectedEquipment.equipmentType === eq.equipmentType &&
        vm.selectedEquipment.category === eq.category;
    }

    function _refreshScroll() {
      $rootScope.$emit('iscroll:refresh');
    }

    function cancelExercise() {
      popup.confirm({
        title: $translate.instant('ARE_YOU_SURE?'),
        okText: $translate.instant('CANCEL_EXERCISE')
      }).then(function() {
        $state.go(USER_HOME_PAGE.URL, _.extend($state.params, USER_HOME_PAGE.PARAMS));
      });
    }

  }

}());

(function() {
  'use strict';

  angular.module('ptCrm')
    .controller('PermissionGroupsCtrl', ['permissionGroupsService', 'permissionsService', '$translate', 'popup', 'profileService', '$q', function(permissionGroupsService, permissionsService,
      $translate, popup, profileService, $q) {
      var vm = this;

      vm.forms = {};
      vm.copy = copy;
      vm.remove = remove;
      vm.add = add;
      vm.save = save;
      vm.reset = reset;

      vm.myPermissons = {};
      vm.permissionGroups = {};

      $q.all({
        groups: permissionGroupsService.getGroups(),
        myPermissons: permissionsService.getUserPermissions(profileService.user._id)
      })
      .then(function(response) {
        vm.permissionGroups = response.groups.data;
        vm.myPermissons = response.myPermissons;
        vm.backup = angular.copy(vm.permissionGroups);
        if (vm.permissionGroups[0]) {
          vm.blank = createBlank(vm.permissionGroups[0]);
        } else {
          getFormattedGroup().then(function(emptyGroup) {
            vm.blank = createBlank(emptyGroup);
          });
        }
      });

      // ============ Methods =============
      function add() {
        var group = angular.copy(vm.blank);
        group._isNew = true;
        group._virtualId = getVirtualId();
        delete group._id;
        vm.permissionGroups.push(group);
      }

      function save() {
        popup.confirm({
          title: $translate.instant('ARE_YOU_SURE?'),
          description: $translate.instant('CHANGED_GROUP_PERMISSION'),
          templateUrl: '/app/settings/tabs/permissionGroups/deleteGroup.html',
          okText: $translate.instant('SAVE_CHANGES')
        }).then(function() {
          updateGroups();
        });
      }

      function reset() {
        vm.permissionGroups = angular.copy(vm.backup);
      }

      function remove(group) {
        var userGroups = vm.myPermissons.groups;
        var popupContent = {
          templateUrl: '/app/settings/tabs/permissionGroups/deleteGroup.html',
          okText: $translate.instant('DELETE_GROUP')
        };

        if (_.includes(userGroups, group._id)) {
          popupContent = _.extend(popupContent, {
            title: $translate.instant('ARE_YOU_SURE?'),
            description: $translate.instant('ADMINISRTATE_PERMISSION')
          });
        } else {
          popupContent = _.extend(popupContent, {
            title: $translate.instant('DELETE_THIS_GROUP?'),
            description: $translate.instant('PLEASE_CONFIRM_DELETE_GROUP'),
            scope: {
              group: group
            }
          });
        }
        popup.confirm(popupContent).then(function() {
          group.isDeleted = true;
        });
      }

      function copy(group) {
        var newGroup = angular.copy(group);
        newGroup._isNew = true;
        newGroup._virtualId = getVirtualId();
        delete newGroup._id;
        vm.permissionGroups.push(newGroup);
      }

      // =========== PRIVATE METHODS ==========
      function updateGroups() {
        _.each(vm.permissionGroups, function(permissionGroup) {

          if (permissionGroup.isDeleted) {
            if (!permissionGroup._isNew) {
              permissionGroupsService.deleteGroup(permissionGroup._id);
            }

          } else if (permissionGroup._isNew) {
            permissionGroupsService.createGroup(permissionGroup).then(function(data) {
              _updateGroupId(permissionGroup, data);
            });
            delete permissionGroup._isNew;
          } else if ((vm.forms[permissionGroup._id || permissionGroup._virtualId].$dirty)) {
            permissionGroupsService.setGroups(permissionGroup);
          }

          vm.forms[permissionGroup._id || permissionGroup._virtualId].$setPristine();

        });

        vm.backup = angular.copy(vm.permissionGroups);
      }

      function createBlank(permissionGroup) {
        var blank = angular.copy(permissionGroup);
        blank.name = 'New permission group';
        _.each(blank.subjects, function(subject) {
          _.each(subject.options, function(option, key) {
            subject.options[key] = false;
          });
        });
        return blank;
      }

      function _updateGroupId(group, data) {
        group._id = data._id;

        delete group._virtualId;
        vm.backup = angular.copy(vm.permissionGroups);
      }

      function getFormattedGroup() {
        return permissionGroupsService.getSubjects().then(function(subjects) {
          var emptyGroup = {
            subjects: _.map(subjects, function(subject) {
              return {
                name: subject.name,
                options: _.invert(subject.options)
              };
            })
          };
          return emptyGroup;
        });
      }

      function getVirtualId() {
        return _.uniqueId('virtual_');
      }

    }]);
}());

(function() {
  'use strict';

  permissionGroupsService.$inject = ['$http', 'config'];
  angular.module('ptCrm')
    .service('permissionGroupsService', permissionGroupsService);

  function permissionGroupsService($http, config) {
    return {
      getGroups: getPermissionGroups,
      setGroups: updatePermissionGroups,
      getSubjects: getAvailablePermissionSubjects,
      deleteGroup: deletePermissionGroup,
      createGroup: createPermissionGroup
    };

    function getPermissionGroups() {
      return $http.get(config.apiBase + '/permission_groups')
      .then(function(response) {
        return response.data;
      });
    }

    function updatePermissionGroups(permissionGroup) {
      return $http.put(config.apiBase + '/permission_groups/' + permissionGroup._id, {
        name: permissionGroup.name,
        subjects: permissionGroup.subjects
      });
    }

    function deletePermissionGroup(permissionGroupId) {
      return $http.delete(config.apiBase + '/permission_groups/' + permissionGroupId);
    }

    function createPermissionGroup(permissionGroups) {
      return $http.post(config.apiBase + '/permission_groups', {
        name: permissionGroups.name,
        subjects: permissionGroups.subjects
      }).then(function(response) {
        return response.data;
      });
    }


    function getAvailablePermissionSubjects() {
      return $http.get(config.apiBase + '/permission_subjects').then(function(response) {
        return response.data;
      });
    }
  }
}());

(function() {
  'use strict';
  angular.module('ptCrm')
    .controller('SettingLocalizationCtrl', SettingLocalizationCtrl);

  function SettingLocalizationCtrl() {
    var vm = this;

    vm.term = 'USER GENERATED NAME';
  }

}());

(function() {
  'use strict';
  angular.module('ptCrm')
    .controller('SettingsController', function() {
      var vm = this;

      vm.colorpickers = {
        main: false,
        action: false,
        selected: false,
        inTheGym: false
      };
      vm.selectedColorPicker = '';

      vm.onColorCheckboxClick = onColorCheckboxClick;
      vm.updateColor = updateColor;
      vm.resetColor = resetColor;

      function onColorCheckboxClick(colorName) {
        Object.keys(vm.colorpickers).map(function(key) {
          if (key !== colorName) {
            vm.colorpickers[key] = false;
          }
        });
        vm.selectedColorPicker = colorName;
      }

      function updateColor(color) {
        color.currentColor = color.newColor;
        closeColorPickerDropdown();
      }

      function resetColor(color) {
        color.newColor = color.currentColor;
        closeColorPickerDropdown();
      }

      function closeColorPickerDropdown() {
        Object.keys(vm.colorpickers).map(function(value) {
          vm.colorpickers[value] = false;
        });
      }

      // TODO: @afilenko remove when data will be received from server
      vm.mainColor = {
        currentColor: 'rgb(103, 130, 138)',
        newColor: 'rgb(103, 130, 138)'
      };

      vm.actionColor = {
        currentColor: 'rgb(21, 92, 150)',
        newColor: 'rgb(21, 92, 150)'
      };

      vm.selectedColor = {
        currentColor: 'rgb(245, 177, 32)',
        newColor: 'rgb(245, 177, 32)'
      };

      vm.inTheGymColor = {
        currentColor: 'rgb(34, 55, 69)',
        newColor: 'rgb(34, 55, 69)'
      };
    });
}());

(function() {
  'use strict';
  angular.module('ptCrm')
    .controller('RiskController', ['riskService', 'popup', '$translate', function RiskCtrl(riskService, popup, $translate) {
      var vm = this;
      vm.risks = {};
      vm.form = {};

      vm.save = save;
      vm.reset = init;

      init();

      function init() {
        riskService.getRisks().then(function(risks) {
          vm.risks = risks;
          vm.form.$setPristine();
        });
      }

      function save(risks) {
        var isValid = _.every(risks, isNaturalNumber);
        if (isValid) {
          riskService.updateRisks(risks)
            .then(function() {
              vm.form.$setPristine();
            });
        } else {
          popup.alert({
            title: $translate.instant('ONLY_NATURAL_NUMBERS!')
          });
        }
      }

      function isNaturalNumber(str) {
        var pattern = /^(0|([1-9]\d*))$/;
        return pattern.test(str);
      }

    }]);
}());

(function() {
  'use strict';

  angular.module('ptCrm')
    .directive('bindHtmlCompile', ['$compile', function($compile) {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          scope.$watch(function() {
            return scope.$eval(attrs.bindHtmlCompile);
          }, function(value) {
            element.html(value && value.toString());

            // If scope is provided use it, otherwise use parent scope
            var compileScope = scope;
            if (attrs.bindHtmlScope) {
              compileScope = scope.$eval(attrs.bindHtmlScope);
            }
            $compile(element.contents())(compileScope);
          });
        }
      };

    }]);

}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('integerOnly', function() {
      return {
        require: 'ngModel',
        link: function(scope, element, attr, ngModelCtrl) {
          function fromUser(text) {
            var transformedInput = String(text).replace(/[^0-9]/g, '');
            if (transformedInput !== text) {
              ngModelCtrl.$setViewValue(transformedInput);
              ngModelCtrl.$render();
            }
            return Number(transformedInput);
          }

          ngModelCtrl.$parsers.push(fromUser);
        }
      };
    });
}());

(function() {
  'use strict';

  angular.module('ptCrm')
    .directive('dragulaConfigure', function() {
      return {
        bindToController: {
          dragulaScope: '=',
          dragulaCopy: '=',
          dragulaBag: '@',
          dragulaDirection: '@',
          dragulaMoveOn: '@',
          dragulaInvalid: '@'
        },
        controllerAs: 'dragulaConf',
        controller: ['$scope', 'dragulaService', function($scope, dragulaService) {
          var vm = this;

          dragulaService.options(vm.dragulaScope, vm.dragulaBag, {
            copy: vm.dragulaCopy,
            revertOnSpill: vm.dragulaCopy,
            moves: function(el, container, handler) {

              if (vm.dragulaMoveOn) {
                return angular.element(handler).hasClass(vm.dragulaMoveOn);
              }

              return true;

            },
            invalid: function(el) {
              if (vm.dragulaInvalid) {
                return angular.element(el).hasClass(vm.dragulaInvalid);
              }
              return false;
            },
            direction: vm.dragulaDirection || 'vertical'
          });
        }]
      };
    });

}());

(function() {
  'use strict';

  angular.module('ptCrm')

    /**
     * infinite-scroll specifies a function to call when the container
     * is scrolled within a certain range from the bottom of the container
     *
     * @param {string} infinite-scroll Function from controller to be called
     * @param {boolean} can-load If set to false, infinite-scroll wont be called
     * @param {number} threshold Range in pixels, within infinite-scroll can be called
     *
     * @example
     <example>
       <ul style='height: 300px; overflow: auto;'
         infinite-scroll='updateData()'
         can-load='moreDataIsAvailable'
         threshold='30'>
         <li>lorem ipsum</li>
         ...
       </ul>
     </example>
     */

    .directive('infiniteScroll', ['$window', '$q', '$rootScope', function($window, $q, $rootScope) {
      return function(scope, element, attrs) {
        var offset = parseInt(attrs.threshold, 10) || 0,
          el = element[0],
          windowEl = angular.element($window),
          debouncedScroll = _debouncedScroll(),
          loadingInProcess = false;

        var deregisterInfiniteComplete =
          $rootScope.$on('infiniteScroll:complete', debouncedScroll);
        element.on('scroll', debouncedScroll);
        windowEl.on('resize', debouncedScroll);
        scope.$on('$destroy', _deregisterHandlers);

        function _debouncedScroll() {
          return _.throttle(function() {
            if (!loadingInProcess &&
              scope.$eval(attrs.canLoad) &&
              el.offsetParent &&
              el.scrollTop + el.offsetHeight >= el.scrollHeight - offset) {

              loadingInProcess = true;
              var result = scope.$apply(attrs.infiniteScroll);
              $q.when(result).finally(function() {
                _.defer(function() {
                  loadingInProcess = false;
                });
              });
            }
          }, 300, { leading: false });
        }

        function _deregisterHandlers() {
          windowEl.off('resize', debouncedScroll);
          deregisterInfiniteComplete();
        }

      };
    }]);

}());

(function() {
  'use strict';

  angular.module('ptCrm')
    .directive('unixDateInput', function() {
      return {
        require: 'ngModel',
        priority: 1,
        link: function(scope, ele, attr, ngModel) {
          // view to model
          ngModel.$parsers.push(function(value) {
            return moment(value).unix();
          });

          // model to view
          ngModel.$formatters.push(function(value) {
            return value ? moment.unix(value).toDate() : null;
          });
        }
      };
    });
}());


// This directive was taken from pt-mobile project
(function() {
  'use strict';

  angular.module('ptCrm')
    .directive('chart', pieChartDirective);

  function pieChartDirective() {

    return {
      restrict: 'A',
      scope: {
        data: '='
      },
      link: linkFn
    };


    function linkFn(scope, element) {

      if (element[0].tagName.toLowerCase() !== 'canvas') {
        console.error('chart directive requires "<canvas>" element'); // eslint-disable-line no-console
        return false;
      }

      var canvas = element[0],
        context = canvas.getContext('2d'),
        defaultFillColor = '#aaaaaa';

      scope.$watch(function() {
        return scope.data;
      }, function(data) {
        if (data && data.length) {
          pie(context, canvas.width, canvas.height, data);
        }
      }, true);


      function pie(ctx, w, h, dataList) {
        var radius = h / 2;
        var centerX = w / 2;
        var centerY = h / 2;
        var lastEnd = 0;

        var offset = Math.PI / 2;
        var labelXY = [];

        // clear canvas
        context.clearRect(0, 0, w, h);

        ctx.textAlign = 'center';
        ctx.font = '30px Arial';

        var total = 0;

        for (var n = 0; n < dataList.length; n++) {
          total += dataList[n].value;
        }

        for (var x = 0; x < dataList.length; x++) {
          var sectorPart = dataList[x].value;
          ctx.beginPath();
          ctx.fillStyle = dataList[x].color || defaultFillColor;
          ctx.moveTo(centerX, centerY);
          var arcSector = Math.PI * (2 * sectorPart / total);
          ctx.arc(centerX, centerY, radius, lastEnd - offset, lastEnd + arcSector - offset, false);
          ctx.lineTo(centerX, centerY);
          ctx.fill();
          ctx.closePath();

          labelXY.push(lastEnd + arcSector / 2 + Math.PI + offset);

          lastEnd += arcSector;
        }

        var lradius = radius / 2,
          percentValuesSum = 0;

        ctx.font = 'bold 20px Arial';
        ctx.strokeStyle = 'rgb(255,255,255)';
        ctx.fillStyle = 'rgb(255,255,255)';

        for (var i = 0; i < labelXY.length; i++) {
          var langle = labelXY[i],
            dx = centerX + lradius * Math.cos(langle),
            dy = centerY + lradius * Math.sin(langle),
            percentValue = Math.round(dataList[i].value / total * 100);

          // calculate last value as diff 100 and sum of other values
          if (i !== labelXY.length - 1) {
            percentValuesSum += percentValue;
          } else {
            percentValue = 100 - percentValuesSum;
          }

          if (percentValue && percentValue > 3) {
            ctx.fillText(percentValue + '%', dx, dy);
          }
        }
      }
    }

  }
}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .config(['uibDatepickerPopupConfig', function(uibDatepickerPopupConfig) {
      uibDatepickerPopupConfig.datepickerPopup = 'dd/MM/yyyy';
      uibDatepickerPopupConfig.appendToBody = true;
    }]);
}());

(function() {
  'use strict';

  angular.module('ptCrm').filter('camelToSnakeCase', function() {
    return function camelToSnakeCase(string) {
      return string && string.replace(/([A-Z])/g, '_$1').toUpperCase();
    };
  });

}());

angular.module('templates-dist', ['/app/auth/login.html', '/app/calendar/calendar.html', '/app/components/add-client/add-client.modal.html', '/app/components/add-client/add-staff.modal.html', '/app/components/add-client/add-user.modal.html', '/app/components/add-client/confirm-client.modal.html', '/app/components/add-client/find-staff.modal.html', '/app/components/calendar/calendar-body.html', '/app/components/datepicker/datepicker.html', '/app/components/day-schedule/day-schedule.html', '/app/components/embed-video/embed-video.html', '/app/components/exercise-item-details/exercise-item-details.html', '/app/components/exercise-multimedia/exercise-multimedia.html', '/app/components/exercise-profile/exercise-profile.html', '/app/components/exercise-profile/partials/connected-exercise-profile.html', '/app/components/exercise-profile/partials/not-connected-exercise-profile.html', '/app/components/header/facility.modal.html', '/app/components/header/header.html', '/app/components/image-carousel/image-carousel.html', '/app/components/items-bag/items-bag.html', '/app/components/left_menu/left_menu.html', '/app/components/library-card/library-card.html', '/app/components/popup/_popup.html', '/app/components/selected-exercise-card/selected-exercise-card.html', '/app/components/tabs/tab.html', '/app/components/tabs/tabs.html', '/app/components/time-slot/time-slot.html', '/app/components/timepicker/timepicker.html', '/app/components/user-card/user-card.html', '/app/components/users-bag/users-bag.html', '/app/dashboard/dashboard.html', '/app/layout/layout.html', '/app/library/create-assignment/create-assignment.html', '/app/library/create-assignment/tabs/client.html', '/app/library/create-assignment/tabs/date.html', '/app/library/create-assignment/tabs/exercise-profile.html', '/app/library/create-assignment/tabs/exercise.html', '/app/library/create-assignment/tabs/trainer.html', '/app/library/exercise/exercise.html', '/app/library/exercise/tabs/choose-equip.html', '/app/library/exercise/tabs/details.html', '/app/library/exercise/tabs/multimedia.html', '/app/library/exercise/tabs/profile-connected.html', '/app/library/exercise/tabs/profile-params.html', '/app/library/library.html', '/app/library/tabs/list.html', '/app/library/task/tabs/details.html', '/app/library/task/tabs/period.html', '/app/library/task/tabs/users.html', '/app/library/task/task.html', '/app/library/training-set/tabs/exercise-profile.html', '/app/library/training-set/tabs/exercises.html', '/app/library/training-set/tabs/training-set-details.html', '/app/library/training-set/tabs/training-set-media.html', '/app/library/training-set/training-set.html', '/app/roster/roster.html', '/app/schedule/schedule.html', '/app/settings/settings.html', '/app/settings/tabs/branding.html', '/app/settings/tabs/localization/localization.html', '/app/settings/tabs/permissionGroups/deleteGroup.html', '/app/settings/tabs/permissions.html', '/app/settings/tabs/risk.html', '/app/user/tabs/nutrition/nutrition.html', '/app/user/tabs/permissions/groups-modal.html', '/app/user/tabs/permissions/permissions.html', '/app/user/tabs/schedule.html', '/app/user/tabs/userDetails/certifications/certifications.html', '/app/user/tabs/userDetails/changePassword/change-password-modal.html', '/app/user/tabs/userDetails/deleteAccount/deleteAccount.html', '/app/user/tabs/userDetails/facilityStaff.html', '/app/user/tabs/userDetails/settings/settings.html', '/app/user/tabs/userDetails/userDetails.html', '/app/user/tabs/userDetails/userModal/userModal.html', '/app/user/tabs/userNotes/notes.html', '/app/user/tabs/workouts/workout-status-modal.html', '/app/user/tabs/workouts/workouts.html', '/app/user/user.html']);

angular.module("/app/auth/login.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/auth/login.html",
    "<section class=\"login\">\n" +
    "\n" +
    "  <header class=\"login__header\">\n" +
    "    <h1 class=\"login__title\">{{ \"PERSONAL_TRAINER_PORTAL\" | translate }}</h1>\n" +
    "  </header>\n" +
    "\n" +
    "  <form class=\"login__form\" name=\"loginCtrl.loginForm\" novalidate>\n" +
    "    <h2 class=\"login__form-title\">{{ \"LOGIN\" | translate }}</h2>\n" +
    "\n" +
    "    <label class=\"login__field-title login__field-title--spacer-lg\">\n" +
    "      {{ \"USERNAME\" | translate }}\n" +
    "    </label>\n" +
    "    <input class=\"login__input\" placeholder=\"example@example.com\" autofocus\n" +
    "           ng-model=\"loginCtrl.user.login\"\n" +
    "               required />\n" +
    "\n" +
    "    <label class=\"login__field-title login__field-title--spacer-lg\">\n" +
    "      {{ \"PASSWORD\" | translate }}\n" +
    "    </label>\n" +
    "    <input type=\"password\" class=\"login__input\" placeholder=\"password\"\n" +
    "           ng-model=\"loginCtrl.user.password\"\n" +
    "           required/>\n" +
    "\n" +
    "    <!--<div class=\"login__field-title login__field-title&#45;&#45;spacer-sm\">-->\n" +
    "      <!--<input type=\"checkbox\" class=\"login__checkbox\" ng-model=\"loginCtrl.remember\"/>-->\n" +
    "      <!--<label>{{\"REMEMBER_ME\" | translate}}</label>-->\n" +
    "    <!--</div>-->\n" +
    "\n" +
    "    <button class=\"login__submit\"\n" +
    "            ng-disabled=\"loginCtrl.loginForm.$invalid\"\n" +
    "            ng-click=\"loginCtrl.login()\">{{ \"LOGIN\" | translate }}\n" +
    "    </button>\n" +
    "\n" +
    "  </form>\n" +
    "</section>\n" +
    "");
}]);

angular.module("/app/calendar/calendar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/calendar/calendar.html",
    "<div class='calendar'\n" +
    "  ng-class='{\"calendar--timeline-view\": calendar.showTimeline}'>\n" +
    "\n" +
    "  <header class=\"container-header\">\n" +
    "    <div class=\"container-header__content\">\n" +
    "      <i class=\"container-header__icon icon icon-calendar\"></i>\n" +
    "      <h1 class=\"container-header__title\">{{ 'SCHEDULE' | translate }}</h1>\n" +
    "    </div>\n" +
    "  </header>\n" +
    "\n" +
    "  <section class='calendar__content'>\n" +
    "\n" +
    "    <div class=\"calendar__selector\"></div>\n" +
    "    <div class=\"calendar__header\">\n" +
    "\n" +
    "      <div class=\"calendar__header-content\">\n" +
    "        <div class=\"calendar__top-year\">{{ calendar.fromYear }}</div>\n" +
    "\n" +
    "        <div class=\"calendar__top-month\"\n" +
    "             ng-repeat-start=\"month in calendar.monthRange track by $index\"\n" +
    "             ng-click=\"calendar.selectMonth(month.number, month.year)\"\n" +
    "             ng-class=\"{'calendar__top-month--selected': $index == calendar.monthOffset}\">\n" +
    "          {{month.displayText}}\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"calendar__top-separator\"\n" +
    "          ng-repeat-end\n" +
    "          ng-if=\"month.number == 11\">\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"calendar__top-year\">{{ calendar.toYear }}</div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"calendar__bodies\">\n" +
    "\n" +
    "      <!--<calendar-body class=\"calendar__body calendar__body&#45;&#45;hidden calendar__body&#45;&#45;hidden-left\"-->\n" +
    "        <!--month-offset=\"+1\">-->\n" +
    "      <!--</calendar-body>-->\n" +
    "\n" +
    "      <!--<calendar-body class=\"calendar__body calendar__body&#45;&#45;hidden calendar__body&#45;&#45;hidden-right\"-->\n" +
    "        <!--month-offset=\"+1\">-->\n" +
    "      <!--</calendar-body>-->\n" +
    "\n" +
    "      <calendar-body\n" +
    "        options=\"{initialDate: calendar.selectedDate}\"\n" +
    "        user=\"calendar.selectedUser\"\n" +
    "        on-day-selected=\"calendar.chooseDate(event, day)\"\n" +
    "        add-event=\"calendar.addEvent(day)\">\n" +
    "      </calendar-body>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div class='timepicker-wrapper'>\n" +
    "      <div class='timepicker-wrapper__header'>\n" +
    "\n" +
    "        <div class='timepicker-wrapper__close'\n" +
    "          ng-click='calendar.toggleTimelineVeiw()'>\n" +
    "          <i class=\"icon icon-cross\"></i>\n" +
    "        </div>\n" +
    "\n" +
    "        <div>\n" +
    "          <span class='timepicker-wrapper__control'\n" +
    "            ng-click='calendar.selectSiblingDay(-1)'>\n" +
    "            <i class=\"icon icon-triangle-left\"></i>\n" +
    "          </span>\n" +
    "          <span>{{ calendar.timelineDisplayDate | date: \"MMMM dd, yyyy\" }}</span>\n" +
    "          <span class='timepicker-wrapper__control'\n" +
    "            ng-click='calendar.selectSiblingDay(1)'>\n" +
    "            <i class=\"icon icon-triangle-right\"></i>\n" +
    "          </span>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <label class=\"user-picker\"\n" +
    "        permission\n" +
    "        permission-only=\"['WORKOUT_ASSIGNMENTS_OTHER_READ', 'TASKS_OTHER_READ']\">\n" +
    "        <input class=\"user-picker__input\"\n" +
    "          type=\"text\"\n" +
    "          ng-model=\"calendar.searchStr\"\n" +
    "          ng-blur=\"calendar.searchStr = calendar.selectedUser.fullName\"\n" +
    "          placeholder=\"{{ :: 'CHOOSE_USER' | translate }}\"\n" +
    "          uib-typeahead=\"user as calendar.getFullUserName(user) for user in calendar.users | filter:{fullName: $viewValue}\"\n" +
    "          typeahead-on-select=\"calendar.changeUser($item)\"/>\n" +
    "        <i class=\"icon icon-search user-picker__search-icon\"></i>\n" +
    "      </label>\n" +
    "\n" +
    "      <timepicker\n" +
    "        clients=\"calendar.timelineClients\"\n" +
    "        on-client-select='calendar.navigateToUserDetails($item)'\n" +
    "        on-edit-client=\"calendar.onEditAssigment($item)\"\n" +
    "        on-edit-task=\"calendar.onEditTask($item)\"\n" +
    "        is-editable=\"true\"\n" +
    "        read-only>\n" +
    "      </timepicker>\n" +
    "    </div>\n" +
    "\n" +
    "  </section>\n" +
    "  <div class=\"calendar-loader\" ng-if=\"calendar.isLoading\">\n" +
    "    <i class=\"calendar-loader__icon spinner-icon\"></i>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/add-client/add-client.modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/add-client/add-client.modal.html",
    "<ng-form name='addClientForm' autofill='false' >\n" +
    "  <label class=\"data-block__container\">\n" +
    "    <div class=\"data-block__info-container\">\n" +
    "      <div class=\"data-block__info\">\n" +
    "        <input type=\"text\"\n" +
    "               required\n" +
    "               ng-model=\"xID\"\n" +
    "               name=\"xID\"\n" +
    "               placeholder=\"---\"\n" +
    "               class=\"data-block__info--input user-details__input--password modal__input--pass input-clear\">\n" +
    "      </div>\n" +
    "      <div class=\"data-block__title\">{{ :: 'XID' | translate }}</div>\n" +
    "    </div>\n" +
    "  </label>\n" +
    "  <label class=\"data-block__container\">\n" +
    "    <div class=\"data-block__info-container\">\n" +
    "      <div class=\"data-block__info\">\n" +
    "          <input type=\"password\"\n" +
    "             ng-model=\"password\"\n" +
    "             name=\"password\"\n" +
    "             class=\"data-block__info--input user-details__input--password modal__input--pass input-clear\">\n" +
    "      </div>\n" +
    "      <div class=\"data-block__title\">{{ :: 'Passcode' | translate }}</div>\n" +
    "    </div>\n" +
    "  </label>\n" +
    "</ng-form>\n" +
    "");
}]);

angular.module("/app/components/add-client/add-staff.modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/add-client/add-staff.modal.html",
    "<ng-form name='addFacilityForm' autofill='false' >\n" +
    "  <label class=\"data-block__container data-block__container--border-bottom\">\n" +
    "    <div class=\"data-block__info-container\">\n" +
    "      <div class=\"data-block__info\">\n" +
    "        <input class=\"data-block__info--input user-details__input--password modal__input--pass input-clear\"\n" +
    "          type=\"text\"\n" +
    "          required\n" +
    "          ng-model=\"firstName\"\n" +
    "          name=\"firstName\"\n" +
    "          placeholder=\"---\">\n" +
    "      </div>\n" +
    "      <div class=\"data-block__title\">{{ :: 'FIRST_NAME' | translate }}</div>\n" +
    "    </div>\n" +
    "  </label>\n" +
    "  <label class=\"data-block__container data-block__container--border-bottom\">\n" +
    "    <div class=\"data-block__info-container\">\n" +
    "      <div class=\"data-block__info\">\n" +
    "        <input class=\"data-block__info--input user-details__input--password modal__input--pass input-clear\"\n" +
    "          type=\"text\"\n" +
    "          required\n" +
    "          ng-model=\"lastName\"\n" +
    "          name=\"lastName\"\n" +
    "          placeholder=\"---\">\n" +
    "      </div>\n" +
    "      <div class=\"data-block__title\">{{ :: 'LAST_NAME' | translate }}</div>\n" +
    "    </div>\n" +
    "  </label>\n" +
    "  <label class=\"data-block__container data-block__container--border-bottom\">\n" +
    "    <div class=\"data-block__info-container\">\n" +
    "      <div class=\"data-block__info\">\n" +
    "        <input class=\"data-block__info--input user-details__input--password modal__input--pass input-clear\"\n" +
    "          type=\"email\"\n" +
    "          required\n" +
    "          ng-model=\"email\"\n" +
    "          name=\"email\"\n" +
    "          placeholder=\"email@example.com\">\n" +
    "      </div>\n" +
    "      <div class=\"data-block__title\">{{ :: 'EMAIL_ADDRESS' | translate }}</div>\n" +
    "    </div>\n" +
    "  </label>\n" +
    "  <label class=\"data-block__container\">\n" +
    "    <div class=\"data-block__info-container\">\n" +
    "      <div class=\"data-block__info\">\n" +
    "        <input class=\"data-block__info--input user-details__input--password modal__input--pass input-clear\"\n" +
    "          required\n" +
    "          type=\"password\"\n" +
    "          ng-model=\"password\"\n" +
    "          name=\"password\"\n" +
    "          placeholder=\"***\">\n" +
    "      </div>\n" +
    "      <div class=\"data-block__title\">{{ :: 'PASSWORD' | translate }}</div>\n" +
    "    </div>\n" +
    "  </label>\n" +
    "</ng-form>\n" +
    "");
}]);

angular.module("/app/components/add-client/add-user.modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/add-client/add-user.modal.html",
    "<ul class=\"modal__list-wrapper\">\n" +
    "  <li class=\"modal__list-item\"\n" +
    "      ng-click=\"addClient(this)\">\n" +
    "    <a> {{ :: \"ADD_CLIENT\" | translate}} </a>\n" +
    "  </li>\n" +
    "  <li class=\"modal__list-item\"\n" +
    "      ng-click=\"findFacility(this)\">\n" +
    "    <a> {{ :: \"ADD_TRAINER_FACILITY\" | translate}} </a>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("/app/components/add-client/confirm-client.modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/add-client/confirm-client.modal.html",
    "<div class=\"confirm-client__wrapper clearfix\">\n" +
    "  <div class=\"confirm-client__image pull-left\">\n" +
    "    <img ng-src=\"{{ user.pictureUrl || '//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png' }}\">\n" +
    "  </div>\n" +
    "  <div class=\"confirm-client__info-container pull-left\">\n" +
    "    <div class=\"confirm-client__info border-bottom\">\n" +
    "      <div class=\"confirm-client__name\">\n" +
    "        {{user.firstName}} {{user.lastName}}\n" +
    "      </div>\n" +
    "      <div class=\"confirm-client__title\">\n" +
    "        {{:: 'FULL_NAME' | translate}}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"confirm-client__info\">\n" +
    "      <div class=\"confirm-client__email\">\n" +
    "        {{user.email}}\n" +
    "      </div>\n" +
    "      <div class=\"confirm-client__title\">\n" +
    "        {{:: 'EMAIL_ADDRESS' | translate}}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/add-client/find-staff.modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/add-client/find-staff.modal.html",
    "<ng-form name='findFacilityForm' autofill='false' >\n" +
    "  <div class=\"data-block__container\">\n" +
    "    <div class=\"data-block__info-container\">\n" +
    "      <div class=\"data-block__info\">\n" +
    "        <input class=\"data-block__info--input user-details__input--password modal__input--pass\"\n" +
    "          type=\"email\"\n" +
    "          required\n" +
    "          ng-model=\"email\"\n" +
    "          name=\"email\"\n" +
    "          placeholder=\"email@example.com\">\n" +
    "      </div>\n" +
    "      <div class=\"data-block__title\">{{ :: 'EMAIL_ADDRESS' | translate }}</div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</ng-form>\n" +
    "");
}]);

angular.module("/app/components/calendar/calendar-body.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/calendar/calendar-body.html",
    "<div class=\"calendar-body\">\n" +
    "\n" +
    "  <div class=\"calendar-body__month\">\n" +
    "    <span class=\"calendar-body__month--number\">\n" +
    "      {{body.getSelectedMonthNumber()}}\n" +
    "    </span>\n" +
    "    {{ body.getSelectedMonthName() | uppercase}}\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"calendar-body__week\">\n" +
    "    <div class=\"calendar-body__weekday\"\n" +
    "      ng-repeat=\"day in ::body.weekdays track by $index\"\n" +
    "      ng-bind=\"::day\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div>\n" +
    "    <div ng-repeat=\"week in body.weeks track by $index\">\n" +
    "      <div class=\"calendar-day calendar-day--single-event\"\n" +
    "           ng-repeat=\"date in week track by $index\"\n" +
    "           ng-class=\"{\n" +
    "             'calendar-day--current': date.current,\n" +
    "             'calendar-day--past': !date.isFuture && !date.current,\n" +
    "             'calendar-day--selected': !monthOffset && date.selected,\n" +
    "             'calendar-day--empty': date && date.isFuture && !date.events.length,\n" +
    "             'calendar-day--no-date': !date}\"\n" +
    "           ng-click=\"body.onDaySelected(date, $event)\">\n" +
    "        <div class=\"calendar-day__add-event\"\n" +
    "          ng-click=\"body.addEvent(date)\"\n" +
    "        ></div>\n" +
    "        <div class=\"calendar-day__number\" ng-bind=\"date.day\"></div>\n" +
    "        <div class=\"calendar-day__events\"\n" +
    "          ng-if=\"date.events.length\"\n" +
    "          ng-bind=\"date.events.length\"></div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/datepicker/datepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/datepicker/datepicker.html",
    "<div class='datepicker' ng-class=\"{'ng-invalid': !isValid && true}\">\n" +
    "  <div ng-if=\"!collapsed\" class='datepicker__container'>\n" +
    "    <div class='datepicker__header'>\n" +
    "      <div class='datepicker__prev' ng-click='prev()'>\n" +
    "        <img src=\"//images.jhtassets.com/24aa3742430a6aa24cac94fccb886943098681ec/\">\n" +
    "      </div>\n" +
    "      <div class='datepicker__title'>{{getTitle()}}</div>\n" +
    "      <div class='datepicker__next' ng-click='next()'>\n" +
    "        <img src=\"//images.jhtassets.com/becccdb54fe56925875de5bd98804462cf3774a7/\">\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class='datepicker__row' ng-if='weeks' data-ng-repeat='week in weeks'>\n" +
    "      <div data-ng-repeat='day in week track by $index'\n" +
    "        class='datepicker__ceil-container'>\n" +
    "        <div class='datepicker__ceil'\n" +
    "             ng-class=\"{'datepicker__ceil--day': day >= 0,\n" +
    "            'datepicker__ceil--inactive': !day,\n" +
    "           'datepicker__ceil--selected': isSelected(day),\n" +
    "            'datepicker__ceil--current': day && day === now(),\n" +
    "           'datepicker__ceil--not-availiable': !isAvailiable(day)}\"\n" +
    "             ng-click='selectDay(day)'>{{day || \" \"}}\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/day-schedule/day-schedule.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/day-schedule/day-schedule.html",
    "<div class=\"pt-day-schedule\">\n" +
    "  <div class=\"pt-day-schedule__day\">{{ day | camelToSnakeCase | translate}}</div>\n" +
    "  <div class=\"pt-day-schedule__time\" ng-repeat=\"time in times\" ng-if=\"time\">\n" +
    "      <div class=\"pt-day-schedule__time pt-day-schedule__time--start\">\n" +
    "        <div uib-timepicker\n" +
    "             readonly-input=\"true\"\n" +
    "             ng-disabled=\"!editable\"\n" +
    "             ng-model=\"time.min\">\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"pt-day-schedule__time-divider\">-</div>\n" +
    "      <div class=\"pt-day-schedule__time pt-day-schedule__time--end\">\n" +
    "        <div uib-timepicker\n" +
    "             readonly-input=\"true\"\n" +
    "             ng-disabled=\"!editable\"\n" +
    "             ng-model=\"time.max\">\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div ng-if=\"editable\" class=\"pt-day-schedule__time pt-day-schedule__time--remove\">\n" +
    "        <a href ng-click=\"removeHours(time)\">&times;</a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  <div ng-if=\"!times.length\" class=\"pt-day-schedule__time pt-day-schedule__time--na-block\">N/A</div>\n" +
    "  <div ng-if=\"editable\" class=\"pt-day-schedule__add-hour\" ng-click=\"addHours()\">+{{ :: 'ADD_HOURS' | translate}}</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/embed-video/embed-video.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/embed-video/embed-video.html",
    "<div class=\"pt-embed-video\">\n" +
    "  <iframe ng-if=\"trustedYoutubeSrc\" width=\"100%\" height=\"100%\" ng-src=\"{{trustedYoutubeSrc}}\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>\n" +
    "  <iframe ng-if=\"trustedVimeoSrc\" ng-src=\"{{trustedVimeoSrc}}\" width=\"100%\" height=\"100%\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>\n" +
    "</div>");
}]);

angular.module("/app/components/exercise-item-details/exercise-item-details.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/exercise-item-details/exercise-item-details.html",
    "<div class=\"create-exercise-details\">\n" +
    "\n" +
    "  <input class=\"create-exercise-details__title\"\n" +
    "    permission\n" +
    "    permission-only=\"itemCtrl.editPermission\"\n" +
    "    permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "    permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "    type=\"text\"\n" +
    "    maxlength=\"50\"\n" +
    "    ng-model=\"itemCtrl.item.title\"\n" +
    "    placeholder=\"{{ itemCtrl.type + 'Title' | camelToSnakeCase | translate }}\"/>\n" +
    "\n" +
    "  <label class=\"checkbox-custom create-exercise-details__checkbox-container\"\n" +
    "    permission\n" +
    "    permission-only=\"'RESTRICTED_FLAG_READ'\"\n" +
    "    ng-if=\"itemCtrl.type === 'trainingSets' || itemCtrl.type === 'exercises'\">\n" +
    "    <input\n" +
    "      permission\n" +
    "      permission-only=\"'RESTRICTED_FLAG_CREATE'\"\n" +
    "      permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "      permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "      type=\"checkbox\"\n" +
    "      ng-model=\"itemCtrl.item.restricted\">\n" +
    "    <span class=\"checkbox-label\">{{ :: 'RESTRICTED' | translate }}</span>\n" +
    "  </label>\n" +
    "\n" +
    "  <label class=\"checkbox-custom create-exercise-details__checkbox-container\"\n" +
    "    permission\n" +
    "    permission-only=\"'CHAIN_WIDE_READ'\">\n" +
    "    <input type=\"checkbox\"\n" +
    "      permission\n" +
    "      permission-only=\"itemCtrl.item.chainWide && itemCtrl.item._id ?\n" +
    "        'CHAIN_WIDE_DELETE' :\n" +
    "        'CHAIN_WIDE_CREATE'\"\n" +
    "      permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "      permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "      ng-model=\"itemCtrl.item.chainWide\">\n" +
    "    <span class=\"checkbox-label\">{{ :: 'CHAIN_WIDE' | translate }}</span>\n" +
    "  </label>\n" +
    "\n" +
    "  <label class=\"create-exercise-details__description-title\"\n" +
    "    ng-if=\"itemCtrl.type !== 'trainingSets'\">\n" +
    "    <div class=\"create-exercise-details__checkbox-container\">\n" +
    "      {{ :: 'DESCRIPTION'  | translate}}\n" +
    "    </div>\n" +
    "    <textarea class=\"create-exercise-details__description\"\n" +
    "      permission\n" +
    "      permission-only=\"itemCtrl.editPermission\"\n" +
    "      permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "      permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "      maxlength=\"681\"\n" +
    "      ng-model=\"itemCtrl.item.description\">\n" +
    "    </textarea>\n" +
    "  </label>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/exercise-multimedia/exercise-multimedia.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/exercise-multimedia/exercise-multimedia.html",
    "<div>\n" +
    "  <div class=\"upload-multimedia-block\">\n" +
    "    <div class=\"upload-multimedia-block__header\">\n" +
    "      <div class=\"upload-multimedia-block__title\">\n" +
    "        {{ :: 'FILE_REQUIREMENTS'  | translate }}\n" +
    "      </div>\n" +
    "      <div class=\"upload-multimedia-block__note\">\n" +
    "        {{ :: 'IMAGE_REQUIREMENTS_NOTE'  | translate }}\n" +
    "      </div>\n" +
    "      <div class=\"upload-multimedia-block__requirement-wrapper clearfix\">\n" +
    "        <div class=\"upload-multimedia-block__requirement upload-multimedia-block__requirement--left\">\n" +
    "          <table>\n" +
    "            <tr>\n" +
    "              <td class=\"upload-multimedia-block__table-column upload-multimedia-block__table-column--number\">1.</td>\n" +
    "              <td class=\"upload-multimedia-block__table-column\">\n" +
    "                {{ :: 'FILE_MUST_BE_A_VALID_JPG_OR_PNG' | translate }}\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "              <td></td>\n" +
    "              <td class=\"upload-multimedia-block__table-column upload-multimedia-block__table-column--note\">{{ :: 'IMAGE_REQUIREMENTS_FORMATS_NOT_ALLOWED'  | translate }}</td>\n" +
    "            </tr>\n" +
    "          </table>\n" +
    "        </div>\n" +
    "        <div class=\"upload-multimedia-block__requirement upload-multimedia-block__requirement--right\">\n" +
    "          <table>\n" +
    "            <tr>\n" +
    "              <td class=\"upload-multimedia-block__table-column upload-multimedia-block__table-column--number\">2.</td>\n" +
    "              <td class=\"upload-multimedia-block__table-column\">\n" +
    "              {{ :: 'FILE_DIMENSIONS_FOR_EXERCISE_IMAGE' | translate}}\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "          </table>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"upload-multimedia-block__content\">\n" +
    "      <div class=\"upload-multimedia-block__main-content upload-multimedia-block__main-content--images\">\n" +
    "        <div class=\"upload-multimedia-block__images-carousel\">\n" +
    "          <pt-image-carousel\n" +
    "            images-limit=\"exMultCtrl.imagesLimit\"\n" +
    "            images-list=\"exMultCtrl.imagesList\"></pt-image-carousel>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "  <div class=\"upload-multimedia-block\"\n" +
    "  ng-if=\"exMultCtrl.type !== 'trainingSet'\">\n" +
    "    <div class=\"upload-multimedia-block__header\">\n" +
    "      <div class=\"upload-multimedia-block__title\">\n" +
    "        {{ :: 'VIDEO_REQUIREMENTS'  | translate }}\n" +
    "      </div>\n" +
    "      <div class=\"upload-multimedia-block__note\">\n" +
    "        {{ :: 'VIDEO_REQUIREMENTS_NOTE'  | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"upload-multimedia-controls\">\n" +
    "      <div ng-click=\"exMultCtrl.onVideoPreview()\" class=\"upload-multimedia-controls__button upload-multimedia-controls__button pull-right\">\n" +
    "        <span ng-if=\"!exMultCtrl.showEmbedVideo\">{{ :: 'ADD_VIDEO'  | translate }}</span>\n" +
    "        <span ng-if=\"exMultCtrl.showEmbedVideo\">{{ :: 'REPLACE_VIDEO'  | translate }}</span>\n" +
    "      </div>\n" +
    "      <div class=\"upload-multimedia-controls__action-row upload-multimedia-controls__action-row--url upload-multimedia-controls__action-row--left\">\n" +
    "        <input\n" +
    "        ng-keypress=\"($event.which === 13) ? exMultCtrl.onVideoPreview() : 0\"\n" +
    "        type=\"text\"\n" +
    "        placeholder=\"{{ :: 'PASTE_VIDEO_URL' | translate }}\"\n" +
    "        ng-model=\"exMultCtrl.videoUrl\"\n" +
    "        ng-change=\"exMultCtrl.onVideoUrlChange()\"\n" +
    "        class=\"pt-crm-input pt-crm-input--blue\">\n" +
    "        <div ng-if=\"exMultCtrl.isVideoUrlInvalid\" class=\"upload-multimedia-controls__invalid-text\">{{ :: 'VIDEO_URL_IS_INVALID'  | translate }}</div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"upload-multimedia-block__content\">\n" +
    "      <div class=\"upload-multimedia-block__main-content\">\n" +
    "        <div ng-if=\"!exMultCtrl.showEmbedVideo\" class=\"upload-multimedia-block__preview-text\">{{ :: 'VIDEO_PREVIEW'  | translate }}</div>\n" +
    "        <pt-embed-video ng-if=\"exMultCtrl.showEmbedVideo\" url=\"exMultCtrl.videoUrlForEmbedVideo\" on-invalid=\"exMultCtrl.onVideoUrlInvalid()\"></pt-embed-video>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/exercise-profile/exercise-profile.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/exercise-profile/exercise-profile.html",
    "<div permission\n" +
    "  permission-only=\"'EXERCISES_READ'\">\n" +
    "  <div class=\"create-exercise__profile\"\n" +
    "    ng-if=\"exerciseCtrl.exercise.equipmentType\"\n" +
    "    ng-include=\"'/app/components/exercise-profile/partials/connected-exercise-profile.html'\"></div>\n" +
    "  <div class=\"create-exercise__profile\"\n" +
    "    ng-if=\"!exerciseCtrl.exercise.equipmentType\"\n" +
    "    ng-include=\"'/app/components/exercise-profile/partials/not-connected-exercise-profile.html'\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/exercise-profile/partials/connected-exercise-profile.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/exercise-profile/partials/connected-exercise-profile.html",
    "<div class=\"exercise-profile__info exercise-profile__info--training-set\">\n" +
    "\n" +
    "  <!--============= TOP TILES WITH SUMMARY METRICS ================ -->\n" +
    "  <div class=\"exercise-profile__tiles\">\n" +
    "    <div class=\"exercise-profile__tile\"\n" +
    "      ng-repeat=\"tile in exerciseCtrl.exercise.preset.metrics | filter: {forSegment: true}\">\n" +
    "\n" +
    "      <div class=\"exercise-profile__tile-header\">\n" +
    "        <div class=\"exercise-profile__tile-title\">{{ tile.name | camelToSnakeCase | translate }}</div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"exercise-profile__tile-content\">\n" +
    "        <div class=\"exercise-profile__tile-value\"\n" +
    "          ng-if=\"tile.name !== 'duration'\">\n" +
    "          {{ exerciseCtrl.exercise.assignedProfile.segments[0][tile.name] }}\n" +
    "        </div>\n" +
    "        <div class=\"exercise-profile__tile-value\"\n" +
    "          ng-if=\"tile.name === 'duration'\">\n" +
    "          {{ exerciseCtrl.exercise.totalDuration }}\n" +
    "        </div>\n" +
    "        <div class=\"exercise-profile__tile-units\">{{ tile.unit | camelToSnakeCase | translate }}</div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <!--============= SEGMENTS ================ -->\n" +
    "  <div class=\"exercise-profile__segments\">\n" +
    "    <div class=\"exercise-profile__segments-title\">{{ :: 'EXERCISE_PROFILE' | translate }}</div>\n" +
    "    <div class=\"exercise-profile__segments-content\">\n" +
    "\n" +
    "      <!--============= SCROLL LEFT BUTTON ===========-->\n" +
    "      <div class=\"exercise-profile__segments-controls exercise-profile__segments-controls--left\">\n" +
    "        <div class=\"exercise-profile__segments-control\"\n" +
    "             ng-disabled=\"!exerciseCtrl.scrollInstance._enableLeft\"\n" +
    "             ng-click=\"exerciseCtrl.scrollInstance.prev()\">\n" +
    "          <i class=\"icon icon-arrow-back\"></i>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"exercise-profile__segments-controls exercise-profile__segments-controls\">\n" +
    "\n" +
    "        <!--============= ADD SEGMENT BUTTON ===========-->\n" +
    "        <div class=\"exercise-profile__segments-control\"\n" +
    "             permission\n" +
    "             permission-only=\"exerciseCtrl.editPermission\"\n" +
    "             ng-disabled=\"!exerciseCtrl.moreSegmentsAvailable()\"\n" +
    "             ng-click=\"exerciseCtrl.addSegment()\">\n" +
    "          <i class=\"icon icon-ion-plus\"></i>\n" +
    "        </div>\n" +
    "\n" +
    "        <!--============= SCROLL RIGHT BUTTON ===========-->\n" +
    "        <div class=\"exercise-profile__segments-control\"\n" +
    "             ng-disabled=\"!exerciseCtrl.scrollInstance._enableRight\"\n" +
    "             ng-click=\"exerciseCtrl.scrollInstance.next()\">\n" +
    "          <i class=\"icon icon-arrow-forward\"></i>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"exercise-profile__segments-list\">\n" +
    "\n" +
    "        <div class=\"exercise-profile__segments-list-wrapper iscroll-wrapper\"\n" +
    "             iscroll=\"{scrollX: true, scrollY: false, mouseWheel: false, click: true, snap: true}\"\n" +
    "             iscroll-instance=\"exerciseCtrl.scrollInstance\">\n" +
    "\n" +
    "          <div class=\"exercise-profile__segments-list-content iscroll-scroller iscroll-scroller--horizontal\">\n" +
    "            <div class=\"exercise-profile__segments-item\"\n" +
    "                 ng-repeat=\"segment in exerciseCtrl.segments\"\n" +
    "                 ng-class=\"{active: segment._isActive}\"\n" +
    "                 ng-click=\"exerciseCtrl.activateSegment(segment)\">\n" +
    "\n" +
    "              <div class=\"exercise-profile__segments-counter\">{{ $index + 1 }}</div>\n" +
    "              <div class=\"exercise-profile__segments-level-container\">\n" +
    "                <div class=\"exercise-profile__segments-level\"\n" +
    "                     ng-style=\"{height: segment._progressHeight}\"></div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "<!--============= SEGMENT DETAILS POPUP ================ -->\n" +
    "<div class=\"exercise-profile__sliders fade-onload\"\n" +
    "     permission\n" +
    "     permission-only=\"exerciseCtrl.editPermission\"\n" +
    "     ng-if=\"exerciseCtrl.activeSegment\">\n" +
    "\n" +
    "  <div class=\"exercise-profile__sliders-buttons\">\n" +
    "    <button class=\"exercise-profile__sliders-button exercise-profile__sliders-button--danger\"\n" +
    "            ng-disabled=\"!exerciseCtrl.canDeleteSegments()\"\n" +
    "            ng-click=\"exerciseCtrl.deleteActiveSegment()\">\n" +
    "      {{ :: 'DELETE_SEGMENT' | translate }}\n" +
    "    </button>\n" +
    "    <button class=\"exercise-profile__sliders-button\"\n" +
    "            ng-click=\"exerciseCtrl.resetActiveSegment()\">\n" +
    "      {{ :: 'RESET_SEGMENT' | translate }}\n" +
    "    </button>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"exercise-profile__sliders-list\">\n" +
    "    <div class=\"exercise-profile__sliders-item\"\n" +
    "         ng-repeat=\"metric in exerciseCtrl.exercise.preset.metrics | filter: {forSegment: true}\">\n" +
    "\n" +
    "      <div segment-slider\n" +
    "           value=\"exerciseCtrl.activeSegment[metric.name]\"\n" +
    "           options=\"metric.validation\"\n" +
    "           on-end=\"exerciseCtrl.sliderValueChanged(metric.name)\">\n" +
    "      </div>\n" +
    "      <div class=\"exercise-profile__sliders-item-title\">{{ metric.name | camelToSnakeCase | translate }}</div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/exercise-profile/partials/not-connected-exercise-profile.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/exercise-profile/partials/not-connected-exercise-profile.html",
    "<div class=\"exercise-profile__info\">\n" +
    "  <div class=\"exercise-profile__param-field\">\n" +
    "    <label class=\"exercise-profile__param-label\">\n" +
    "      <span class=\"exercise-profile__param-title\">{{ :: 'EXERCISE_CATEGORY' | translate }}</span>\n" +
    "      <span class=\"exercise-profile__param-select\">\n" +
    "        {{exerciseCtrl.exercise.category}}\n" +
    "      </span>\n" +
    "    </label>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"exercise-profile__param-field\"\n" +
    "    ng-repeat=\"metric in exerciseCtrl.exercise.preset.metrics\">\n" +
    "    <label class=\"exercise-profile__param-label\">\n" +
    "      <span class=\"exercise-profile__param-title\">{{ metric.title | translate }}</span>\n" +
    "      <input class=\"exercise-profile__param-input\"\n" +
    "        permission\n" +
    "        permission-only=\"exerciseCtrl.editPermission\"\n" +
    "        permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "        permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "        type=\"number\"\n" +
    "        min=\"0\"\n" +
    "        ng-model=\"exerciseCtrl.exercise.assignedProfile.global[metric.name]\">\n" +
    "       <span>{{ metric.unit | camelToSnakeCase | translate }}</span>\n" +
    "    </label>\n" +
    "  </div>\n" +
    "  <div class=\"exercise-profile__param-field\">\n" +
    "    <label class=\"exercise-profile__param-label\">\n" +
    "      <span class=\"exercise-profile__param-title\">{{ 'DESCRIPTION' | translate }}</span>\n" +
    "      <textarea class=\"exercise-profile__param-textarea\"\n" +
    "        permission\n" +
    "        permission-only=\"exerciseCtrl.editPermission\"\n" +
    "        permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "        permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "        ng-model=\"exerciseCtrl.exercise.description\"></textarea>\n" +
    "    </label>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/header/facility.modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/header/facility.modal.html",
    "<ul class=\"modal__list-wrapper\">\n" +
    "  <li class=\"modal__list-item\"\n" +
    "    permission\n" +
    "    permission-only=\"'CURRENT_FACILITY_READ'\"\n" +
    "    ng-click=\"selectNewFacility(facility)\"\n" +
    "    ng-repeat=\"facility in facilities\">\n" +
    "    <div>\n" +
    "      {{facility.name}}\n" +
    "      <div class=\"pull-right permissions-groups-pop-up__group-selected-icon\"\n" +
    "        ng-if=\"user.activeFacility === facility._id\">\n" +
    "        &#x2713;\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("/app/components/header/header.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/header/header.html",
    "<div class=\"main-header\">\n" +
    "  <div class=\"top-profile\" uib-dropdown is-open=\"status.isopen\">\n" +
    "    <img class=\"top-profile__face\" ng-src=\"{{user.pictureUrl}}\">\n" +
    "    <a class=\"top-profile__link\" uib-dropdown-toggle>\n" +
    "      <span class=\"top-profile__name\">\n" +
    "        <span>{{ user.firstName }}</span>\n" +
    "        <span class=\"top-profile__arrow\"></span>\n" +
    "      </span>\n" +
    "    </a>\n" +
    "\n" +
    "    <ul class=\"top-profile__dropdown\" uib-dropdown-menu role=\"menu\">\n" +
    "      <li class=\"top-profile__dropdown-item\" role=\"menuitem\">\n" +
    "        <a class=\"top-profile__link\"\n" +
    "          ui-sref-active='active'\n" +
    "          ui-sref='app.users.details({userId: \"me\"})'>\n" +
    "          <i class=\"top-profile__icon icon icon-user\"></i>\n" +
    "          <span>{{ :: \"PROFILE\" | translate }}</span>\n" +
    "        </a>\n" +
    "      </li>\n" +
    "      <li class=\"top-profile__dropdown-item\"\n" +
    "        permission\n" +
    "        permission-only=\"'CURRENT_FACILITY_READ'\"\n" +
    "        role=\"menuitem\"\n" +
    "        ng-click=\"header.selectNewFacility(facility)\"\n" +
    "        ng-repeat=\"facility in header.facilities | limitTo:2\">\n" +
    "\n" +
    "        <a class=\"top-profile__link clearfix\">\n" +
    "          <div class=\"pull-left top-profile__list-wrapper\">\n" +
    "            <i class=\"top-profile__icon icon icon-home\"></i>\n" +
    "            <span>{{ facility.name }}</span>\n" +
    "          </div>\n" +
    "          <div class=\"top-profile__icon selected-icon\"\n" +
    "            ng-if=\"user.activeFacility === facility._id\">\n" +
    "            &#x2713;\n" +
    "          </div>\n" +
    "        </a>\n" +
    "\n" +
    "      </li>\n" +
    "      <li class=\"top-profile__dropdown-item\"\n" +
    "        permission\n" +
    "        permission-only=\"'CURRENT_FACILITY_READ'\"\n" +
    "        role=\"menuitem\"\n" +
    "        ng-if=\"header.facilities.length > 2\">\n" +
    "        <a class=\"top-profile__link\" ng-click=\"header.showAllFacilities()\">\n" +
    "          <i class=\"top-profile__icon icon icon-ion-plus\"></i>\n" +
    "          <span>{{ :: \"More_Facilities\" | translate }}</span>\n" +
    "        </a>\n" +
    "      </li>\n" +
    "      <li class=\"divider\"></li>\n" +
    "      <li class=\"top-profile__dropdown-item\" role=\"menuitem\">\n" +
    "        <a class=\"top-profile__link\" ng-click=\"header.logout()\">\n" +
    "          <i class=\"top-profile__icon icon icon-exit\"></i>\n" +
    "          <span>{{ :: \"LOG_OUT\" | translate }}</span>\n" +
    "        </a>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "\n" +
    "  <h1 class=\"main-header__title\">{{\"PERSONAL_TRAINER_PORTAL\" | translate}}</h1>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/image-carousel/image-carousel.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/image-carousel/image-carousel.html",
    "<div>\n" +
    "  <div class=\"pt-image-carousel\"\n" +
    "    ngf-drop=\"imageCarouselCtrl.imagesList.add($files, imageCarouselCtrl.imagesLimit)\"\n" +
    "    ngf-max-size=\"3MB\"\n" +
    "    ngf-pattern=\"'image/*'\"\n" +
    "    ngf-multiple=\"false\">\n" +
    "    <div class=\"pt-image-carousel__gallery\">\n" +
    "      <ul class=\"pt-image-carousel__list\"\n" +
    "       rn-carousel\n" +
    "       rn-carousel-index=\"carouselIndex\"\n" +
    "       rn-carousel-controls>\n" +
    "        <li class=\"pt-image-carousel__list-item\"\n" +
    "          ng-repeat=\"image in imageCarouselCtrl.imagesList.items\">\n" +
    "          <div class=\"pt-image-carousel__image-controls\">\n" +
    "            <i class='icon icon-star-full pt-image-carousel__image-control'\n" +
    "              ng-class=\"{'pt-image-carousel__image-control--active': image.isPrimary}\"\n" +
    "              ng-click=\"imageCarouselCtrl.imagesList.setAsPrimary(image)\"></i>\n" +
    "            <i class='icon icon-bin pt-image-carousel__image-control'\n" +
    "              ng-click=\"imageCarouselCtrl.imagesList.remove(image)\"></i>\n" +
    "          </div>\n" +
    "          <img class=\"pt-image-carousel__list-item-image\"\n" +
    "            draggable=\"false\"\n" +
    "            ngf-src=\"image.picture || image.picturePath\"/>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "      <div class=\"pt-image-carousel__indicators\"\n" +
    "        rn-carousel-indicators\n" +
    "        ng-if=\"imageCarouselCtrl.imagesList.items.length > 1\"\n" +
    "        slides=\"imageCarouselCtrl.imagesList.items\" rn-carousel-index=\"carouselIndex\">\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"pt-image-carousel-control\">\n" +
    "    <div class=\"upload-multimedia-controls__button upload-multimedia-controls__button pull-left\"\n" +
    "      ng-show=\"imageCarouselCtrl.imagesList.items.length < imageCarouselCtrl.imagesLimit\"\n" +
    "      ngf-select='imageCarouselCtrl.imagesList.add($files)'\n" +
    "      ngf-max-size=\"3MB\"\n" +
    "      ngf-pattern=\"'image/*'\"\n" +
    "      ngf-multiple=\"false\">\n" +
    "      {{ :: 'BROWSE'  | translate }}\n" +
    "    </div>\n" +
    "    <div class=\"upload-multimedia-controls__action-row upload-multimedia-controls__action-row--drag upload-multimedia-controls__action-row\">\n" +
    "      {{ :: 'IMAGE_UPLOAD_INSTRUCTION' | translate }}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/items-bag/items-bag.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/items-bag/items-bag.html",
    "<div class=\"items-bag iscroll-wrapper\"\n" +
    "  iscroll=\"{scrollX: true, scrollY:false, mouseWheel:false, click:false}\"\n" +
    "  dragula-configure\n" +
    "  dragula-scope=\"bagCtrl.scope\"\n" +
    "  dragula-bag=\"itemsList.items\"\n" +
    "  dragula-invalid=\"client-card-placeholder__text\"\n" +
    "  dragula-direction=\"horizontal\">\n" +
    "\n" +
    "  <div class=\"iscroll-scroller iscroll-scroller--horizontal\"\n" +
    "    ng-mouseenter=\"this.$emit('iscroll:refresh')\">\n" +
    "    <div class=\"client-card-placeholder\"\n" +
    "      ng-if=\"bagCtrl.itemsList\"\n" +
    "      dragula=\"'itemsList.items'\"\n" +
    "      dragula-scope=\"bagCtrl.scope\"\n" +
    "      dragula-model=\"bagCtrl.selectedItems\">\n" +
    "      <div class=\"client-card-placeholder__text\">\n" +
    "        {{ 'drop_' + bagCtrl.itemType + '_here' | camelToSnakeCase | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!--TODO: RENAME to ITEM Card-->\n" +
    "    <selected-exercise-card class=\"items-bag__selected-item\"\n" +
    "      ng-repeat=\"item in bagCtrl.selectedItems\"\n" +
    "      ng-class=\"{\n" +
    "        'items-bag__selected-item--inactive': !bagCtrl.itemsList  && $index !== bagCtrl.activeItemIndex\n" +
    "      }\"\n" +
    "      ng-click=\"bagCtrl.activateItem($index)\"\n" +
    "      data=\"item\"\n" +
    "      index=\"$index\"\n" +
    "      remove=\"bagCtrl.deselectItem($index)\"\n" +
    "      remove-permission=\"bagCtrl.editBagPermission\"\n" +
    "      is-removable=\"bagCtrl.itemsList\">\n" +
    "    </selected-exercise-card>\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"exercise-tab__items-list\"\n" +
    "  permission\n" +
    "  permission-only=\"bagCtrl.editBagPermission\"\n" +
    "  dragula=\"'itemsList.items'\"\n" +
    "  dragula-scope=\"bagCtrl.scope\"\n" +
    "  dragula-model=\"bagCtrl.itemsList.items\"\n" +
    "  infinite-scroll='bagCtrl.itemsList.load()'\n" +
    "  can-load='bagCtrl.itemsList.nextPage'\n" +
    "  threshold='100'>\n" +
    "\n" +
    "  <library-card class=\"exercise-tab__exercise\"\n" +
    "    permission\n" +
    "    permission-only=\"bagCtrl.itemType + 'Read' | camelToSnakeCase\"\n" +
    "    ng-repeat=\"item in bagCtrl.itemsList.items track by item._id\"\n" +
    "    data=\"item\"\n" +
    "    type=\"{{ :: bagCtrl.itemType }}\"\n" +
    "    hide-print-icon=\"bagCtrl.hidePrintIcon\"\n" +
    "    on-edit-card=\"bagCtrl.editItem(item)\">\n" +
    "      <span>{{ :: item.title }}</span>\n" +
    "  </library-card>\n" +
    "\n" +
    "  <div class=\"exercise-tab__no-itemsList\"\n" +
    "    permission\n" +
    "    permission-only=\"bagCtrl.itemType + 'Read' | camelToSnakeCase\"\n" +
    "    ng-if=\"bagCtrl.itemsList && (!bagCtrl.itemsList.items.length && !bagCtrl.itemsList.isLoading)\">\n" +
    "    {{ 'no_' + bagCtrl.itemType + '_availiable' | camelToSnakeCase | translate }}\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"roster-load-more\"\n" +
    "    permission\n" +
    "    permission-only=\"bagCtrl.itemType + 'Read' | camelToSnakeCase\"\n" +
    "    ng-if=\"bagCtrl.itemsList && bagCtrl.itemsList.isLoading\">\n" +
    "    <div class=\"roster-load-more__icon spinner-icon\"></div>\n" +
    "    {{ 'loadingMore_'  + bagCtrl.itemType | camelToSnakeCase | translate }}\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/left_menu/left_menu.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/left_menu/left_menu.html",
    "<div class=\"left-menu-wrapper\">\n" +
    "  <div class=\"left-menu\" ng-class=\"{opened: menu.isOpened}\">\n" +
    "    <div class=\"left-menu__section left-menu__section--top\"\n" +
    "      iscroll=\"{scrollX: false, scrollY: true, mouseWheel:true, click:true, scrollbars: true}\">\n" +
    "\n" +
    "      <div class='left-menu__section-content iscroll-scroller'>\n" +
    "        <div class=\"left-menu__item\"\n" +
    "          pt-crm-left-menu-toggle>\n" +
    "\n" +
    "          <div class='menu-toggler'\n" +
    "            ng-class='{active: menu.isOpened}'>\n" +
    "            <div class='menu-toggler-content'></div>\n" +
    "          </div>\n" +
    "          <span class=\"left-menu__item-name\">{{ :: \"CLOSE\" | translate }}</span>\n" +
    "        </div>\n" +
    "\n" +
    "        <a class=\"left-menu__item\"\n" +
    "          ui-sref-active=\"active\"\n" +
    "          ui-sref=\"app.dashboard\"\n" +
    "          permission\n" +
    "          permission-only=\"'DASHBOARD_VIEW_READ'\">\n" +
    "          <div class=\"left-menu__item-img left-menu__item-img--dashboard\"></div>\n" +
    "          <span class=\"left-menu__item-name\">{{ :: \"DASHBOARD\" | translate }}</span>\n" +
    "        </a>\n" +
    "        <a class=\"left-menu__item\"\n" +
    "           ui-sref-active=\"active\"\n" +
    "           ui-sref=\"app.calendar\"\n" +
    "           permission\n" +
    "           permission-only=\"'SCHEDULE_VIEW_READ'\">\n" +
    "          <div class=\"left-menu__item-img left-menu__item-img--schedule\"></div>\n" +
    "          <span class=\"left-menu__item-name\">{{ :: \"SCHEDULE\" | translate }}</span>\n" +
    "        </a>\n" +
    "        <a class=\"left-menu__item\"\n" +
    "           ui-sref-active=\"{'active': 'app.library'}\"\n" +
    "           ui-sref=\"app.library.list\"\n" +
    "           permission\n" +
    "           permission-only=\"'TRAINING_LIBRARY_VIEW_READ'\">\n" +
    "          <div class=\"left-menu__item-img left-menu__item-img--library\"></div>\n" +
    "          <span class=\"left-menu__item-name\">{{ :: \"TRAINING_LIBRARY\" | translate }}</span>\n" +
    "        </a>\n" +
    "        <a class=\"left-menu__item\"\n" +
    "          ui-sref-active=\"{'active': 'app.users'}\"\n" +
    "          ui-sref=\"app.users.list\"\n" +
    "          permission\n" +
    "          permission-only=\"['ROSTER_CLIENT_VIEW_READ', 'ROSTER_NON_CLIENT_VIEW_READ']\">\n" +
    "          <div class=\"left-menu__item-img left-menu__item-img--roster\"></div>\n" +
    "          <span class=\"left-menu__item-name\">{{ :: \"ROSTER\" | translate }}</span>\n" +
    "        </a>\n" +
    "        <a class=\"left-menu__item\"\n" +
    "           ui-sref-active=\"active\"\n" +
    "           ui-sref=\"app.settings\"\n" +
    "           permission\n" +
    "           permission-only=\"'SETTINGS_VIEW_READ'\">\n" +
    "          <div class=\"left-menu__item-img left-menu__item-img--settings\"></div>\n" +
    "          <span class=\"left-menu__item-name\">{{ :: \"SETTINGS\" | translate }}</span>\n" +
    "        </a>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"left-menu__section left-menu__section--bottom\">\n" +
    "        <a class=\"left-menu__item\"\n" +
    "          ui-sref-active=\"active\"\n" +
    "          ui-sref=\"app.assignment\"\n" +
    "          permission\n" +
    "          permission-only=\"['WORKOUT_ASSIGNMENTS_OTHER_CREATE', 'WORKOUT_ASSIGNMENTS_SELF_CREATE']\">\n" +
    "          <div class=\"left-menu__item-img left-menu__item-img--new_assignment\"></div>\n" +
    "          <span class=\"left-menu__item-name\">{{ :: \"NEW_ASSIGNMENT\" | translate }}</span>\n" +
    "        </a>\n" +
    "        <a class=\"left-menu__item\"\n" +
    "          ui-sref-active=\"active\"\n" +
    "          ui-sref=\"app.library.exercise\"\n" +
    "          permission\n" +
    "          permission-only=\"'EXERCISES_CREATE'\">\n" +
    "          <div class=\"left-menu__item-img left-menu__item-img--new_workout\"></div>\n" +
    "          <span class=\"left-menu__item-name\">{{ :: \"NEW_EXERCISE\" | translate }}</span>\n" +
    "        </a>\n" +
    "        <a class=\"left-menu__item\"\n" +
    "           permission\n" +
    "           permission-only=\"'CREATE_USERS_CREATE'\"\n" +
    "           ng-click=\"menu.addUser()\">\n" +
    "          <div class=\"left-menu__item-img left-menu__item-img--add_client\"></div>\n" +
    "          <span class=\"left-menu__item-name\">{{ :: \"ADD_CLIENT\" | translate}}</span>\n" +
    "        </a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/library-card/library-card.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/library-card/library-card.html",
    "<div class='library-card'>\n" +
    "\n" +
    "  <div class='library-card__front'>\n" +
    "    <div class='library-card__img-wrapper'>\n" +
    "      <img class='library-card__img' ng-src=\"{{ :: card.getImagePath() }}\"/>\n" +
    "    </div>\n" +
    "    <div class='library-card__content'>\n" +
    "      <div class='library-card__title'>{{ :: card.data.title }}</div>\n" +
    "      <div class='library-card__description'>{{ :: card.data.equipmentType | translate }}</div>\n" +
    "    </div>\n" +
    "\n" +
    "    <i class='icon icon-info_outline library-card__info'></i>\n" +
    "    <i class=\"icon library-card__print\"\n" +
    "      ng-if=\"!card.hidePrintIcon\"\n" +
    "      ng-click=\"card.onPrintCard(card.data)\">\n" +
    "    </i>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class='library-card__back'>\n" +
    "\n" +
    "    <div class='library-card__back__corner'\n" +
    "      permission\n" +
    "      permission-only=\"card.editPermission\"\n" +
    "      ng-click=\"card.onEditCard(card.data)\">\n" +
    "\n" +
    "      <i class='icon icon-edit'></i>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class='library-card__content'>\n" +
    "      <div class='library-card__content-head'>\n" +
    "        <div class='library-card__title library-card__title--inverse'>\n" +
    "          {{ :: card.data.title }}\n" +
    "        </div>\n" +
    "        <div class='library-card__description library-card__description--inverse'>\n" +
    "          {{ :: card.data.equipmentType | translate }}\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <!--=========== EXERCISE ONLY ================-->\n" +
    "      <div class='library-card__content-item'\n" +
    "        ng-repeat=\"(key, val) in ::card.metrics\">\n" +
    "\n" +
    "        <div class='library-card__title library-card__title--inverse library-card__item-title--inverse'>\n" +
    "          {{ val }}\n" +
    "        </div>\n" +
    "        <div class='library-card__description library-card__description--inverse library-card__item-description--inverse'>\n" +
    "          {{ key }}\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class='library-card__content-description'>\n" +
    "        <div class='library-card__description library-card__description--inverse'>\n" +
    "          {{ :: card.data.description }}\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <!--=============== SET ONLY =============-->\n" +
    "      <div class='library-card__content-item'\n" +
    "        ng-repeat=\"exercise in ::card.data.exercises\">\n" +
    "        <div class='library-card__title library-card__title--inverse library-card__item-title--inverse'>{{ :: exercise.title }}</div>\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/popup/_popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/popup/_popup.html",
    "<div class=\"{{ cssClass }}\">\n" +
    "\n" +
    "  <form ng-submit='ok()'>\n" +
    "    <div class=\"modal__popup-header\">\n" +
    "      <div class=\"modal__popup-header--back\" ng-if='showBack' ng-click=\"back()\"></div>\n" +
    "      <div class=\"modal__popup-header--title\">{{ title }}</div>\n" +
    "      <div class=\"modal__popup-header--exit icon icon-cross\"\n" +
    "        ng-click=\"cancel()\"></div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class='modal__content'>\n" +
    "      <div class='modal__content-description'\n" +
    "        ng-if='description'>{{ description }}</div>\n" +
    "\n" +
    "      <div class='modal__content-template' bind-html-compile='content'></div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"footer-buttons\">\n" +
    "      <button type='submit' autofocus ng-if='showOk'\n" +
    "        class=\"button button-action\">\n" +
    "        <i class=\"roster-load-more__icon spinner-icon\"\n" +
    "          ng-if=\"isLoading\">\n" +
    "        </i>\n" +
    "        {{ okText }}\n" +
    "      </button>\n" +
    "\n" +
    "      <div class=\"button button-assertive button-clear pull-right\"\n" +
    "        ng-if='showCancel'\n" +
    "        ng-click='cancel()'>\n" +
    "        {{ cancelText }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/selected-exercise-card/selected-exercise-card.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/selected-exercise-card/selected-exercise-card.html",
    "<div class=\"selected-exercise-card\" ng-class=\"{'selected-exercise-card--remove': card.isRemove}\"\n" +
    "     ng-swipe-up=\"card.isRemove = false;\" ng-swipe-down=\"card.isRemove = true;\">\n" +
    "  <button class=\"selected-exercise-card__remove-button\" ng-click=\"card.remove()\">\n" +
    "    {{ :: 'REMOVE_EXERCISE'| translate }}\n" +
    "  </button>\n" +
    "\n" +
    "  <img class=\"selected-exercise-card__img\"\n" +
    "    ng-src=\"{{card.data.pictureUrl}}\">\n" +
    "  <div class=\"selected-exercise-card__content\">\n" +
    "    <div class=\"selected-exercise-card__title\">{{ card.data.title }}</div>\n" +
    "    <div class=\"selected-exercise-card__subtitle\">{{ card.data.equipmentType || card.data.category }}</div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"selected-exercise-card__icon selected-exercise-card__icon--delete\"\n" +
    "    permission\n" +
    "    permission-only=\"card.removePermission\"\n" +
    "    ng-if=\"card.isRemovable\"\n" +
    "    ng-click=\"card.isRemove = !card.isRemove;\"></div>\n" +
    "  <div class=\"selected-exercise-card__index\">{{ card.index + 1 }}</div>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("/app/components/tabs/tab.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/tabs/tab.html",
    "<li class=\"tab-head__item\"\n" +
    "    ng-class=\"{'tab-head__item--active': active, 'tab-head__item--right': button, 'tab-head__item--disabled': disabled}\"\n" +
    "    ng-click=\"!button && select()\">\n" +
    "\n" +
    "</li>");
}]);

angular.module("/app/components/tabs/tabs.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/tabs/tabs.html",
    "<div class=\"tab\">\n" +
    "  <ul class=\"tab-head\" ng-transclude></ul>\n" +
    "\n" +
    "  <div class=\"tab-content\">\n" +
    "    <div class=\"tab-content__panel\"\n" +
    "         ng-repeat=\"tab in tabsCtrl.tabs\"\n" +
    "         ng-class=\"{'tab-content__panel--active': tab.active}\"\n" +
    "         tab-content tab-instance=\"tab\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/time-slot/time-slot.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/time-slot/time-slot.html",
    "<div class=\"timepicker-container-right-client-wrapper\"\n" +
    "  ng-class=\"{'timepicker-container-right-client-wrapper--task': timeCtrl.item.type === 'task'}\">\n" +
    "\n" +
    "  <div permission\n" +
    "  permission-only=\"timeCtrl.readPermission\">\n" +
    "    <img class=\"timepicker-container-right-client-img\"\n" +
    "      ng-class=\"{'timepicker-container-right-client-img--half-hour': timeCtrl.item.timeTo - timeCtrl.item.timeFrom <= 0.5}\"\n" +
    "      ng-src=\"{{timeCtrl.item.img}}\">\n" +
    "\n" +
    "    <div class=\"timepicker-container-right-client-time\">\n" +
    "      {{timeRanges[timeCtrl.item.timeFrom * 2]}} - {{timeRanges[timeCtrl.item.timeTo * 2]}}\n" +
    "    </div>\n" +
    "    <div class=\"timepicker-container-right-client-name\">\n" +
    "      {{timeCtrl.item.caption}}\n" +
    "    </div>\n" +
    "    <div class=\"timepicker-container-right-client-location\">\n" +
    "      {{timeCtrl.item.club}}\n" +
    "    </div>\n" +
    "    <i class='icon icon-info_outline timepicker-info-icon'\n" +
    "      title=\"{{::timeCtrl.item.title + '\\n' + timeCtrl.item.description}}\"\n" +
    "      ng-if=\"timeCtrl.isTask(timeCtrl.item)\"\n" +
    "      permission\n" +
    "      permission-only=\"timeCtrl.readPermission\"\n" +
    "      ng-click=\"timeCtrl.showTaskInfo($event)\">\n" +
    "    </i>\n" +
    "    <div class=\"timepicker-container-right-client-corner\"\n" +
    "      permission\n" +
    "      permission-only=\"timeCtrl.editPermission\"\n" +
    "      ng-if=\"timeCtrl.isEditable && !timeCtrl.isPassedAssignment\"\n" +
    "      ng-click=\"timeCtrl.editTimeSlot($event, client)\">\n" +
    "      <i class='icon icon-edit'></i>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/timepicker/timepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/timepicker/timepicker.html",
    "<div class=\"timepicker\">\n" +
    "  <div class=\"timepicker-header\">\n" +
    "    <button class=\"timepicker-title\"\n" +
    "      ng-click=\"titleClicked()\">{{ :: 'ANYTIME' | translate }}\n" +
    "    </button>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"timepicker-container\">\n" +
    "    <div class=\"timepicker-container-left\">\n" +
    "      <div class=\"timepicker-container-left-item\"\n" +
    "           data-ng-repeat=\"title in titles\">\n" +
    "        {{title}}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <pt-time-slot class=\"timepicker-container-right-client\"\n" +
    "      ng-repeat=\"client in clients\"\n" +
    "      ng-click=\"clientSelect(client)\"\n" +
    "      ng-if=\"(editAssign && (editAssign._id === client._id)) ? false : true\"\n" +
    "      ng-style=\"generateStyle(client)\"\n" +
    "      edit-slot=\"client.type === 'task' ? editTask : editClient\"\n" +
    "      is-editable=\"isEditable\"\n" +
    "      item=\"client\">\n" +
    "    </pt-time-slot>\n" +
    "\n" +
    "    <div class=\"timepicker-container-right-client\"\n" +
    "         ng-if=\"selectedClients.timeFrom >= 0 && selectedClients.timeTo\"\n" +
    "         ng-class=\"{'timepicker-container-right-client--conflict': checkOverlap()}\"\n" +
    "         ng-style=\"generateStyle(selectedClients)\">\n" +
    "      <div class=\"timepicker-container-right-client-wrapper\"\n" +
    "        ng-class=\"{'timepicker-container-right-client-wrapper--task': selectedClients.type === 'task'}\">\n" +
    "        <img class=\"timepicker-container-right-client-img\"\n" +
    "             ng-class=\"{'timepicker-container-right-client-img--half-hour': selectedClients.timeTo - selectedClients.timeFrom <= 0.5}\"\n" +
    "             ng-src=\"{{selectedClients.img}}\">\n" +
    "\n" +
    "        <div class=\"timepicker-container-right-client-time\">\n" +
    "          {{timeRanges[selectedClients.timeFrom * 2]}} - {{timeRanges[selectedClients.timeTo * 2]}}\n" +
    "        </div>\n" +
    "        <div class=\"timepicker-container-right-client-name\">\n" +
    "          {{selectedClients.caption}}\n" +
    "        </div>\n" +
    "        <div class=\"timepicker-container-right-client-location\">\n" +
    "          {{selectedClients.club}}\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"timepicker-container-right-client-dragger\"></div>\n" +
    "    </div>\n" +
    "\n" +
    "\n" +
    "    <div class=\"timepicker-container-right\">\n" +
    "      <div class=\"timepicker-container-right-item\"\n" +
    "           data-ng-repeat=\"item in timeRanges track by $index\">\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/user-card/user-card.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/user-card/user-card.html",
    "<div class=\"user-card\" ng-class=\"{'user-card--remove':card.isRemove}\"\n" +
    "     ng-swipe-up=\"card.isRemove = false;\" ng-swipe-down=\"card.isRemove = true;\">\n" +
    "  <button class=\"user-card__remove-button\" ng-click=\"card.remove()\">\n" +
    "    <span ng-if=\"card.role !== 'trainer'\">{{ :: 'REMOVE_CLIENT' | translate }}</span>\n" +
    "    <span ng-if=\"card.role === 'trainer'\">{{ :: 'REMOVE_TRAINER' | translate }}</span>\n" +
    "  </button>\n" +
    "\n" +
    "  <img ng-src=\"{{card.user.pictureUrl || '//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png'}}\" class=\"user-card__img\">\n" +
    "  <div class=\"user-card__content\">\n" +
    "    <div class=\"user-card__name\">{{card.user.firstName}} {{card.user.lastName}}</div>\n" +
    "    <div class=\"user-card__work\">{{card.user.clientProfile.club.name}}</div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"user-card__icon user-card__icon--delete\"\n" +
    "       ng-if=\"card.isRemovable\"\n" +
    "       ng-click=\"card.isRemove = !card.isRemove\"></div>\n" +
    "  <div class=\"user-card__icon user-card__icon--move\"></div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/components/users-bag/users-bag.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/components/users-bag/users-bag.html",
    "<div class=\"items-bag iscroll-wrapper\"\n" +
    "     iscroll=\"{scrollX: true, scrollY:false, mouseWheel:false, click:false}\"\n" +
    "     dragula-configure\n" +
    "     dragula-scope=\"bagCtrl.scope\"\n" +
    "     dragula-bag=\"usersList.items\"\n" +
    "     dragula-invalid=\"client-card-placeholder__text\"\n" +
    "     dragula-direction=\"horizontal\">\n" +
    "\n" +
    "  <div class=\"iscroll-scroller iscroll-scroller--horizontal\">\n" +
    "    <div class=\"client-card-placeholder\"\n" +
    "         ng-if=\"bagCtrl.usersList\"\n" +
    "         ng-show=\"bagCtrl.selectedUsers.length < bagCtrl.bagLimit\"\n" +
    "         dragula=\"'usersList.items'\"\n" +
    "         dragula-scope=\"bagCtrl.scope\"\n" +
    "         dragula-model=\"bagCtrl.selectedUsers\">\n" +
    "      <div class=\"client-card-placeholder__text\">\n" +
    "        {{ 'drop_' + bagCtrl.userType + '_here' | camelToSnakeCase | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <user-card class=\"client-tab__selected-client\"\n" +
    "      ng-repeat=\"user in bagCtrl.selectedUsers track by user._id\"\n" +
    "      is-removable=\"true\"\n" +
    "      user=\"user\"\n" +
    "      remove=\"bagCtrl.deselectUser($index)\">\n" +
    "    </user-card>\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "<library-search>\n" +
    "  <div class=\"library-search\">\n" +
    "    <div class=\"library-search__icon\"></div>\n" +
    "    <input type=\"text\"\n" +
    "           class=\"library-search__input\"\n" +
    "           placeholder=\"{{ :: 'SEARCH' | translate }}\"\n" +
    "           ng-model-options=\"{ debounce: 500 }\"\n" +
    "           ng-model=\"bagCtrl.searchStr\"\n" +
    "           ng-change=\"bagCtrl.loadUsers(bagCtrl.searchStr)\">\n" +
    "  </div>\n" +
    "</library-search>\n" +
    "\n" +
    "<div class=\"client-tab__clients\"\n" +
    "     permission\n" +
    "     permission-only=\"bagCtrl.editBagPermission\"\n" +
    "     dragula=\"'usersList.items'\"\n" +
    "     dragula-scope=\"bagCtrl.scope\"\n" +
    "     dragula-model=\"bagCtrl.usersList.items\"\n" +
    "     infinite-scroll='bagCtrl.loadUsers()'\n" +
    "     can-load='bagCtrl.usersList.nextPage'\n" +
    "     threshold='100'>\n" +
    "\n" +
    "  <user-card class=\"client-tab__client\"\n" +
    "     ng-repeat=\"user in bagCtrl.usersList.items track by user._id\"\n" +
    "     user=\"user\">\n" +
    "  </user-card>\n" +
    "  <div class=\"client-tab__no-clients\"\n" +
    "    ng-if=\"bagCtrl.usersList && (!bagCtrl.usersList.items.length && !bagCtrl.usersList.isLoading)\">\n" +
    "    {{ 'no_' + bagCtrl.userType + '_availiable' | camelToSnakeCase | translate }}\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"roster-load-more\"\n" +
    "    ng-if=\"bagCtrl.usersList && bagCtrl.usersList.isLoading\">\n" +
    "    <div class=\"roster-load-more__icon spinner-icon\"></div>\n" +
    "    {{ 'loadingMore_'  + bagCtrl.userType | camelToSnakeCase | translate }}\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/dashboard/dashboard.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/dashboard/dashboard.html",
    "<div class=\"dashboard\">\n" +
    "\n" +
    "  <header class=\"container-header\">\n" +
    "    <div class='container-header__content'>\n" +
    "      <div class=\"container-header__caption\">{{ dashboard.today | date : 'MMMM dd, yyyy' }}</div>\n" +
    "\n" +
    "      <i class='container-header__icon icon icon-schedule'></i>\n" +
    "      <h1 class=\"container-header__title\">{{ 'WELCOME' | translate}} {{ user.firstName }}</h1>\n" +
    "    </div>\n" +
    "  </header>\n" +
    "\n" +
    "\n" +
    "  <section class='dashboard__content'>\n" +
    "\n" +
    "    <div class=\"dashboard__right-section\">\n" +
    "      <div class='dashboard__list'>\n" +
    "        <div class='dashboard__list-title'>{{ \"TODAYS_APPOINTMENT\" | translate }}</div>\n" +
    "        <div class=\"timepicker-wrapper\">\n" +
    "          <timepicker\n" +
    "            clients=\"dashboard.timelineClients\"\n" +
    "            on-edit-client=\"dashboard.onEditAssigment($item)\"\n" +
    "            on-client-select='dashboard.navigateToUserDetails($item)'\n" +
    "            is-editable=\"true\"\n" +
    "            read-only>\n" +
    "          </timepicker>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"dashboard__left-section\">\n" +
    "\n" +
    "      <div permission\n" +
    "      permission-only=\"'INTERESTED_READ'\"\n" +
    "      class='dashboard__list dashboard__interested'>\n" +
    "        <div class='dashboard__list-title'>{{ :: \"INTERESTED\" | translate }}</div>\n" +
    "\n" +
    "        <div class='client-item client-item--no-label'\n" +
    "          ng-repeat='client in dashboard.clients.interested'\n" +
    "          ui-sref='app.users.details({userId: client._id})'>\n" +
    "\n" +
    "          <div class='client-item__left'>\n" +
    "            <img class='client-item__picture' ng-src='{{ client.pictureUrl || \"//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png\" }}'/>\n" +
    "\n" +
    "            <div class='client-item__title'>\n" +
    "              <div>{{ client.firstName }} {{ client.lastName }}</div>\n" +
    "              <span class='client-item__caption'>{{ client.location }}</span>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class='client-item--empty'\n" +
    "          ng-if='!dashboard.clients.interested.length'>\n" +
    "          {{ :: \"NO_CLIENTS\" | translate }}\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class='dashboard__list'>\n" +
    "        <div class='dashboard__list-title'>{{ :: \"IN_THE_GYM\" | translate }}</div>\n" +
    "\n" +
    "        <div class='client-item client-item--ingym'\n" +
    "          ng-repeat='client in dashboard.clients.in_gym'\n" +
    "          ui-sref='app.users.details({userId: client._id})'>\n" +
    "\n" +
    "          <div class='client-item__left'>\n" +
    "            <img class='client-item__picture' ng-src='{{ client.pictureUrl || \"//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png\" }}'/>\n" +
    "            <div class='client-item__label'>\n" +
    "              <!-- TODO: add custom icons -->\n" +
    "              <div class='client-item__label-icon'></div>\n" +
    "            </div>\n" +
    "            <div class='client-item__title'>\n" +
    "              <div>{{ client.firstName }} {{ client.lastName }}</div>\n" +
    "              <span class='client-item__caption'>{{ client.location }}</span>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class='client-item--empty'\n" +
    "          ng-if='!dashboard.clients.in_gym.length'>\n" +
    "          {{ :: \"NO_CLIENTS\" | translate }}\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class='dashboard__list'>\n" +
    "        <div class='dashboard__list-title'>{{ :: \"MISSING_IN_ACTION\" | translate }}</div>\n" +
    "\n" +
    "        <div class='client-item client-item--missing'\n" +
    "          ng-repeat='client in dashboard.clients.at_risk'\n" +
    "          ui-sref='app.users.details({userId: client._id})'>\n" +
    "\n" +
    "          <div class='client-item__right'>\n" +
    "            <div class='client-item__info'>\n" +
    "              <div class='client-item__info-content'>\n" +
    "                <div class='client-item__info-title'\n" +
    "                  ng-if='client.clientProfile.lastWorkoutDate'>{{ client.clientProfile.lastWorkoutDate * 1000 | date:'MM/dd/yyyy' }}</div>\n" +
    "                <div class='client-item__info-title'\n" +
    "                  ng-if='!client.clientProfile.lastWorkoutDate'>-//-</div>\n" +
    "                <div class='client-item__info-caption'>{{ :: 'LAST_WORKOUT' | translate }}</div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class='client-item__left'>\n" +
    "            <img class='client-item__picture' ng-src='{{ client.pictureUrl || \"//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png\" }}'/>\n" +
    "            <div class='client-item__label'>\n" +
    "              <!-- TODO: add custom icons -->\n" +
    "              <div class='client-item__label-icon'></div>\n" +
    "            </div>\n" +
    "            <div class='client-item__title'>\n" +
    "              <div>{{ client.firstName }} {{ client.lastName }}</div>\n" +
    "              <span class='client-item__caption'>{{ client.location }}</span>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class='client-item--empty'\n" +
    "          ng-if='!dashboard.clients.at_risk.length'>\n" +
    "          {{ :: \"NO_CLIENTS\" | translate }}\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "  </section>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/layout/layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/layout/layout.html",
    "<div class=\"main-container\">\n" +
    "  <pt-crm-header></pt-crm-header>\n" +
    "  <pt-crm-left-menu></pt-crm-left-menu>\n" +
    "  <div class=\"container\">\n" +
    "    <div ui-view class='container-view fade-onload'></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/library/create-assignment/create-assignment.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/create-assignment/create-assignment.html",
    "<section class=\"create-assignment\" ng-form=\"createCtrl.assignmentForm\" novalidate>\n" +
    "  <header class=\"create-assignment__header\">\n" +
    "    <!--TODO: calculate needConfirmation programmly-->\n" +
    "    <span class=\"back-button\"\n" +
    "      need-confirmation=\"true\"></span>\n" +
    "    <h1 class=\"create-assignment__header-title\">\n" +
    "      {{ :: createCtrl.isEdit ? 'UPDATE_ASSIGNMENT' : 'CREATE_NEW_ASSIGNMENT' | translate}}\n" +
    "    </h1>\n" +
    "\n" +
    "    <div class=\"button button-assertive pull-right exercise-delete-btn set-delete-btn\"\n" +
    "      permission\n" +
    "      permission-only=\"'WORKOUT_ASSIGNMENTS_OTHER_DELETE'\"\n" +
    "      ng-if=\"createCtrl.isEdit\"\n" +
    "      ng-click=\"createCtrl.remove()\">\n" +
    "      <span class=\"button__icon button__icon--delete-exercise\"></span>\n" +
    "      {{ :: 'DELETE_ASSIGNMENT' | translate }}\n" +
    "    </div>\n" +
    "  </header>\n" +
    "\n" +
    "  <section class=\"create-assignment__content\">\n" +
    "\n" +
    "    <tabs theme=\"dark\">\n" +
    "      <tab>\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ createCtrl.selectedClients.length }} {{ :: 'CLIENTS' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <ng-include src=\"'/app/library/create-assignment/tabs/client.html'\"></ng-include>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "      <tab is-disabled=\"!createCtrl.isClientSelected()\"\n" +
    "        select='createCtrl.activateTrainerTab()'>\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ :: 'TRAINER' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <ng-include src=\"'/app/library/create-assignment/tabs/trainer.html'\"></ng-include>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "      <tab is-disabled=\"!createCtrl.isRequiredDataFilled()\"\n" +
    "        select='createCtrl.activateDateTab()'>\n" +
    "\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\"\n" +
    "            ng-if=\"!createCtrl.isDateTabWasSelected\">\n" +
    "            {{ :: 'PICK_DATE_TIME' | translate }}\n" +
    "          </span>\n" +
    "          <span class=\"tab-head__multiline-item\"\n" +
    "            ng-if=\"createCtrl.isDateTabWasSelected\">\n" +
    "            {{createCtrl.parseDate()}}\n" +
    "            <span class=\"create-assignment__dark-text\"\n" +
    "              ng-if=\"createCtrl.canPickTime && createCtrl.startTime\">\n" +
    "              <br/>\n" +
    "              {{ createCtrl.startTime |date: \"hh:mm a\" : 'UTC'}} -\n" +
    "              {{ createCtrl.endTime |date: \"hh:mm a\" : 'UTC'}}\n" +
    "            </span>\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <ng-include src=\"'/app/library/create-assignment/tabs/date.html'\"></ng-include>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "\n" +
    "\n" +
    "      <!--================== CHOOSE EXERCISE ===============-->\n" +
    "      <tab is-disabled=\"!createCtrl.isRequiredDataFilled()\"\n" +
    "        select='createCtrl.activateExerciseTab()'>\n" +
    "\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\"\n" +
    "            ng-if=\"!createCtrl.isExerciseTabWasSelected\">\n" +
    "            {{ :: 'CHOOSE_EXERCISE' | translate }}\n" +
    "          </span>\n" +
    "          <span ng-if=\"createCtrl.isExerciseTabWasSelected\">\n" +
    "            {{createCtrl.selectedExercises.length}} {{ :: 'EXERCISES' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <ng-include src=\"'/app/library/create-assignment/tabs/exercise.html'\"></ng-include>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "      <!--========= Exercises Profile===========-->\n" +
    "      <tab is-disabled=\"!createCtrl.selectedExercises.length\">\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ :: 'EXERSCISE_PROFILES' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <ng-include class=\"training-set\"\n" +
    "                      src=\"'/app/library/create-assignment/tabs/exercise-profile.html'\">\n" +
    "          </ng-include>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "      <tab class='tab-action'\n" +
    "        is-button=\"true\"\n" +
    "        is-disabled=\"!createCtrl.isRequiredDataFilled() || createCtrl.isLoading\">\n" +
    "        <tab-head\n" +
    "          ng-click=\"createCtrl.save()\">\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ :: createCtrl.isEdit ? 'EDIT_ASSIGNMENT' : 'CREATE_WORKOUT' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "      </tab>\n" +
    "\n" +
    "      <tab class='tab-assertive button-clear'\n" +
    "        is-button=\"true\"\n" +
    "        ng-hide=\"createCtrl.isEdit\">\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\"\n" +
    "            ui-sref=\"app.dashboard\">\n" +
    "            {{ :: 'CANCEL_WORKOUT' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "      </tab>\n" +
    "\n" +
    "    </tabs>\n" +
    "\n" +
    "  </section>\n" +
    "\n" +
    "\n" +
    "</section>\n" +
    "");
}]);

angular.module("/app/library/create-assignment/tabs/client.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/create-assignment/tabs/client.html",
    "<div class=\"user-tab__selected-users iscroll-wrapper\"\n" +
    "     iscroll=\"{scrollX: true, scrollY:false, mouseWheel:false, click:false}\"\n" +
    "     dragula-configure\n" +
    "     dragula-scope=\"createCtrl.scope\"\n" +
    "     dragula-bag=\"clients\"\n" +
    "     dragula-invalid=\"client-card-placeholder__text\"\n" +
    "     dragula-direction=\"horizontal\">\n" +
    "\n" +
    "  <div class=\"iscroll-scroller iscroll-scroller--horizontal\">\n" +
    "    <div class=\"client-card-placeholder\"\n" +
    "      dragula=\"'clients'\"\n" +
    "      dragula-scope=\"createCtrl.scope\"\n" +
    "      dragula-model=\"createCtrl.selectedClients\">\n" +
    "      <div class=\"client-card-placeholder__text\">\n" +
    "        {{'DROP_CLIENT_TILE_HERE' | translate}}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <user-card class=\"user-tab__selected-user\"\n" +
    "      is-removable=\"true\"\n" +
    "      user=\"client\"\n" +
    "      remove=\"createCtrl.removeClient($index)\"\n" +
    "      ng-repeat=\"client in createCtrl.selectedClients track by client._id\">\n" +
    "    </user-card>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"user-tab__scrollbar\"></div>\n" +
    "\n" +
    "<library-search>\n" +
    "  <div class=\"library-search\">\n" +
    "    <div class=\"library-search__icon\"></div>\n" +
    "    <input type=\"text\"\n" +
    "      class=\"library-search__input\"\n" +
    "      placeholder=\"{{'SEARCH' |translate}}\"\n" +
    "      ng-model-options=\"{ debounce: 500 }\"\n" +
    "      ng-model=\"createCtrl.clientSearch\"\n" +
    "      ng-change=\"createCtrl.loadClients(true)\">\n" +
    "  </div>\n" +
    "</library-search>\n" +
    "\n" +
    "\n" +
    "<div class=\"user-tab__users\"\n" +
    "  dragula=\"'clients'\"\n" +
    "  dragula-scope=\"createCtrl.scope\"\n" +
    "  dragula-model=\"createCtrl.clients.items\"\n" +
    "  infinite-scroll='createCtrl.loadClients()'\n" +
    "  can-load='createCtrl.clients.nextPage'\n" +
    "  threshold='30'>\n" +
    "\n" +
    "  <user-card class=\"user-tab__user\"\n" +
    "    user=\"client\"\n" +
    "    ng-disabled=\"createCtrl.isClientDisabled(client)\"\n" +
    "    ng-repeat=\"client in createCtrl.clients.items track by client._id\">\n" +
    "  </user-card>\n" +
    "\n" +
    "  <div class='user-tab__no-users'\n" +
    "    ng-if='!createCtrl.clients.items.length && !createCtrl.clients.isLoading'>\n" +
    "    {{ \"NO_CLIENTS\" | translate }}\n" +
    "  </div>\n" +
    "\n" +
    "  <div class='roster-load-more' ng-if='createCtrl.clients.isLoading'>\n" +
    "    <div class='roster-load-more__icon spinner-icon'></div>\n" +
    "    {{ 'LOADING_MORE_CLIENTS' | translate }}\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/library/create-assignment/tabs/date.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/create-assignment/tabs/date.html",
    "<div class=\"date-tab\" ng-class=\"{'date-tab--with-time': createCtrl.canPickTime}\">\n" +
    "  <div class=\"date-tab__bar\">\n" +
    "    <span class=\"date-tab__bar-text\">{{'START_DATE' | translate}}</span>\n" +
    "    <span class=\"date-tab__bar-text\">{{'END_DATE' | translate}}</span>\n" +
    "    <span class=\"date-tab__bar-text\"\n" +
    "          ng-if=\"createCtrl.canPickTime\">\n" +
    "      {{'TIME' | translate}}\n" +
    "    </span>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"date-tab__picker-wrapper\">\n" +
    "    <datepicker\n" +
    "      selected=\"createCtrl.startDate\"\n" +
    "      first-availiable=\"createCtrl.today\"\n" +
    "      validator=\"dateIsSet(selectedDay)\">\n" +
    "    </datepicker>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"date-tab__picker-wrapper\">\n" +
    "    <datepicker\n" +
    "      selected=\"createCtrl.endDate\"\n" +
    "      from=\"createCtrl.startDate\"\n" +
    "      validator=\"dateIsSet(selectedDay)\">\n" +
    "    </datepicker>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"date-tab__picker-wrapper\"\n" +
    "    ng-class=\"{'date-tab__picker-wrapper--invisible': !createCtrl.canPickTime}\">\n" +
    "    <timepicker clients=\"createCtrl.timelineClients\"\n" +
    "      selected-clients=\"createCtrl.timelineSelectedClients\"\n" +
    "      edit-assign=\"createCtrl.activeAssignment\"\n" +
    "      on-title-click=\"createCtrl.resetAppointmentTime()\"\n" +
    "      start-time=\"createCtrl.startTime\"\n" +
    "      end-time=\"createCtrl.endTime\">\n" +
    "    </timepicker>\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/library/create-assignment/tabs/exercise-profile.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/create-assignment/tabs/exercise-profile.html",
    "<pt-items-bag\n" +
    "  active-item-index=\"createCtrl.activeExerciseIndex\"\n" +
    "  selected-items=\"createCtrl.selectedExercises\"\n" +
    "  bag-type=\"workoutAssignmentOther\"\n" +
    "  item-type=\"exercises\">\n" +
    "</pt-items-bag>\n" +
    "<pt-exercise-profile\n" +
    "  exercise=\"createCtrl.selectedExercises[createCtrl.activeExerciseIndex]\"\n" +
    "  edit-permission=\"WORKOUT_ASSIGNMENTS_OTHER_CREATE\"\n" +
    "></pt-exercise-profile>\n" +
    "\n" +
    "");
}]);

angular.module("/app/library/create-assignment/tabs/exercise.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/create-assignment/tabs/exercise.html",
    "<div class=\"exercise-tab__selected-exercises iscroll-wrapper\"\n" +
    "     iscroll=\"{scrollX: true, scrollY:false, mouseWheel:false, click:false}\"\n" +
    "     dragula-configure\n" +
    "     dragula-scope=\"createCtrl.scope\"\n" +
    "     dragula-bag=\"exercises.items\"\n" +
    "     dragula-invalid=\"client-card-placeholder__text\"\n" +
    "     dragula-direction=\"horizontal\">\n" +
    "\n" +
    "  <div class=\"iscroll-scroller iscroll-scroller--horizontal\">\n" +
    "    <div class=\"client-card-placeholder\" dragula=\"'exercises.items'\"\n" +
    "      dragula-scope=\"createCtrl.scope\"\n" +
    "      dragula-model=\"createCtrl.selectedExercises\">\n" +
    "      <div class=\"client-card-placeholder__text\">\n" +
    "        {{'DROP_EXERCISE_TILE_HERE' | translate}}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <selected-exercise-card\n" +
    "      class=\"exercise-tab__selected-exercise\"\n" +
    "      data=\"exercise\"\n" +
    "      index=\"$index\"\n" +
    "      remove=\"createCtrl.removeExercise($index)\"\n" +
    "      is-removable=\"true\"\n" +
    "      ng-repeat=\"exercise in createCtrl.selectedExercises\">\n" +
    "    </selected-exercise-card>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "<library-search>\n" +
    "  <div class=\"library-search\">\n" +
    "    <div class=\"library-search__icon\"></div>\n" +
    "    <input type=\"text\"\n" +
    "      class=\"library-search__input\"\n" +
    "      placeholder=\"{{'SEARCH' | translate}}\"\n" +
    "      ng-model-options=\"{ debounce: 500 }\"\n" +
    "      ng-model=\"createCtrl.exerciseSearch\"\n" +
    "      ng-change=\"createCtrl.filterExercises()\">\n" +
    "  </div>\n" +
    "</library-search>\n" +
    "\n" +
    "<div class=\"exercise-tab__exercises\">\n" +
    "  <!--============= EXERCISES =============-->\n" +
    "  <div\n" +
    "    dragula=\"'exercises.items'\"\n" +
    "    dragula-scope=\"createCtrl.scope\"\n" +
    "    dragula-model=\"createCtrl.exercises.items\"\n" +
    "    infinite-scroll=\"createCtrl.loadExercises()\"\n" +
    "    can-load=\"createCtrl.exercises.nextPage\"\n" +
    "    threshold=\"100\">\n" +
    "\n" +
    "    <library-card class=\"exercise-tab__exercise\"\n" +
    "      data=\"exercise\"\n" +
    "      ng-repeat=\"exercise in createCtrl.exercises.items track by exercise._id\">\n" +
    "      <span>{{exercise.title}}</span>\n" +
    "    </library-card>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"exercise-tab__no-exercises\"\n" +
    "    ng-if=\"!createCtrl.exercises.items.length && !createCtrl.exercises.isLoading\">\n" +
    "    {{ :: 'NO_EXERCISES_AVAILABLE' | translate }}\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"roster-load-more\" ng-if=\"createCtrl.exercises.isLoading\">\n" +
    "    <div class=\"roster-load-more__icon spinner-icon\"></div>\n" +
    "    {{ :: 'LOADING_MORE_EXERCISES' | translate }}\n" +
    "  </div>\n" +
    "\n" +
    "  <!--============= TRAINING SETS =============-->\n" +
    "  <div\n" +
    "       dragula=\"'exercises.items'\"\n" +
    "       dragula-scope=\"createCtrl.scope\"\n" +
    "       dragula-model=\"createCtrl.trainingSets.items\"\n" +
    "       infinite-scroll=\"createCtrl.loadTrainingSets()\"\n" +
    "       can-load=\"createCtrl.trainingSets.nextPage\"\n" +
    "       threshold='100'>\n" +
    "\n" +
    "    <library-card class=\"exercise-tab__exercise\"\n" +
    "      ng-repeat=\"set in createCtrl.trainingSets.items track by set._id\"\n" +
    "      type=\"trainingSets\"\n" +
    "      data=\"set\">\n" +
    "      <span>{{set.title}}</span>\n" +
    "    </library-card>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"exercise-tab__no-exercises\"\n" +
    "       ng-if=\"!createCtrl.trainingSets.items.length && !createCtrl.trainingSets.isLoading\">\n" +
    "    {{ :: 'NO_TRAINING_SETS_AVAILABLE' | translate }}\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"roster-load-more\" ng-if=\"createCtrl.trainingSets.isLoading\">\n" +
    "    <div class=\"roster-load-more__icon spinner-icon\"></div>\n" +
    "    {{ :: 'LOADING_MORE_TRAINING_SETS' | translate }}\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/library/create-assignment/tabs/trainer.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/create-assignment/tabs/trainer.html",
    "<div class=\"user-tab__selected-users iscroll-wrapper\"\n" +
    "     iscroll=\"{scrollX: true, scrollY:false, mouseWheel:false, click:false}\"\n" +
    "     dragula-configure\n" +
    "     dragula-scope=\"createCtrl.scope\"\n" +
    "     dragula-bag=\"trainers\"\n" +
    "     dragula-invalid=\"client-card-placeholder__text\"\n" +
    "     dragula-direction=\"horizontal\">\n" +
    "\n" +
    "  <div class=\"iscroll-scroller iscroll-scroller--horizontal\">\n" +
    "    <div class=\"client-card-placeholder\"\n" +
    "      dragula=\"'trainers'\"\n" +
    "      dragula-scope=\"createCtrl.scope\"\n" +
    "      dragula-model=\"createCtrl.selectedTrainers\">\n" +
    "      <div class=\"client-card-placeholder__text\">\n" +
    "        {{ :: 'DROP_TRAINER_TILE_HERE' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <user-card class=\"user-tab__selected-user\"\n" +
    "      is-removable=\"true\"\n" +
    "      role=\"trainer\"\n" +
    "      user=\"trainer\"\n" +
    "      remove=\"createCtrl.removeTrainer($index)\"\n" +
    "      ng-repeat=\"trainer in createCtrl.selectedTrainers track by trainer._id\">\n" +
    "    </user-card>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"user-tab__scrollbar\"></div>\n" +
    "\n" +
    "<library-search>\n" +
    "  <div class=\"library-search\">\n" +
    "    <div class=\"library-search__icon\"></div>\n" +
    "    <input type=\"text\"\n" +
    "      class=\"library-search__input\"\n" +
    "      placeholder=\"{{ :: 'SEARCH' | translate }}\"\n" +
    "      ng-model-options=\"{ debounce: 500 }\"\n" +
    "      ng-model=\"createCtrl.trainerSearch\"\n" +
    "      ng-change=\"createCtrl.loadTrainers(true)\">\n" +
    "  </div>\n" +
    "</library-search>\n" +
    "\n" +
    "\n" +
    "<div class=\"user-tab__users\"\n" +
    "  dragula=\"'trainers'\"\n" +
    "  dragula-scope=\"createCtrl.scope\"\n" +
    "  dragula-model=\"createCtrl.trainers.items\"\n" +
    "  infinite-scroll=\"createCtrl.loadTrainers()\"\n" +
    "  can-load='createCtrl.trainers.nextPage'\n" +
    "  threshold='30'>\n" +
    "\n" +
    "  <user-card class=\"user-tab__user\"\n" +
    "    user=\"trainer\"\n" +
    "    ng-repeat=\"trainer in createCtrl.trainers.items track by trainer._id\">\n" +
    "  </user-card>\n" +
    "\n" +
    "  <div class='user-tab__no-users'\n" +
    "    ng-if='!createCtrl.trainers.items.length && !createCtrl.trainers.isLoading'>\n" +
    "    {{ :: \"NO_TRAINERS\" | translate }}\n" +
    "  </div>\n" +
    "\n" +
    "  <div class='roster-load-more' ng-if='createCtrl.trainers.isLoading'>\n" +
    "    <div class='roster-load-more__icon spinner-icon'></div>\n" +
    "    {{ :: \"LOADING_MORE_TRAINERS\" | translate }}\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/app/library/exercise/exercise.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/exercise/exercise.html",
    "<section class=\"create-exercise\">\n" +
    "  <header class=\"create-exercise__header\">\n" +
    "    <a class=\"back-button\" need-confirmation=\"true\"></a>\n" +
    "    <h1 class=\"create-exercise__header-title\"\n" +
    "        ng-if=\"exerciseCtrl.isEdit \">\n" +
    "      {{ :: 'EDIT' | translate}} {{ exerciseCtrl.exercise.title }}\n" +
    "    </h1>\n" +
    "    <h1 class=\"create-exercise__header-title\"\n" +
    "      ng-if=\"!exerciseCtrl.isEdit \">\n" +
    "      {{ :: 'CREATE_NEW_EXERCISE' | translate}}\n" +
    "    </h1>\n" +
    "    <div class=\"button button-assertive pull-right exercise-delete-btn\"\n" +
    "         permission\n" +
    "         permission-only=\"exerciseCtrl.exercise.restricted ?\n" +
    "            'EXERCISES_DELETE+RESTRICTED_FLAG_DELETE' : 'EXERCISES_DELETE'\"\n" +
    "         ng-if=\"exerciseCtrl.isEdit\"\n" +
    "         ng-click=\"exerciseCtrl.deleteExercise()\">\n" +
    "      <span class=\"button__icon button__icon--delete-exercise\"></span>\n" +
    "      {{ 'DELETE_EXERCISE' | translate }}\n" +
    "    </div>\n" +
    "  </header>\n" +
    "\n" +
    "  <section class=\"create-exercise__content\">\n" +
    "\n" +
    "    <tabs theme=\"dark\">\n" +
    "      <tab>\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ :: 'CHOOSE_EQUIPMENT_TYPE' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <div ng-include=\"'/app/library/exercise/tabs/choose-equip.html'\" class=\"create-exercise__equipments\"></div>\n" +
    "        </tab-content>\n" +
    "\n" +
    "      </tab>\n" +
    "\n" +
    "      <tab is-disabled='!exerciseCtrl.selectedEquipment'>\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ :: 'EXERCISE_PROFILE' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <div class=\"create-exercise__profile\"\n" +
    "            ng-if=\"exerciseCtrl.isConnected\"\n" +
    "            ng-include=\"'/app/library/exercise/tabs/profile-connected.html'\"></div>\n" +
    "\n" +
    "          <form name=\"exerciseCtrl.exerciseProfileForm\">\n" +
    "            <div class=\"create-exercise__profile\"\n" +
    "              ng-if=\"exerciseCtrl.selectedEquipment && !exerciseCtrl.isConnected\"\n" +
    "              ng-include=\"'/app/library/exercise/tabs/profile-params.html'\"></div>\n" +
    "          </form>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "      <tab is-disabled='!exerciseCtrl.selectedEquipment'>\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ :: 'EXERCISE_DETAILS' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <div ng-include=\"'/app/library/exercise/tabs/details.html'\"></div>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "      <tab is-disabled='!exerciseCtrl.selectedEquipment'>\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ :: 'EXERCISE_IMAGE' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <div ng-include=\"'/app/library/exercise/tabs/multimedia.html'\" class=\"create-exercise-image\"></div>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "      <tab class='tab-action'\n" +
    "        is-button=\"true\"\n" +
    "        is-disabled=\"!exerciseCtrl.exerciseProfileForm.$valid\">\n" +
    "        <tab-head\n" +
    "          ng-class=\"{'create-exercise__tab-title--disabled': exerciseCtrl.isLoading}\"\n" +
    "          ng-click=\"exerciseCtrl.createExercise()\">\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            <i class=\"create-exercise__tab-title-icon spinner-icon\" ng-if=\"exerciseCtrl.isLoading\"></i>\n" +
    "            {{ exerciseCtrl.isEdit ? 'SAVE_CHANGES' : 'CREATE_EXERCISE' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "      </tab>\n" +
    "\n" +
    "      <tab class='tab-assertive button-clear'\n" +
    "        is-button=\"true\">\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\"\n" +
    "            ng-click=\"exerciseCtrl.cancelExercise()\">\n" +
    "            {{ :: 'CANCEL_EXERCISE' | translate}}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "      </tab>\n" +
    "\n" +
    "    </tabs>\n" +
    "\n" +
    "  </section>\n" +
    "\n" +
    "\n" +
    "</section>\n" +
    "");
}]);

angular.module("/app/library/exercise/tabs/choose-equip.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/exercise/tabs/choose-equip.html",
    "<div class=\"create-exercise__equipment\"\n" +
    "  ng-class=\"{'create-exercise__equipment--active': exerciseCtrl.isActiveEquipment(equipment)}\"\n" +
    "  ng-repeat=\"equipment in exerciseCtrl.equipmentPresets\"\n" +
    "  ng-click=\"exerciseCtrl.selectEquipment(equipment)\">\n" +
    "  <img class=\"create-exercise__equipment-img\"\n" +
    "    ng-src=\"{{ equipment.pictureUrl }}\">\n" +
    "  <div class='create-exercise__equipment-content'>\n" +
    "    <div class=\"create-exercise__equipment-type\">{{ (equipment.equipmentType || equipment.category) | translate}}</div>\n" +
    "    <div class=\"create-exercise__equipment-program\"> {{ equipment.title }}</div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/library/exercise/tabs/details.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/exercise/tabs/details.html",
    "<!--<div>-->\n" +
    "  <!--<input class='create-exercise-details__title'-->\n" +
    "         <!--type='text'-->\n" +
    "         <!--ng-model='exerciseCtrl.exerciseTitle'-->\n" +
    "         <!--placeholder='{{ \"EXERCISE_TITLE\" | translate }}'/>-->\n" +
    "\n" +
    "  <!--<label for=\"create-exercise-details__description\"-->\n" +
    "    <!--class=\"create-exercise-details__description-title\">-->\n" +
    "    <!--{{'EXERCISE_DESCRIPTION'| translate}}-->\n" +
    "  <!--</label>-->\n" +
    "  <!--<textarea class=\"create-exercise-details__description\"-->\n" +
    "    <!--id=\"create-exercise-details__description\"-->\n" +
    "    <!--ng-model=\"exerciseCtrl.exerciseDescription\">-->\n" +
    "  <!--</textarea>-->\n" +
    "\n" +
    "<!--</div>-->\n" +
    "<pt-exercise-item-details\n" +
    "  item=\"exerciseCtrl.details\"\n" +
    "  type=\"exercises\"\n" +
    "></pt-exercise-item-details>\n" +
    "");
}]);

angular.module("/app/library/exercise/tabs/multimedia.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/exercise/tabs/multimedia.html",
    "<pt-exercise-multimedia\n" +
    "  images-list=\"exerciseCtrl.exercise.images\"\n" +
    "  video=\"exerciseCtrl.exercise.video\"\n" +
    "  on-video-update=\"exerciseCtrl.setVideo(url)\">\n" +
    "</pt-exercise-multimedia>\n" +
    "");
}]);

angular.module("/app/library/exercise/tabs/profile-connected.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/exercise/tabs/profile-connected.html",
    "<div class='exercise-profile__info'>\n" +
    "\n" +
    "  <div class='exercise-profile__tiles'>\n" +
    "\n" +
    "    <div class='exercise-profile__tile'\n" +
    "      ng-repeat='tile in exerciseCtrl.selectedEquipment.metrics | filter: {forSegment: true}'>\n" +
    "\n" +
    "      <div class='exercise-profile__tile-header'>\n" +
    "        <div class='exercise-profile__tile-title'>{{ tile.name | camelToSnakeCase | translate }}</div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class='exercise-profile__tile-content'>\n" +
    "        <div class='exercise-profile__tile-value'\n" +
    "          ng-if='tile.name !== \"duration\"'>{{ exerciseCtrl.segments[0].data[tile.name] }}\n" +
    "        </div>\n" +
    "        <div class='exercise-profile__tile-value'\n" +
    "          ng-if='tile.name === \"duration\"'>{{ exerciseCtrl.totalDuration }}\n" +
    "        </div>\n" +
    "        <div class='exercise-profile__tile-units'>{{ tile.unit | camelToSnakeCase | translate }}</div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <div class='exercise-profile__segments'>\n" +
    "    <div class='exercise-profile__segments-title'>{{ 'EXERCISE_PROFILE' | translate }}</div>\n" +
    "    <div class='exercise-profile__segments-content'>\n" +
    "\n" +
    "\n" +
    "      <div class='exercise-profile__segments-controls exercise-profile__segments-controls--left'>\n" +
    "        <div class='exercise-profile__segments-control'\n" +
    "          ng-disabled='!exerciseCtrl.scrollInstance._enableLeft'\n" +
    "          ng-click='exerciseCtrl.scrollInstance._enableLeft && exerciseCtrl.scrollInstance.prev()'>\n" +
    "          <i class='icon icon-arrow-back'></i>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class='exercise-profile__segments-controls exercise-profile__segments-controls'>\n" +
    "\n" +
    "        <div class='exercise-profile__segments-control'\n" +
    "          ng-disabled='!exerciseCtrl.moreSegmentsAvailable()'\n" +
    "          ng-click='exerciseCtrl.moreSegmentsAvailable() && exerciseCtrl.addSegment()'>\n" +
    "          <i class='icon icon-ion-plus'></i>\n" +
    "        </div>\n" +
    "        <div class='exercise-profile__segments-control'\n" +
    "          ng-disabled='!exerciseCtrl.scrollInstance._enableRight'\n" +
    "          ng-click='exerciseCtrl.scrollInstance._enableRight && exerciseCtrl.scrollInstance.next()'>\n" +
    "          <i class='icon icon-arrow-forward'></i>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class='exercise-profile__segments-list'>\n" +
    "\n" +
    "        <div class='exercise-profile__segments-list-wrapper iscroll-wrapper'\n" +
    "          iscroll=\"{scrollX: true, scrollY: false, mouseWheel: false, click: true, snap: true}\"\n" +
    "          iscroll-instance=\"exerciseCtrl.scrollInstance\">\n" +
    "\n" +
    "          <div class='exercise-profile__segments-list-content iscroll-scroller iscroll-scroller--horizontal'>\n" +
    "            <div class='exercise-profile__segments-item'\n" +
    "              ng-repeat='segment in exerciseCtrl.segments'\n" +
    "              ng-class='{active: segment._isActive}'\n" +
    "              ng-click='exerciseCtrl.activateSegment(segment)'>\n" +
    "\n" +
    "              <div class='exercise-profile__segments-counter'>{{ $index + 1 }}</div>\n" +
    "              <div class='exercise-profile__segments-level-container'>\n" +
    "                <div class='exercise-profile__segments-level'\n" +
    "                     ng-style='{height: segment._progressHeight}'></div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class='exercise-profile__sliders fade-onload'\n" +
    "  ng-if='exerciseCtrl.activeSegment'>\n" +
    "\n" +
    "  <div class='exercise-profile__sliders-buttons'>\n" +
    "    <button class='exercise-profile__sliders-button exercise-profile__sliders-button--danger'\n" +
    "      ng-disabled='!exerciseCtrl.canDeleteSegments()'\n" +
    "      ng-click='exerciseCtrl.deleteActiveSegment()'>\n" +
    "      {{ 'DELETE_SEGMENT' | translate }}\n" +
    "    </button>\n" +
    "    <button class='exercise-profile__sliders-button'\n" +
    "      ng-click='exerciseCtrl.resetActiveSegment()'>\n" +
    "      {{ 'RESET_SEGMENT' | translate }}\n" +
    "    </button>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class='exercise-profile__sliders-list'>\n" +
    "    <div class='exercise-profile__sliders-item'\n" +
    "      ng-repeat='metric in exerciseCtrl.selectedEquipment.metrics | filter: {forSegment: true}'>\n" +
    "\n" +
    "      <div segment-slider\n" +
    "        value='exerciseCtrl.activeSegment.data[metric.name]'\n" +
    "        options='metric.validation'\n" +
    "        on-end='exerciseCtrl.sliderValueChanged(metric.name)'>\n" +
    "      </div>\n" +
    "      <div class='exercise-profile__sliders-item-title'>{{ metric.name | camelToSnakeCase | translate }}</div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/library/exercise/tabs/profile-params.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/exercise/tabs/profile-params.html",
    "<div class='exercise-profile__info'>\n" +
    "  <div class=\"exercise-profile__param-field\">\n" +
    "    <label class=\"exercise-profile__param-label\">\n" +
    "      <span class=\"exercise-profile__param-title\">{{ :: 'EXERCISE_CATEGORY' | translate }}</span>\n" +
    "      <select class=\"exercise-profile__param-select\"\n" +
    "        ng-options=\"category.name as category.name for category in exerciseCtrl.categories | orderBy: 'name'\"\n" +
    "        ng-model=\"exerciseCtrl.selectedEquipment.category\"></select>\n" +
    "    </label>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"exercise-profile__param-field\"\n" +
    "    ng-repeat=\"metric in exerciseCtrl.selectedEquipment.metrics\">\n" +
    "    <label class=\"exercise-profile__param-label\">\n" +
    "      <span class=\"exercise-profile__param-title\">{{ metric.name | camelToSnakeCase | translate }}</span>\n" +
    "      <input class=\"exercise-profile__param-input\"\n" +
    "        type=\"number\"\n" +
    "        min=\"0\"\n" +
    "        ng-model=\"exerciseCtrl.global[metric.name]\">\n" +
    "       <span>{{ metric.unit | camelToSnakeCase | translate }}</span>\n" +
    "    </label>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/library/library.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/library.html",
    "<section class=\"training-library\">\n" +
    "\n" +
    "  <!--================ HEADER WITH BUTTONS ================-->\n" +
    "  <header\n" +
    "    class=\"container-header\">\n" +
    "    <div class=\"container-header__content\">\n" +
    "      <i class=\"container-header__icon icon icon-books\"></i>\n" +
    "      <h1 class=\"container-header__title\">{{:: 'TRAINING_LIBRARY' | translate}}</h1>\n" +
    "\n" +
    "      <div class=\"button-toolbar pull-right\">\n" +
    "        <div class=\"button button-action\"\n" +
    "          permission\n" +
    "          permission-only=\"'EXERCISES_CREATE'\"\n" +
    "          ui-sref=\"app.library.exercise\">\n" +
    "          <span class=\"button__icon button__icon--add-exercise\"></span>\n" +
    "          {{ :: 'NEW_EXERCISE' | translate }}\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"button button-action\"\n" +
    "          permission\n" +
    "          permission-only=\"'TRAINING_SETS_CREATE'\"\n" +
    "          ui-sref=\"app.library.set\">\n" +
    "          <span class=\"button__icon button__icon--add-assignment\"></span>\n" +
    "          {{ :: 'NEW_TRAINING_SET' | translate }}\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "  </header>\n" +
    "\n" +
    "\n" +
    "  <!-- ============== SEARCH   ==========-->\n" +
    "  <!-- Only exercise read permission -> search works only for exercises-->\n" +
    "  <div permission\n" +
    "    permission-only=\"'EXERCISES_READ'\">\n" +
    "    <div class=\"library-search\">\n" +
    "      <div class=\"library-search__icon\"></div>\n" +
    "      <input type=\"text\"\n" +
    "             class=\"library-search__input\"\n" +
    "             placeholder=\"{{ :: 'SEARCH' | translate }}\"\n" +
    "             ng-model=\"library.search\"\n" +
    "             ng-model-options=\"{debounce: 500}\"\n" +
    "             ng-change=\"library.filterByName(library.activeTab)\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "  <!--================= TABS FOR SETS AND EXERCISES ========== -->\n" +
    "  <tabs class=\"training-library__tabs\">\n" +
    "\n" +
    "    <!--========= EXERCISES ===========-->\n" +
    "    <tab permission\n" +
    "      permission-only=\"'EXERCISES_READ'\"\n" +
    "      permission-on-unauthorized=\"PermissionStrategies.disableTab\"\n" +
    "      name=\"exercises\"\n" +
    "      select=\"library.showTab('EXERCISES')\">\n" +
    "      <tab-head>\n" +
    "          <span class=\"button__icon button__icon--exercise training-library__icon--add-exercise\"></span>\n" +
    "          <span>\n" +
    "            {{ :: 'EXERCISES' | translate }}\n" +
    "          </span>\n" +
    "      </tab-head>\n" +
    "    </tab>\n" +
    "\n" +
    "    <!--========= TRAINING_SETS ===========-->\n" +
    "    <tab permission\n" +
    "      permission-only=\"'TRAINING_SETS_READ'\"\n" +
    "      permission-on-unauthorized=\"PermissionStrategies.disableTab\"\n" +
    "      name=\"training-sets\"\n" +
    "      select=\"library.showTab('TRAINING_SETS')\">\n" +
    "      <tab-head>\n" +
    "          <span class=\"button__icon button__icon--assignment training-library__icon--add-assignment\"></span>\n" +
    "          <span>\n" +
    "            {{ :: 'TRAINING_SETS' | translate }}\n" +
    "          </span>\n" +
    "      </tab-head>\n" +
    "    </tab>\n" +
    "  </tabs>\n" +
    "\n" +
    "  <ng-include permission\n" +
    "    permission-only=\"['EXERCISES_READ', 'TRAINING_SETS_READ']\"\n" +
    "    src=\"'/app/library/tabs/list.html'\">\n" +
    "  </ng-include>\n" +
    "\n" +
    "\n" +
    "\n" +
    "</section>\n" +
    "");
}]);

angular.module("/app/library/tabs/list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/tabs/list.html",
    "<section class=\"exercise-tab\">\n" +
    "  <!-- ============== TRAINING SETS ==========-->\n" +
    "  <div class=\"training-library__tabs-content\"\n" +
    "    ng-if=\"library.activeTab === 'TRAINING_SETS'\">\n" +
    "\n" +
    "    <div class=\"exercise-tab__exercises\"\n" +
    "      ng-init=\"library.trainingSets.load()\"\n" +
    "      permission\n" +
    "      permission-only=\"'TRAINING_SETS_READ'\"\n" +
    "      infinite-scroll=\"library.trainingSets.load()\"\n" +
    "      can-load=\"library.trainingSets.nextPage\"\n" +
    "      threshold=\"250\">\n" +
    "\n" +
    "      <div class=\"library-cards\">\n" +
    "\n" +
    "        <library-card\n" +
    "          ng-repeat=\"set in library.trainingSets.items\"\n" +
    "          exercise=\"set\"\n" +
    "          type=\"trainingSets\"\n" +
    "          data=\"set\"\n" +
    "          on-edit-card=\"library.editTrainingSet(set)\"\n" +
    "          on-print-card=\"library.printTrainingSet(set)\"\n" +
    "          edit-permission=\"library.getCardPermission(set)\"\n" +
    "          hide-print-icon=\"!set.exercises.length\">\n" +
    "        </library-card>\n" +
    "\n" +
    "      </div>\n" +
    "      <div class=\"client-item--empty\"\n" +
    "        ng-if='!library.trainingSets.items.length && !library.trainingSets.isLoading'>\n" +
    "        {{ :: \"NO_TRAINING_SETS\" | translate }}\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"roster-load-more\" ng-if=\"library.trainingSets.isLoading\">\n" +
    "        <div class=\"roster-load-more__icon spinner-icon\"></div>\n" +
    "        {{ :: 'LOADING_MORE_TRAINING_SETS' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <!-- ============== EXERCISES ==========-->\n" +
    "  <div class=\"training-library__tabs-content\"\n" +
    "    ng-if=\"library.activeTab === 'EXERCISES'\">\n" +
    "    <div class=\"exercise-tab__exercises\"\n" +
    "      ng-init=\"library.exercises.load()\"\n" +
    "      permission\n" +
    "      permission-only=\"'EXERCISES_READ'\"\n" +
    "      infinite-scroll=\"library.exercises.load()\"\n" +
    "      can-load=\"library.exercises.nextPage\"\n" +
    "      threshold=\"250\">\n" +
    "\n" +
    "      <div class=\"library-cards\">\n" +
    "\n" +
    "        <library-card\n" +
    "          ng-repeat=\"exercise in library.exercises.items\"\n" +
    "          exercise=\"exercise\"\n" +
    "          type=\"exercises\"\n" +
    "          data=\"exercise\"\n" +
    "          on-edit-card=\"library.editExercise(exercise)\"\n" +
    "          on-print-card=\"library.printExerciseTemplate(exercise)\"\n" +
    "          edit-permission=\"library.getCardPermission(exercise)\">\n" +
    "        </library-card>\n" +
    "\n" +
    "      </div>\n" +
    "      <div class=\"client-item--empty\"\n" +
    "        ng-if=\"!library.exercises.items.length && !library.exercises.isLoading\">\n" +
    "        {{ :: 'NO_EXERCISES' | translate }}\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"roster-load-more\" ng-if=\"library.exercises.isLoading\">\n" +
    "        <div class=\"roster-load-more__icon spinner-icon\"></div>\n" +
    "        {{ :: 'LOADING_MORE_EXERCISES' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"client-item--empty\"\n" +
    "    ng-show=\"!library.activeTab\"\n" +
    "    ng-if=\"!library.exercises.items.length && !library.exercises.isLoading\n" +
    "        && !library.trainingSets.items.length && !library.trainingSets.isLoading\">\n" +
    "    {{ :: \"NO_ITEMS\" | translate }}\n" +
    "  </div>\n" +
    "\n" +
    "</section>\n" +
    "");
}]);

angular.module("/app/library/task/tabs/details.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/task/tabs/details.html",
    "<pt-exercise-item-details\n" +
    "  item=\"taskCtrl.task\"\n" +
    "  edit-permission=\"taskCtrl.editPermission\"\n" +
    "  type=\"task\"\n" +
    "></pt-exercise-item-details>\n" +
    "");
}]);

angular.module("/app/library/task/tabs/period.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/task/tabs/period.html",
    "<div class=\"date-tab\" ng-class=\"{'date-tab--with-time': taskCtrl.canPickTime}\">\n" +
    "  <div class=\"date-tab__bar\">\n" +
    "    <span class=\"date-tab__bar-text\">{{'START_DATE' | translate}}</span>\n" +
    "    <span class=\"date-tab__bar-text\">{{'END_DATE' | translate}}</span>\n" +
    "    <span class=\"date-tab__bar-text\"\n" +
    "      ng-if=\"taskCtrl.canPickTime\">\n" +
    "      {{'TIME' | translate}}\n" +
    "    </span>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"date-tab__picker-wrapper\">\n" +
    "    <datepicker\n" +
    "      selected=\"taskCtrl.task.startDate\"\n" +
    "      first-availiable=\"taskCtrl.today\"\n" +
    "      validator=\"dateIsSet(selectedDay)\">\n" +
    "    </datepicker>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"date-tab__picker-wrapper\">\n" +
    "    <datepicker\n" +
    "      selected=\"taskCtrl.task.endDate\"\n" +
    "      from=\"taskCtrl.task.startDate\"\n" +
    "      validator=\"dateIsSet(selectedDay)\">\n" +
    "    </datepicker>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"date-tab__picker-wrapper\"\n" +
    "       ng-class=\"{'date-tab__picker-wrapper--invisible': !taskCtrl.canPickTime}\">\n" +
    "    <timepicker\n" +
    "      clients=\"taskCtrl.timeSlots\"\n" +
    "      selected-clients=\"taskCtrl.namePlate\"\n" +
    "      edit-assign=\"taskCtrl.taskOnEdit\"\n" +
    "      on-title-click=\"taskCtrl.resetAppointmentTime()\"\n" +
    "      on-client-select='taskCtrl.navigateToUserDetails($item)'\n" +
    "      on-edit-client=\"taskCtrl.onEditAssigment($item)\"\n" +
    "      on-edit-task=\"taskCtrl.onEditTask($item)\"\n" +
    "      start-time=\"taskCtrl.task.appointment.startTime\"\n" +
    "      end-time=\"taskCtrl.task.appointment.endTime\">\n" +
    "    </timepicker>\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/library/task/tabs/users.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/task/tabs/users.html",
    "<section class=\"exercise-tab training-set__tab-content\">\n" +
    "  <pt-users-bag class=\"task__users-bag\"\n" +
    "    users-list=\"taskCtrl.users\"\n" +
    "    selected-users=\"taskCtrl.task.users\"\n" +
    "    id=\"taskCtrl.task._id\"\n" +
    "    bag-type=\"trainingSets\"\n" +
    "    edit-bag-permission=\"taskCtrl.editPermission\"\n" +
    "    bag-limit=\"1\"\n" +
    "    user-type=\"users\">\n" +
    "  </pt-users-bag>\n" +
    "</section>\n" +
    "");
}]);

angular.module("/app/library/task/task.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/task/task.html",
    "<section class=\"create-assignment task\" ng-form=\"taskCtrl.form\" novalidate>\n" +
    "  <header class=\"create-assignment__header\">\n" +
    "    <a class=\"back-button\"></a>\n" +
    "    <h1 class=\"create-assignment__header-title\">\n" +
    "      {{ :: taskCtrl.isEdit ? 'EDIT_TASK' : 'CREATE_TASK' | translate }}\n" +
    "    </h1>\n" +
    "\n" +
    "    <div class=\"button button-assertive pull-right exercise-delete-btn set-delete-btn\"\n" +
    "      permission\n" +
    "      permission-only=\"taskCtrl.deletePermission\"\n" +
    "      ng-if=\"taskCtrl.task._id\"\n" +
    "      ng-click=\"taskCtrl.remove(taskCtrl.task._id)\">\n" +
    "      <span class=\"button__icon button__icon--delete-exercise\"></span>\n" +
    "      {{ :: 'DELETE_TASK' | translate }}\n" +
    "    </div>\n" +
    "  </header>\n" +
    "\n" +
    "  <section class=\"create-assignment__content\">\n" +
    "\n" +
    "    <tabs theme=\"dark\">\n" +
    "      <tab>\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ taskCtrl.task.users.length }} {{ :: 'USERS' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <ng-include src=\"'/app/library/task/tabs/users.html'\"></ng-include>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "      <!--============ PERIOD ==============-->\n" +
    "      <tab is-disabled=\"!taskCtrl.task.users.length\"\n" +
    "        select='taskCtrl.activateDateTab()'>\n" +
    "\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\"\n" +
    "            ng-if=\"!taskCtrl.isDateTabWasSelected\">\n" +
    "            {{ :: 'PICK_DATE_TIME' | translate }}\n" +
    "          </span>\n" +
    "          <span class=\"tab-head__multiline-item\"\n" +
    "            ng-if=\"taskCtrl.isDateTabWasSelected\">\n" +
    "            {{taskCtrl.parseDate()}}\n" +
    "            <span class=\"create-assignment__dark-text\"\n" +
    "              ng-if=\"taskCtrl.canPickTime && taskCtrl.task.appointment.startTime\">\n" +
    "              <br/>\n" +
    "              {{ taskCtrl.task.appointment.startTime.valueOf() | date: 'hh:mm a' : 'UTC' }} -\n" +
    "              {{ taskCtrl.task.appointment.endTime.valueOf() | date: 'hh:mm a' : 'UTC' }}\n" +
    "            </span>\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <ng-include src=\"'/app/library/task/tabs/period.html'\"></ng-include>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "\n" +
    "\n" +
    "      <!--================== TASK DETAILS ===============-->\n" +
    "      <tab>\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ :: 'TASK_DETAILS' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <ng-include src=\"'/app/library/task/tabs/details.html'\"></ng-include>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "      <tab class='tab-action'\n" +
    "        is-button=\"true\"\n" +
    "        is-disabled=\"!taskCtrl.task.users.length || !taskCtrl.isDateTabWasSelected\">\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\"\n" +
    "            ng-click=\"taskCtrl.save(taskCtrl.task)\">\n" +
    "            {{ :: taskCtrl.isEdit ? 'EDIT_TASK' : 'CREATE_TASK' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "      </tab>\n" +
    "\n" +
    "      <tab class='tab-assertive button-clear'\n" +
    "        is-button=\"true\"\n" +
    "        ng-hide=\"taskCtrl.isEdit\">\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\"\n" +
    "            ui-sref=\"app.dashboard\">\n" +
    "            {{ :: 'CANCEL_TASK' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "      </tab>\n" +
    "\n" +
    "    </tabs>\n" +
    "\n" +
    "  </section>\n" +
    "\n" +
    "\n" +
    "</section>\n" +
    "");
}]);

angular.module("/app/library/training-set/tabs/exercise-profile.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/training-set/tabs/exercise-profile.html",
    "<pt-items-bag\n" +
    "  active-item-index=\"createSetCtrl.activeExerciseIndex\"\n" +
    "  selected-items=\"createSetCtrl.set.exercises\"\n" +
    "  bag-type=\"trainingSets\"\n" +
    "  item-type=\"exercises\">\n" +
    "</pt-items-bag>\n" +
    "<pt-exercise-profile\n" +
    "  exercise=\"createSetCtrl.set.exercises[createSetCtrl.activeExerciseIndex]\"\n" +
    "  edit-permission=\"createSetCtrl.set.chainWide ?\n" +
    "    (createSetCtrl.set._id ? 'CHAIN_WIDE_UPDATE' : 'CHAIN_WIDE_CREATE'):\n" +
    "    (createSetCtrl.set._id ? 'TRAINING_SETS_UPDATE' : 'TRAINING_SETS_CREATE')\"\n" +
    "></pt-exercise-profile>\n" +
    "\n" +
    "");
}]);

angular.module("/app/library/training-set/tabs/exercises.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/training-set/tabs/exercises.html",
    "<section class=\"exercise-tab training-set__tab-content\">\n" +
    "  <pt-items-bag\n" +
    "    items-list=\"createSetCtrl.exercises\"\n" +
    "    edit-item=\"createSetCtrl.editExercise\"\n" +
    "    selected-items=\"createSetCtrl.set.exercises\"\n" +
    "    active-item-index=\"createSetCtrl.activeExerciseIndex\"\n" +
    "    is-chain-wide=\"createSetCtrl.set.chainWide\"\n" +
    "    id=\"createSetCtrl.set._id\"\n" +
    "    bag-type=\"trainingSets\"\n" +
    "    hide-print-icon=\"true\"\n" +
    "    item-type=\"exercises\">\n" +
    "  </pt-items-bag>\n" +
    "</section>\n" +
    "");
}]);

angular.module("/app/library/training-set/tabs/training-set-details.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/training-set/tabs/training-set-details.html",
    "<pt-exercise-item-details\n" +
    "  item=\"createSetCtrl.set\"\n" +
    "  type=\"trainingSets\"\n" +
    "></pt-exercise-item-details>\n" +
    "");
}]);

angular.module("/app/library/training-set/tabs/training-set-media.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/training-set/tabs/training-set-media.html",
    "<pt-exercise-multimedia\n" +
    "  images-list=\"createSetCtrl.set.imagesList\"\n" +
    "  images-limit=\"1\"\n" +
    "  type=\"trainingSet\"\n" +
    "  video=\"createSetCtrl.set.video\"\n" +
    "  on-video-update=\"createSetCtrl.setVideo(url)\"\n" +
    ">\n" +
    "</pt-exercise-multimedia>\n" +
    "");
}]);

angular.module("/app/library/training-set/training-set.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/library/training-set/training-set.html",
    "<!--THIS PAGE IS AVAILIABLE IF YOU HAVE\n" +
    "TRAINING_SETS_READ OR TRAINING_SETS_UPDATE PERMISSSION -->\n" +
    "\n" +
    "<section\n" +
    "  class=\"create-assignment\" novalidate>\n" +
    "  <header class=\"create-assignment__header\">\n" +
    "    <a class=\"back-button\" need-confirmation=\"true\"></a>\n" +
    "    <h1 class=\"create-assignment__header-title\">\n" +
    "      {{ :: createSetCtrl.isEdit ? 'EDIT_TRAINING_SET' : 'CREATE_TRAINING_SET' | translate}}\n" +
    "    </h1>\n" +
    "\n" +
    "\n" +
    "    <div class=\"button button-assertive pull-right exercise-delete-btn set-delete-btn\"\n" +
    "      permission\n" +
    "      permission-only=\"createSetCtrl.deletePermission\"\n" +
    "      ng-if=\"createSetCtrl.set._id\"\n" +
    "      ng-click=\"createSetCtrl.remove(createSetCtrl.set._id)\">\n" +
    "        <span class=\"button__icon button__icon--delete-exercise\"></span>\n" +
    "        {{ :: 'DELETE_TRAINING_SET' | translate }}\n" +
    "    </div>\n" +
    "  </header>\n" +
    "\n" +
    "  <section class=\"create-assignment__content\">\n" +
    "\n" +
    "    <tabs theme=\"dark\">\n" +
    "\n" +
    "      <!--========= Exercises tab===========-->\n" +
    "      <tab permission\n" +
    "        permission-only=\"'EXERCISES_READ'\"\n" +
    "        permission-on-unauthorized=\"PermissionStrategies.disableTab\">\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ createSetCtrl.set.exercises.length }} {{ :: 'EXERSCISES' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <ng-include class=\"training-set\"\n" +
    "            src=\"'/app/library/training-set/tabs/exercises.html'\">\n" +
    "          </ng-include>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "      <!--========= Exercises Profile===========-->\n" +
    "      <tab permission\n" +
    "        permission-only=\"'EXERCISES_READ'\"\n" +
    "        permission-on-unauthorized=\"PermissionStrategies.disableTab\"\n" +
    "        is-disabled=\"!createSetCtrl.set.exercises.length\">\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ :: 'EXERSCISE_PROFILES' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <ng-include class=\"training-set\"\n" +
    "            src=\"'/app/library/training-set/tabs/exercise-profile.html'\">\n" +
    "          </ng-include>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "      <!--========= SET MEDIA ===========-->\n" +
    "      <tab permission\n" +
    "         permission-only=\"'TRAINING_SETS_READ'\"\n" +
    "         permission-on-unauthorized=\"PermissionStrategies.disableTab\"\n" +
    "         is-disabled=\"!createSetCtrl.set.exercises.length\">\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ :: 'TRAINING_SET_MEDIA' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <ng-include class=\"training-set\"\n" +
    "            src=\"'/app/library/training-set/tabs/training-set-media.html'\">\n" +
    "          </ng-include>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "      <!--========= SET MEDIA ===========-->\n" +
    "      <tab permission\n" +
    "        permission-only=\"['TRAINING_SETS_READ', 'TRAINING_SETS_UPDATE']\"\n" +
    "        permission-on-unauthorized=\"PermissionStrategies.disableTab\"\n" +
    "        is-disabled=\"!createSetCtrl.set.exercises.length\">\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ :: 'TRAINING_SET_DETAILS' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <ng-include class=\"training-set\"\n" +
    "            src=\"'/app/library/training-set/tabs/training-set-details.html'\">\n" +
    "          </ng-include>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "      <!--  ========= CREATE tab===========-->\n" +
    "\n" +
    "      <tab class='tab-action'\n" +
    "        is-button=\"true\"\n" +
    "        permission\n" +
    "        permission-only=\"createSetCtrl.set.chainWide ?\n" +
    "          (createSetCtrl.set._id ? 'CHAIN_WIDE_UPDATE' : 'CHAIN_WIDE_CREATE'):\n" +
    "          (createSetCtrl.set._id ? 'TRAINING_SETS_UPDATE' : 'TRAINING_SETS_CREATE')\">\n" +
    "        <tab-head>\n" +
    "          <button class=\"tab-head__multiline-item\"\n" +
    "            ng-click=\"createSetCtrl.save(createSetCtrl.set)\"\n" +
    "            ng-disabled=\"createSetCtrl.isLoading\">\n" +
    "            <i class=\"create-exercise__tab-title-icon spinner-icon\" ng-if=\"createSetCtrl.isLoading\"></i>\n" +
    "            {{ :: createSetCtrl.isEdit ? 'EDIT_SET' : 'SAVE_SET' | translate}}\n" +
    "          </button>\n" +
    "        </tab-head>\n" +
    "      </tab>\n" +
    "\n" +
    "      <!--  ========= CANCEL tab===========-->\n" +
    "      <tab class='tab-assertive button-clear'\n" +
    "        is-button=\"true\"\n" +
    "        permission\n" +
    "        permission-only=\"createSetCtrl.set.chainWide ?\n" +
    "          (createSetCtrl.set._id ? 'CHAIN_WIDE_UPDATE' : 'CHAIN_WIDE_CREATE'):\n" +
    "          (createSetCtrl.set._id ? 'TRAINING_SETS_UPDATE' : 'TRAINING_SETS_CREATE')\">\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\"\n" +
    "            ng-click=\"createSetCtrl.cancel()\">\n" +
    "            {{ :: 'CANCEL' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "      </tab>\n" +
    "\n" +
    "    </tabs>\n" +
    "\n" +
    "  </section>\n" +
    "\n" +
    "\n" +
    "</section>\n" +
    "");
}]);

angular.module("/app/roster/roster.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/roster/roster.html",
    "<section class=\"roster\">\n" +
    "\n" +
    "  <header class=\"container-header\">\n" +
    "    <div class=\"container-header__content\">\n" +
    "      <i class=\"container-header__icon icon icon-users\"></i>\n" +
    "      <h1 class=\"container-header__title\">{{ 'ROSTER' | translate}}</h1>\n" +
    "    </div>\n" +
    "  </header>\n" +
    "\n" +
    "  <library-search>\n" +
    "    <div class=\"library-search\">\n" +
    "      <div class=\"library-search__icon\"></div>\n" +
    "      <input type=\"text\"\n" +
    "        class=\"library-search__input\"\n" +
    "        placeholder=\"{{ 'SEARCH' | translate}}\"\n" +
    "        ng-model=\"roster.search\"\n" +
    "        ng-model-options=\"{debounce: 500}\"\n" +
    "        ng-change=\"roster.filterByName()\">\n" +
    "    </div>\n" +
    "  </library-search>\n" +
    "\n" +
    "  <section class='roster__content'\n" +
    "    infinite-scroll='roster.loadClients()'\n" +
    "    can-load='roster.clientsList.nextPage'\n" +
    "    threshold='30'>\n" +
    "\n" +
    "    <div class='client-item fade-onload'\n" +
    "      ng-repeat='client in roster.clientsList.items'\n" +
    "      permission\n" +
    "      permission-only=\"roster.getUserViewPermission(client)\"\n" +
    "      ui-sref='app.users.details({userId: client._id, prevState: \"app.users.list\"})'>\n" +
    "\n" +
    "      <div class='client-item__right'>\n" +
    "<!--\n" +
    "        <div class='client-item__info'>\n" +
    "          <div class='client-item__info-content'>\n" +
    "            <div class='client-item__info-title'>{{ ::client.remain }} {{ 'REMAIN' | translate }}</div>\n" +
    "            <div class='client-item__info-caption'>{{ 'TRAINING_EXPIRES' | translate }}</div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    " -->\n" +
    "        <div class='client-item__info'>\n" +
    "          <div class='client-item__info-content'>\n" +
    "            <div class='client-item__info-title'\n" +
    "              ng-if='client.clientProfile.lastWorkoutDate'>{{ client.clientProfile.lastWorkoutDate * 1000 | date:'MM/dd/yyyy' }}</div>\n" +
    "            <div class='client-item__info-title'\n" +
    "              ng-if='!client.clientProfile.lastWorkoutDate'>-//-</div>\n" +
    "            <div class='client-item__info-caption'>{{ 'LAST_WORKOUT' | translate }}</div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class='client-item__info'>\n" +
    "          <div class='client-item__info-content'>\n" +
    "            <div class='client-item__info-title'\n" +
    "              ng-if='client.clientProfile.nextAssignmentDate'>{{ client.clientProfile.nextAssignmentDate * 1000 | date:'MM/dd/yyyy' || \"-//-\"  }}</div>\n" +
    "            <div class='client-item__info-title'\n" +
    "              ng-if='!client.clientProfile.nextAssignmentDate'>-//-</div>\n" +
    "            <div class='client-item__info-caption'>{{ 'NEXT_WORKOUT' | translate }}</div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class='client-item__left'>\n" +
    "        <img class='client-item__picture'\n" +
    "          ng-src='{{ client.pictureUrl || \"//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png\" }}'/>\n" +
    "        <div class='client-item__label'>\n" +
    "          <!-- TODO: add custom icons -->\n" +
    "          <div class='client-item__label-icon'></div>\n" +
    "        </div>\n" +
    "        <div class='client-item__title'>\n" +
    "          <div>{{ client.firstName }} {{ client.lastName }}</div>\n" +
    "          <span class='client-item__caption'>{{ client.location }}</span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class='client-item--empty'\n" +
    "      ng-if='!roster.clientsList.items.length && !roster.clientsList.isLoading'>\n" +
    "      {{ \"NO_CLIENTS\" | translate }}\n" +
    "    </div>\n" +
    "\n" +
    "    <div class='roster-load-more' ng-if='roster.clientsList.isLoading'>\n" +
    "      <div class='roster-load-more__icon spinner-icon'></div>\n" +
    "      {{ 'LOADING_MORE_CLIENTS' | translate }}\n" +
    "    </div>\n" +
    "  </section>\n" +
    "\n" +
    "\n" +
    "</section>\n" +
    "");
}]);

angular.module("/app/schedule/schedule.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/schedule/schedule.html",
    "<section class=\"schedule\">\n" +
    "\n" +
    "  <header class=\"container-header\">\n" +
    "    <div class=\"container-header__content\">\n" +
    "      <i class=\"container-header__icon icon icon-calendar\"></i>\n" +
    "      <h1 class=\"container-header__title\">{{ 'SCHEDULE' | translate}}</h1>\n" +
    "    </div>\n" +
    "  </header>\n" +
    "\n" +
    "</section>\n" +
    "");
}]);

angular.module("/app/settings/settings.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/settings/settings.html",
    "<section class=\"settings\">\n" +
    "\n" +
    "  <header class=\"container-header\">\n" +
    "    <div class=\"container-header__content\">\n" +
    "      <i class=\"container-header__icon icon icon-gear\"></i>\n" +
    "      <h1 class=\"container-header__title\">{{ :: 'SETTINGS' | translate}}</h1>\n" +
    "    </div>\n" +
    "  </header>\n" +
    "\n" +
    "  <section class=\"settings__content\">\n" +
    "\n" +
    "    <tabs theme=\"dark\">\n" +
    "\n" +
    "      <tab name='branding'\n" +
    "        permission\n" +
    "        permission-only=\"'BRANDING_READ'\"\n" +
    "        permission-on-unauthorized=\"PermissionStrategies.disableTab\">\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ :: 'BRANDING' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <div ng-include=\"'/app/settings/tabs/branding.html'\" class=\"settings__branding\"></div>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "      <tab name='localization'\n" +
    "        permission\n" +
    "        permission-only=\"'CUSTOMIZATION_READ'\"\n" +
    "        permission-on-unauthorized=\"PermissionStrategies.disableTab\">\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ :: 'CUSTOMIZATION' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <div ng-include=\"'/app/settings/tabs/localization/localization.html'\" class=\"settings__localization\">\n" +
    "          </div>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "      <tab name='risk'\n" +
    "        permission\n" +
    "        permission-only=\"'RISK_CALCULATIONS_READ'\"\n" +
    "        permission-on-unauthorized=\"PermissionStrategies.disableTab\">\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ :: 'RISK_CALCULATION' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <div ng-include=\"'/app/settings/tabs/risk.html'\" class=\"settings__risk\"></div>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "      <tab name='permission-groups'\n" +
    "        permission\n" +
    "        permission-only=\"'PERMISSIONS_GROUPS_READ'\"\n" +
    "        permission-on-unauthorized=\"PermissionStrategies.disableTab\">\n" +
    "        <tab-head>\n" +
    "          <span class=\"tab-head__multiline-item\">\n" +
    "            {{ :: 'PERMISSION_GROUPS' | translate }}\n" +
    "          </span>\n" +
    "        </tab-head>\n" +
    "        <tab-content>\n" +
    "          <div ng-include=\"'/app/settings/tabs/permissions.html'\" class=\"settings__permissions\"></div>\n" +
    "        </tab-content>\n" +
    "      </tab>\n" +
    "\n" +
    "    </tabs>\n" +
    "\n" +
    "  </section>\n" +
    "\n" +
    "</section>\n" +
    "");
}]);

angular.module("/app/settings/tabs/branding.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/settings/tabs/branding.html",
    "<div class=\"settings__branding\">\n" +
    "\n" +
    "  <div class=\"data-wrapper\">\n" +
    "    <div class=\"data-block settings__logo-container\">\n" +
    "\n" +
    "      <div class=\"data-block__header settings__title\">{{:: 'LOGO' | translate}}</div>\n" +
    "      <div class=\"settings__file-requirements\">\n" +
    "        <div class=\"info-title\">\n" +
    "          File Requirements\n" +
    "        </div>\n" +
    "        <div class=\"settings__hint\">\n" +
    "          These restrictions are required for proper splash page display on the exercise equipments's console.\n" +
    "        </div>\n" +
    "        <div class=\"two-columns-table\">\n" +
    "          <div class=\"two-columns-table--column\">\n" +
    "            1. File must be a valid .jpg or .png file.\n" +
    "            <div class=\"settings__hint\">\n" +
    "              (other file formats not allowed)\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"two-columns-table--column\">\n" +
    "            2. File dimenssions muse be 551 px wide by 99 px high.\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "<!--LOGO SECTION-->\n" +
    "\n" +
    "  <div class=\"settings__logo-preview\">\n" +
    "    {{:: 'LOGO_PREVIEW' | translate }}\n" +
    "    <img src=\"data:image/png;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=\" alt=\"{{:: 'LOGO_PREVIEW' | translate }}\">\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"settings__select-container\">\n" +
    "    <div class=\"settings__browse-button\">{{:: 'BROWSE' | translate }}</div>\n" +
    "    <div class=\"settings__drag-and-drop-area settings__hint\">\n" +
    "      Drag your image here or select it from your computer or device.\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"footer-buttons\">\n" +
    "    <div class=\"button button-action\">\n" +
    "      {{ :: 'UPDATE_LOGO' | translate }}\n" +
    "    </div>\n" +
    "    <div class=\"button button-assertive button-clear pull-right\">\n" +
    "      {{ :: 'RESET_LOGO' | translate }}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "  <!--COLOR PALETTE SECTION-->\n" +
    "\n" +
    "  <div class=\"data-wrapper settings__color-palete-container\">\n" +
    "    <div class=\"data-block settings__logo-container\">\n" +
    "      <div class=\"data-block__header settings__title\">{{:: 'COLOR_PALETE' | translate}}</div>\n" +
    "      <!-- COLORS LINE-->\n" +
    "      <div class=\"two-columns-table {{settingsCtrl.colorpickers.main || settingsCtrl.colorpickers.action ? 'settings__color--edited' : ''}}\">\n" +
    "        <div class=\"settings__color-container two-columns-table--column\">\n" +
    "\n" +
    "          <label class=\"settings__color--preview\" style=\"background-color: {{settingsCtrl.mainColor.currentColor}}\">\n" +
    "            <input type=\"checkbox\"\n" +
    "                   ng-model=\"settingsCtrl.colorpickers.main\"\n" +
    "                   ng-change=\"settingsCtrl.onColorCheckboxClick('main')\">\n" +
    "          </label>\n" +
    "\n" +
    "          <div class=\"settings__color--info {{settingsCtrl.colorpickers.main ? 'color-section-selected' : ''}}\">\n" +
    "            <div class=\"settings__color--name\">Main Color</div>\n" +
    "            <div class=\"settings__color--description settings__hint\">\n" +
    "              FPO: Description of places that this color effects. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"color-section-selected-marker\"></div>\n" +
    "\n" +
    "        </div>\n" +
    "        <div class=\"settings__color-container two-columns-table--column\">\n" +
    "          <label class=\"settings__color--preview\" style=\"background-color: {{settingsCtrl.actionColor.currentColor}}\">\n" +
    "            <input type=\"checkbox\"\n" +
    "                   ng-model=\"settingsCtrl.colorpickers.action\"\n" +
    "                   ng-change=\"settingsCtrl.onColorCheckboxClick('action')\">\n" +
    "          </label>\n" +
    "\n" +
    "          <div class=\"settings__color--info {{settingsCtrl.colorpickers.action ? 'color-section-selected' : ''}}\">\n" +
    "            <div class=\"settings__color--name\">Action Color</div>\n" +
    "            <div class=\"settings__color--description settings__hint\">\n" +
    "              FPO: Description of places that this color effects. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"color-section-selected-marker\"></div>\n" +
    "\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <!-- COLOR-PICKER MENU-->\n" +
    "\n" +
    "      <div class=\"color-pickers-dropdown-wrapper {{settingsCtrl.colorpickers.main || settingsCtrl.colorpickers.action ? 'color-pickers-dropdown-wrapper-visible' : ''}}\">\n" +
    "        <div class=\"color-picker-container {{settingsCtrl.selectedColorPicker == 'main' ? 'color-picker-visible' : ''}}\">\n" +
    "          <color-picker class=\"color-picker\"\n" +
    "            ng-model=\"settingsCtrl.mainColor\"\n" +
    "            options=\"{alpha:false, format:'rgb', inline: true}\">\n" +
    "          </color-picker>\n" +
    "\n" +
    "          <div class=\"footer-buttons settings__color-footer\">\n" +
    "            <div class=\"button button-action\"\n" +
    "              ng-click=\"settingsCtrl.updateColor(settingsCtrl.mainColor)\">\n" +
    "              {{ :: 'UPDATE_COLOR' | translate }}\n" +
    "            </div>\n" +
    "            <div class=\"button button-assertive button-clear pull-right\"\n" +
    "              ng-click=\"settingsCtrl.resetColor(settingsCtrl.mainColor)\">\n" +
    "              {{ :: 'RESET_COLOR' | translate }}\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"color-picker-container {{settingsCtrl.selectedColorPicker == 'action' ? 'color-picker-visible' : ''}}\">\n" +
    "          <color-picker class=\"color-picker\" ng-model=\"settingsCtrl.actionColor\" options=\"{alpha:false, format:'rgb', inline: true}\"></color-picker>\n" +
    "\n" +
    "          <div class=\"footer-buttons settings__color-footer\">\n" +
    "            <div class=\"button button-action\"\n" +
    "              ng-click=\"settingsCtrl.updateColor(settingsCtrl.mainColor)\">\n" +
    "              {{ :: 'UPDATE_COLOR' | translate }}\n" +
    "            </div>\n" +
    "            <div class=\"button button-assertive button-clear pull-right\"\n" +
    "              ng-click=\"settingsCtrl.resetColor(settingsCtrl.mainColor)\">\n" +
    "              {{ :: 'RESET_COLOR' | translate }}\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <!-- COLORS LINE-->\n" +
    "      <div class=\"two-columns-table {{settingsCtrl.colorpickers.selected || settingsCtrl.colorpickers.inTheGym ? 'settings__color--edited' : ''}}\">\n" +
    "        <div class=\"settings__color-container two-columns-table--column\">\n" +
    "          <label class=\"settings__color--preview\" style=\"background-color: {{settingsCtrl.selectedColor.currentColor}}\">\n" +
    "            <input type=\"checkbox\"\n" +
    "                   ng-model=\"settingsCtrl.colorpickers.selected\"\n" +
    "                   ng-change=\"settingsCtrl.onColorCheckboxClick('selected')\">\n" +
    "          </label>\n" +
    "          <div class=\"settings__color--info {{settingsCtrl.colorpickers.selected ? 'color-section-selected' : ''}}\">\n" +
    "            <div class=\"settings__color--name\">Selected Color</div>\n" +
    "            <div class=\"settings__color--description settings__hint\">\n" +
    "              FPO: Description of places that this color effects. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"color-section-selected-marker\"></div>\n" +
    "\n" +
    "        </div>\n" +
    "        <div class=\"settings__color-container two-columns-table--column\">\n" +
    "          <label class=\"settings__color--preview\" style=\"background-color: {{settingsCtrl.inTheGymColor.currentColor}}\">\n" +
    "            <input type=\"checkbox\"\n" +
    "                   ng-model=\"settingsCtrl.colorpickers.inTheGym\"\n" +
    "                   ng-change=\"settingsCtrl.onColorCheckboxClick('inTheGym')\">\n" +
    "          </label>\n" +
    "          <div class=\"settings__color--info {{settingsCtrl.colorpickers.inTheGym ? 'color-section-selected' : ''}}\">\n" +
    "            <div class=\"settings__color--name\">In The Gym Color</div>\n" +
    "            <div class=\"settings__color--description settings__hint\">\n" +
    "              FPO: Description of places that this color effects. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"color-section-selected-marker\"></div>\n" +
    "\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"color-pickers-dropdown-wrapper {{settingsCtrl.colorpickers.selected || settingsCtrl.colorpickers.inTheGym ? 'color-pickers-dropdown-wrapper-visible' : ''}}\">\n" +
    "        <div class=\"color-picker-container {{settingsCtrl.selectedColorPicker == 'selected' ? 'color-picker-visible' : ''}}\">\n" +
    "          <color-picker class=\"color-picker\" ng-model=\"settingsCtrl.selectedColor\" options=\"{alpha:false, format:'rgb', inline: true}\"></color-picker>\n" +
    "\n" +
    "          <div class=\"footer-buttons settings__color-footer\">\n" +
    "            <div class=\"button button-action\"\n" +
    "              ng-click=\"settingsCtrl.updateColor(settingsCtrl.mainColor)\">\n" +
    "              {{ :: 'UPDATE_COLOR' | translate }}\n" +
    "            </div>\n" +
    "            <div class=\"button button-assertive button-clear pull-right\"\n" +
    "              ng-click=\"settingsCtrl.resetColor(settingsCtrl.mainColor)\">\n" +
    "              {{ :: 'RESET_COLOR' | translate }}\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"color-picker-container {{settingsCtrl.selectedColorPicker == 'inTheGym' ? 'color-picker-visible' : ''}}\">\n" +
    "          <color-picker class=\"color-picker\" ng-model=\"settingsCtrl.inTheGymColor\" options=\"{alpha:false, format:'rgb', inline: true}\"></color-picker>\n" +
    "\n" +
    "          <div class=\"footer-buttons settings__color-footer\">\n" +
    "            <div class=\"button button-action\"\n" +
    "              ng-click=\"settingsCtrl.updateColor(settingsCtrl.mainColor)\">\n" +
    "              {{ :: 'UPDATE_COLOR' | translate }}\n" +
    "            </div>\n" +
    "            <div class=\"button button-assertive button-clear pull-right\"\n" +
    "              ng-click=\"settingsCtrl.resetColor(settingsCtrl.mainColor)\">\n" +
    "              {{ :: 'RESET_COLOR' | translate }}\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/settings/tabs/localization/localization.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/settings/tabs/localization/localization.html",
    "<div class=\"basic-page-block settings-localization\"\n" +
    "  ng-controller=\"SettingLocalizationCtrl as localCtrl\">\n" +
    "\n" +
    "  <div class=\"basic-page-block__content basic-page-block__content--with-buttons basic-page-block__content--white\">\n" +
    "    <div class=\"basic-page-block__header\">{{ :: 'FPO_TERMS_TITLE' | translate }}</div>\n" +
    "    <!-- TODO: use ng-repeat -->\n" +
    "    <div class=\"settings-localization__term-block\">\n" +
    "      <input class=\"pt-crm-input pt-crm-input--blue settings-localization__input\"\n" +
    "        permission\n" +
    "        permission-only=\"'CUSTOMIZATION_UPDATE'\"\n" +
    "        permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "        permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "        type=\"text\"\n" +
    "        ng-model=\"localCtrl.term\">\n" +
    "      <!-- TODO: use translation filter after integration with BE -->\n" +
    "      <div class=\"settings-localization__term-title\">Our Title Name</div>\n" +
    "      <div class=\"settings-localization__term-description\">\n" +
    "        FPO: Description of this term. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"settings-localization__term-block\">\n" +
    "      <input class=\"pt-crm-input pt-crm-input--blue settings-localization__input\"\n" +
    "        permission\n" +
    "        permission-only=\"'CUSTOMIZATION_UPDATE'\"\n" +
    "        permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "        permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "        type=\"text\"\n" +
    "        ng-model=\"localCtrl.term\">\n" +
    "      <div class=\"settings-localization__term-title\">Our Title Name</div>\n" +
    "      <div class=\"settings-localization__term-description\">\n" +
    "        FPO: Description of this term. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"settings-localization__term-block\">\n" +
    "      <input class=\"pt-crm-input pt-crm-input--blue settings-localization__input\"\n" +
    "        permission\n" +
    "        permission-only=\"'CUSTOMIZATION_UPDATE'\"\n" +
    "        permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "        permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "        type=\"text\"\n" +
    "        ng-model=\"localCtrl.term\">\n" +
    "      <div class=\"settings-localization__term-title\">Our Title Name</div>\n" +
    "      <div class=\"settings-localization__term-description\">\n" +
    "        FPO: Description of this term. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"settings-localization__term-block\">\n" +
    "      <input class=\"pt-crm-input pt-crm-input--blue settings-localization__input\"\n" +
    "        permission\n" +
    "        permission-only=\"'CUSTOMIZATION_UPDATE'\"\n" +
    "        permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "        permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "        type=\"text\"\n" +
    "        ng-model=\"localCtrl.term\">\n" +
    "      <div class=\"settings-localization__term-title\">Our Title Name</div>\n" +
    "      <div class=\"settings-localization__term-description\">\n" +
    "        FPO: Description of this term. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"tab-footer footer-buttons\">\n" +
    "    <div class=\"button button-action\">\n" +
    "      {{ :: 'UPDATE_TERMINOLOGY' | translate }}\n" +
    "    </div>\n" +
    "    <div class=\"button button-assertive button-clear pull-right\">\n" +
    "      {{ ::'RESET_TERMINOLOGY' | translate }}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/app/settings/tabs/permissionGroups/deleteGroup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/settings/tabs/permissionGroups/deleteGroup.html",
    "<div class=\"data-block__container modal--delete-acc__details\" ng-if=\"group\">\n" +
    "  <div class=\"data-block__info-container\">\n" +
    "    <div class=\"data-block__info\">\n" +
    "        <span class=\"data-block__info--input user-details__input--text\">\n" +
    "          {{ :: group.name }}\n" +
    "        </span>\n" +
    "    </div>\n" +
    "    <div class=\"data-block__title\">\n" +
    "      {{ :: 'GROUP_NAME' | translate }}</div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/settings/tabs/permissions.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/settings/tabs/permissions.html",
    "<div class=\"permission-groups\"\n" +
    "  ng-controller=\"PermissionGroupsCtrl as  PermissionsCtrl\">\n" +
    "\n" +
    "  <div class=\"permission-groups__content\">\n" +
    "\n" +
    "    <ng-form class=\"drop-down\"\n" +
    "      ng-repeat=\"(i, permissionGroup) in PermissionsCtrl.permissionGroups\"\n" +
    "      name='PermissionsCtrl.forms[\"{{ (permissionGroup._id || permissionGroup._virtualId) }}\"]'\n" +
    "      ng-show=\"!permissionGroup.isDeleted\">\n" +
    "\n" +
    "      <div class=\"drop-down__group-container fade-onload\">\n" +
    "\n" +
    "        <div class=\"drop-down__group-header\">\n" +
    "          <input permission\n" +
    "            permission-only=\"permissionGroup._isNew ? 'PERMISSIONS_GROUPS_CREATE' : 'PERMISSIONS_GROUPS_UPDATE'\"\n" +
    "            permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "            permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "            type=\"text\"\n" +
    "            ng-model=\"permissionGroup.name\"\n" +
    "            class=\"drop-down__group-title\">\n" +
    "\n" +
    "\n" +
    "          <div class=\"drop-down__group-button drop-down__group-button--hide\"\n" +
    "            ng-class=\"{'drop-down__group-button--hide--collapsed': !permissionGroup.isExpanded}\"\n" +
    "            ng-click=\"permissionGroup.isExpanded = !permissionGroup.isExpanded\">\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"drop-down__group-button drop-down__group-button--remove\"\n" +
    "            permission\n" +
    "            permission-only=\"'PERMISSIONS_GROUPS_DELETE'\"\n" +
    "            ng-if=\"!permissionGroup.isDefault || !!permissionGroup._virtualId\"\n" +
    "            ng-click=\"PermissionsCtrl.remove(permissionGroup)\">\n" +
    "          </div>\n" +
    "\n" +
    "          <div permission\n" +
    "            permission-only=\"'PERMISSIONS_GROUPS_CREATE'\"\n" +
    "            class=\"drop-down__group-button drop-down__group-button--copy\"\n" +
    "            ng-click=\"PermissionsCtrl.copy(permissionGroup)\">\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"drop-down__group-content\" ng-if=\"permissionGroup.isExpanded\">\n" +
    "          <div class=\"permission-groups__item-group-container\"\n" +
    "            ng-repeat=\"(k, subject) in permissionGroup.subjects\">\n" +
    "\n" +
    "            <div class=\"permission-groups__item-group-header\">{{ :: subject.name | translate }}</div>\n" +
    "            <div class='permission-groups__item-group-options'>\n" +
    "              <label class=\"checkbox-custom permission-groups__item-group-option\"\n" +
    "                ng-repeat=\"(subjName, subjValue) in subject.options\">\n" +
    "                <input permission\n" +
    "                  permission-only=\"permissionGroup._isNew ? 'PERMISSIONS_GROUPS_CREATE' : 'PERMISSIONS_GROUPS_UPDATE'\"\n" +
    "                  permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                  permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                  type=\"checkbox\"\n" +
    "                  ng-model=\"subject.options[subjName]\">\n" +
    "                <span class=\"checkbox-label\">{{ :: subjName | translate }}</span>\n" +
    "              </label>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </ng-form>\n" +
    "\n" +
    "    <div permission\n" +
    "      permission-only=\"'PERMISSIONS_GROUPS_CREATE'\"\n" +
    "      ng-click=\"PermissionsCtrl.add()\"\n" +
    "      class=\"button button-full button-large button-primary\">\n" +
    "      {{ :: 'ADD_PERMISSION_GROUP' | translate }}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"tab-footer footer-buttons\"\n" +
    "    permission\n" +
    "    permission-only=\"['PERMISSIONS_GROUPS_UPDATE', 'PERMISSIONS_GROUPS_DELETE', 'PERMISSIONS_GROUPS_CREATE']\">\n" +
    "    <div\n" +
    "      class=\"button button-action\"\n" +
    "      ng-click=\"PermissionsCtrl.save()\">\n" +
    "      {{::'SAVE'  | translate}}\n" +
    "    </div>\n" +
    "    <div\n" +
    "      class=\"button button-assertive button-clear pull-right\"\n" +
    "      ng-click=\"PermissionsCtrl.reset()\">\n" +
    "      {{::'CANCEL'  | translate}}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/settings/tabs/risk.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/settings/tabs/risk.html",
    "<form\n" +
    "  ng-controller=\"RiskController as riskCtrl\"\n" +
    "  ng-submit=\"riskCtrl.save(riskCtrl.risks)\"\n" +
    "  name=\"riskCtrl.form\">\n" +
    "  <div class=\"clearfix risk\">\n" +
    "    <div ng-repeat=\"(risk, value) in riskCtrl.risks\"\n" +
    "      class=\"risk__container\">\n" +
    "      <div class=\"risk__title-container\">\n" +
    "        <input class=\"data-block__info--input risk__input\"\n" +
    "          permission\n" +
    "          permission-only=\"'RISK_CALCULATIONS_UPDATE'\"\n" +
    "          permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "          permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "          type=\"number\"\n" +
    "          min=\"1\"\n" +
    "          step=\"1\"\n" +
    "          ng-model=\"riskCtrl.risks[risk]\">\n" +
    "        <span>\n" +
    "          {{ risk + '.subject'  | camelToSnakeCase | translate }}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"risk__content-container\">\n" +
    "        <b>{{ risk + '.title'  | camelToSnakeCase | translate }}</b>\n" +
    "        <div>\n" +
    "          {{ risk + '.description'  | camelToSnakeCase | translate }}\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"footer-buttons\">\n" +
    "    <input type=\"submit\" class=\"button button-action\"\n" +
    "     permission\n" +
    "     permission-only=\"'RISK_CALCULATIONS_UPDATE'\"\n" +
    "     value=\"{{::'SAVE'  | translate}}\"\n" +
    "     ng-show='riskCtrl.form.$dirty'/>\n" +
    "    <div permission\n" +
    "         permission-only=\"'RISK_CALCULATIONS_UPDATE'\"\n" +
    "         ng-show='riskCtrl.form.$dirty'\n" +
    "         ng-click=\"riskCtrl.reset()\"\n" +
    "         class=\"button button-clear button-assertive pull-right\">\n" +
    "      {{::'CANCEL'  | translate}}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</form>\n" +
    "");
}]);

angular.module("/app/user/tabs/nutrition/nutrition.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/user/tabs/nutrition/nutrition.html",
    "<div class=\"nutrition\" ng-controller=\"NutritionController as nutritionCtrl\">\n" +
    "  <div ng-if=\"nutritionCtrl.data\">\n" +
    "    <div class=\"nutrition__header\">\n" +
    "      <img class=\"nutrition__header-logo\" src=\"//images.jhtassets.com/5074cee5f1d1aec2d7f76d761f89a22803da73cf/\"/>\n" +
    "      <div class=\"nutrition__header-date\">\n" +
    "        <div class=\"nutrition__left-arrow\"\n" +
    "          ng-click=\"nutritionCtrl.goLeft()\">\n" +
    "        </div>\n" +
    "        <div class=\"nutrition__date\">\n" +
    "          {{ nutritionCtrl.date * 1000 | date: \"MM/dd/yyyy\" : \"+0\" }}\n" +
    "        </div>\n" +
    "        <div class=\"nutrition__right-arrow\"\n" +
    "          ng-click=\"nutritionCtrl.goRight()\">\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"nutrition__content\">\n" +
    "      <div class=\"nutrition__table\">\n" +
    "        <div class=\"nutrition-calculator\">\n" +
    "          <div class=\"nutrition-calculator__num\">\n" +
    "            <div class=\"calculator-num__value\">{{ nutritionCtrl.data.goal || 0 }}</div>\n" +
    "            <div class=\"calculator-num__caption\">{{ :: \"GOAL\" | translate }}</div>\n" +
    "          </div>\n" +
    "          <div class=\"nutrition-calculator__sign\">-</div>\n" +
    "          <div class=\"nutrition-calculator__num\">\n" +
    "            <div class=\"calculator-num__value\">{{ nutritionCtrl.data.food || 0 }}</div>\n" +
    "            <div class=\"calculator-num__caption\">{{ :: \"FOOD\" | translate }}</div>\n" +
    "          </div>\n" +
    "          <div class=\"nutrition-calculator__sign\">+</div>\n" +
    "          <div class=\"nutrition-calculator__num\">\n" +
    "            <div class=\"calculator-num__value\">{{ nutritionCtrl.data.exercise || 0 }}</div>\n" +
    "            <div class=\"calculator-num__caption\">{{ :: \"EXERCISE\" | translate }}</div>\n" +
    "          </div>\n" +
    "          <div class=\"nutrition-calculator__sign\">=</div>\n" +
    "          <div class=\"nutrition-calculator__num\">\n" +
    "            <div class=\"calculator-num__value\">{{ nutritionCtrl.data.remaining || 0 }}</div>\n" +
    "            <div class=\"calculator-num__caption\">{{ :: \"REMAINING\" | translate }}</div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <table class=\"nutrition-table\">\n" +
    "          <tr class=\"nutrition-table__tr\">\n" +
    "            <td class=\"nutrition-table__td nutrition-table__td--title\"></td>\n" +
    "            <td class=\"nutrition-table__td nutrition-table__td--title\">{{ :: \"CALORIES\" | translate }}</td>\n" +
    "            <td class=\"nutrition-table__td nutrition-table__td--title\">{{ :: \"CARBS\" | translate }}</td>\n" +
    "            <td class=\"nutrition-table__td nutrition-table__td--title\">{{ :: \"FAT\" | translate }}</td>\n" +
    "            <td class=\"nutrition-table__td nutrition-table__td--title\">{{ :: \"PROTEIN\" | translate }}</td>\n" +
    "          </tr>\n" +
    "          <tr class=\"nutrition-table__tr\">\n" +
    "            <td class=\"nutrition-table__td nutrition-table__td--title\">{{:: \"NUTRITION_DIARY\" | translate }}</td>\n" +
    "            <td class=\"nutrition-table__td\">{{ nutritionCtrl.data.nutrition.calories || 0 }}</td>\n" +
    "            <td class=\"nutrition-table__td\">{{ nutritionCtrl.data.nutrition.carbs || 0 }}</td>\n" +
    "            <td class=\"nutrition-table__td\">{{ nutritionCtrl.data.nutrition.fats || 0 }}</td>\n" +
    "            <td class=\"nutrition-table__td\">{{ nutritionCtrl.data.nutrition.proteins || 0 }}</td>\n" +
    "          </tr>\n" +
    "        </table>\n" +
    "      </div>\n" +
    "      <div class=\"nutrition__chart\">\n" +
    "        <h4>{{ :: \"CALORIE_BREAKDOWN\" | translate }}</h4>\n" +
    "\n" +
    "\n" +
    "        <ul class=\"nutrition__chart-breakdown-list\">\n" +
    "          <li class=\"nutrition__chart-breakdown-list-item\"\n" +
    "            ng-repeat=\"data in nutritionCtrl.data.breakdown\"\n" +
    "            ng-style=\"{color: data.color}\">\n" +
    "            <div>{{ data.value }}</div>\n" +
    "            <div>\n" +
    "              {{ data.title }}\n" +
    "            </div>\n" +
    "          </li>\n" +
    "        </ul>\n" +
    "        <i class=\"nutrition__chart-loading roster-load-more__icon spinner-icon\"\n" +
    "          ng-if=\"nutritionCtrl.isLoading\">\n" +
    "        </i>\n" +
    "        <canvas chart\n" +
    "          data=\"nutritionCtrl.data.breakdown\"\n" +
    "          width=\"200\"\n" +
    "          height=\"200\">\n" +
    "        </canvas>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"container-header__title\"\n" +
    "    ng-if=\"!nutritionCtrl.data\">\n" +
    "    {{ :: 'USER_HAS_NO_NETPULSE_ACCOUNT' | translate }}\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/user/tabs/permissions/groups-modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/user/tabs/permissions/groups-modal.html",
    "<ul class=\"modal__list-wrapper\">\n" +
    "  <li class=\"modal__list-item\" ng-repeat=\"group in permissionsGroups\" ng-if=\"!group.isDefault\" ng-click=\"onGroupClick(group)\">\n" +
    "    <div>\n" +
    "      {{::group.name}}\n" +
    "      <div ng-if=\"hasUserTheGroup(group)\" class=\"pull-right permissions-groups-pop-up__group-selected-icon\">&#x2713;</div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>");
}]);

angular.module("/app/user/tabs/permissions/permissions.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/user/tabs/permissions/permissions.html",
    "<div class='client-permissions' ng-controller=\"UserPermissionsController as permCtrl\">\n" +
    "  <div class='client-permissions__content'>\n" +
    "    <div class='client-permissions__controls'\n" +
    "      permission\n" +
    "      permission-only=\"'PERMISSIONS_GROUPS_READ'\">\n" +
    "\n" +
    "      <a class='button button-action'\n" +
    "        ng-click=\"permCtrl.showGroupsPopup()\">\n" +
    "        {{ :: 'SELECT_GROUPS' | translate }}\n" +
    "      </a>\n" +
    "\n" +
    "      <a class='button button-action pull-right'\n" +
    "        ui-sref='app.settings({tab: \"permission-groups\"})'>\n" +
    "        {{ :: 'EDIT_PERMISSION_GROUPS' | translate }}\n" +
    "      </a>\n" +
    "    </div>\n" +
    "\n" +
    "    <form\n" +
    "      name=\"permCtrl.forms.permissions\">\n" +
    "      <div class='client-permissions__card'>\n" +
    "        <div class='client-permissions__card-content'>\n" +
    "          <label class='checkbox-custom' ng-repeat=\"group in permCtrl.permissionsGroups\" ng-if=\"group.isDefault\">\n" +
    "            <input type=\"checkbox\" ng-model=\"group.isSelected\" ng-checked=\"permCtrl.hasUserTheGroup(group)\" ng-click=\"permCtrl.onGroupClick(group)\">\n" +
    "            <span class='checkbox-label'>{{::group.name | translate}}</span>\n" +
    "          </label>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class='client-permissions__card' ng-repeat=\"permission in permCtrl.userPermissions.subjects\">\n" +
    "        <div class='client-permissions__card-header'>\n" +
    "          <span class=''>{{::permission.name | translate}}</span>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class='client-permissions__card-content'>\n" +
    "          <label class='checkbox-custom'\n" +
    "            ng-repeat='(name, value) in permission.options'>\n" +
    "            <input\n" +
    "            type=\"checkbox\"\n" +
    "            ng-disabled=\"permCtrl.disabledOptions[permission.name][name]\"\n" +
    "            ng-model='permission.options[name]'>\n" +
    "              <span class='checkbox-label'>{{::name | translate }}</span>\n" +
    "          </label>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </form>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"tab-footer footer-buttons\"\n" +
    "    ng-show=\"permCtrl.forms.permissions.$dirty\"\n" +
    "    permission\n" +
    "    permission-only=\"['USER_PERMISSIONS_UPDATE']\">\n" +
    "\n" +
    "    <div class=\"button button-action\"\n" +
    "      permission\n" +
    "      permission-only=\"'USER_PERMISSIONS_UPDATE'\"\n" +
    "      ng-click=\"permCtrl.savePermissions()\">\n" +
    "      {{ :: 'SAVE'  | translate}}\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"button button-assertive button-clear pull-right\"\n" +
    "      ng-click=\"permCtrl.resetPermissions()\">\n" +
    "      {{ :: 'CANCEL'  | translate}}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/user/tabs/schedule.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/user/tabs/schedule.html",
    "Shedule\n" +
    "");
}]);

angular.module("/app/user/tabs/userDetails/certifications/certifications.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/user/tabs/userDetails/certifications/certifications.html",
    "<div class='certifications-form'\n" +
    "  permission\n" +
    "  permission-only=\":: userCtrl.permissions.certifications.read\"\n" +
    "  ng-init='userCtrl.certifications.load()'>\n" +
    "\n" +
    "  <div class=\"data-section\">\n" +
    "    <div class=\"data-section__header\">\n" +
    "      <div class=\"data-section__title\">{{ :: 'CERTIFICATIONS' | translate }}</div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"data-section__content\">\n" +
    "      <div ng-repeat=\"cert in userCtrl.certifications.items | filter:{_isDeleted: '!'}\"\n" +
    "        class=\"data-section__item\">\n" +
    "\n" +
    "        <ng-form name='userCtrl.certifications.forms[\"{{ (cert.data._id || cert._virtualId) }}\"]'>\n" +
    "\n" +
    "          <div class=\"pull-right\">\n" +
    "            <div permission\n" +
    "              permission-only=\":: userCtrl.permissions.certifications.delete\"\n" +
    "              ng-click=\"userCtrl.certifications.remove(cert)\"\n" +
    "              class=\"button button-clear button-assertive push-top-sm\">\n" +
    "                {{ :: 'DELETE' | translate }}\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"data-section__image-container data-section__upload-container\">\n" +
    "\n" +
    "            <div class='button button-action button-clear camera-button'\n" +
    "              permission-only=\":: userCtrl.permissions.certifications.update\"\n" +
    "              ngf-select\n" +
    "              ng-model=\"cert.data.picture\"\n" +
    "              name=\"file\"\n" +
    "              ngf-pattern=\"'image/*'\"\n" +
    "              ngf-multiple=\"false\"\n" +
    "              tooltip-placement=\"bottom\"\n" +
    "              uib-tooltip=\"{{ :: 'CHANGE_CERTIFICATION_PIC' | translate }}\">\n" +
    "              <i class=\"icon icon-camera\"></i>\n" +
    "            </div>\n" +
    "            <img ngf-thumbnail=\"cert.data.picture || cert.data.picturePath\"\n" +
    "              ngf-size=\"{width: 150}\">\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"data-section__item-content\">\n" +
    "\n" +
    "            <div class=\"inline col-md-6 col-sm-6\">\n" +
    "              <div class=\"data-section__info-container\">\n" +
    "                <input type=\"text\"\n" +
    "                  permission-only=\":: userCtrl.permissions.certifications.update\"\n" +
    "                  permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                  permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                  name=\"name\"\n" +
    "                  ng-model=\"cert.data.name\"\n" +
    "                  required\n" +
    "\n" +
    "                  class=\"data-section__info--input input-clear\"\n" +
    "                  placeholder='type name here'>\n" +
    "                <div class=\"data-section__info-description\">{{ :: 'NAME' | translate }}</div>\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"data-section__info-container\">\n" +
    "                <input type=\"text\"\n" +
    "                  permission-only=\":: userCtrl.permissions.certifications.update\"\n" +
    "                  permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                  permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                  name=\"authority\"\n" +
    "                  ng-model=\"cert.data.authority\"\n" +
    "                  required\n" +
    "\n" +
    "                  class=\"data-section__info--input input-clear\"\n" +
    "                  placeholder='type author here'>\n" +
    "                <div class=\"data-section__info-description\">{{ :: 'AUTHOR' | translate }}</div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"inline col-md-6 col-sm-6\">\n" +
    "              <div class=\"data-section__info-container\">\n" +
    "                <input type=\"text\"\n" +
    "                  uib-datepicker-popup\n" +
    "                  is-open=\"issuedDatePopUpIsOpen\"\n" +
    "                  ng-click=\"issuedDatePopUpIsOpen = !issuedDatePopUpIsOpen\"\n" +
    "                  permission-only=\":: userCtrl.permissions.certifications.update\"\n" +
    "                  permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                  permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                  name=\"issuedDate\"\n" +
    "                  ng-model=\"cert.data.issuedDate\"\n" +
    "                  unix-date-input\n" +
    "                  required\n" +
    "                  class=\"data-section__info--input input-clear\"\n" +
    "                  placeholder='dd/mm/yyyy'>\n" +
    "                <div class=\"data-section__info-description\">{{ :: 'ISSUED_DATE' | translate }}</div>\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"data-section__info-container\">\n" +
    "                <input type=\"text\"\n" +
    "                  uib-datepicker-popup\n" +
    "                  is-open=\"expirationdDatePopUpIsOpen\"\n" +
    "                  ng-click=\"expirationdDatePopUpIsOpen = !expirationdDatePopUpIsOpen\"\n" +
    "                  permission-only=\":: userCtrl.permissions.certifications.update\"\n" +
    "                  permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                  permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                  name=\"expirationDate\"\n" +
    "                  ng-model=\"cert.data.expirationDate\"\n" +
    "                  unix-date-input\n" +
    "                  required\n" +
    "                  class=\"data-section__info--input input-clear\"\n" +
    "                  placeholder='dd/mm/yyyy'>\n" +
    "                <div class=\"data-section__info-description\">{{ :: 'EXPIRATION_DATE' | translate }}</div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "        </ng-form>\n" +
    "      </div>\n" +
    "\n" +
    "      <div permission\n" +
    "          permission-only=\":: userCtrl.permissions.certifications.create\"\n" +
    "          ng-click=\"userCtrl.certifications.add()\"\n" +
    "          class=\"button button-large button-full button-primary\">\n" +
    "        <b>{{ :: 'ADD_CERTIFICATION' | translate }}</b>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"footer-buttons\">\n" +
    "    <div ng-click=\"userCtrl.certifications.revertAll()\"\n" +
    "      class=\"button button-clear button-assertive pull-right\">\n" +
    "      {{ :: 'CANCEL'  | translate }}\n" +
    "    </div>\n" +
    "\n" +
    "    <div permission\n" +
    "      permission-only=\":: userCtrl.permissions.certifications.update\"\n" +
    "      ng-click=\"userCtrl.certifications.saveAll()\"\n" +
    "      ng-disabled=\"userCtrl.certifications._isLoading\"\n" +
    "      class=\"button button-action\">\n" +
    "      {{ :: 'SAVE'  | translate }}\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/user/tabs/userDetails/changePassword/change-password-modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/user/tabs/userDetails/changePassword/change-password-modal.html",
    "<form name=\"changePasswordForm\" ng-submit=\"changePasswordController.ok()\" novalidate>\n" +
    "<div class=\"modal--add-client\">\n" +
    "\n" +
    "    <div class=\"modal__popup-header\">\n" +
    "      <div class=\"modal__popup-header--title ng-binding\">{{'CHANGE_YOUR_PASSWORD' | translate}}</div>\n" +
    "      <div class=\"modal__popup-header--exit icon icon-cross\" ng-click=\"changePasswordController.cancel()\"></div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"modal__content\">\n" +
    "      <div class=\"modal__content-template\" bind-html-compile=\"content\">\n" +
    "  <div class=\"data-block__container\">\n" +
    "    <div class=\"data-block__info-container\">\n" +
    "      <div class=\"data-block__info\">\n" +
    "        <input class=\"data-block__info--input user-details__input--password modal__input--pass\" type=\"password\" required=\"required\" ng-model=\"changePasswordController.currentPassword\" name=\"currentPassword\" placeholder=\"·······\">\n" +
    "      </div>\n" +
    "      <div class=\"data-block__title ng-binding\">{{'OLD_PASSWORD' | translate}}</div>\n" +
    "    </div>\n" +
    "    <div class=\"data-block__info-container\">\n" +
    "      <div class=\"data-block__info\">\n" +
    "        <input class=\"data-block__info--input user-details__input--password modal__input--pass\" type=\"password\" ng-minlength=\"6\" required=\"required\" ng-model=\"changePasswordController.newPassword\" name=\"newPassword\" placeholder=\"·······\" ng-model-options=\"{ allowInvalid: true }\">\n" +
    "      </div>\n" +
    "      <div class=\"data-block__title ng-binding\">{{'NEW_PASSWORD' | translate}}</div>\n" +
    "\n" +
    "      <div ng-messages=\"changePasswordForm.newPassword.$error\">\n" +
    "        <ng-message when=\"minlength\" class=\"data-block__error\">{{'PASSWORD_MIN_LENGTH' | translate}}</ng-message>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"data-block__info-container\">\n" +
    "      <div class=\"data-block__info\">\n" +
    "        <input class=\"data-block__info--input user-details__input--password modal__input--pass\" type=\"password\" required=\"required\" ng-model=\"changePasswordController.confirmNewPassword\" name=\"confirmNewPassword\" placeholder=\"·······\" compare-to=\"changePasswordController.newPassword\">\n" +
    "      </div>\n" +
    "      <div class=\"data-block__title ng-binding\">{{'CONFIRM_NEW_PASSWORD' | translate}}</div>\n" +
    "\n" +
    "      <div ng-messages=\"changePasswordForm.confirmNewPassword.$error\">\n" +
    "        <ng-message when=\"compareTo\" class=\"data-block__error\">{{'PASSWORD_DOES_NOT_MATCH' | translate}}</ng-message>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "</div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"footer-buttons\">\n" +
    "      <button type=\"submit\" autofocus=\"\" class=\"button button-action\">\n" +
    "        {{'CHANGE_PASSWORD' | translate}}\n" +
    "      </button>\n" +
    "\n" +
    "      <div ng-if=\"changePasswordController.error\" class=\"footer-buttons__error\">{{'OLD_PASSWORD_INVALID' | translate}}</div>\n" +
    "\n" +
    "      <div class=\"button button-assertive button-clear pull-right\" ng-click=\"changePasswordController.cancel()\">\n" +
    "        {{'CANCEL' | translate}}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "</div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("/app/user/tabs/userDetails/deleteAccount/deleteAccount.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/user/tabs/userDetails/deleteAccount/deleteAccount.html",
    "<div class=\"data-block__container modal--delete-acc__details\">\n" +
    "  <div class=\"data-block__info-container\">\n" +
    "      <div class=\"data-block__info\">\n" +
    "        <span class=\"data-block__info--input user-details__input--text\">\n" +
    "          {{ :: user.firstName }} {{ :: user.lastName }}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"data-block__title\">{{ :: 'ACCOUNT_NAME' | translate }}</div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/user/tabs/userDetails/facilityStaff.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/user/tabs/userDetails/facilityStaff.html",
    "<div class=\"user-details\">\n" +
    "<!-- ========== PERSONAL INFORAMTION =================== -->\n" +
    "  <form name=\"userCtrl.forms.personalInfoFacility\"\n" +
    "    permission\n" +
    "    permission-only=\":: userCtrl.permissions.personalDetails.read\">\n" +
    "    <div class=\"data-wrapper\">\n" +
    "\n" +
    "      <div class=\"data-block\">\n" +
    "        <div class=\"data-block__header\">\n" +
    "          {{ :: 'PERSONAL_INFORAMTION' | translate }}\n" +
    "        </div>\n" +
    "        <div class=\"data-block__container data-block__container--border-bottom\">\n" +
    "\n" +
    "          <div class=\"data-block__info-container data-block__info-container--block\">\n" +
    "            <div class=\"data-block__info\">\n" +
    "              <textarea permission\n" +
    "              permission-only=\":: userCtrl.permissions.personalDetails.update\"\n" +
    "              permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "              permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "              ng-model=\"userCtrl.user.personalInfo.address1\"\n" +
    "              class=\"data-block__info--input user-details__input--area input-clear\"\n" +
    "              placeholder=\"---\">\n" +
    "              </textarea>\n" +
    "            </div>\n" +
    "            <div class=\"data-block__title\">{{ :: 'ADDRESS1' | translate }}</div>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"data-block\">\n" +
    "        <div class=\"data-block__container data-block__container--border-bottom\">\n" +
    "\n" +
    "          <div class=\"data-block__info-container data-block__info-container--2-col\">\n" +
    "            <div class=\"data-block__info\">\n" +
    "              <input permission\n" +
    "              permission-only=\":: userCtrl.permissions.personalDetails.update\"\n" +
    "              permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "              permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "              ui-mask=\"(999) 999-9999\"\n" +
    "              ui-mask-placeholder\n" +
    "              ui-mask-placeholder-char=\"_\"\n" +
    "              ui-options=\"{allowInvalidValue:true, clearOnBlur: false}\"\n" +
    "              type=\"text\"\n" +
    "              ng-model=\"userCtrl.user.personalInfo.phoneNumber1\"\n" +
    "              class=\"data-block__info--input user-details__input--text input-clear\"\n" +
    "              placeholder=\"---\">\n" +
    "            </div>\n" +
    "            <div class=\"data-block__title\">{{ :: 'PHONE_NUMBER_1' | translate }}</div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"data-block__info-container data-block__info-container--2-col\">\n" +
    "            <div class=\"data-block__info\">\n" +
    "              <input permission\n" +
    "              permission-only=\":: userCtrl.permissions.personalDetails.update\"\n" +
    "              permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "              permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "              ui-mask=\"(999) 999-9999\"\n" +
    "              ui-mask-placeholder\n" +
    "              ui-mask-placeholder-char=\"_\"\n" +
    "              ui-options=\"{allowInvalidValue:true, clearOnBlur: false}\"\n" +
    "              type=\"text\"\n" +
    "              ng-model=\"userCtrl.user.personalInfo.phoneNumber2\"\n" +
    "              class=\"data-block__info--input user-details__input--text input-clear\"\n" +
    "              placeholder=\"---\">\n" +
    "            </div>\n" +
    "            <div class=\"data-block__title\">{{ :: 'PHONE_NUMBER_2' | translate }}</div>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"data-block\">\n" +
    "        <div class=\"data-block__container data-block__container--border-bottom\">\n" +
    "\n" +
    "          <div class=\"data-block__info-container data-block__info-container--2-col\">\n" +
    "            <div class=\"data-block__info\">\n" +
    "            <span class=\"data-block__info--input user-details__input--email\">\n" +
    "              {{ userCtrl.user.personalInfo.email }}\n" +
    "            </span>\n" +
    "            </div>\n" +
    "            <div class=\"data-block__title\">{{ :: 'EMAIL_ADDRESS' | translate }}</div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"data-block__info-container data-block__info-container--2-col\">\n" +
    "            <div class=\"data-block__info\">\n" +
    "              <div permission\n" +
    "              permission-only=\":: userCtrl.permissions.resetPassword.update\"\n" +
    "              class=\"data-block__button\" ng-click=\"userCtrl.resetPassword()\">\n" +
    "                {{ :: 'RESET_PASSWORD' | translate }}\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div class=\"data-block__info\" ng-if=\"userCtrl.userId === user._id || userCtrl.userId === 'me'\">\n" +
    "              <div class=\"data-block__button\" ng-click=\"userCtrl.changePassword()\">\n" +
    "                {{ :: 'CHANGE_PASSWORD' | translate }}\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"data-block\">\n" +
    "        <div class=\"data-block__container\">\n" +
    "\n" +
    "          <div class=\"data-block__info-container data-block__info-container--2-col\">\n" +
    "            <div class=\"data-block__info\">\n" +
    "              <input class=\"data-block__info--input input-clear\"\n" +
    "                ng-value=\"userCtrl.user.personalInfo.club.chain\"\n" +
    "                readonly\n" +
    "                placeholder=\"---\">\n" +
    "            </div>\n" +
    "            <div class=\"data-block__title\">{{::'CLUB_CHAIN' | translate}}</div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"data-block__info-container data-block__info-container--2-col\">\n" +
    "            <div class=\"data-block__info\">\n" +
    "              <span class=\"data-block__info--input\">\n" +
    "                {{ userCtrl.user.personalInfo.club.name}}\n" +
    "              </span>\n" +
    "            </div>\n" +
    "            <div class=\"data-block__title\">{{::'HOME_CLUB' | translate}}</div>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"footer-buttons\">\n" +
    "      <div permission\n" +
    "      permission-only=\":: userCtrl.permissions.personalDetails.update\"\n" +
    "      ng-show='userCtrl.forms.personalInfoFacility.$dirty'\n" +
    "      ng-click=\"userCtrl.save('personalInfo', userCtrl.user.personalInfo, 'Facility')\"\n" +
    "      class=\"button button-action\">\n" +
    "        {{::'SAVE'  | translate}}\n" +
    "      </div>\n" +
    "      <div permission\n" +
    "      permission-only=\":: userCtrl.permissions.personalDetails.update\"\n" +
    "      ng-show='userCtrl.forms.personalInfoFacility.$dirty'\n" +
    "      ng-click=\"userCtrl.reset('personalInfo', 'Facility')\"\n" +
    "      class=\"button button-clear button-assertive pull-right\">\n" +
    "        {{::'CANCEL'  | translate}}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "<!-- ========== CERTIFICATIONS =================== -->\n" +
    "  <div ng-include=\"'/app/user/tabs/userDetails/certifications/certifications.html'\"\n" +
    "    ng-if=\"userCtrl.user.roles['trainer']\"></div>\n" +
    "<!-- ========== WORK INFORAMTION =================== -->\n" +
    "  <form name=\"userCtrl.forms.workInfo\">\n" +
    "\n" +
    "    <div class=\"data-wrapper\">\n" +
    "      <div class=\"data-block data-block--without-margin\">\n" +
    "        <div class=\"data-block__header\">{{::'WORK_INFORMATION' | translate}}</div>\n" +
    "          <div class=\"user-details__schedules-wrapper\">\n" +
    "            <div ng-repeat=\"schedule in userCtrl.user.workInfo.permittedSchedules\" class=\"user-details__schedule-wrapper\">\n" +
    "              <div class=\"data-block__info-container data-block__info-container--block data-block__line-container\">\n" +
    "                <div class=\"data-block__title\">{{:: schedule.facility.name}}</div>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__info-container data-block__info-container--block user-details__schedule\">\n" +
    "                <div ng-repeat=\"(day, times) in schedule.days\" class=\"user-details__schedule-item data-block__line-container\">\n" +
    "                  <pt-day-schedule day=\"day\" times=\"times\" editable=\"schedule.facility.hoursEditable\"></pt-day-schedule>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"footer-buttons\">\n" +
    "      <div\n" +
    "        ng-show='userCtrl.forms.workInfo.$dirty'\n" +
    "        ng-click=\"userCtrl.saveWorkInfo(userCtrl.user.workInfo)\"\n" +
    "        class=\"button button-action\">\n" +
    "          {{ :: 'SAVE'  | translate }}\n" +
    "      </div>\n" +
    "      <div\n" +
    "        ng-show='userCtrl.forms.workInfo.$dirty'\n" +
    "        ng-click=\"userCtrl.reset('workInfo')\"\n" +
    "        class=\"button button-clear button-assertive pull-right\">\n" +
    "          {{ :: 'CANCEL'  | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "<!-- ========== CLIENT INFORMATION =================== -->\n" +
    "  <form name=\"userCtrl.forms.clients\"\n" +
    "    permission\n" +
    "    permission-only=\":: userCtrl.permissions.clients.read\"\n" +
    "    ng-if=\"userCtrl.user.roles['trainer']\">\n" +
    "\n" +
    "    <div class=\"data-section\">\n" +
    "      <div class=\"data-section__header\">\n" +
    "        <div class=\"data-section__title\">{{ :: 'ASSIGN_CLIENTS' | translate }}</div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"data-section__content\">\n" +
    "        <div class=\"data-section__item\"\n" +
    "          ng-repeat=\"(i, client) in userCtrl.user.clients\">\n" +
    "\n" +
    "          <div class=\"pull-right\">\n" +
    "            <div class=\"button button-clear button-assertive push-top-sm\"\n" +
    "              permission\n" +
    "              permission-only=\":: userCtrl.permissions.clients.delete\"\n" +
    "              ng-click=\"userCtrl.removeClient(client)\">\n" +
    "                {{ :: 'REMOVE_CLIENT' | translate }}\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"data-section__image-container\">\n" +
    "            <img class=\"user-page__user-img--trainer\" ng-src=\"{{ client.pictureUrl || '//images.jhtassets.com/69dcdf7c42e69031c482c0c1c6cf8d5050db00d7/' }}\">\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"data-section__item-content push-top-sm\">\n" +
    "\n" +
    "            <div class=\"data-block__info-container data-block__info-container--block\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <span\n" +
    "                  class=\"data-block__info--input user-details__input--text user-details__trainer-input\">\n" +
    "                  {{ :: client.firstName }} {{ :: client.lastName }}\n" +
    "                </span>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'NAME' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"data-block__info-container data-block__info-container--block\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <span\n" +
    "                  class=\"data-block__info--input user-details__input--email user-details__trainer-input\">\n" +
    "                  {{ :: client.email}}\n" +
    "                </span>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'CONTACT' | translate }}</div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"button button-large button-full button-primary\"\n" +
    "          permission\n" +
    "          permission-only=\":: userCtrl.permissions.clients.create\"\n" +
    "          ng-click=\"userCtrl.showClientPopup()\">\n" +
    "          {{ :: 'ADD_CLIENT' | translate }}\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"footer-buttons\">\n" +
    "      <div permission\n" +
    "        permission-only=\":: userCtrl.permissions.clients.update\"\n" +
    "        ng-show='userCtrl.forms.clients.$dirty'\n" +
    "        ng-click=\"userCtrl.updateTrainerClients(userCtrl.user.clients)\"\n" +
    "        class=\"button button-action\">\n" +
    "        {{ :: 'UPDATE_CLIENT'  | translate }}\n" +
    "      </div>\n" +
    "      <div permission\n" +
    "        permission-only=\":: userCtrl.permissions.clients.update\"\n" +
    "        ng-show='userCtrl.forms.clients.$dirty'\n" +
    "        ng-click=\"userCtrl.reset('clients')\"\n" +
    "        class=\"button button-clear button-assertive pull-right\">\n" +
    "        {{ :: 'CANCEL'  | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "\n" +
    "<!-- ========== SETTINGS INFORAMTION =================== -->\n" +
    "  <div\n" +
    "    ng-init=\"role = 'Facility'\"\n" +
    "    ng-include=\"'/app/user/tabs/userDetails/settings/settings.html'\">\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/user/tabs/userDetails/settings/settings.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/user/tabs/userDetails/settings/settings.html",
    "<form name=\"userCtrl.forms['settings' + role]\"\n" +
    "  permission\n" +
    "  permission-only=\":: userCtrl.permissions.settings.read\">\n" +
    "\n" +
    "  <div class=\"data-wrapper\">\n" +
    "    <div class=\"data-wrapper--left\">\n" +
    "\n" +
    "      <div class=\"data-block\">\n" +
    "        <div class=\"data-block__header\">{{::'EMAIL_NOTIFICATION' | translate}}</div>\n" +
    "        <div class=\"data-block__container\">\n" +
    "          <div class=\"data-block__line-container user-details__email-notification\"\n" +
    "            ng-repeat=\"(name, value) in userCtrl.user.settings.notices\">\n" +
    "            <label class=\"checkbox-custom\">\n" +
    "              <input permission\n" +
    "                permission-only=\":: userCtrl.permissions.settings.update\"\n" +
    "                permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                type=\"checkbox\"\n" +
    "                ng-model=\"userCtrl.user.settings.notices[name]\"\n" +
    "                class=\"data-block__info--input user-details__input--text\">\n" +
    "              <span class=\"checkbox-label\">\n" +
    "                {{::name | camelToSnakeCase | translate}}\n" +
    "              </span>\n" +
    "            </label>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"data-wrapper--right\">\n" +
    "      <div class=\"data-block\">\n" +
    "        <div class=\"data-block__header\">{{::'PREFERENCES' | translate}}</div>\n" +
    "        <div class=\"data-block__container data-block__container--border-bottom user-details__units\">\n" +
    "          <div ng-class=\"data-block__info\">\n" +
    "          <ui-select\n" +
    "            class='select-custom user-details__input--select'\n" +
    "            search-enabled='false'\n" +
    "            append-to-body='true'\n" +
    "\n" +
    "            title=\"{{::'CHOOSE_UNITS'| translate}}\"\n" +
    "            ng-model=\"userCtrl.user.settings.measurementUnit\">\n" +
    "            <ui-select-match\n" +
    "              permission\n" +
    "              permission-only=\":: userCtrl.permissions.settings.update\"\n" +
    "              permission-on-unauthorized=\"PermissionStrategies.disableUiSelect(this)\"\n" +
    "              permission-on-authorized=\"PermissionStrategies.enableUiSelect(this)\"\n" +
    "              placeholder=\"{{::'CHOOSE_UNITS'| translate}}\">{{'MEASUREMENT_UNIT_' + $select.selected | translate }}</ui-select-match>\n" +
    "            <ui-select-choices repeat=\"option in ['I', 'M']\">\n" +
    "              <span\n" +
    "                ng-bind=\"'MEASUREMENT_UNIT_' + option | translate\"></span>\n" +
    "            </ui-select-choices>\n" +
    "          </ui-select>\n" +
    "          <div class=\"data-block__title\">{{::'UNIT_SETTINGS' | translate}}</div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"data-block\">\n" +
    "        <div class=\"data-block__container\">\n" +
    "          <div ng-class=\"data-block__info\">\n" +
    "            <ui-select\n" +
    "              class='select-custom user-details__input--select'\n" +
    "              search-enabled='false'\n" +
    "              append-to-body='true'\n" +
    "\n" +
    "              title=\"{{::'CHOOSE_LANGUAGE' | translate}}\"\n" +
    "              ng-model=\"userCtrl.user.settings.language\">\n" +
    "              <ui-select-match\n" +
    "                permission\n" +
    "                permission-only=\":: userCtrl.permissions.settings.update\"\n" +
    "                permission-on-unauthorized=\"PermissionStrategies.disableUiSelect(this)\"\n" +
    "                permission-on-authorized=\"PermissionStrategies.enableUiSelect(this)\"\n" +
    "                placeholder=\"{{::'CHOOSE_LANGUAGE' | translate}}\">{{ 'LANGUAGE_' + $select.selected | translate}}</ui-select-match>\n" +
    "              <ui-select-choices repeat=\"language in userCtrl.languages\">\n" +
    "                <span\n" +
    "                  ng-bind=\"'LANGUAGE_' + language | translate\"></span>\n" +
    "              </ui-select-choices>\n" +
    "            </ui-select>\n" +
    "            <div class=\"data-block__title\">{{::'LANGUAGE' | translate}}</div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"footer-buttons\">\n" +
    "    <div class=\"button button-action\"\n" +
    "      permission\n" +
    "      permission-only=\":: userCtrl.permissions.settings.update\"\n" +
    "      ng-show=\"userCtrl.forms['settings' + role].$dirty\"\n" +
    "      ng-click=\"userCtrl.save('settings', userCtrl.user.settings, role)\">\n" +
    "      {{ :: 'SAVE'  | translate }}\n" +
    "    </div>\n" +
    "    <div class=\"button button-assertive button-clear pull-right\"\n" +
    "      permission\n" +
    "      permission-only=\":: userCtrl.permissions.settings.update\"\n" +
    "      ng-show=\"userCtrl.forms['settings' + role].$dirty\"\n" +
    "      ng-click=\"userCtrl.reset('settings', role)\">\n" +
    "      {{ :: 'CANCEL'  | translate }}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("/app/user/tabs/userDetails/userDetails.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/user/tabs/userDetails/userDetails.html",
    "<div class=\"user-details\">\n" +
    "\n" +
    "<!-- =============== STATS  INFORAMTION=================== -->\n" +
    "  <form name=\"userCtrl.forms.stats\">\n" +
    "    <div permission\n" +
    "      permission-only=\":: userCtrl.permissions.stats.read\"\n" +
    "      class=\"data-wrapper user-details__first-page\">\n" +
    "      <div class=\"data-block__header\">{{ :: 'STATS' | translate }}</div>\n" +
    "      <div class=\"data-wrapper--left\">\n" +
    "\n" +
    "        <!-- =============== STATS =================== -->\n" +
    "        <div class=\"data-block  user-details__first-block\">\n" +
    "          <div class=\"data-block__container\">\n" +
    "\n" +
    "            <div class=\"data-block__info-container\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <!-- disabled here, because for client it should be not editable\n" +
    "                TODO: fix when new client functionality will be presented-->\n" +
    "                <input disabled\n" +
    "                  ng-model=\"userCtrl.user.stats.birthday\"\n" +
    "                  class=\"data-block__info--input client-details__input--text\"\n" +
    "                  ng-click=\"isOpenCDatePicker1 = !isOpenCDatePicker1\"\n" +
    "                  show-button-bar=\"false\"\n" +
    "                  is-open=\"isOpenCDatePicker1\"\n" +
    "                  popup-placement=\"bottom-left\"\n" +
    "                  uib-datepicker-popup=\"MM/dd/yyyy\"\n" +
    "                  ng-model-options=\"{ timezone: 'UTC' }\"\n" +
    "                  placeholder=\"---\">\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'DATE_OF_BIRTH' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"data-block__info-container\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "              <!-- disabled here, because for client it should be not editable\n" +
    "              TODO: fix when new client functionality will be presented-->\n" +
    "                <input disabled\n" +
    "                  ng-model=\"userCtrl.user.stats.gender\"\n" +
    "                  class=\"data-block__info--input user-details__input--select\">\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'GENDER' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"data-block__info-container\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "              <!-- disabled here, because for client it should be not editable\n" +
    "              TODO: fix when new client functionality will be presented-->\n" +
    "                <input disabled\n" +
    "                  ng-model=\"userCtrl.user.stats.body.weight\"\n" +
    "                  class=\"data-block__info--input user-details__input--number input-clear\"\n" +
    "                  placeholder=\"0\">\n" +
    "                <span class=\"data-block__units\">{{ userCtrl.user.stats.body.weightUnit | camelToSnakeCase | translate }}</span>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'WEIGHT' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"data-block__info-container\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "              <!-- disabled here, because for client it should be not editable\n" +
    "              TODO: fix when new client functionality will be presented-->\n" +
    "                <input disabled\n" +
    "                  ng-model=\"userCtrl.user.stats.body.height\"\n" +
    "                  class=\"data-block__info--input user-details__input--number input-clear\"\n" +
    "                  placeholder=\"0\">\n" +
    "                <span class=\"data-block__units\">{{ userCtrl.user.stats.body.lengthUnit | camelToSnakeCase | translate }}</span>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'HEIGHT' | translate }}</div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- =============== BODY_STATS =================== -->\n" +
    "        <div class=\"data-block\">\n" +
    "          <div class=\"data-block__header\">{{ :: 'BODY_STATS' | translate }}</div>\n" +
    "          <div class=\"data-block__container\">\n" +
    "\n" +
    "            <div class=\"data-block__info-container\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <input permission\n" +
    "                  permission-only=\":: userCtrl.permissions.stats.update\"\n" +
    "                  permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                  permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                  type=\"number\"\n" +
    "                  ng-model=\"userCtrl.user.stats.body.fat\"\n" +
    "                  class=\"data-block__info--input user-details__input--number input-clear\"\n" +
    "                  placeholder=\"0\">\n" +
    "                <span class=\"data-block__units\">%</span>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'BODY_FAT_PCT' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"data-block__info-container\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <input permission\n" +
    "                  permission-only=\":: userCtrl.permissions.stats.update\"\n" +
    "                  permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                  permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                  type=\"number\"\n" +
    "                  ng-model=\"userCtrl.user.stats.body.bmi\"\n" +
    "                  class=\"data-block__info--input user-details__input--number input-clear\"\n" +
    "                  placeholder=\"0\">\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'BMI' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"data-block__info-container\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <input permission\n" +
    "                  permission-only=\":: userCtrl.permissions.stats.update\"\n" +
    "                  permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                  permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                  type=\"number\"\n" +
    "                  ng-model=\"userCtrl.user.stats.body.leanMass\"\n" +
    "                  class=\"data-block__info--input user-details__input--number input-clear\"\n" +
    "                  placeholder=\"0\">\n" +
    "                <span class=\"data-block__units\">{{ userCtrl.user.stats.body.weightUnit | camelToSnakeCase | translate  }}</span>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'LEAN_BODY_MASS' | translate }}</div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- =============== HEART_STATS =================== -->\n" +
    "        <div class=\"data-block\">\n" +
    "          <div class=\"data-block__header\">{{ :: 'HEART_STATS' | translate }}</div>\n" +
    "          <div class=\"data-block__container\">\n" +
    "\n" +
    "            <div class=\"data-block__info-container\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <input permission\n" +
    "                  permission-only=\":: userCtrl.permissions.stats.update\"\n" +
    "                  permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                  permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                  type=\"number\"\n" +
    "                  ng-model=\"userCtrl.user.stats.body.hr.resting\"\n" +
    "                  class=\"data-block__info--input user-details__input--number input-clear\"\n" +
    "                  placeholder=\"0\">\n" +
    "                <span class=\"data-block__units\">{{ :: 'bpm'  | camelToSnakeCase | translate }}</span>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'RESTING_HR' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"data-block__info-container\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <input permission\n" +
    "                  permission-only=\":: userCtrl.permissions.stats.update\"\n" +
    "                  permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                  permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                  type=\"number\"\n" +
    "                  ng-model=\"userCtrl.user.stats.body.hr.avg\"\n" +
    "                  class=\"data-block__info--input user-details__input--number input-clear\"\n" +
    "                  placeholder=\"0\">\n" +
    "                <span class=\"data-block__units\">{{ :: 'bpm'  | camelToSnakeCase | translate }}</span>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'AVG_HR' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"data-block__info-container\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <input permission\n" +
    "                  permission-only=\":: userCtrl.permissions.stats.update\"\n" +
    "                  permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                  permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                  type=\"number\"\n" +
    "                  ng-model=\"userCtrl.user.stats.body.hr.min\"\n" +
    "                  class=\"data-block__info--input user-details__input--number input-clear\"\n" +
    "                  placeholder=\"0\">\n" +
    "                <span class=\"data-block__units\">{{ :: 'bpm'  | camelToSnakeCase | translate }}</span>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'MIN_HR' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"data-block__info-container\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <input permission\n" +
    "                  permission-only=\":: userCtrl.permissions.stats.update\"\n" +
    "                  permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                  permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                  type=\"number\"\n" +
    "                  ng-model=\"userCtrl.user.stats.body.hr.max\"\n" +
    "                  class=\"data-block__info--input user-details__input--number input-clear\"\n" +
    "                  placeholder=\"0\">\n" +
    "                <span class=\"data-block__units\">{{ :: 'bpm'  | camelToSnakeCase | translate }}</span>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'MAX_HR' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"data-block__container\">\n" +
    "\n" +
    "            <div class=\"data-block__info-container\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <input permission\n" +
    "                  permission-only=\":: userCtrl.permissions.stats.update\"\n" +
    "                  permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                  permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                  type=\"number\"\n" +
    "                  ng-model=\"userCtrl.user.stats.body.vo2\"\n" +
    "                  class=\"data-block__info--input user-details__input--number input-clear\"\n" +
    "                  placeholder=\"0\">\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'VO2' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"data-block__info-container\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <input permission\n" +
    "                permission-only=\":: userCtrl.permissions.stats.update\"\n" +
    "                permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                type=\"number\"\n" +
    "                ng-model=\"userCtrl.user.stats.body.bp.systolitic\"\n" +
    "                class=\"data-block__info--input user-details__input--number input-clear\"\n" +
    "                placeholder=\"0\">\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'SYNSTOLIC_BP' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"data-block__info-container\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <input permission\n" +
    "                  permission-only=\":: userCtrl.permissions.stats.update\"\n" +
    "                  permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                  permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                  type=\"number\"\n" +
    "                  ng-model=\"userCtrl.user.stats.body.bp.diastolitic\"\n" +
    "                  class=\"data-block__info--input user-details__input--number input-clear\"\n" +
    "                  placeholder=\"0\">\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'DIASTOLIC_BP' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <!-- =========== PERSON_IMAGE =================== -->\n" +
    "      <div class=\"data-wrapper--right\">\n" +
    "        <div class=\"user-details__person-img\" ng-class=\"{'user-details__person-img--female': (userCtrl.user.stats.gender === 'F')}\">\n" +
    "          <div class=\"user-details__person-sizes\">\n" +
    "            <div class=\"user-details__person-sizes--block user-details__person-sizes--block--1 data-block__info-container data-block__info-container--block\">\n" +
    "                <div class=\"data-block__info\">\n" +
    "                  <input permission\n" +
    "                    permission-only=\":: userCtrl.permissions.stats.update\"\n" +
    "                    permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                    permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                    type=\"number\"\n" +
    "                    ng-model=\"userCtrl.user.stats.body.neck\"\n" +
    "                    class=\"data-block__info--input user-details__input--number user-details__person-sizes--input input-clear\"\n" +
    "                    placeholder=\"0\">\n" +
    "                  <span class=\"data-block__units\">{{ userCtrl.user.stats.body.lengthUnit | camelToSnakeCase | translate  }}</span>\n" +
    "                </div>\n" +
    "                <div class=\"data-block__title\">{{ :: 'NECK' | translate }}</div>\n" +
    "            </div>\n" +
    "            <div class=\"user-details__person-sizes--block user-details__person-sizes--block--2 data-block__info-container data-block__info-container--block\">\n" +
    "                <div class=\"data-block__info\">\n" +
    "                  <input permission\n" +
    "                    permission-only=\":: userCtrl.permissions.stats.update\"\n" +
    "                    permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                    permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                    type=\"number\"\n" +
    "                    ng-model=\"userCtrl.user.stats.body.chest\"\n" +
    "                    class=\"data-block__info--input user-details__input--number user-details__person-sizes--input input-clear\"\n" +
    "                    placeholder=\"0\">\n" +
    "                  <span class=\"data-block__units\">{{ userCtrl.user.stats.body.lengthUnit | camelToSnakeCase | translate  }}</span>\n" +
    "                </div>\n" +
    "                <div class=\"data-block__title\">{{ :: 'CHEST' | translate }}</div>\n" +
    "            </div>\n" +
    "            <div class=\"user-details__person-sizes--block user-details__person-sizes--block--3 data-block__info-container data-block__info-container--block\">\n" +
    "                <div class=\"data-block__info\">\n" +
    "                  <input permission\n" +
    "                    permission-only=\":: userCtrl.permissions.stats.update\"\n" +
    "                    permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                    permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                    type=\"number\"\n" +
    "                    ng-model=\"userCtrl.user.stats.body.waist\"\n" +
    "                    class=\"data-block__info--input user-details__input--number user-details__person-sizes--input input-clear\"\n" +
    "                    placeholder=\"0\">\n" +
    "                  <span class=\"data-block__units\">{{ userCtrl.user.stats.body.lengthUnit | camelToSnakeCase | translate  }}</span>\n" +
    "                </div>\n" +
    "                <div class=\"data-block__title\">{{ :: 'WAIST' | translate }}</div>\n" +
    "            </div>\n" +
    "            <div class=\"user-details__person-sizes--block user-details__person-sizes--block--4 data-block__info-container data-block__info-container--block\">\n" +
    "                <div class=\"data-block__info\">\n" +
    "                  <input permission\n" +
    "                    permission-only=\":: userCtrl.permissions.stats.update\"\n" +
    "                    permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                    permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                    type=\"number\"\n" +
    "                    ng-model=\"userCtrl.user.stats.body.hips\"\n" +
    "                    class=\"data-block__info--input user-details__input--number user-details__person-sizes--input input-clear\"\n" +
    "                    placeholder=\"0\">\n" +
    "                  <span class=\"data-block__units\">{{ userCtrl.user.stats.body.lengthUnit | camelToSnakeCase | translate  }}</span>\n" +
    "                </div>\n" +
    "                <div class=\"data-block__title\">{{ :: 'HIPS' | translate }}</div>\n" +
    "            </div>\n" +
    "            <div class=\"user-details__person-sizes--block user-details__person-sizes--block--5 data-block__info-container data-block__info-container--block\">\n" +
    "                <div class=\"data-block__info\">\n" +
    "                  <input permission\n" +
    "                    permission-only=\":: userCtrl.permissions.stats.update\"\n" +
    "                    permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                    permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                    type=\"number\"\n" +
    "                    ng-model=\"userCtrl.user.stats.body.thigh\"\n" +
    "                    class=\"data-block__info--input user-details__input--number user-details__person-sizes--input input-clear\"\n" +
    "                    placeholder=\"0\">\n" +
    "                  <span class=\"data-block__units\">{{ userCtrl.user.stats.body.lengthUnit | camelToSnakeCase | translate  }}</span>\n" +
    "                </div>\n" +
    "                <div class=\"data-block__title\">{{ :: 'THIGH' | translate }}</div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"footer-buttons\">\n" +
    "      <div permission\n" +
    "        permission-only=\":: userCtrl.permissions.stats.update\"\n" +
    "        ng-show='userCtrl.forms.stats.$dirty'\n" +
    "        ng-click=\"userCtrl.save('stats', userCtrl.user.stats)\"\n" +
    "        class=\"button button-action\">\n" +
    "        {{ :: 'SAVE'  | translate }}\n" +
    "      </div>\n" +
    "      <div permission\n" +
    "        permission-only=\":: userCtrl.permissions.stats.update\"\n" +
    "        ng-show='userCtrl.forms.stats.$dirty'\n" +
    "        ng-click=\"userCtrl.reset('stats')\"\n" +
    "        class=\"button button-clear button-assertive pull-right\">\n" +
    "        {{ :: 'CANCEL'  | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "\n" +
    "<!-- ========== PERSONAL INFORAMTION =================== -->\n" +
    "\n" +
    "  <form name=\"userCtrl.forms.personalInfoClient\">\n" +
    "    <div permission\n" +
    "      permission-only=\":: userCtrl.permissions.personalDetails.read\"\n" +
    "      class=\"data-wrapper\">\n" +
    "\n" +
    "      <div class=\"data-wrapper--left\">\n" +
    "\n" +
    "        <div class=\"data-block\">\n" +
    "          <div class=\"data-block__header\">\n" +
    "            {{ :: 'PERSONAL_INFORAMTION' | translate }}\n" +
    "          </div>\n" +
    "          <div class=\"data-block__container data-block__container--border-bottom\">\n" +
    "\n" +
    "            <div class=\"data-block__info-container data-block__info-container--block\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <textarea permission\n" +
    "                permission-only=\":: userCtrl.permissions.personalDetails.update\"\n" +
    "                permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                ng-model=\"userCtrl.user.personalInfo.address1\"\n" +
    "                class=\"data-block__info--input user-details__input--area input-clear\"\n" +
    "                placeholder=\"---\">\n" +
    "                </textarea>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'ADDRESS1' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"data-block\">\n" +
    "          <div class=\"data-block__container data-block__container--border-bottom\">\n" +
    "\n" +
    "            <div class=\"data-block__info-container data-block__info-container--2-col\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <input permission\n" +
    "                permission-only=\":: userCtrl.permissions.personalDetails.update\"\n" +
    "                permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                ui-mask=\"(999) 999-9999\"\n" +
    "                ui-mask-placeholder\n" +
    "                ui-mask-placeholder-char=\"_\"\n" +
    "                ui-options=\"{allowInvalidValue:true, clearOnBlur: false}\"\n" +
    "                type=\"text\"\n" +
    "                ng-model=\"userCtrl.user.personalInfo.phoneNumber1\"\n" +
    "                class=\"data-block__info--input user-details__input--text input-clear\"\n" +
    "                placeholder=\"---\">\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'PHONE_NUMBER_1' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"data-block__info-container data-block__info-container--2-col\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <input permission\n" +
    "                permission-only=\":: userCtrl.permissions.personalDetails.update\"\n" +
    "                permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                ui-mask=\"(999) 999-9999\"\n" +
    "                ui-mask-placeholder\n" +
    "                ui-mask-placeholder-char=\"_\"\n" +
    "                ui-options=\"{allowInvalidValue:true, clearOnBlur: false}\"\n" +
    "                type=\"text\"\n" +
    "                ng-model=\"userCtrl.user.personalInfo.phoneNumber2\"\n" +
    "                class=\"data-block__info--input user-details__input--text input-clear\"\n" +
    "                placeholder=\"---\">\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'PHONE_NUMBER_2' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"data-block\">\n" +
    "          <div class=\"data-block__container data-block__container--border-bottom\">\n" +
    "\n" +
    "            <div class=\"data-block__info-container data-block__info-container--2-col\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "              <span class=\"data-block__info--input user-details__input--email\">\n" +
    "                {{::userCtrl.user.personalInfo.email}}\n" +
    "              </span>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'EMAIL_ADDRESS' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"data-block__info-container data-block__info-container--2-col\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <div permission\n" +
    "                permission-only=\":: userCtrl.permissions.resetPassword.update\"\n" +
    "                class=\"data-block__button\" ng-click=\"userCtrl.resetPassword()\">\n" +
    "                  {{ :: 'RESET_PASSWORD' | translate }}\n" +
    "                </div>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__info\" ng-if=\"userCtrl.userId === user._id || userCtrl.userId === 'me'\">\n" +
    "                <div class=\"data-block__button\" ng-click=\"userCtrl.changePassword()\">\n" +
    "                  {{ :: 'CHANGE_PASSWORD' | translate }}\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"data-block\" permission\n" +
    "            permission-only=\"'CURRENT_FACILITY_READ'\">\n" +
    "          <div class=\"data-block__container\">\n" +
    "\n" +
    "            <div class=\"data-block__info-container data-block__info-container--2-col\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "\n" +
    "              <input class=\"data-block__info--input\"\n" +
    "                ng-value=\"userCtrl.user.personalInfo.club.chain\"\n" +
    "                readonly\n" +
    "                placeholder=\"---\">\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'CLUB_CHAIN' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"data-block__info-container data-block__info-container--2-col\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "              <span class=\"data-block__info--input\">\n" +
    "                {{ userCtrl.user.personalInfo.club.name}}\n" +
    "              </span>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'HOME_CLUB' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"data-wrapper--right\">\n" +
    "        <div class=\"data-block\">\n" +
    "          <div class=\"data-block__header\">{{ :: 'PLAN_DETAILS' | translate }}</div>\n" +
    "          <div class=\"data-block__container user-details__plan-details\">\n" +
    "\n" +
    "            <div class=\"user-details__plan-details--left-column\">\n" +
    "              <div class=\"data-block__info-container\">\n" +
    "                <div class=\"data-block__info\" permission permission-only=\"'SESSION_FLAG_READ'\">\n" +
    "\n" +
    "                  <input permission\n" +
    "                    permission-only=\"'SESSION_FLAG_UPDATE'\"\n" +
    "                    permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "                    permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "                    type=\"text\"\n" +
    "                    required\n" +
    "                    ng-pattern=\"/^(0|[1-9][0-9]*)$/\"\n" +
    "                    ng-model=\"userCtrl.user.personalInfo.planDetails.sessionRemains\"\n" +
    "                    class=\"data-block__info--input user-details__input--number input-clear user-details__plan-details--sessions-input\">\n" +
    "                </div>\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"data-block__info-container\"\n" +
    "                  ng-if=\"userCtrl.user.personalInfo.planDetails.lastWorkoutDate\">\n" +
    "                  <div class=\"data-block__info\">\n" +
    "                    <span class=\"data-block__info--input user-details__input--text user-details__plan-details--checkicon\">\n" +
    "                    </span>\n" +
    "                  </div>\n" +
    "                  <div class=\"data-block__title data-block__title--hidden\">✔</div>\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"data-block__info-container\">\n" +
    "                  <div class=\"data-block__info\">\n" +
    "                    <span class=\"data-block__info--input--hidden user-details__input--text\">\n" +
    "                      ✔\n" +
    "                    </span>\n" +
    "                  </div>\n" +
    "                  <div class=\"data-block__title data-block__title--hidden\">✔</div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"user-details__plan-details--right-column\">\n" +
    "              <div class=\"data-block__info-container\" permission permission-only=\"'SESSION_FLAG_READ'\">\n" +
    "                 <div class=\"data-block__title\">{{ :: 'SESSION_REMAINS' | translate }}</div>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__info-container\"\n" +
    "                ng-if=\"userCtrl.user.personalInfo.planDetails.lastWorkoutDate\">\n" +
    "                <div class=\"data-block__info\">\n" +
    "                  <!-- Disablie, because this data we are receiving from NetPulse -->\n" +
    "                  <input disabled\n" +
    "                    ng-model=\"userCtrl.user.personalInfo.planDetails.lastWorkoutDate\"\n" +
    "                    ng-click=\"lastWorkoutDatePicker = !lastWorkoutDatePicker\"\n" +
    "                    show-button-bar=\"false\"\n" +
    "                    is-open=\"lastWorkoutDatePicker\"\n" +
    "                    popup-placement=\"bottom-left\"\n" +
    "                    uib-datepicker-popup=\"MM/dd/yyyy\"\n" +
    "                    class=\"data-block__info--input client-details__input--text client-details__plan-details--date\">\n" +
    "                </div>\n" +
    "                <div class=\"data-block__title\">{{ :: 'LAST_WORKOUT' | translate }}</div>\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"data-block__info-container\"\n" +
    "                ng-if=\"userCtrl.user.personalInfo.planDetails.nextAssignmentDate\">\n" +
    "                <div class=\"data-block__info\">\n" +
    "                  <!-- Disablie, because this data we are receiving from NetPulse -->\n" +
    "                  <input disabled\n" +
    "                    ng-model=\"userCtrl.user.personalInfo.planDetails.nextAssignmentDate\"\n" +
    "                    ng-click=\"nextAssignmentDatePicker = !nextAssignmentDatePicker\"\n" +
    "                    show-button-bar=\"false\"\n" +
    "                    is-open=\"nextAssignmentDatePicker\"\n" +
    "                    popup-placement=\"bottom-left\"\n" +
    "                    uib-datepicker-popup=\"MM/dd/yyyy\"\n" +
    "                    class=\"data-block__info--input client-details__input--text client-details__plan-details--date\">\n" +
    "                </div>\n" +
    "                <div class=\"data-block__title\">{{ :: 'NEXT_WORKOUT' | translate }}</div>\n" +
    "              </div>\n" +
    "\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"footer-buttons\">\n" +
    "      <div permission\n" +
    "      permission-only=\":: userCtrl.permissions.personalDetails.update\"\n" +
    "      ng-show='userCtrl.forms.personalInfoClient.$dirty'\n" +
    "      ng-click=\"userCtrl.savePersonalInfo('personalInfo', userCtrl.user.personalInfo, 'Client')\"\n" +
    "      class=\"button button-action\">\n" +
    "        {{ :: 'SAVE'  | translate }}\n" +
    "      </div>\n" +
    "      <div permission\n" +
    "      permission-only=\":: userCtrl.permissions.personalDetails.update\"\n" +
    "      ng-show='userCtrl.forms.personalInfoClient.$dirty'\n" +
    "      ng-click=\"userCtrl.reset('personalInfo', 'Client')\"\n" +
    "      class=\"button button-clear button-assertive pull-right\">\n" +
    "        {{ :: 'CANCEL'  | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "\n" +
    "<!-- ========== TRAINER INFORMATION =================== -->\n" +
    "  <form name=\"userCtrl.forms.trainers\"\n" +
    "    permission\n" +
    "    permission-only=\" :: userCtrl.permissions.trainers.read\">\n" +
    "\n" +
    "    <div class=\"data-section\">\n" +
    "      <div class=\"data-section__header\">\n" +
    "        <div class=\"data-section__title\">{{ :: 'TRAINER' | translate }}</div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"data-section__content\">\n" +
    "        <div class=\"data-section__item\"\n" +
    "          ng-repeat=\"(i, trainer) in userCtrl.user.trainers\">\n" +
    "\n" +
    "          <div class=\"pull-right\">\n" +
    "            <div class=\"button button-clear button-assertive push-top-sm\"\n" +
    "              permission\n" +
    "              permission-only=\"userCtrl.permissions.trainers.delete\"\n" +
    "              ng-click=\"userCtrl.removeTrainer(trainer)\">\n" +
    "                {{ :: 'REMOVE_TRAINER' | translate }}\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"data-section__image-container\">\n" +
    "            <img class=\"user-page__user-img--trainer\" ng-src=\"{{ trainer.pictureUrl || '//images.jhtassets.com/69dcdf7c42e69031c482c0c1c6cf8d5050db00d7/' }}\">\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"data-section__item-content push-top-sm\">\n" +
    "            <div class=\"data-block__info-container data-block__info-container--block\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <span\n" +
    "                  class=\"data-block__info--input user-details__input--text user-details__trainer-input\">\n" +
    "                  {{::trainer.firstName}} {{::trainer.lastName}}\n" +
    "                </span>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'NAME' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"data-block__info-container data-block__info-container--block\">\n" +
    "              <div class=\"data-block__info\">\n" +
    "                <span\n" +
    "                  class=\"data-block__info--input user-details__input--email user-details__trainer-input\">\n" +
    "                  {{::trainer.email}}\n" +
    "                </span>\n" +
    "              </div>\n" +
    "              <div class=\"data-block__title\">{{ :: 'CONTACT' | translate }}</div>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"button button-large button-full button-primary\"\n" +
    "          permission\n" +
    "          permission-only=\"userCtrl.permissions.trainers.create\"\n" +
    "          ng-click=\"userCtrl.showTrainerPopup()\">\n" +
    "          {{ :: 'ADD_TRAINER' | translate }}\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"footer-buttons\">\n" +
    "      <div permission\n" +
    "        permission-only=\"'CLIENT_TRAINER_OTHER_UPDATE'\"\n" +
    "        ng-show='userCtrl.forms.trainers.$dirty'\n" +
    "        ng-click=\"userCtrl.save('trainers', userCtrl.user.trainers)\"\n" +
    "        class=\"button button-action\">\n" +
    "        {{ :: 'UPDATE_TRAINER'  | translate }}\n" +
    "      </div>\n" +
    "      <div permission\n" +
    "        permission-only=\"['CLIENT_TRAINER_OTHER_UPDATE', 'CLIENT_TRAINER_OTHER_CREATE', 'CLIENT_TRAINER_OTHER_DELETE']\"\n" +
    "        ng-show='userCtrl.forms.trainers.$dirty'\n" +
    "        ng-click=\"userCtrl.reset('trainers')\"\n" +
    "        class=\"button button-clear button-assertive pull-right\">\n" +
    "        {{ :: 'CANCEL'  | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "\n" +
    "<!-- ========== SETTINGS INFORAMTION =================== -->\n" +
    "  <div\n" +
    "    ng-init=\"role = 'Client'\"\n" +
    "    ng-include=\"'/app/user/tabs/userDetails/settings/settings.html'\">\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/user/tabs/userDetails/userModal/userModal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/user/tabs/userDetails/userModal/userModal.html",
    "<form name=\"usersCtrl.trainerModalForm\" class='user-details__trainer-popup-form'>\n" +
    "\n" +
    "  <div class=\"modal__popup-header\">\n" +
    "    <div class=\"modal__popup-header--title\">{{ :: 'SELECT_'+usersCtrl.user.modalType.toUpperCase()+'_PERSON' | translate }}</div>\n" +
    "    <div ng-click=\"usersCtrl.closeModal()\"\n" +
    "    class=\"modal__popup-header--exit icon icon-cross\"></div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"user-details__trainer-popup-search-container\">\n" +
    "    <label for=\"searchStr\" class=\"user-details__trainer-popup-search-icon icon icon-search\"></label>\n" +
    "    <input type=\"text\"\n" +
    "      id=\"searchStr\"\n" +
    "      ng-model=\"usersCtrl.searchStr\"\n" +
    "      ng-model-options=\"{'debounce': 400}\"\n" +
    "      ng-change=\"usersCtrl.searcUsersByStr(usersCtrl.searchStr)\"\n" +
    "      class=\"user-details__trainer-popup-search-input\"\n" +
    "      placeholder=\"{{::'SEARCH_'+usersCtrl.user.modalType.toUpperCase() | translate}}\">\n" +
    "\n" +
    "    <div class=\"user-details__trainer-popup-select-all\">\n" +
    "      <label class=\"checkbox-custom\">\n" +
    "        <input\n" +
    "          permission\n" +
    "          permission-only=\"'INTERESTED_UPDATE'\"\n" +
    "          permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "          permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "          type=\"checkbox\"\n" +
    "          ng-model=\"usersCtrl.isAllSelected\"\n" +
    "          ng-change=\"usersCtrl.selectAll(usersCtrl.isAllSelected, usersCtrl.usersList.items)\"\n" +
    "          class=\"right-checkbox black-checkbox\">\n" +
    "        <span class=\"checkbox-label\">{{ :: 'SELECT_ALL' | translate }}</span>\n" +
    "      </label>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <!-- ========== TRAINERS LIST =========== -->\n" +
    "  <div class=\"data-section\"\n" +
    "     infinite-scroll='usersCtrl.loadUsers()'\n" +
    "     can-load='usersCtrl.usersList.nextPage'\n" +
    "     threshold='30'>\n" +
    "\n" +
    "    <div class=\"data-section__content\">\n" +
    "\n" +
    "      <div class=\"data-section__item\"\n" +
    "        ng-repeat=\"(i, user) in usersCtrl.usersList.items | filter: { _id: '!' + usersCtrl.user._id }\">\n" +
    "\n" +
    "        <div class=\"pull-right push-top-md push-right-md\">\n" +
    "          <label class=\"checkbox-custom\">\n" +
    "            <input class=\"right-checkbox\"\n" +
    "              permission\n" +
    "              permission-only=\"'INTERESTED_UPDATE'\"\n" +
    "              permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "              permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "              type=\"checkbox\"\n" +
    "              ng-model=\"user.selected\">\n" +
    "            <span class=\"checkbox-label\">{{ :: 'ADD_' + usersCtrl.user.modalType.toUpperCase() | translate }}</span>\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"data-section__image-container\">\n" +
    "          <img class=\"user-page__user-img--trainer\" ng-src=\"{{ user.pictureUrl || '//images.jhtassets.com/69dcdf7c42e69031c482c0c1c6cf8d5050db00d7/' }}\">\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"data-section__item-content push-top-sm\">\n" +
    "\n" +
    "          <div class=\"data-block__info-container data-block__info-container--block\">\n" +
    "            <div class=\"data-block__info\">\n" +
    "              <span\n" +
    "                class=\"data-block__info--input user-details__input--text user-details__trainer-input\">\n" +
    "                {{ :: user.firstName }} {{ :: user.lastName }}\n" +
    "              </span>\n" +
    "            </div>\n" +
    "            <div class=\"data-block__title\">{{ :: 'NAME' | translate }}</div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"data-block__info-container data-block__info-container--block\">\n" +
    "            <div class=\"data-block__info\">\n" +
    "              <span\n" +
    "                class=\"data-block__info--input user-details__input--email user-details__trainer-input\">\n" +
    "                {{ :: user.email }}\n" +
    "              </span>\n" +
    "            </div>\n" +
    "            <div class=\"data-block__title\">{{ :: 'CONTACT' | translate }}</div>\n" +
    "          </div>\n" +
    "\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "    <div class='roster-load-more' ng-if='usersCtrl.usersList.isLoading'>\n" +
    "      <div class='roster-load-more__icon spinner-icon'></div>\n" +
    "      {{ :: 'LOADING_MORE_' + usersCtrl.user.modalType.toUpperCase() + 'S' | translate }}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"footer-buttons\">\n" +
    "    <div class=\"button button-action\"\n" +
    "      permission\n" +
    "      permission-only=\"'CLIENT_TRAINER_OTHER_UPDATE'\"\n" +
    "      ng-show='usersCtrl.trainerModalForm.$dirty'\n" +
    "      ng-click=\"usersCtrl.addUsers(usersCtrl.usersList.items)\">\n" +
    "      <span>{{ :: 'ADD_' + usersCtrl.user.modalType.toUpperCase() | translate }}</span>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"button button-clear button-assertive pull-right\"\n" +
    "      ng-show='usersCtrl.trainerModalForm.$dirty'\n" +
    "      ng-click=\"usersCtrl.resetTrainers('trainerModal')\">\n" +
    "      {{ :: 'CANCEL'  | translate }}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("/app/user/tabs/userNotes/notes.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/user/tabs/userNotes/notes.html",
    "<div class=\"notes\" ng-controller=\"NotesController as notesCtrl\">\n" +
    "  <div class=\"notes__content\"\n" +
    "    permission\n" +
    "    permission-only=\"'STAFF_NOTES_READ'\">\n" +
    "\n" +
    "    <form name=\"notesCtrl.forms.notes\"></form>\n" +
    "\n" +
    "    <div class=\"drop-down\">\n" +
    "      <form class=\"drop-down__group-container\"\n" +
    "        name='notesCtrl.forms[\"{{(note._id || note._virtualId)}}\"]'\n" +
    "        ng-repeat=\"note in notesCtrl.notes\"\n" +
    "        ng-show='!note.isDeleted'>\n" +
    "\n" +
    "        <div class=\"drop-down__group-container fade-onload\">\n" +
    "          <div class=\"drop-down__group-header\">\n" +
    "            <input permission\n" +
    "              permission-only=\"note._isNew ? 'STAFF_NOTES_CREATE': 'STAFF_NOTES_UPDATE'\"\n" +
    "              permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "              permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "              type=\"text\"\n" +
    "              ng-model=\"note.title\"\n" +
    "              ng-change=\"notesCtrl.onTitleChange()\"\n" +
    "              class=\"drop-down__group-title\">\n" +
    "\n" +
    "\n" +
    "            <div class=\"drop-down__group-button drop-down__group-button--hide\"\n" +
    "              ng-class=\"{'drop-down__group-button--hide--collapsed': !note.isExpanded}\"\n" +
    "              ng-click=\"note.isExpanded = !note.isExpanded\">\n" +
    "            </div>\n" +
    "\n" +
    "            <div permission\n" +
    "              permission-only=\"'STAFF_NOTES_DELETE'\"\n" +
    "              class=\"drop-down__group-button drop-down__group-button--remove\"\n" +
    "              ng-click=\"notesCtrl.remove(note)\">\n" +
    "            </div>\n" +
    "\n" +
    "            <div ng-if=\"note.isEdited && note.isExpanded\"\n" +
    "              permission\n" +
    "              permission-only=\"note._isNew ? 'STAFF_NOTES_CREATE': 'STAFF_NOTES_UPDATE'\"\n" +
    "              class=\"drop-down__group-button drop-down__group-button--cancel\"\n" +
    "              ng-click=\"notesCtrl.cancelNoteEdit(note); note.isExpanded = false;\">\n" +
    "            </div>\n" +
    "\n" +
    "            <div ng-if=\"note.isEdited && note.isExpanded\"\n" +
    "              permission\n" +
    "              permission-only=\"note._isNew ? 'STAFF_NOTES_CREATE': 'STAFF_NOTES_UPDATE'\"\n" +
    "              class=\"drop-down__group-button drop-down__group-button--apply\"\n" +
    "              ng-click=\"notesCtrl.applyNoteEdit(note); note.isExpanded = false;\">\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"drop-down__group-button drop-down__group-button--edit\"\n" +
    "              permission\n" +
    "              permission-only=\"note._isNew ? 'STAFF_NOTES_CREATE': 'STAFF_NOTES_UPDATE'\"\n" +
    "              ng-if=\"!note.isEdited\"\n" +
    "              ng-click=\"note.isEdited = true; note.isExpanded = true;\">\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"drop-down__group-date\">{{note.formattedDate}}</div>\n" +
    "\n" +
    "          </div>\n" +
    "          <div class=\"drop-down__group-content\" uib-collapse=\"!note.isExpanded\">\n" +
    "            <div ng-if=\"note.isEdited\">\n" +
    "              <trix-editor angular-trix ng-model=\"note.content\"></trix-editor>\n" +
    "            </div>\n" +
    "            <div ng-if=\"!note.isEdited\" ng-bind-html=\"note.content\"></div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </form>\n" +
    "    </div>\n" +
    "\n" +
    "    <div\n" +
    "        permission\n" +
    "        permission-only=\"'STAFF_NOTES_CREATE'\"\n" +
    "        ng-click=\"notesCtrl.add()\"\n" +
    "        class=\"button button-full button-large button-primary\">\n" +
    "      {{ :: 'ADD_NOTE' | translate }}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"tab-footer footer-buttons\"\n" +
    "       permission\n" +
    "       permission-only=\"['STAFF_NOTES_UPDATE', 'STAFF_NOTES_DELETE', 'STAFF_NOTES_CREATE']\">\n" +
    "    <div\n" +
    "      class=\"button button-action\"\n" +
    "      ng-show='notesCtrl.forms.notes.$dirty'\n" +
    "      ng-click=\"notesCtrl.save()\">\n" +
    "      {{::'SAVE'  | translate}}\n" +
    "    </div>\n" +
    "    <div\n" +
    "      class=\"button button-assertive button-clear pull-right\"\n" +
    "      ng-click=\"notesCtrl.reset()\">\n" +
    "      {{::'CANCEL'  | translate}}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/user/tabs/workouts/workout-status-modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/user/tabs/workouts/workout-status-modal.html",
    "<!--HEADER-->\n" +
    "<div class=\"modal__popup-header workout-status__header\">\n" +
    "  <div class=\"workout-status__assignment-date-selector\">\n" +
    "    <span class='timepicker-wrapper__control'\n" +
    "      ng-click='workoutStatusController.selectAssignment(1)'>\n" +
    "\n" +
    "      <i class=\"icon icon-triangle-left\"></i>\n" +
    "    </span>\n" +
    "\n" +
    "    <span>{{workoutStatusController.selectedAssignment.date}}</span>\n" +
    "\n" +
    "    <span class='timepicker-wrapper__control'\n" +
    "      ng-click='workoutStatusController.selectAssignment(-1)'>\n" +
    "\n" +
    "      <i class=\"icon icon-triangle-right\"></i>\n" +
    "    </span>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"workout-status__exercise-selector\">\n" +
    "    <span class='timepicker-wrapper__control'\n" +
    "      ng-click='workoutStatusController.selectExercise(-1)'>\n" +
    "\n" +
    "      <i class=\"icon icon-triangle-left\"></i>\n" +
    "    </span>\n" +
    "\n" +
    "    <span>\n" +
    "      {{ workoutStatusController.selectedExerciseIndex + 1 }}\n" +
    "      of\n" +
    "      {{ workoutStatusController.selectedAssignment.exercises.length }}\n" +
    "    </span>\n" +
    "\n" +
    "    <span class='timepicker-wrapper__control'\n" +
    "      ng-click='workoutStatusController.selectExercise(1)'>\n" +
    "\n" +
    "      <i class=\"icon icon-triangle-right\"></i>\n" +
    "    </span>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"modal__popup-header--exit icon icon-cross\"\n" +
    "    ng-click=\"workoutStatusController.closeModal()\"></div>\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "<!--CONTENT-->\n" +
    "\n" +
    "<div class=\"modal__content-template workout-status clearfix\">\n" +
    "\n" +
    "  <div class=\"workout-status__title\">\n" +
    "    {{ workoutStatusController.selectedExercise.title }}\n" +
    "  </div>\n" +
    "\n" +
    "  <!--ASSIGNED-->\n" +
    "  <div class=\"workout-status__column workout-status__assigned-stats clearfix\">\n" +
    "\n" +
    "    <div class=\"data-block__header\">\n" +
    "      {{ :: 'ASSIGNED' | translate }}\n" +
    "    </div>\n" +
    "\n" +
    "    <!--SPEED-->\n" +
    "    <div class=\"workout-status__exercise-param\"\n" +
    "      ng-if=\"workoutStatusController.selectedExercise.assignedData.startingSpeed\">\n" +
    "      <div class=\"workout-status__exercise-param--value\">\n" +
    "        {{ workoutStatusController.selectedExercise.assignedData.startingSpeed.value }}\n" +
    "        <span class=\"workout-status__exercise-param--units\">\n" +
    "          {{ workoutStatusController.selectedExercise.assignedData.startingSpeed.unit }}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"workout-status__exercise-param--name\">\n" +
    "        {{ :: 'SPEED' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!--DISTANCE-->\n" +
    "    <div class=\"workout-status__exercise-param\"\n" +
    "      ng-if=\"workoutStatusController.selectedExercise.assignedData.distance\">\n" +
    "      <div class=\"workout-status__exercise-param--value\">\n" +
    "        {{ workoutStatusController.selectedExercise.assignedData.distance.value }}\n" +
    "        <span class=\"workout-status__exercise-param--units\">\n" +
    "          {{ workoutStatusController.selectedExercise.assignedData.distance.unit }}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"workout-status__exercise-param--name\">\n" +
    "        {{ :: 'DISTANCE' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!--INCLINE-->\n" +
    "    <div class=\"workout-status__exercise-param\"\n" +
    "      ng-if=\"workoutStatusController.selectedExercise.assignedData.startingIncline\">\n" +
    "      <div class=\"workout-status__exercise-param--value\">\n" +
    "        {{ workoutStatusController.selectedExercise.assignedData.startingIncline.value }}\n" +
    "        <span class=\"workout-status__exercise-param--units\">\n" +
    "          {{ workoutStatusController.selectedExercise.assignedData.startingIncline.unit }}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"workout-status__exercise-param--name\">\n" +
    "        {{ :: 'INCLINE' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!--RESISTANCE-->\n" +
    "    <div class=\"workout-status__exercise-param\"\n" +
    "      ng-if=\"workoutStatusController.selectedExercise.assignedData.startingResistance\">\n" +
    "      <div class=\"workout-status__exercise-param--value\">\n" +
    "        {{ workoutStatusController.selectedExercise.assignedData.startingResistance.value }}\n" +
    "        <span class=\"workout-status__exercise-param--units\">\n" +
    "          {{ workoutStatusController.selectedExercise.assignedData.startingResistance.unit }}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"workout-status__exercise-param--name\">\n" +
    "        {{ :: 'RESISTANCE' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!--LEVEL-->\n" +
    "    <div class=\"workout-status__exercise-param\"\n" +
    "      ng-if=\"workoutStatusController.selectedExercise.assignedData.level\">\n" +
    "      <div class=\"workout-status__exercise-param--value\">\n" +
    "        {{ workoutStatusController.selectedExercise.assignedData.level.value }}\n" +
    "        <span class=\"workout-status__exercise-param--units\">\n" +
    "          {{ workoutStatusController.selectedExercise.assignedData.level.unit }}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"workout-status__exercise-param--name\">\n" +
    "        {{ :: 'LEVEL' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!--DURATION-->\n" +
    "    <div class=\"workout-status__exercise-param\"\n" +
    "      ng-if=\"workoutStatusController.selectedExercise.assignedData.duration\">\n" +
    "      <div class=\"workout-status__exercise-param--value\">\n" +
    "        {{ workoutStatusController.selectedExercise.assignedData.duration.value }}\n" +
    "        <span class=\"workout-status__exercise-param--units\">\n" +
    "          {{ workoutStatusController.selectedExercise.assignedData.duration.unit }}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"workout-status__exercise-param--name\">\n" +
    "        {{ :: 'DURATION' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!--CALORIES-->\n" +
    "    <div class=\"workout-status__exercise-param\"\n" +
    "      ng-if=\"workoutStatusController.selectedExercise.assignedData.calories\">\n" +
    "      <div class=\"workout-status__exercise-param--value\">\n" +
    "        {{ workoutStatusController.selectedExercise.assignedData.calories.value }}\n" +
    "        <span class=\"workout-status__exercise-param--units\">\n" +
    "          {{ workoutStatusController.selectedExercise.assignedData.calories.unit }}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"workout-status__exercise-param--name\">\n" +
    "        {{ :: 'CALORIES' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <!--COMPLETED-->\n" +
    "  <div class=\"workout-status__column workout-status__completed-stats clearfix\">\n" +
    "\n" +
    "    <div class=\"data-block__header\">\n" +
    "      {{ :: 'ACCOMPLISHED' | translate }}\n" +
    "    </div>\n" +
    "\n" +
    "    <!--SPEED-->\n" +
    "    <div class=\"workout-status__exercise-param\"\n" +
    "      ng-if=\"workoutStatusController.selectedExercise.completedData.averageSpeed\">\n" +
    "      <div class=\"workout-status__exercise-param--value\">\n" +
    "        <span class=\"{{ workoutStatusController.selectedExercise.completedData.averageSpeed.comparision }}\">\n" +
    "          {{ workoutStatusController.selectedExercise.completedData.averageSpeed.value }}\n" +
    "        </span>\n" +
    "        <span class=\"workout-status__exercise-param--units\">\n" +
    "          {{ workoutStatusController.selectedExercise.completedData.averageSpeed.unit }}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"workout-status__exercise-param--name\">\n" +
    "        {{ :: 'SPEED' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!--DISTANCE-->\n" +
    "    <div class=\"workout-status__exercise-param\"\n" +
    "      ng-if=\"workoutStatusController.selectedExercise.completedData.distance\">\n" +
    "      <div class=\"workout-status__exercise-param--value\">\n" +
    "        <span class=\"{{ workoutStatusController.selectedExercise.completedData.distance.comparision }}\">\n" +
    "          {{ workoutStatusController.selectedExercise.completedData.distance.value }}\n" +
    "        </span>\n" +
    "        <span class=\"workout-status__exercise-param--units\">\n" +
    "          {{ workoutStatusController.selectedExercise.completedData.distance.unit }}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"workout-status__exercise-param--name\">\n" +
    "        {{ :: 'DISTANCE' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!--INCLINE-->\n" +
    "    <div class=\"workout-status__exercise-param\"\n" +
    "      ng-if=\"workoutStatusController.selectedExercise.completedData.averageIncline\">\n" +
    "      <div class=\"workout-status__exercise-param--value\">\n" +
    "        <span class=\"{{ workoutStatusController.selectedExercise.completedData.averageIncline.comparision }}\">\n" +
    "          {{ workoutStatusController.selectedExercise.completedData.averageIncline.value }}\n" +
    "        </span>\n" +
    "        <span class=\"workout-status__exercise-param--units\">\n" +
    "          {{ workoutStatusController.selectedExercise.completedData.averageIncline.unit }}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"workout-status__exercise-param--name\">\n" +
    "        {{ :: 'INCLINE' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!--RESISTANCE-->\n" +
    "    <div class=\"workout-status__exercise-param\"\n" +
    "      ng-if=\"workoutStatusController.selectedExercise.completedData.averageResistance\">\n" +
    "      <div class=\"workout-status__exercise-param--value\">\n" +
    "        <span class=\"{{ workoutStatusController.selectedExercise.completedData.averageResistance.comparision }}\">\n" +
    "          {{ workoutStatusController.selectedExercise.completedData.averageResistance.value }}\n" +
    "        </span>\n" +
    "        <span class=\"workout-status__exercise-param--units\">\n" +
    "          {{ workoutStatusController.selectedExercise.completedData.averageResistance.unit }}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"workout-status__exercise-param--name\">\n" +
    "        {{ :: 'RESISTANCE' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!--LEVEL-->\n" +
    "    <div class=\"workout-status__exercise-param\"\n" +
    "      ng-if=\"workoutStatusController.selectedExercise.completedData.level\">\n" +
    "      <div class=\"workout-status__exercise-param--value\">\n" +
    "        <span class=\"{{ workoutStatusController.selectedExercise.completedData.level.comparision }}\">\n" +
    "          {{ workoutStatusController.selectedExercise.completedData.level.value }}\n" +
    "        </span>\n" +
    "        <span class=\"workout-status__exercise-param--units\">\n" +
    "          {{ workoutStatusController.selectedExercise.completedData.level.unit }}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"workout-status__exercise-param--name\">\n" +
    "        {{ :: 'LEVEL' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!--DURATION-->\n" +
    "    <div class=\"workout-status__exercise-param\"\n" +
    "      ng-if=\"workoutStatusController.selectedExercise.completedData.duration\">\n" +
    "      <div class=\"workout-status__exercise-param--value\">\n" +
    "        <span class=\"{{ workoutStatusController.selectedExercise.completedData.duration.comparision }}\">\n" +
    "          {{ workoutStatusController.selectedExercise.completedData.duration.value }}\n" +
    "        </span>\n" +
    "        <span class=\"workout-status__exercise-param--units\">\n" +
    "          {{ workoutStatusController.selectedExercise.completedData.duration.unit }}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"workout-status__exercise-param--name\">\n" +
    "        {{ :: 'DURATION' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!--CALORIES-->\n" +
    "    <div class=\"workout-status__exercise-param\"\n" +
    "      ng-if=\"workoutStatusController.selectedExercise.completedData.calories\">\n" +
    "      <div class=\"workout-status__exercise-param--value\">\n" +
    "        <span class=\"{{ workoutStatusController.selectedExercise.completedData.calories.comparision }}\">\n" +
    "          {{ workoutStatusController.selectedExercise.completedData.calories.value }}\n" +
    "        </span>\n" +
    "        <span class=\"workout-status__exercise-param--units\">\n" +
    "          {{ workoutStatusController.selectedExercise.completedData.calories.unit }}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"workout-status__exercise-param--name\">\n" +
    "        {{ :: 'CALORIES' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!--HEART_RATE-->\n" +
    "    <div class=\"workout-status__exercise-param\"\n" +
    "      ng-if=\"workoutStatusController.selectedExercise.completedData.averageHeartRate\">\n" +
    "      <div class=\"workout-status__exercise-param--value\">\n" +
    "        <span class=\"{{ workoutStatusController.selectedExercise.completedData.averageHeartRate.comparision }}\">\n" +
    "          {{ workoutStatusController.selectedExercise.completedData.averageHeartRate.value }}\n" +
    "        </span>\n" +
    "        <span class=\"workout-status__exercise-param--units\">\n" +
    "          {{ workoutStatusController.selectedExercise.completedData.averageHeartRate.unit }}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"workout-status__exercise-param--name\">\n" +
    "        {{ :: 'HEART_RATE' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal__content-template workout-status clearfix\">\n" +
    "  <div class=\"workout-status__column\"\n" +
    "    ng-if=\"workoutStatusController.selectedExercise.description\">\n" +
    "\n" +
    "    <div class=\"data-block__header\">\n" +
    "      {{ :: 'ASSIGNED_DESCRIPTION' | translate }}\n" +
    "    </div>\n" +
    "\n" +
    "    <pre class=\"workout-status__exercise-param--user-feedback\"\n" +
    "      ng-bind=\"workoutStatusController.selectedExercise.description\">\n" +
    "    </pre>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"workout-status__column\"\n" +
    "    ng-if=\"workoutStatusController.selectedExercise.exerciserDescription\">\n" +
    "\n" +
    "    <div class=\"data-block__header\">\n" +
    "      {{ :: 'ACCOMPLISHED_DESCRIPTION' | translate }}\n" +
    "    </div>\n" +
    "\n" +
    "    <pre class=\"workout-status__exercise-param--user-feedback\"\n" +
    "      ng-bind=\"workoutStatusController.selectedExercise.exerciserDescription\">\n" +
    "    </pre>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"workout-status__feedback\"\n" +
    "  ng-if=\"workoutStatusController.selectedExercise.feedback\">\n" +
    "\n" +
    "  <div class=\"data-block__header\">\n" +
    "    {{ :: 'USER_WORKOUT_FEEDBACK' | translate }}\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"workout-status__exercise-param--emoji\" ng-if=\"workoutStatusController.selectedExercise.emoji\">\n" +
    "    {{workoutStatusController.selectedExercise.emoji}}\n" +
    "  </div>\n" +
    "\n" +
    "  <pre class=\"workout-status__exercise-param--user-feedback\"\n" +
    "    ng-bind=\"workoutStatusController.selectedExercise.feedback\">\n" +
    "  </pre>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/user/tabs/workouts/workouts.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/user/tabs/workouts/workouts.html",
    "<div class=\"workout-history\"\n" +
    "  ng-init='userCtrl.loadAssignments()'\n" +
    "  infinite-scroll='userCtrl.loadAssignments()'\n" +
    "  can-load='userCtrl.assignments.nextPage'\n" +
    "  threshold='30'>\n" +
    "\n" +
    "  <div class=\"workout-history__header\">\n" +
    "    <div class=\"workout-history__header-caption\">{{'DATE_RANGE' | translate}}</div>\n" +
    "    <div class=\"workout-history__header-caption\">{{'ASSIGNMENT' | translate}}</div>\n" +
    "    <div class=\"workout-history__header-caption\">{{'CALORIES' | translate}}</div>\n" +
    "    <div class=\"workout-history__header-caption\">{{'DURATION' | translate}}</div>\n" +
    "    <div class=\"workout-history__header-caption\"></div> <!--for controls-->\n" +
    "  </div>\n" +
    "\n" +
    "  <div ng-repeat=\"assignment in userCtrl.assignments.items\"\n" +
    "       class=\"workout-history__assignment-container\">\n" +
    "    <div class=\"workout-history__assignment\"\n" +
    "      ng-click=\"assignment.showDetails = !assignment.showDetails\">\n" +
    "      <div class=\"workout-history__header-caption\">{{assignment.date}}</div>\n" +
    "      <div class=\"workout-history__header-caption\"><strong>{{assignment.count}}</strong> {{'EXERCISES' | translate}}\n" +
    "      </div>\n" +
    "      <div class=\"workout-history__header-caption\">{{assignment.calories}}</div>\n" +
    "      <div class=\"workout-history__header-caption\">{{assignment.duration}}</div>\n" +
    "      <div class=\"workout-history__header-caption workout-history__header-caption--button-container\">\n" +
    "        <div class=\"workout-history__button workout-history__button--print\"\n" +
    "             ng-click=\"userCtrl.printAssignment(assignment, $event)\"></div>\n" +
    "        <div class=\"workout-history__button workout-history__button--edit\"\n" +
    "          permission\n" +
    "          permission-only=\"'WORKOUT_ASSIGNMENTS_OTHER_UPDATE'\"\n" +
    "          ng-class=\"{'workout-history__button--disabled': assignment.isPassed}\"\n" +
    "          ng-click=\"userCtrl.onEditAssigment(assignment)\">\n" +
    "        </div>\n" +
    "        <div class=\"workout-history__button workout-history__button--show\"\n" +
    "          ng-class=\"{'workout-history__button--collapsed': assignment.showDetails}\">\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"workout-history__exercise-container\"\n" +
    "         ng-if=\"assignment.showDetails\">\n" +
    "      <div class=\"workout-history__exercise\"\n" +
    "        ng-repeat=\"exercise in assignment.exercises\"\n" +
    "        ng-class=\"{\n" +
    "          'workout-history__exercise--uncompleted': !exercise.completedProfile,\n" +
    "          'workout-history__exercise--passed': assignment.isPassed\n" +
    "          }\"\n" +
    "        ng-click=\"userCtrl.showCompletionState(assignment, exercise)\">\n" +
    "\n" +
    "        <div class=\"workout-history__exercise-top\">{{$index+1}}\n" +
    "          <span class=\"workout-history__exercise-top-img\n" +
    "             workout-history__exercise-top-img--{{(exercise.equipmentType | lowercase) || 'default'}}\"></span>\n" +
    "        </div>\n" +
    "        <div class=\"workout-history__exercise-title\">\n" +
    "          <img class=\"workout-history__exercise-title-img\"\n" +
    "               ng-src=\"{{exercise.completedProfile ? '//images.jhtassets.com/7b31cab26903dd249e70020b877c375950619a20/' : '//images.jhtassets.com/784df7de262dee8663e219eb6f1524f486050dac/'}}\">\n" +
    "          {{exercise.title}}\n" +
    "        </div>\n" +
    "        <div class=\"workout-history__exercise-params\">\n" +
    "          <div ng-repeat=\"(key, val) in exercise.metrics\"\n" +
    "               class=\"workout-history__exercise-param\">\n" +
    "            <div class=\"workout-history__exercise-param-name\">{{key}}</div>\n" +
    "            <div class=\"workout-history__exercise-param-val\">{{val}}</div>\n" +
    "          </div>\n" +
    "          <div ng-if=\"userCtrl.hasDescription(exercise)\" class=\"workout-history__exercise-param\"\n" +
    "               ng-repeat=\"line in exercise.description.split('↵') track by $index\">\n" +
    "            <div class=\"workout-history__exercise-param-description\">{{line}}</div>\n" +
    "          </div>\n" +
    "          <div class=\"workout-history__exercise-params-gradient\"\n" +
    "               ng-class=\"{'workout-history__exercise-params-gradient--uncompleted': !exercise.completedProfile}\">\n" +
    "          </div>\n" +
    "          <div class=\"workout-history__exercise-print-icon\"\n" +
    "            ng-click=\"userCtrl.printExercise(exercise, $event)\"></div>\n" +
    "        </div>\n" +
    "        <div class=\"workout-history__exercise-details\"></div>\n" +
    "      </div>\n" +
    "      <div ng-repeat=\"workout in assignment.workouts\"\n" +
    "           class=\"workout-history__exercise workout-history__exercise--uncompleted\">\n" +
    "        <div class=\"workout-history__exercise-top\">{{$index+1+assignment.exercises.length}}\n" +
    "          <span class=\"workout-history__exercise-top-img\n" +
    "             workout-history__exercise-top-img--{{(workout.equipmentType | lowercase) || 'default'}}\"></span>\n" +
    "        </div>\n" +
    "        <div class=\"workout-history__exercise-title\">\n" +
    "          {{workout.title}}\n" +
    "        </div>\n" +
    "        <div class=\"workout-history__exercise-params\">\n" +
    "          <div ng-repeat=\"(key, val) in workout.metrics\"\n" +
    "               class=\"workout-history__exercise-param\">\n" +
    "            <div class=\"workout-history__exercise-param-name\">{{key}}</div>\n" +
    "            <div class=\"workout-history__exercise-param-val\">{{val}}</div>\n" +
    "          </div>\n" +
    "          <div class=\"workout-history__exercise-params-gradient\"\n" +
    "               ng-class=\"{'workout-history__exercise-params-gradient--uncompleted': !exercise.completedProfile}\">\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"workout-history__exercise-details\"></div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class='roster-load-more' ng-if='userCtrl.assignments.nextPage'>\n" +
    "    <div class='roster-load-more__icon spinner-icon'></div>\n" +
    "    {{ :: 'LOADING_MORE_WORKOUTS' | translate }}\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/app/user/user.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/app/user/user.html",
    "<section class=\"user-page\">\n" +
    "\n" +
    "  <div class=\"container-header\">\n" +
    "    <div class=\"back-button\" need-confirmation=\"false\"></div>\n" +
    "\n" +
    "    <div class=\"button-toolbar pull-right\">\n" +
    "      <button class=\"button button-action pull-right\"\n" +
    "        ng-if=\"userCtrl.user.roles['client']\"\n" +
    "        ng-disabled=\"!userCtrl.backup.personalInfo.planDetails.sessionRemains\"\n" +
    "        permission\n" +
    "        permission-only=\":: userCtrl.permissions.workout.create\"\n" +
    "        ui-sref=\"app.assignment({prevState: 'app.users.details',\n" +
    "          prevParams:{userId: userCtrl.userId, }, userId: userCtrl.userId})\">\n" +
    "        <span class=\"button__icon button__icon--add-assignment\"></span>\n" +
    "        {{ :: 'NEW_WORKOUT' | translate }}\n" +
    "      </button>\n" +
    "\n" +
    "      <button class=\"button button-action pull-right\"\n" +
    "        ng-if=\"userCtrl.user.roles['facility_staff'] || userCtrl.user.roles[ 'trainer']\"\n" +
    "        permission\n" +
    "        permission-only=\":: userCtrl.permissions.task.create\"\n" +
    "        ui-sref=\"app.task({prevState: 'app.users.details', userId: userCtrl.userId})\">\n" +
    "        <span class=\"button__icon button__icon--add-assignment\"></span>\n" +
    "        {{ :: 'NEW_TASK' | translate }}\n" +
    "      </button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"user-page__profile-wrapper\">\n" +
    "    <div class=\"user-page__profile\">\n" +
    "      <div class=\"user-page__user-img-container\">\n" +
    "        <div class=\"file-input__container user-page__file-input icon icon-camera\"\n" +
    "          permission\n" +
    "          permission-only=\":: userCtrl.permissions.personalDetails.update\"\n" +
    "          ng-if=\"userCtrl.initialDataIsLoaded && !userCtrl.user.npXid\"\n" +
    "          ngf-select='userCtrl.updateAvatar($files[0])'\n" +
    "          ngf-pattern=\"'image/*'\"\n" +
    "          ngf-multiple=\"false\"\n" +
    "          uib-tooltip=\"{{ :: 'CHANGE_AVATAR_PIC' | translate }}\"\n" +
    "          tooltip-placement=\"right-top\">\n" +
    "        </div>\n" +
    "        <img class=\"user-page__user-img\" ng-src=\"{{userCtrl.user.pictureUrl || '//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png'}}\">\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"user-page__user-name\">\n" +
    "        {{ :: userCtrl.user.firstName }} {{ :: userCtrl.user.lastName }}\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"user-page__user-activity\">\n" +
    "        <div\n" +
    "          permission\n" +
    "          permission-only=\"'INTERESTED_READ'\"\n" +
    "          ng-if=\"userCtrl.user.roles[ 'client']\"\n" +
    "          class=\"user-page__user-activity-caption\">\n" +
    "          <label class=\"checkbox-custom\">\n" +
    "            <input\n" +
    "              permission\n" +
    "              permission-only=\"'INTERESTED_UPDATE'\"\n" +
    "              permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "              permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "              type=\"checkbox\"\n" +
    "              id=\"interested\"\n" +
    "              ng-model=\"userCtrl.user.interested\"\n" +
    "              ng-change=\"userCtrl.updateClientFlags(userCtrl.user.interested, 'interested')\"\n" +
    "              class=\"right-checkbox\">\n" +
    "            <span class=\"checkbox-label\">{{ :: 'INTERESTED' | translate }}</span>\n" +
    "          </label>\n" +
    "        </div>\n" +
    "        <div class=\"user-page__user-activity-caption\"\n" +
    "          permission\n" +
    "          permission-only=\"'ACTIVE_READ'\"\n" +
    "          ng-if=\"userCtrl.user.roles[ 'client']\">\n" +
    "          <label class=\"checkbox-custom\">\n" +
    "            <input\n" +
    "              permission\n" +
    "              permission-only=\"'ACTIVE_UPDATE'\"\n" +
    "              permission-on-unauthorized=\"PermissionStrategies.disableElement\"\n" +
    "              permission-on-authorized=\"PermissionStrategies.enableElement\"\n" +
    "              type=\"checkbox\"\n" +
    "              id=\"active\"\n" +
    "              ng-model=\"userCtrl.user.active\"\n" +
    "              ng-change=\"userCtrl.updateClientFlags(userCtrl.user.active, 'active')\"\n" +
    "              class=\"right-checkbox\">\n" +
    "            <span class=\"checkbox-label\">{{ :: 'ACTIVE' | translate }}</span>\n" +
    "          </label>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <tabs theme=\"dark\" ng-if='userCtrl.initialDataIsLoaded'>\n" +
    "    <tab name='workout-history'\n" +
    "      is-hidden=\"!userCtrl.user.roles['client']\"\n" +
    "      permission\n" +
    "      permission-only=\":: userCtrl.permissions.workoutHistory.read\"\n" +
    "      permission-on-unauthorized=\"PermissionStrategies.disableTab\">\n" +
    "      <tab-head>\n" +
    "        <span class=\"tab-head__multiline-item\">{{ :: 'WORKOUT_HISTORY' | translate}}</span>\n" +
    "      </tab-head>\n" +
    "      <tab-content>\n" +
    "        <ng-include src=\"'/app/user/tabs/workouts/workouts.html'\"></ng-include>\n" +
    "      </tab-content>\n" +
    "    </tab>\n" +
    "\n" +
    "    <tab name='nutrition'\n" +
    "      is-hidden=\"!userCtrl.user.roles['client']\"\n" +
    "      permission\n" +
    "      permission-only=\":: userCtrl.permissions.nutrition.read\"\n" +
    "      permission-on-unauthorized=\"PermissionStrategies.disableTab\">\n" +
    "      <tab-head>\n" +
    "        <span class=\"tab-head__multiline-item\">{{ :: 'NUTRITION_HISTORY' | translate }}</span>\n" +
    "      </tab-head>\n" +
    "      <tab-content>\n" +
    "        <ng-include src=\"'/app/user/tabs/nutrition/nutrition.html'\"></ng-include>\n" +
    "      </tab-content>\n" +
    "    </tab>\n" +
    "\n" +
    "    <tab name='user-details'\n" +
    "      is-hidden=\"!userCtrl.user.roles['client']\"\n" +
    "      permission\n" +
    "      permission-only=\":: userCtrl.permissions.personalDetails.read\"\n" +
    "      permission-on-unauthorized=\"PermissionStrategies.disableTab\">\n" +
    "      <tab-head>\n" +
    "        <span class=\"tab-head__multiline-item\">{{ :: 'CLIENT_DETAILS' | translate }}</span>\n" +
    "      </tab-head>\n" +
    "      <tab-content>\n" +
    "        <ng-include src=\"'/app/user/tabs/userDetails/userDetails.html'\"></ng-include>\n" +
    "      </tab-content>\n" +
    "    </tab>\n" +
    "\n" +
    "    <tab name='facility-staff-details'\n" +
    "      is-hidden=\"!(userCtrl.user.roles['facility_staff'] || userCtrl.user.roles['trainer'])\"\n" +
    "      permission\n" +
    "      permission-only=\":: userCtrl.permissions.personalDetails.read\"\n" +
    "      permission-on-unauthorized=\"PermissionStrategies.disableTab\">\n" +
    "      <tab-head>\n" +
    "        <span class=\"tab-head__multiline-item\">{{ :: 'FACILITY_STAFF' | translate }}</span>\n" +
    "      </tab-head>\n" +
    "      <tab-content>\n" +
    "        <ng-include src=\"'/app/user/tabs/userDetails/facilityStaff.html'\"></ng-include>\n" +
    "      </tab-content>\n" +
    "    </tab>\n" +
    "\n" +
    "    <tab name='notes'\n" +
    "      is-hidden=\"!userCtrl.user.roles['client']\"\n" +
    "      permission\n" +
    "      permission-only=\"'STAFF_NOTES_READ'\"\n" +
    "      permission-on-unauthorized=\"PermissionStrategies.disableTab\">\n" +
    "      <tab-head>\n" +
    "        <span class=\"tab-head__multiline-item\">{{ :: 'NOTES' | translate }}</span>\n" +
    "      </tab-head>\n" +
    "      <tab-content>\n" +
    "        <ng-include src=\"'/app/user/tabs/userNotes/notes.html'\"></ng-include>\n" +
    "      </tab-content>\n" +
    "    </tab>\n" +
    "\n" +
    "    <!--<tab name='schedule'-->\n" +
    "      <!--is-hidden=\"!userCtrl.user.roles['client']\"-->\n" +
    "      <!--permission-->\n" +
    "      <!--permission-only=\"'SCHEDULE_VIEW_READ'\"-->\n" +
    "      <!--permission-on-unauthorized=\"PermissionStrategies.disableTab\">-->\n" +
    "      <!--<tab-head>-->\n" +
    "        <!--<span>{{ :: 'SCHEDULE' | translate }}</span>-->\n" +
    "      <!--</tab-head>-->\n" +
    "      <!--<tab-content>-->\n" +
    "        <!--<ng-include src=\"'/app/user/tabs/schedule.html'\"></ng-include>-->\n" +
    "      <!--</tab-content>-->\n" +
    "    <!--</tab>-->\n" +
    "\n" +
    "    <tab name='user-permissions'\n" +
    "      permission\n" +
    "      permission-only=\"'USER_PERMISSIONS_READ'\"\n" +
    "      permission-on-unauthorized=\"PermissionStrategies.disableTab\">\n" +
    "      <tab-head>\n" +
    "        <span class=\"tab-head__multiline-item\">{{ :: 'PERMISSIONS' | translate }}</span>\n" +
    "      </tab-head>\n" +
    "      <tab-content>\n" +
    "        <ng-include src=\"'/app/user/tabs/permissions/permissions.html'\"></ng-include>\n" +
    "      </tab-content>\n" +
    "    </tab>\n" +
    "\n" +
    "  </tabs>\n" +
    "\n" +
    "  <div class='roster-load-more' ng-if='!userCtrl.initialDataIsLoaded'>\n" +
    "    <div class='roster-load-more__icon spinner-icon'></div>\n" +
    "  </div>\n" +
    "</section>\n" +
    "");
}]);
